/* tslint:disable */
/* eslint:disable */
/**
* @typedef {Object} myAccountEditSite71Params
* @property {string} ds_origin - adi/editor
* @property {GUID} esi -  the editing session guid
* @property {string} hosting - hosting
* @property {number} src - null
* @property {GUID} msid - null
* @property {string} origin - msid if was inside a site dashboard, 'my-sites' if was in my-sites page
* @property {string} place - button/left-nav/my-sites
* @property {string} platform - null
* @property {GUID} site_id - site id
* @property {number} site_type_enriched - null
* @property {number} artificial_src - null
**/
/**
 * Name: my account -> Edit site. Evid: 71.


 * ds_origin - Type: string. Desc: adi/editor
 *
 * esi - Type: guid. Desc:  the editing session guid
 *
 * hosting - Type: string. Desc: hosting
 *
 * src - Type: numeric.
 *
 * msid - Type: guid.
 *
 * origin - Type: string. Desc: msid if was inside a site dashboard, 'my-sites' if was in my-sites page
 *
 * place - Type: string. Desc: button/left-nav/my-sites
 *
 * platform - Type: string.
 *
 * site_id - Type: guid. Desc: site id
 *
 * site_type_enriched - Type: numeric.
 *
 * artificial_src - Type: numeric.
 * @param {myAccountEditSite71Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var myAccountEditSite71 = function (params) {
    return { evid: 71, src: 2, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} myAccountSelectSiteFromSiteListPopup129Params
* @property {string} hosting - null
* @property {number} src - null
* @property {GUID} msid - null
* @property {number} num_selected_sites - null
* @property {string} origin - null
* @property {string} place - null
* @property {string} platform - null
* @property {GUID} site_id - null
* @property {number} artificial_src - null
* @property {string} sub_view - null
* @property {string} view - null
**/
/**
 * Name: my account -> select site from site-list popup. Evid: 129.


 * hosting - Type: string.
 *
 * src - Type: numeric.
 *
 * msid - Type: guid.
 *
 * num_selected_sites - Type: numeric.
 *
 * origin - Type: string.
 *
 * place - Type: string.
 *
 * platform - Type: string.
 *
 * site_id - Type: guid.
 *
 * artificial_src - Type: numeric.
 *
 * sub_view - Type: string.
 *
 * view - Type: string.
 * @param {myAccountSelectSiteFromSiteListPopup129Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var myAccountSelectSiteFromSiteListPopup129 = function (params) {
    return { evid: 129, src: 2, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerClickOnBackInSidebarItemParams
* @property {string} app_id - app_id of the item
* @property {string} hosting - MA/editor
* @property {string} legacy_name - deprecated
* @property {GUID} msid - metasite id
* @property {string} name - unique name that doesn't change when changing the name on the side bar
* @property {string} platform - null
* @property {string} sidebar_name - the name that appears in the sidebar - can be changed
**/
/**
 * Name: Biz Manager - click on back in sidebar item. src: 5 Evid: 570.
 * Event description: user clicks on back from the sidebar in the business manager.

 * app_id - Type: string. Desc: app_id of the item
 *
 * hosting - Type: string. Desc: MA/editor
 *
 * legacy_name - Type: string. Desc: deprecated
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: unique name that doesn't change when changing the name on the side bar
 *
 * platform - Type: string.
 *
 * sidebar_name - Type: string. Desc: the name that appears in the sidebar - can be changed
 * @param {bizManagerClickOnBackInSidebarItemParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerClickOnBackInSidebarItem = function (params) {
    return { evid: 570, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} accountSettingsManagePrivacyPreferencesParams
* @property {string} platform - null
**/
/**
 * Name: Account Settings - Manage Privacy Preferences. src: 5 Evid: 695.
 * Event description: The user clicks on 'manage preferences' in the 'privacy preferences' section.

 * platform - Type: string.
 * @param {accountSettingsManagePrivacyPreferencesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accountSettingsManagePrivacyPreferences = function (params) {
    return { evid: 695, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} wixInvoicesClickingOnNextMobileParams
* @property {GUID} invoice_id - invoice_id
* @property {string} invoiceSource - app def id
* @property {GUID} msid - --
* @property {string} platform - web/mobile
* @property {string} status - Creation Form/Draft
**/
/**
 * Name: Wix Invoices Clicking on Next Mobile. src: 5 Evid: 8965.
 * Event description: When a user is clicking on ‘Next’ while creating or Previewing existing.

 * invoice_id - Type: guid. Desc: invoice_id
 *
 * invoiceSource - Type: string. Desc: app def id
 *
 * msid - Type: guid. Desc: --
 *
 * platform - Type: string. Desc: web/mobile
 *
 * status - Type: string. Desc: Creation Form/Draft
 * @param {wixInvoicesClickingOnNextMobileParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var wixInvoicesClickingOnNextMobile = function (params) {
    return { evid: 8965, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesDownloadPdfQuoteParams
* @property {string} msid - msid
* @property {string} origin - customer for UoU, my quote for users
* @property {string} platform - null
* @property {GUID} quoteId - quote guid
**/
/**
 * Name: Quotes - Download PDF Quote. src: 5 Evid: 89.
 * Event description: click on save as PDF on quote.

 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: customer for UoU, my quote for users
 *
 * platform - Type: string.
 *
 * quoteId - Type: guid. Desc: quote guid
 * @param {quotesDownloadPdfQuoteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesDownloadPdfQuote = function (params) {
    return { evid: 89, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} email2faSetupSendCodeFailParams
* @property {string} action - send/resend
* @property {string} platform - null
**/
/**
 * Name: Email 2FA Setup - Send Code Fail. src: 5 Evid: 1675.
 * Event description: The code was not sent to the user's email after he clicked on send code.

 * action - Type: string. Desc: send/resend
 *
 * platform - Type: string.
 * @param {email2faSetupSendCodeFailParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var email2faSetupSendCodeFail = function (params) {
    return { evid: 1675, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesEditProductOrServiceParams
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} platform - null
* @property {number} product_id - product_id
* @property {string} productName - product_name
* @property {GUID} uuid - uuid
**/
/**
 * Name: Quotes - edit Product or service. src: 5 Evid: 468.
 * Event description: edit Product or service (line item).

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 *
 * product_id - Type: numeric. Desc: product_id
 *
 * productName - Type: string. Desc: product_name
 *
 * uuid - Type: guid. Desc: uuid
 * @param {quotesEditProductOrServiceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesEditProductOrService = function (params) {
    return { evid: 468, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} ascendPageAscendVideoClickParams
* @property {number} loading_time - loading_time
* @property {string} platform - null
* @property {string} prev_view - prev_view
* @property {string} referral_info - referral_info
**/
/**
 * Name: ascend page - ascend video click. src: 5 Evid: 121.
 * Event description: when user clicked on the video.

 * loading_time - Type: numeric. Desc: loading_time
 *
 * platform - Type: string.
 *
 * prev_view - Type: string. Desc: prev_view
 *
 * referral_info - Type: string. Desc: referral_info
 * @param {ascendPageAscendVideoClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ascendPageAscendVideoClick = function (params) {
    return { evid: 121, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerBizInfoClickOnSaveParams
* @property {string} fold_name - list of fold names, separated by commas
* @property {string} hosting - MA/editor
* @property {string} location_details - 0- first location (create), 1-second location (add), 2- third location (add),...
* @property {GUID} msid - metasite id
* @property {string} name - list of fields, separated by commas
* @property {string} origin - app
* @property {string} page_view - The page where the changes were made
* @property {string} place - place of save button: header, footer
* @property {string} platform - null
**/
/**
 * Name: Biz Manager - Biz Info - click on save. src: 5 Evid: 552.
 * Event description: user saves changes in business info page.

 * fold_name - Type: string. Desc: list of fold names, separated by commas
 *
 * hosting - Type: string. Desc: MA/editor
 *
 * location_details - Type: string. Desc: 0- first location (create), 1-second location (add), 2- third location (add),...
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: list of fields, separated by commas
 *
 * origin - Type: string. Desc: app
 *
 * page_view - Type: string. Desc: The page where the changes were made
 *
 * place - Type: string. Desc: place of save button: header, footer
 *
 * platform - Type: string.
 * @param {bizManagerBizInfoClickOnSaveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerBizInfoClickOnSave = function (params) {
    return { evid: 552, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} wixInvoicesToastIsShownParams
* @property {GUID} msid - metasite id
* @property {string} name - toast name, supplied by toast initiator
* @property {string} origin - "my invoices", "preview"
* @property {string} platform - platform
* @property {number} timeout - miliseconds to auto hide toast, 0 is sticky toast
* @property {string} type - standard, error, warning, success, premium
**/
/**
 * Name: Wix Invoices - toast is shown. src: 5 Evid: 8957.
 * Event description: When a payment is made by user ( Recorded, Moto) and Toast is shown..

 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: toast name, supplied by toast initiator
 *
 * origin - Type: string. Desc: "my invoices", "preview"
 *
 * platform - Type: string. Desc: platform
 *
 * timeout - Type: numeric. Desc: miliseconds to auto hide toast, 0 is sticky toast
 *
 * type - Type: string. Desc: standard, error, warning, success, premium
 * @param {wixInvoicesToastIsShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var wixInvoicesToastIsShown = function (params) {
    return { evid: 8957, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} accountSettingsStep1ToDisablePartnerDashboardParams
* @property {string} platform - null
**/
/**
 * Name: Account Settings - step 1 to disable Partner Dashboard. src: 5 Evid: 739.
 * Event description: In account setting, the user clicked to disable Partner Dashboard and will need to confirm again to disable it.

 * platform - Type: string.
 * @param {accountSettingsStep1ToDisablePartnerDashboardParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accountSettingsStep1ToDisablePartnerDashboard = function (params) {
    return { evid: 739, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesNewProductClickParams
* @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
* @property {string} msid - msid
* @property {string} origin - product page, create invoice, empty experience
* @property {string} platform - null
**/
/**
 * Name: Quotes - New product click. src: 5 Evid: 414.
 * Event description: new product.

 * invoiceType - Type: string. Desc: ’recurringAutoCharge’/ 'recurring'/ 'one time'
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: product page, create invoice, empty experience
 *
 * platform - Type: string.
 * @param {quotesNewProductClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesNewProductClick = function (params) {
    return { evid: 414, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} accountSettingsDisableSocialAccountClickDisableInConfirmationModalParams
* @property {string} platform - null
* @property {string} provider_id - the social provider the user tried to disable (apple/google/facebook)
**/
/**
 * Name: Account Settings -  Disable Social Account - Click Disable in Confirmation Modal. src: 5 Evid: 1120.
 * Event description: The user clicked on "disable" in the confirmation message shown once trying to disable Apple social account.

 * platform - Type: string.
 *
 * provider_id - Type: string. Desc: the social provider the user tried to disable (apple/google/facebook)
 * @param {accountSettingsDisableSocialAccountClickDisableInConfirmationModalParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accountSettingsDisableSocialAccountClickDisableInConfirmationModal = function (params) {
    return { evid: 1120, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} teamManagementEditRoleOpenDialogParams
* @property {string} invite_status - pending/expired
* @property {GUID} member_id - the uuid of the member which we edit the role for
* @property {string} origin - where the dialog is opened from
* @property {string} platform - null
* @property {string} roles_displayed - list of roles displayed to the user
**/
/**
 * Name: Team Management - edit role - open dialog. src: 5 Evid: 183.
 * Event description: When the user clicks on edit role.

 * invite_status - Type: string. Desc: pending/expired
 *
 * member_id - Type: guid. Desc: the uuid of the member which we edit the role for
 *
 * origin - Type: string. Desc: where the dialog is opened from
 *
 * platform - Type: string.
 *
 * roles_displayed - Type: string. Desc: list of roles displayed to the user
 * @param {teamManagementEditRoleOpenDialogParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teamManagementEditRoleOpenDialog = function (params) {
    return { evid: 183, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeIntegrationsCommunicationsConnectParams
* @property {string} connectTab - which connection the user choose
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: CRM Home - integrations - communications connect. src: 5 Evid: 855.
 * Event description: CRM Home - integrations - communications connect.

 * connectTab - Type: string. Desc: which connection the user choose
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {crmHomeIntegrationsCommunicationsConnectParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeIntegrationsCommunicationsConnect = function (params) {
    return { evid: 855, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} apesUpdateTooltipParams
* @property {boolean} isPreinstalled - if the automation is pre installed
* @property {GUID} msid - msid
* @property {string} origin - app id
* @property {string} pingTemplateId - pingTemplateId
* @property {string} platform - null
* @property {GUID} ruleId - ruleId
**/
/**
 * Name: APeS - update tooltip. src: 5 Evid: 1701.
 * Event description: APeS - update tooltip.

 * isPreinstalled - Type: bool. Desc: if the automation is pre installed
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: app id
 *
 * pingTemplateId - Type: string. Desc: pingTemplateId
 *
 * platform - Type: string.
 *
 * ruleId - Type: guid. Desc: ruleId
 * @param {apesUpdateTooltipParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var apesUpdateTooltip = function (params) {
    return { evid: 1701, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardTourCloseTourParams
* @property {string} experiment_name - null
* @property {GUID} msid - null
* @property {string} stage_process - null
* @property {number} stage_number - null
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: dashboard tour > close tour. src: 5 Evid: 31.


 * experiment_name - Type: string.
 *
 * msid - Type: guid.
 *
 * stage_process - Type: string.
 *
 * stage_number - Type: numeric.
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {dashboardTourCloseTourParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardTourCloseTour = function (params) {
    return { evid: 31, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsSendCouponChooseUniqueCouponParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations - send coupon - choose unique coupon. src: 5 Evid: 1614.
 * Event description: Automations - send coupon - choose unique coupon.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsSendCouponChooseUniqueCouponParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsSendCouponChooseUniqueCoupon = function (params) {
    return { evid: 1614, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSelectorUserNotificationParams
* @property {string} device - mobile / desktop
* @property {string} filtered_by - premium/published/adi / none
* @property {string} notificationType - unsupported editor / no permissions / selection limit
* @property {string} platform - null
* @property {string} selectionType - single / multi
* @property {number} site_type_enriched - site_type
* @property {string} siteType - HtmlWeb / modal
**/
/**
 * Name: dashboard > site selector user notification. src: 5 Evid: 1599.
 * Event description: when users got any notification in site selector.

 * device - Type: string. Desc: mobile / desktop
 *
 * filtered_by - Type: string. Desc: premium/published/adi / none
 *
 * notificationType - Type: string. Desc: unsupported editor / no permissions / selection limit
 *
 * platform - Type: string.
 *
 * selectionType - Type: string. Desc: single / multi
 *
 * site_type_enriched - Type: numeric. Desc: site_type
 *
 * siteType - Type: string. Desc: HtmlWeb / modal
 * @param {dashboardSiteSelectorUserNotificationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSelectorUserNotification = function (params) {
    return { evid: 1599, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesWidgetReportsTimePickerParams
* @property {GUID} msid - msid
* @property {string} origin - ‘crm home widget/ ‘os-dashboard’
* @property {string} platform - null
* @property {string} time_frame - time picker
**/
/**
 * Name: Invoices - widget - reports - time picker. src: 5 Evid: 1328.
 * Event description: Invoices - widget - see all invoices.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: ‘crm home widget/ ‘os-dashboard’
 *
 * platform - Type: string.
 *
 * time_frame - Type: string. Desc: time picker
 * @param {invoicesWidgetReportsTimePickerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesWidgetReportsTimePicker = function (params) {
    return { evid: 1328, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesResendFromPreviewPageParams
* @property {GUID} appDefId - appDefId (application ID)
* @property {GUID} externalId - An external id of an entity, relevant to the invoiceSource application
* @property {GUID} invoice_id - invoice_guid
* @property {string} msid - msid
* @property {string} origin - origin page - from which place this action was made (invoices, contacts full page, crm home...)
* @property {string} platform - null
**/
/**
 * Name: Quotes - Resend from preview page. src: 5 Evid: 450.
 * Event description: Quotes - Resend from preview page.

 * appDefId - Type: guid. Desc: appDefId (application ID)
 *
 * externalId - Type: guid. Desc: An external id of an entity, relevant to the invoiceSource application
 *
 * invoice_id - Type: guid. Desc: invoice_guid
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: origin page - from which place this action was made (invoices, contacts full page, crm home...)
 *
 * platform - Type: string.
 * @param {quotesResendFromPreviewPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesResendFromPreviewPage = function (params) {
    return { evid: 450, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationCreationModalOpenedParams
* @property {GUID} msid - msid
* @property {string} origin - null
* @property {string} platform - null
**/
/**
 * Name: Automation > creation modal opened. src: 5 Evid: 1335.
 * Event description: Complex Phone - help panel opened.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string.
 *
 * platform - Type: string.
 * @param {automationCreationModalOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationCreationModalOpened = function (params) {
    return { evid: 1335, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardContributorsClickOnMangeRolesAndPermissionsParams
* @property {string} hosting - MA
* @property {GUID} msid - --
* @property {string} platform - null
**/
/**
 * Name: dashboard > contributors > click on mange roles and permissions. src: 5 Evid: 187.
 * Event description: When a user clicks on 'manage roles and permissions' from contributors pic.

 * hosting - Type: string. Desc: MA
 *
 * msid - Type: guid. Desc: --
 *
 * platform - Type: string.
 * @param {dashboardContributorsClickOnMangeRolesAndPermissionsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardContributorsClickOnMangeRolesAndPermissions = function (params) {
    return { evid: 187, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardTriggersEditTriggerClickParams
* @property {GUID} msid - msid
* @property {string} origin - from where this action was called
* @property {string} platform - null
* @property {string} recipe_name - recipe name
* @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
* @property {number} src - null
**/
/**
 * Name: Automations > Edit Automation Click. src: 5 Evid: 213.
 * Event description: Edit Automation rule Click.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: from where this action was called
 *
 * platform - Type: string.
 *
 * recipe_name - Type: string. Desc: recipe name
 *
 * rule_id - Type: guid. Desc: if this trigger all ready customized, null if it first time customization
 *
 * src - Type: numeric.
 * @param {dashboardTriggersEditTriggerClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardTriggersEditTriggerClick = function (params) {
    return { evid: 213, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardTriggersStep2ActionSelectedParams
* @property {string} event_name - name of event (action)
* @property {string} flowType - flow in which the save happens: {create, edit}
* @property {number} index - number of action
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} recipe_name - recipe name
* @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
**/
/**
 * Name: Automations > step 2 > action selected. src: 5 Evid: 224.
 * Event description: selecting an action for trigger.

 * event_name - Type: string. Desc: name of event (action)
 *
 * flowType - Type: string. Desc: flow in which the save happens: {create, edit}
 *
 * index - Type: numeric. Desc: number of action
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * recipe_name - Type: string. Desc: recipe name
 *
 * rule_id - Type: guid. Desc: if this trigger all ready customized, null if it first time customization
 * @param {dashboardTriggersStep2ActionSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardTriggersStep2ActionSelected = function (params) {
    return { evid: 224, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsDaComponentCreateYourOwn287Params
* @property {GUID} invoice_id - invoice guid
* @property {string} invoiceSource - by app_def_id
* @property {string} msid - msid
* @property {string} paymentType - 'recurring','one time'
* @property {string} platform - null
**/
/**
 * Name: Quotes - Invoice paid - Thank you page shown. src: 5 Evid: 287.
 * Event description: Quotes - Invoice paid - Thank you page shown.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * invoiceSource - Type: string. Desc: by app_def_id
 *
 * msid - Type: string. Desc: msid
 *
 * paymentType - Type: string. Desc: 'recurring','one time'
 *
 * platform - Type: string.
 * @param {automationsDaComponentCreateYourOwn287Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsDaComponentCreateYourOwn287 = function (params) {
    return { evid: 287, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardTriggersInactivateActivateTriggerParams
* @property {string} status - new status
* @property {boolean} isPreinstalled - if the automation was pre installed, null = false
* @property {GUID} msid - msid
* @property {string} origin - origin which this action was made
* @property {string} platform - null
* @property {string} recipe_name - recipe name
* @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
* @property {number} src - null
**/
/**
 * Name: Automations > Inactivate /Activate trigger. src: 5 Evid: 211.
 * Event description: Inactivate /Activate trigger.

 * status - Type: string. Desc: new status
 *
 * isPreinstalled - Type: bool. Desc: if the automation was pre installed, null = false
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin which this action was made
 *
 * platform - Type: string.
 *
 * recipe_name - Type: string. Desc: recipe name
 *
 * rule_id - Type: guid. Desc: if this trigger all ready customized, null if it first time customization
 *
 * src - Type: numeric.
 * @param {dashboardTriggersInactivateActivateTriggerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardTriggersInactivateActivateTrigger = function (params) {
    return { evid: 211, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesSortInvoicesParams
* @property {string} msid - msid
* @property {string} name - name of field sorted by
* @property {number} num_of_invoices - number of invoices the user has
* @property {string} order - desc/asc
* @property {string} platform - null
**/
/**
 * Name: Quotes - Sort invoices. src: 5 Evid: 446.
 * Event description: user clicks on a column to sort by it.

 * msid - Type: string. Desc: msid
 *
 * name - Type: string. Desc: name of field sorted by
 *
 * num_of_invoices - Type: numeric. Desc: number of invoices the user has
 *
 * order - Type: string. Desc: desc/asc
 *
 * platform - Type: string.
 * @param {quotesSortInvoicesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesSortInvoices = function (params) {
    return { evid: 446, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsDaComponentShowPage290Params
* @property {string} asset_campaign_guid - asset_campaign_guid
* @property {GUID} msid - msid
* @property {string} origin - button, link, header, success creation dialog
* @property {string} platform - null
* @property {string} referral_info - indicate which vertical is the dacomponent triggered from
* @property {string} widget_name - dashboard/rows/recommendations
**/
/**
 * Name: Automations > DaComponent > show page. src: 5 Evid: 290.
 * Event description: Automations > DaComponent > show page.

 * asset_campaign_guid - Type: string. Desc: asset_campaign_guid
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: button, link, header, success creation dialog
 *
 * platform - Type: string.
 *
 * referral_info - Type: string. Desc: indicate which vertical is the dacomponent triggered from
 *
 * widget_name - Type: string. Desc: dashboard/rows/recommendations
 * @param {automationsDaComponentShowPage290Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsDaComponentShowPage290 = function (params) {
    return { evid: 290, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} teamManagementDeleteTeamMemberDeleteClickParams
* @property {string} invite_status - pending/expired/leave team
* @property {GUID} member_id - the uuid of the deleted member (if status is pending then invite_id)
* @property {string} origin - where the dialog was opened from
* @property {string} platform - null
* @property {string} role - the deleted user’s role
**/
/**
 * Name: Team Management - delete team member - delete click. src: 5 Evid: 179.
 * Event description: When a user clicks on 'delete' in the delete team member window.

 * invite_status - Type: string. Desc: pending/expired/leave team
 *
 * member_id - Type: guid. Desc: the uuid of the deleted member (if status is pending then invite_id)
 *
 * origin - Type: string. Desc: where the dialog was opened from
 *
 * platform - Type: string.
 *
 * role - Type: string. Desc: the deleted user’s role
 * @param {teamManagementDeleteTeamMemberDeleteClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teamManagementDeleteTeamMemberDeleteClick = function (params) {
    return { evid: 179, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesWidgetCreateNewParams
* @property {GUID} msid - msid
* @property {string} origin - ‘crm home widget/ ‘os-dashboard’
* @property {string} platform - null
**/
/**
 * Name: Invoices - widget - Create New. src: 5 Evid: 1324.
 * Event description: Invoices - widget - Create New.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: ‘crm home widget/ ‘os-dashboard’
 *
 * platform - Type: string.
 * @param {invoicesWidgetCreateNewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesWidgetCreateNew = function (params) {
    return { evid: 1324, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} mySitesUnableToMoveSiteToTrashMessageShownParams
* @property {string} messageTitle - the title of the message
* @property {GUID} msid - site guid
* @property {string} origin - my-sites/dashboard
* @property {string} platform - deprecated
* @property {string} reason - the reason the site can't be deleted, for example: pending subscription/active subscription/not permitted/unknown
**/
/**
 * Name: My Sites - Unable to Move Site to Trash message shown. src: 5 Evid: 1686.
 * Event description: when Unable to Move Site to Trash message shown.

 * messageTitle - Type: string. Desc: the title of the message
 *
 * msid - Type: guid. Desc: site guid
 *
 * origin - Type: string. Desc: my-sites/dashboard
 *
 * platform - Type: string. Desc: deprecated
 *
 * reason - Type: string. Desc: the reason the site can't be deleted, for example: pending subscription/active subscription/not permitted/unknown
 * @param {mySitesUnableToMoveSiteToTrashMessageShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mySitesUnableToMoveSiteToTrashMessageShown = function (params) {
    return { evid: 1686, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} ascendPpPurchasePageViewParams
* @property {GUID} app_id - app_id
* @property {number} cycleId - cycle id
* @property {string} cycle_name - cycle name
* @property {string} origin - product name open PP
* @property {GUID} packageId - package id
* @property {string} package_name - package name
* @property {string} platform - null
* @property {string} referralInfo - button name open PP
**/
/**
 * Name: Ascend PP - Purchase Page view. src: 5 Evid: 138.
 * Event description: User view Payment page.

 * app_id - Type: guid. Desc: app_id
 *
 * cycleId - Type: numeric. Desc: cycle id
 *
 * cycle_name - Type: string. Desc: cycle name
 *
 * origin - Type: string. Desc: product name open PP
 *
 * packageId - Type: guid. Desc: package id
 *
 * package_name - Type: string. Desc: package name
 *
 * platform - Type: string.
 *
 * referralInfo - Type: string. Desc: button name open PP
 * @param {ascendPpPurchasePageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ascendPpPurchasePageView = function (params) {
    return { evid: 138, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bmACallForTokenRefreshIsFailingParams
* @property {GUID} msid - site guid
* @property {string} platform - depreceted
**/
/**
 * Name: BM > a call for token refresh is failing. src: 5 Evid: 1722.
 * Event description: when a call for token refresh is failing.

 * msid - Type: guid. Desc: site guid
 *
 * platform - Type: string. Desc: depreceted
 * @param {bmACallForTokenRefreshIsFailingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bmACallForTokenRefreshIsFailing = function (params) {
    return { evid: 1722, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} homeMultipleSitesCheckParams
* @property {boolean} has_two_sites - deprecated
* @property {GUID} msid - deorecated
* @property {number} num_displayed_sites - num sites that are displayed on page
* @property {string} origin - dashboard / my-sites
* @property {string} platform - null
* @property {string} prev_view - search/dashboard/wix.com
* @property {number} sites_count - total number of sites
**/
/**
 * Name: Home > multiple sites check. src: 5 Evid: 305.
 * Event description: checked if a user has one site or more (including sites that he is a contributor.).

 * has_two_sites - Type: bool. Desc: deprecated
 *
 * msid - Type: guid. Desc: deorecated
 *
 * num_displayed_sites - Type: numeric. Desc: num sites that are displayed on page
 *
 * origin - Type: string. Desc: dashboard / my-sites
 *
 * platform - Type: string.
 *
 * prev_view - Type: string. Desc: search/dashboard/wix.com
 *
 * sites_count - Type: numeric. Desc: total number of sites
 * @param {homeMultipleSitesCheckParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var homeMultipleSitesCheck = function (params) {
    return { evid: 305, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerStartLoadingParams
* @property {string} app_id - --
* @property {string} app_ids - all applications installed om Biz Mgr
* @property {GUID} context - when the context is site - send msid, when the context is app for example (like in devCenter) send appDefId, etc.
* @property {string} hosting - from where the user opened Biz manager
* @property {boolean} initial_load - first load
* @property {number} loading_time_from_performance_now - null
* @property {GUID} msid - metasite id
* @property {string} platform - null
* @property {number} screen_height - screen height of the user screen
* @property {number} screen_width - screen width of the user screen
* @property {number} time_to_first_byte - time in ms until the first time the user sees any feedback rather than empty page
* @property {number} window_height - window height of the user screen
* @property {number} window_width - window width of the user screen
**/
/**
 * Name: Biz Manager - start loading. src: 5 Evid: 561.
 * Event description: user click to open Biz manager.

 * app_id - Type: string. Desc: --
 *
 * app_ids - Type: string. Desc: all applications installed om Biz Mgr
 *
 * context - Type: guid. Desc: when the context is site - send msid, when the context is app for example (like in devCenter) send appDefId, etc.
 *
 * hosting - Type: string. Desc: from where the user opened Biz manager
 *
 * initial_load - Type: bool. Desc: first load
 *
 * loading_time_from_performance_now - Type: numeric.
 *
 * msid - Type: guid. Desc: metasite id
 *
 * platform - Type: string.
 *
 * screen_height - Type: numeric. Desc: screen height of the user screen
 *
 * screen_width - Type: numeric. Desc: screen width of the user screen
 *
 * time_to_first_byte - Type: numeric. Desc: time in ms until the first time the user sees any feedback rather than empty page
 *
 * window_height - Type: numeric. Desc: window height of the user screen
 *
 * window_width - Type: numeric. Desc: window width of the user screen
 * @param {bizManagerStartLoadingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerStartLoading = function (params) {
    return { evid: 561, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesPayInvoiceClick478Params
* @property {string} currency - null
* @property {GUID} externalId - An external id of an entity, relevant to the invoiceSource application
* @property {GUID} invoice_id - invoice guid
* @property {GUID} invoiceSource - by app_def_id
* @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
* @property {string} msid - msid
* @property {string} origin - customer for UoU, my invoices for users
* @property {string} paymentType - 'Recurring','One Time'
* @property {string} platform - null
* @property {number} totalAmountLong - total price multiplied by 100000
**/
/**
 * Name: Quotes - Pay Invoice Click. src: 5 Evid: 478.
 * Event description: Quotes - Pay Invoice Click.

 * currency - Type: string.
 *
 * externalId - Type: guid. Desc: An external id of an entity, relevant to the invoiceSource application
 *
 * invoice_id - Type: guid. Desc: invoice guid
 *
 * invoiceSource - Type: guid. Desc: by app_def_id
 *
 * invoiceType - Type: string. Desc: ’recurringAutoCharge’/ 'recurring'/ 'one time'
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: customer for UoU, my invoices for users
 *
 * paymentType - Type: string. Desc: 'Recurring','One Time'
 *
 * platform - Type: string.
 *
 * totalAmountLong - Type: numeric. Desc: total price multiplied by 100000
 * @param {quotesPayInvoiceClick478Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesPayInvoiceClick478 = function (params) {
    return { evid: 478, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} toolcastGuideLoadedSuccessfullyParams
* @property {string} campaignId - from dealer
* @property {string} offeringGuid - from dealer
* @property {string} platform - null
**/
/**
 * Name: Toolcast- guide loaded successfully. src: 5 Evid: 1368.
 * Event description: If the guide loaded.

 * campaignId - Type: string. Desc: from dealer
 *
 * offeringGuid - Type: string. Desc: from dealer
 *
 * platform - Type: string.
 * @param {toolcastGuideLoadedSuccessfullyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var toolcastGuideLoadedSuccessfully = function (params) {
    return { evid: 1368, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsClickOnViewAllInRecommendedAutomationsSectionParams
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} section_name - Boost Your Store Sales / Stay in Touch With Clients / ...
**/
/**
 * Name: Automations > click on view all in recommended automations section. src: 5 Evid: 142.
 * Event description: click on view all in recommended automations section.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * section_name - Type: string. Desc: Boost Your Store Sales / Stay in Touch With Clients / ...
 * @param {automationsClickOnViewAllInRecommendedAutomationsSectionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsClickOnViewAllInRecommendedAutomationsSection = function (params) {
    return { evid: 142, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} wixInvoicesAutomationDynamicValueClickParams
* @property {string} action - click/add
* @property {string} msid - msid
* @property {string} origin - Chosen app in which this automation was clicked (Now only Bookings)
* @property {string} origin_device - web,native
* @property {string} platform - platform
**/
/**
 * Name: Wix Invoices Automation dynamic value. src: 5 Evid: 8963.
 * Event description: When a user is clicking on dynamic value.

 * action - Type: string. Desc: click/add
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: Chosen app in which this automation was clicked (Now only Bookings)
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string. Desc: platform
 * @param {wixInvoicesAutomationDynamicValueClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var wixInvoicesAutomationDynamicValueClick = function (params) {
    return { evid: 8963, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsClickOnDuplicateAutomationParams
* @property {GUID} msid - msid
* @property {string} origin - 'home' / 'my automations page'
* @property {string} platform - null
* @property {string} recipeName - recipeName
* @property {GUID} rule_id - the origin rule_id
* @property {string} rule_name - rule_name
**/
/**
 * Name: Automations > click on duplicate automation. src: 5 Evid: 109.
 * Event description: user click on duplicate automation.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: 'home' / 'my automations page'
 *
 * platform - Type: string.
 *
 * recipeName - Type: string. Desc: recipeName
 *
 * rule_id - Type: guid. Desc: the origin rule_id
 *
 * rule_name - Type: string. Desc: rule_name
 * @param {automationsClickOnDuplicateAutomationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsClickOnDuplicateAutomation = function (params) {
    return { evid: 109, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsBrokenRulesParams
* @property {string} action - actions
* @property {string} additionalInfo - info off the error
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {GUID} rule_id - the rule_id that the user started/edited
* @property {string} ruleType - is it preinstalled or not
* @property {string} trigger - trigger
* @property {boolean} withTriggersCatalog - is with triggers catalog
**/
/**
 * Name: Automations > Broken rules. src: 5 Evid: 1275.
 * Event description: Automations > Broken rules.

 * action - Type: string. Desc: actions
 *
 * additionalInfo - Type: string. Desc: info off the error
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * rule_id - Type: guid. Desc: the rule_id that the user started/edited
 *
 * ruleType - Type: string. Desc: is it preinstalled or not
 *
 * trigger - Type: string. Desc: trigger
 *
 * withTriggersCatalog - Type: bool. Desc: is with triggers catalog
 * @param {automationsBrokenRulesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsBrokenRules = function (params) {
    return { evid: 1275, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsPriceQuotesInvoicesSubmitFeedbackFormParams
* @property {GUID} msid - msid
* @property {string} origin - {automations, price quotes, invoices}
* @property {string} platform - null
**/
/**
 * Name: Automations/ Price Quotes/ Invoices > Submit Feedback Form. src: 5 Evid: 233.
 * Event description: user click Submit Feedback Form.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: {automations, price quotes, invoices}
 *
 * platform - Type: string.
 * @param {automationsPriceQuotesInvoicesSubmitFeedbackFormParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsPriceQuotesInvoicesSubmitFeedbackForm = function (params) {
    return { evid: 233, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} apesLoadSystemNotificationsModalEndParams
* @property {boolean} edited - is it second time that the modal is opened (after edit mode)
* @property {boolean} isPreinstalled - if the automation is pre installed
* @property {number} loadTime - how much time it took to load the modal
* @property {GUID} msid - msid
* @property {string} origin - app id
* @property {string} platform - null
**/
/**
 * Name: APeS - load system notifications modal - end. src: 5 Evid: 1277.
 * Event description: APeS - load system notifications modal - start.

 * edited - Type: bool. Desc: is it second time that the modal is opened (after edit mode)
 *
 * isPreinstalled - Type: bool. Desc: if the automation is pre installed
 *
 * loadTime - Type: numeric. Desc: how much time it took to load the modal
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: app id
 *
 * platform - Type: string.
 * @param {apesLoadSystemNotificationsModalEndParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var apesLoadSystemNotificationsModalEnd = function (params) {
    return { evid: 1277, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesCreateInvoiceDeleteLineParams
* @property {GUID} invoice_id - invoice guid
* @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
* @property {string} msid - msid
* @property {string} origin - create invoice, edit invoice
* @property {string} platform - null
* @property {string} source - source
**/
/**
 * Name: Quotes - Create invoice - Delete line. src: 5 Evid: 413.
 * Event description: Create invoice - delete line.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * invoiceType - Type: string. Desc: ’recurringAutoCharge’/ 'recurring'/ 'one time'
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: create invoice, edit invoice
 *
 * platform - Type: string.
 *
 * source - Type: string. Desc: source
 * @param {quotesCreateInvoiceDeleteLineParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesCreateInvoiceDeleteLine = function (params) {
    return { evid: 413, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesSelectTaxParams
* @property {string} contact_id - contact_id
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} platform - null
* @property {number} product_id - product_id
* @property {number} taxRate - taxRate
* @property {string} tax_name - tax_name
* @property {GUID} uuid - uuid
**/
/**
 * Name: Quotes -Select Tax. src: 5 Evid: 469.
 * Event description: Quotes - edit Product.

 * contact_id - Type: string. Desc: contact_id
 *
 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 *
 * product_id - Type: numeric. Desc: product_id
 *
 * taxRate - Type: numeric. Desc: taxRate
 *
 * tax_name - Type: string. Desc: tax_name
 *
 * uuid - Type: guid. Desc: uuid
 * @param {quotesSelectTaxParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesSelectTax = function (params) {
    return { evid: 469, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerModuleLoadingFinishParams
* @property {GUID} app_id - application id
* @property {string} hosting - MA/editor
* @property {boolean} initial_load - first load
* @property {number} loading_time - loading time from module loading start
* @property {string} module_id - requested module
* @property {GUID} msid - metasite id
* @property {string} origin - specific button triggered the the view loading (== referral info from editor)
* @property {string} origin_app_id - origin_app_id (what app opened the bizmgr)
* @property {string} platform - null
* @property {string} referral_info - specific button triggered the the view loading
* @property {string} wixsession - authentication token. if the session exists, then the user is logged in.
**/
/**
 * Name: Biz Manager - module loading - finish. src: 5 Evid: 565.
 * Event description: module that is loaded in the biz manager (like Stores, Shoutout, etc.).

 * app_id - Type: guid. Desc: application id
 *
 * hosting - Type: string. Desc: MA/editor
 *
 * initial_load - Type: bool. Desc: first load
 *
 * loading_time - Type: numeric. Desc: loading time from module loading start
 *
 * module_id - Type: string. Desc: requested module
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: specific button triggered the the view loading (== referral info from editor)
 *
 * origin_app_id - Type: string. Desc: origin_app_id (what app opened the bizmgr)
 *
 * platform - Type: string.
 *
 * referral_info - Type: string. Desc: specific button triggered the the view loading
 *
 * wixsession - Type: string. Desc: authentication token. if the session exists, then the user is logged in.
 * @param {bizManagerModuleLoadingFinishParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerModuleLoadingFinish = function (params) {
    return { evid: 565, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardDeleteAndRestoreSiteOpenPopupParams
* @property {GUID} msid - -
* @property {string} name - deprecated
* @property {string} platform - null
* @property {string} popup_name - popup_name
**/
/**
 * Name: dashboard > delete and restore site -> Open Popup. src: 5 Evid: 100.
 * Event description: user clicks on Move to Trash/Restore/Remove from Trash  button from popup window.

 * msid - Type: guid. Desc: -
 *
 * name - Type: string. Desc: deprecated
 *
 * platform - Type: string.
 *
 * popup_name - Type: string. Desc: popup_name
 * @param {dashboardDeleteAndRestoreSiteOpenPopupParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardDeleteAndRestoreSiteOpenPopup = function (params) {
    return { evid: 100, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsEducationRawParams
* @property {GUID} msid - msid
* @property {string} option - which education the user choosed (video-tutorial/drip-campaign/zapier)
* @property {string} platform - null
**/
/**
 * Name: Automations - Education row. src: 5 Evid: 1332.
 * Event description: Automations - stores choose specific product click.

 * msid - Type: guid. Desc: msid
 *
 * option - Type: string. Desc: which education the user choosed (video-tutorial/drip-campaign/zapier)
 *
 * platform - Type: string.
 * @param {automationsEducationRawParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsEducationRaw = function (params) {
    return { evid: 1332, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} notificationsClickOnAChannelSettingsParams
* @property {string} channel - channel section the user clicked on
* @property {string} click_name - collapse/expand
* @property {string} hosting - MA/editor/ADI
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Notifications > Click on Channel settings. src: 5 Evid: 379.
 * Event description: On the Notification Setting page,  "Set Notifications by Channel" section, click on collapse/expand..

 * channel - Type: string. Desc: channel section the user clicked on
 *
 * click_name - Type: string. Desc: collapse/expand
 *
 * hosting - Type: string. Desc: MA/editor/ADI
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {notificationsClickOnAChannelSettingsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var notificationsClickOnAChannelSettings = function (params) {
    return { evid: 379, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} rolesEditRoleClickParams
* @property {string} hosting - MA/Editor
* @property {boolean} is_accepted - true if invite was accepted
* @property {boolean} is_blog_shown - true if shown (blog manager appears only for sites with blog)
* @property {boolean} is_events_shown - is_events_shown
* @property {GUID} msid - msid
* @property {string} origin - origin page
* @property {string} platform - null
* @property {string} roles_displayed - list of roles displayed to the user
**/
/**
 * Name: Roles - edit role - open dialog. src: 5 Evid: 366.
 * Event description: click on edit role.

 * hosting - Type: string. Desc: MA/Editor
 *
 * is_accepted - Type: bool. Desc: true if invite was accepted
 *
 * is_blog_shown - Type: bool. Desc: true if shown (blog manager appears only for sites with blog)
 *
 * is_events_shown - Type: bool. Desc: is_events_shown
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin page
 *
 * platform - Type: string.
 *
 * roles_displayed - Type: string. Desc: list of roles displayed to the user
 * @param {rolesEditRoleClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rolesEditRoleClick = function (params) {
    return { evid: 366, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} teamManagementSaveParams
* @property {boolean} is_logo_shown - true/false
* @property {boolean} is_valid_team_name - true/false (false if error shows)
* @property {string} platform - null
**/
/**
 * Name: Team management > save. src: 5 Evid: 173.
 * Event description: User clicks to save his edit team dialog.

 * is_logo_shown - Type: bool. Desc: true/false
 *
 * is_valid_team_name - Type: bool. Desc: true/false (false if error shows)
 *
 * platform - Type: string.
 * @param {teamManagementSaveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teamManagementSave = function (params) {
    return { evid: 173, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerNewBadgeShowParams
* @property {string} hosting - MA/editor
* @property {GUID} msid - metasite id
* @property {string} name - unique name that doesn't change when changing the name on the side bar
* @property {string} platform - null
* @property {string} sidebar_name - the name that appears in the sidebar - can be changed
**/
/**
 * Name: Biz Manager - 'new' badge show. src: 5 Evid: 673.
 * Event description: 'new' badge show on the sidebar.

 * hosting - Type: string. Desc: MA/editor
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: unique name that doesn't change when changing the name on the side bar
 *
 * platform - Type: string.
 *
 * sidebar_name - Type: string. Desc: the name that appears in the sidebar - can be changed
 * @param {bizManagerNewBadgeShowParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerNewBadgeShow = function (params) {
    return { evid: 673, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesEmailInvoicePageCancelClickParams
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} origin - origin page
* @property {string} origin_device - web,native
* @property {string} platform - null
* @property {boolean} resend - resend mode?
**/
/**
 * Name: Quotes - Email invoice page - Cancel click. src: 5 Evid: 405.
 * Event description: email invoice - clicked on cancel.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: origin page
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string.
 *
 * resend - Type: bool. Desc: resend mode?
 * @param {quotesEmailInvoicePageCancelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesEmailInvoicePageCancelClick = function (params) {
    return { evid: 405, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerViewStartLoadingParams
* @property {string} app_ids - app_ids
* @property {GUID} app_instance_id - --
* @property {string} hosting - ADI/MA/editor
* @property {boolean} initial_load - True if first load
* @property {GUID} msid - --
* @property {string} platform - null
* @property {string} prev_sub_view - previous page in app/module
* @property {string} prev_view - origin view / module / app
* @property {string} referral_info - specific button triggered the the view loading
* @property {string} sub_view - page in app/module
* @property {string} view - requested view/ module/ app
**/
/**
 * Name: Biz Manager  > View start loading. src: 5 Evid: 581.
 * Event description: View/Sub View Start loading.

 * app_ids - Type: string. Desc: app_ids
 *
 * app_instance_id - Type: guid. Desc: --
 *
 * hosting - Type: string. Desc: ADI/MA/editor
 *
 * initial_load - Type: bool. Desc: True if first load
 *
 * msid - Type: guid. Desc: --
 *
 * platform - Type: string.
 *
 * prev_sub_view - Type: string. Desc: previous page in app/module
 *
 * prev_view - Type: string. Desc: origin view / module / app
 *
 * referral_info - Type: string. Desc: specific button triggered the the view loading
 *
 * sub_view - Type: string. Desc: page in app/module
 *
 * view - Type: string. Desc: requested view/ module/ app
 * @param {bizManagerViewStartLoadingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerViewStartLoading = function (params) {
    return { evid: 581, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} tooltipNotificationPopsUpParams
* @property {GUID} msid - msid
* @property {string} name - New released feature's name
* @property {string} origin - web/mobile
* @property {string} platform - null
**/
/**
 * Name: New Releases - Tooltip notification pops up. src: 5 Evid: 337.
 * Event description: Tooltip pops up. It happens only once when the site gets his first  "new release" notification..

 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: New released feature's name
 *
 * origin - Type: string. Desc: web/mobile
 *
 * platform - Type: string.
 * @param {tooltipNotificationPopsUpParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tooltipNotificationPopsUp = function (params) {
    return { evid: 337, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} settingsOverviewPageClickOnItemParams
* @property {string} click_name - deprecated
* @property {string} fold_name - card name
* @property {string} hosting - MA/editor/ADI
* @property {string} item_name - the name of the item
* @property {GUID} msid - --
* @property {string} page_view - The page of the click (website settings/business info/language and region)
* @property {string} platform - null
* @property {string} status_text - deprecated
**/
/**
 * Name: Settings  > click on item. src: 5 Evid: 345.
 * Event description: when a user clicks on item in one of the OS Settings page.

 * click_name - Type: string. Desc: deprecated
 *
 * fold_name - Type: string. Desc: card name
 *
 * hosting - Type: string. Desc: MA/editor/ADI
 *
 * item_name - Type: string. Desc: the name of the item
 *
 * msid - Type: guid. Desc: --
 *
 * page_view - Type: string. Desc: The page of the click (website settings/business info/language and region)
 *
 * platform - Type: string.
 *
 * status_text - Type: string. Desc: deprecated
 * @param {settingsOverviewPageClickOnItemParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var settingsOverviewPageClickOnItem = function (params) {
    return { evid: 345, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsDaComponentExploreMoreClick289Params
* @property {string} exposure_name - exposure_name
* @property {string} hosting - MA/editor
* @property {GUID} msid - metasite id
* @property {string} platform - null
* @property {number} value_from_dealer - The value we get from the Dealer
* @property {number} value_from_was - The value we get from the WAS
**/
/**
 * Name: General - Exposure Analytics from Dealer. src: 5 Evid: 289.
 * Event description: General - Exposure Analytics from Dealer.

 * exposure_name - Type: string. Desc: exposure_name
 *
 * hosting - Type: string. Desc: MA/editor
 *
 * msid - Type: guid. Desc: metasite id
 *
 * platform - Type: string.
 *
 * value_from_dealer - Type: numeric. Desc: The value we get from the Dealer
 *
 * value_from_was - Type: numeric. Desc: The value we get from the WAS
 * @param {automationsDaComponentExploreMoreClick289Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsDaComponentExploreMoreClick289 = function (params) {
    return { evid: 289, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesPrintFromPreviewPageParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Invoices - Print. src: 5 Evid: 481.
 * Event description: Quotes - Resend from preview page.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {quotesPrintFromPreviewPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesPrintFromPreviewPage = function (params) {
    return { evid: 481, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsDaComponentShowPage285Params
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} origin - customer for UoU, my invoices for users
* @property {string} paymentType - 'Recurring','One Time'
* @property {string} platform - null
**/
/**
 * Name: Quotes - Invoice Table  - Download PDF. src: 5 Evid: 285.
 * Event description: Quotes - Invoice Table  - Download PDF.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: customer for UoU, my invoices for users
 *
 * paymentType - Type: string. Desc: 'Recurring','One Time'
 *
 * platform - Type: string.
 * @param {automationsDaComponentShowPage285Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsDaComponentShowPage285 = function (params) {
    return { evid: 285, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesRecurringPremiumPlanSelectedParams
* @property {string} msid - msid
* @property {string} package_id - id of package
* @property {string} platform - platform
* @property {GUID} uuid - uuid
**/
/**
 * Name: Invoices - recurring - Premium Plan selected. src: 5 Evid: 1634.
 * Event description: Quotes - recurring - Premium Plan selected.

 * msid - Type: string. Desc: msid
 *
 * package_id - Type: string. Desc: id of package
 *
 * platform - Type: string. Desc: platform
 *
 * uuid - Type: guid. Desc: uuid
 * @param {invoicesRecurringPremiumPlanSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesRecurringPremiumPlanSelected = function (params) {
    return { evid: 1634, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} tooltipForOwnerAppParams
* @property {string} hosting - Dashboard/editor/ADI
* @property {GUID} msid - msid
* @property {string} origin - entry points -analytics/blog
* @property {string} platform - null
**/
/**
 * Name: Tooltip for owner app. src: 5 Evid: 2002.
 * Event description: when Tooltip for owner app shown.

 * hosting - Type: string. Desc: Dashboard/editor/ADI
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: entry points -analytics/blog
 *
 * platform - Type: string.
 * @param {tooltipForOwnerAppParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tooltipForOwnerApp = function (params) {
    return { evid: 2002, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsShowStatisticsClickParams
* @property {GUID} msid - msid
* @property {string} origin - (e.g: 'Forms') from where this action was called
* @property {string} platform - null
* @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
* @property {string} ruleName - ruleName
**/
/**
 * Name: Automations > Show Statistics Click. src: 5 Evid: 247.
 * Event description: Automations > Show Statistics Click.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: (e.g: 'Forms') from where this action was called
 *
 * platform - Type: string.
 *
 * rule_id - Type: guid. Desc: if this trigger all ready customized, null if it first time customization
 *
 * ruleName - Type: string. Desc: ruleName
 * @param {automationsShowStatisticsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsShowStatisticsClick = function (params) {
    return { evid: 247, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsOpenGoogleSheetFromAutomationParams
* @property {GUID} msid - msid
* @property {string} origin - from where this action was called
* @property {string} platform - null
* @property {string} recipe_name - recipe name
* @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
**/
/**
 * Name: Automations > open google sheet from automation. src: 5 Evid: 2010.
 * Event description: Automations > open google sheet from automation.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: from where this action was called
 *
 * platform - Type: string.
 *
 * recipe_name - Type: string. Desc: recipe name
 *
 * rule_id - Type: guid. Desc: if this trigger all ready customized, null if it first time customization
 * @param {automationsOpenGoogleSheetFromAutomationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsOpenGoogleSheetFromAutomation = function (params) {
    return { evid: 2010, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSettingsChangeValueSuccessParams
* @property {string} create_method - save(pop-up),create new
* @property {string} experience - user's experience
* @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
* @property {GUID} msid - msid
* @property {string} name - name of the field that was changed
* @property {string} origin - name of current tab
* @property {string} platform - null
* @property {number} src - null
* @property {string} value - field's value
**/
/**
 * Name: dashboard > site settings > change value success. src: 5 Evid: 313.
 * Event description: user changed a value in the site settings successfully.

 * create_method - Type: string. Desc: save(pop-up),create new
 *
 * experience - Type: string. Desc: user's experience
 *
 * hosting - Type: string. Desc: from where user arrived to sitesettings (Editor/MA/...)
 *
 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: name of the field that was changed
 *
 * origin - Type: string. Desc: name of current tab
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 *
 * value - Type: string. Desc: field's value
 * @param {dashboardSiteSettingsChangeValueSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSettingsChangeValueSuccess = function (params) {
    return { evid: 313, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} rolesDeleteRoleCloseWindowParams
* @property {string} accept_email - accepted email
* @property {string} hosting - MA /Editor
* @property {GUID} msid - msid
* @property {string} origin - name of tab
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: Roles - delete role - close window. src: 5 Evid: 361.
 * Event description: user closed delete role window.

 * accept_email - Type: string. Desc: accepted email
 *
 * hosting - Type: string. Desc: MA /Editor
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: name of tab
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {rolesDeleteRoleCloseWindowParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rolesDeleteRoleCloseWindow = function (params) {
    return { evid: 361, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} phoneVerificationCodeValidationParams
* @property {string} platform - null
* @property {GUID} uuid - uuid
* @property {string} validstatus - good, expired, wrong, error
**/
/**
 * Name: Phone Verification - Confirmation Ended. src: 5 Evid: 666.
 * Event description: validates the code entered.

 * platform - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 *
 * validstatus - Type: string. Desc: good, expired, wrong, error
 * @param {phoneVerificationCodeValidationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var phoneVerificationCodeValidation = function (params) {
    return { evid: 666, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSettingsOverviewUnpublishPopupCancelParams
* @property {string} experience - user's experience
* @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
* @property {GUID} msid - msid
* @property {string} name - name of the field that was changed
* @property {string} origin - name of current tab
* @property {string} platform - null
**/
/**
 * Name: dashboard > site settings > overview > unpublish popup cancel. src: 5 Evid: 327.
 * Event description: close Pop-up window either with 'cancel' option or 'X' ..

 * experience - Type: string. Desc: user's experience
 *
 * hosting - Type: string. Desc: from where user arrived to sitesettings (Editor/MA/...)
 *
 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: name of the field that was changed
 *
 * origin - Type: string. Desc: name of current tab
 *
 * platform - Type: string.
 * @param {dashboardSiteSettingsOverviewUnpublishPopupCancelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSettingsOverviewUnpublishPopupCancel = function (params) {
    return { evid: 327, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} accountSettingsTwoFactorAuthenticationSetupSendCodeFailedParams
* @property {string} action - send/resend
* @property {string} mode - enable/edit
* @property {string} platform - null
**/
/**
 * Name: Account Settings - Phone 2FA Setup - Send Code Failed. src: 5 Evid: 697.
 * Event description: The code was not sent to the user's phone after he clicked on send code.

 * action - Type: string. Desc: send/resend
 *
 * mode - Type: string. Desc: enable/edit
 *
 * platform - Type: string.
 * @param {accountSettingsTwoFactorAuthenticationSetupSendCodeFailedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accountSettingsTwoFactorAuthenticationSetupSendCodeFailed = function (params) {
    return { evid: 697, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} toolcastClickXInTheGuideParams
* @property {string} campaignId - campaign id from dealer
* @property {string} offeringGuid - offer id
* @property {string} platform - deprecated
**/
/**
 * Name: Toolcast- click X in the guide. src: 5 Evid: 1373.
 * Event description: when the user click on exist X in the guide.

 * campaignId - Type: string. Desc: campaign id from dealer
 *
 * offeringGuid - Type: string. Desc: offer id
 *
 * platform - Type: string. Desc: deprecated
 * @param {toolcastClickXInTheGuideParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var toolcastClickXInTheGuide = function (params) {
    return { evid: 1373, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardDeleteAndRestoreSiteRestoreSiteClickParams
* @property {GUID} msid - -
* @property {string} origin - button name
* @property {string} platform - null
**/
/**
 * Name: dashboard > delete and restore site -> restore site click. src: 5 Evid: 101.
 * Event description: user clicks on Move to Trash/Restore/Remove from Trash  button from popup window.

 * msid - Type: guid. Desc: -
 *
 * origin - Type: string. Desc: button name
 *
 * platform - Type: string.
 * @param {dashboardDeleteAndRestoreSiteRestoreSiteClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardDeleteAndRestoreSiteRestoreSiteClick = function (params) {
    return { evid: 101, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerOpenPanelStartParams
* @property {string} contact_id - contact_id
* @property {string} hosting - MA/editor
* @property {GUID} msid - msid
* @property {string} panel_name - the panel that was opened
* @property {string} platform - null
* @property {string} sub_view - page in app
* @property {string} view - requested view
**/
/**
 * Name: Biz Manager > Open panel start. src: 5 Evid: 598.
 * Event description: panel is starting to load.

 * contact_id - Type: string. Desc: contact_id
 *
 * hosting - Type: string. Desc: MA/editor
 *
 * msid - Type: guid. Desc: msid
 *
 * panel_name - Type: string. Desc: the panel that was opened
 *
 * platform - Type: string.
 *
 * sub_view - Type: string. Desc: page in app
 *
 * view - Type: string. Desc: requested view
 * @param {bizManagerOpenPanelStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerOpenPanelStart = function (params) {
    return { evid: 598, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsRenameTriggerClick249Params
* @property {GUID} msid - msid
* @property {string} origin - (e.g: 'Forms') from where this action was called
* @property {string} platform - null
* @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
**/
/**
 * Name: Automations > Rename Trigger Click. src: 5 Evid: 249.
 * Event description: Rename Trigger Click.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: (e.g: 'Forms') from where this action was called
 *
 * platform - Type: string.
 *
 * rule_id - Type: guid. Desc: if this trigger all ready customized, null if it first time customization
 * @param {automationsRenameTriggerClick249Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsRenameTriggerClick249 = function (params) {
    return { evid: 249, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} mySitesClickOnButtonInDialogParams
* @property {string} action - approve / cancel
* @property {string} cta - X / cancel / move to trash / move to folder etc...
* @property {string} from_level - from where the user moved the sites. In case it’s sites-list main page report: ROOT, in case it’s folder report: folder_name_of_folder, in case it’s search report search_search_term, in case it’s filter report filter
* @property {string} name - dialog name
* @property {number} num_selected_sites - number of sites move to the folder
* @property {string} origin - sites-list-enterprise
* @property {string} platform - null
* @property {string} to_level - to where the user moved the site. In case it’s sites-list main page report: ROOT, in case it’s folder report: folder_name_of_folder, ic case it’s trash folder report: folder_trash
* @property {string} view_mode - list/grid
**/
/**
 * Name: My sites > click on button in dialog. src: 5 Evid: 1735.
 * Event description: when user click on any button in dialog in My-Sites page. currently this BI reported from move to trash/move to folder dialogs..

 * action - Type: string. Desc: approve / cancel
 *
 * cta - Type: string. Desc: X / cancel / move to trash / move to folder etc...
 *
 * from_level - Type: string. Desc: from where the user moved the sites. In case it’s sites-list main page report: ROOT, in case it’s folder report: folder_name_of_folder, in case it’s search report search_search_term, in case it’s filter report filter
 *
 * name - Type: string. Desc: dialog name
 *
 * num_selected_sites - Type: numeric. Desc: number of sites move to the folder
 *
 * origin - Type: string. Desc: sites-list-enterprise
 *
 * platform - Type: string.
 *
 * to_level - Type: string. Desc: to where the user moved the site. In case it’s sites-list main page report: ROOT, in case it’s folder report: folder_name_of_folder, ic case it’s trash folder report: folder_trash
 *
 * view_mode - Type: string. Desc: list/grid
 * @param {mySitesClickOnButtonInDialogParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mySitesClickOnButtonInDialog = function (params) {
    return { evid: 1735, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsDialogShowClickParams
* @property {string} action - name of action: {show, approve, cancel ; create new, all automations}
* @property {string} flowType - flow in which the dialog is shown: {create, edit}
* @property {GUID} msid - msid
* @property {string} name - name of dialog: {leave, creation success}
* @property {string} platform - null
* @property {string} recipe_name - recipe name
* @property {GUID} rule_id - the rule_id that the user started/edited
**/
/**
 * Name: Automations > Dialog show/click. src: 5 Evid: 226.
 * Event description: showing/clicking a dialog under Automations.

 * action - Type: string. Desc: name of action: {show, approve, cancel ; create new, all automations}
 *
 * flowType - Type: string. Desc: flow in which the dialog is shown: {create, edit}
 *
 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: name of dialog: {leave, creation success}
 *
 * platform - Type: string.
 *
 * recipe_name - Type: string. Desc: recipe name
 *
 * rule_id - Type: guid. Desc: the rule_id that the user started/edited
 * @param {automationsDialogShowClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsDialogShowClick = function (params) {
    return { evid: 226, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} financialServicesSettingsPriceQuotesEditNumberingParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Financial Services Settings - Price Quotes - edit numbering. src: 5 Evid: 1312.
 * Event description: Financial Services Settings - Price Quotes - edit numbering.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {financialServicesSettingsPriceQuotesEditNumberingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var financialServicesSettingsPriceQuotesEditNumbering = function (params) {
    return { evid: 1312, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsSendCouponSetCouponParams
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} toggle_status - toggle_status
**/
/**
 * Name: Automations - send coupon - set coupon. src: 5 Evid: 1613.
 * Event description: Automations - send coupon - set coupon.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * toggle_status - Type: string. Desc: toggle_status
 * @param {automationsSendCouponSetCouponParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsSendCouponSetCoupon = function (params) {
    return { evid: 1613, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} rolesAcceptInviteFromMobilePageViewParams
* @property {string} invite_id - invite_id
* @property {string} inviteToken - token
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Roles - accept invite from mobile page view. src: 5 Evid: 365.
 * Event description: user accepted invite from mobile page view.

 * invite_id - Type: string. Desc: invite_id
 *
 * inviteToken - Type: string. Desc: token
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {rolesAcceptInviteFromMobilePageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rolesAcceptInviteFromMobilePageView = function (params) {
    return { evid: 365, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} email2faSetupEnableSuccessClientParams
* @property {string} platform - null
**/
/**
 * Name: Email 2FA Setup - Enable Success (Client). src: 5 Evid: 1679.
 * Event description: The user successfully enabled 2FA by Email.

 * platform - Type: string.
 * @param {email2faSetupEnableSuccessClientParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var email2faSetupEnableSuccessClient = function (params) {
    return { evid: 1679, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} email2faSetupDisableConfirmParams
* @property {string} platform - null
**/
/**
 * Name: Email 2FA Setup - Disable Confirm. src: 5 Evid: 1681.
 * Event description: The user clicks on "disable" in the disable modal for email 2FA
(confirms disable).

 * platform - Type: string.
 * @param {email2faSetupDisableConfirmParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var email2faSetupDisableConfirm = function (params) {
    return { evid: 1681, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesUserSendInvoiceParams
* @property {boolean} createOrder - create order?
* @property {string} currency - currency
* @property {string} depositType - The optional type of the invoice deposit. Possible values: "FLAT"/"PERCENTAGE".
* @property {number} discountPercentage - discountPercentage
* @property {GUID} instanceId - instance_id
* @property {GUID} invoiceId - invoice_guid
* @property {string} invoiceSource - by app_def_id
* @property {string} invoiceTitle - invoiceTitle
* @property {GUID} msid - msid
* @property {string} origin - create invoice, edit invoice
* @property {string} paymentType - 'one time','recurring'
* @property {string} platform - null
* @property {string} status - Creation form/Draft/Sent/Paid
* @property {number} totalAmountLong - Total amount of the invoice, INTEGER multiplied by 100,000
* @property {GUID} uuid - uuid
**/
/**
 * Name: Invoices - user send invoice. src: 5 Evid: 283.
 * Event description: user send invoice.

 * createOrder - Type: bool. Desc: create order?
 *
 * currency - Type: string. Desc: currency
 *
 * depositType - Type: string. Desc: The optional type of the invoice deposit. Possible values: "FLAT"/"PERCENTAGE".
 *
 * discountPercentage - Type: numeric. Desc: discountPercentage
 *
 * instanceId - Type: guid. Desc: instance_id
 *
 * invoiceId - Type: guid. Desc: invoice_guid
 *
 * invoiceSource - Type: string. Desc: by app_def_id
 *
 * invoiceTitle - Type: string. Desc: invoiceTitle
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: create invoice, edit invoice
 *
 * paymentType - Type: string. Desc: 'one time','recurring'
 *
 * platform - Type: string.
 *
 * status - Type: string. Desc: Creation form/Draft/Sent/Paid
 *
 * totalAmountLong - Type: numeric. Desc: Total amount of the invoice, INTEGER multiplied by 100,000
 *
 * uuid - Type: guid. Desc: uuid
 * @param {invoicesUserSendInvoiceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesUserSendInvoice = function (params) {
    return { evid: 283, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteNavigationParams
* @property {string} link - null
* @property {GUID} msid - null
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: dashboard > site -> navigation. src: 5 Evid: 15.


 * link - Type: string.
 *
 * msid - Type: guid.
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {dashboardSiteNavigationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteNavigation = function (params) {
    return { evid: 15, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesDueDateUpdatingParams
* @property {DateTime} due_date - due_date
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} platform - null
* @property {GUID} uuid - uuid
**/
/**
 * Name: Quotes - Due Date Updating. src: 5 Evid: 463.
 * Event description: Invoice Due Date Updating.

 * due_date - Type: datetime. Desc: due_date
 *
 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 * @param {quotesDueDateUpdatingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesDueDateUpdating = function (params) {
    return { evid: 463, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsQuickGoogleSpreadsheetsRecipeActivationCancelClickParams
* @property {string} buttonName - The name of the button clicked
* @property {GUID} msid - msid
* @property {string} originPage - holds the last page viewed before cancel was clicked
* @property {string} platform - null
**/
/**
 * Name: Automations > Quick Google Spreadsheets Recipe Activation - cancel click. src: 5 Evid: 1724.
 * Event description: All cancel click's in Quick Google Spreadsheets Recipe Activation trigger this event.

 * buttonName - Type: string. Desc: The name of the button clicked
 *
 * msid - Type: guid. Desc: msid
 *
 * originPage - Type: string. Desc: holds the last page viewed before cancel was clicked
 *
 * platform - Type: string.
 * @param {automationsQuickGoogleSpreadsheetsRecipeActivationCancelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsQuickGoogleSpreadsheetsRecipeActivationCancelClick = function (params) {
    return { evid: 1724, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardFinishLoadingAllWidgetsParams
* @property {string} app_id - application id
* @property {string} host_id - host
* @property {string} hosting - dashboard/editor/onboarding
* @property {boolean} is_account_mgr - true/ false
* @property {number} loading_time - loading time of page
* @property {number} loading_time_from_host_load - Loading time from module start loading
* @property {number} loading_time_from_performance_now - loading_time_from_performance_now  when server start to load. the real beginning
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} sub_view - --
* @property {string} view - requested view
**/
/**
 * Name: Hosting Container > finish loading all components. src: 5 Evid: 1736.
 * Event description: The event is sent at the first time all components that started loading have been fully loaded.

 * app_id - Type: string. Desc: application id
 *
 * host_id - Type: string. Desc: host
 *
 * hosting - Type: string. Desc: dashboard/editor/onboarding
 *
 * is_account_mgr - Type: bool. Desc: true/ false
 *
 * loading_time - Type: numeric. Desc: loading time of page
 *
 * loading_time_from_host_load - Type: numeric. Desc: Loading time from module start loading
 *
 * loading_time_from_performance_now - Type: numeric. Desc: loading_time_from_performance_now  when server start to load. the real beginning
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * sub_view - Type: string. Desc: --
 *
 * view - Type: string. Desc: requested view
 * @param {dashboardFinishLoadingAllWidgetsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardFinishLoadingAllWidgets = function (params) {
    return { evid: 1736, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteActivityCenterClickOnArchiveItemParams
* @property {string} action_desc - null
* @property {string} action_url - null
* @property {number} expire - null
* @property {GUID} feed_id - null
* @property {boolean} is_archived - null
* @property {boolean} is_deleted - null
* @property {GUID} item_id - null
* @property {number} items_count - null
* @property {GUID} msid - null
* @property {string} origin - null
* @property {string} platform - null
* @property {string} referral - null
* @property {string} source - null
* @property {number} src - null
* @property {string} type - null
**/
/**
 * Name: dashboard > site -> activity center -> click on archive item. src: 5 Evid: 104.


 * action_desc - Type: string.
 *
 * action_url - Type: string.
 *
 * expire - Type: numeric.
 *
 * feed_id - Type: guid.
 *
 * is_archived - Type: bool.
 *
 * is_deleted - Type: bool.
 *
 * item_id - Type: guid.
 *
 * items_count - Type: numeric.
 *
 * msid - Type: guid.
 *
 * origin - Type: string.
 *
 * platform - Type: string.
 *
 * referral - Type: string.
 *
 * source - Type: string.
 *
 * src - Type: numeric.
 *
 * type - Type: string.
 * @param {dashboardSiteActivityCenterClickOnArchiveItemParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteActivityCenterClickOnArchiveItem = function (params) {
    return { evid: 104, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardTriggersReachStepSaveAndActivatesParams
* @property {string} action - open/close - which action the user did
* @property {string} flowType - flow in which the save happens: {create, edit}
* @property {number} index - the action number when multi action
* @property {boolean} is_auto - window opens automatically/manually
* @property {GUID} msid - msid
* @property {string} origin - deprecated
* @property {string} platform - null
* @property {string} recipe_name - recipe name
* @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
* @property {number} src - deprecated
**/
/**
 * Name: Automations > Reach step choose a time. src: 5 Evid: 208.
 * Event description: open/close choose a time.

 * action - Type: string. Desc: open/close - which action the user did
 *
 * flowType - Type: string. Desc: flow in which the save happens: {create, edit}
 *
 * index - Type: numeric. Desc: the action number when multi action
 *
 * is_auto - Type: bool. Desc: window opens automatically/manually
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: deprecated
 *
 * platform - Type: string.
 *
 * recipe_name - Type: string. Desc: recipe name
 *
 * rule_id - Type: guid. Desc: if this trigger all ready customized, null if it first time customization
 *
 * src - Type: numeric. Desc: deprecated
 * @param {dashboardTriggersReachStepSaveAndActivatesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardTriggersReachStepSaveAndActivates = function (params) {
    return { evid: 208, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} notificationsBrowserStatusParams
* @property {string} notification_id - the notification id
* @property {string} origin - from where the bi was sent
* @property {string} platform - null
* @property {string} state - Browser status: Block / Allow /Default
* @property {boolean} status - Deprecated
**/
/**
 * Name: Notifications -> Browser status. src: 5 Evid: 1388.


 * notification_id - Type: string. Desc: the notification id
 *
 * origin - Type: string. Desc: from where the bi was sent
 *
 * platform - Type: string.
 *
 * state - Type: string. Desc: Browser status: Block / Allow /Default
 *
 * status - Type: bool. Desc: Deprecated
 * @param {notificationsBrowserStatusParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var notificationsBrowserStatus = function (params) {
    return { evid: 1388, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardHoverContributorsPicParams
* @property {string} hosting - MA
* @property {GUID} msid - --
* @property {string} platform - null
**/
/**
 * Name: dashboard > Hover contributors pic. src: 5 Evid: 186.
 * Event description: When a user hovers on contributor pic in dashboard.

 * hosting - Type: string. Desc: MA
 *
 * msid - Type: guid. Desc: --
 *
 * platform - Type: string.
 * @param {dashboardHoverContributorsPicParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardHoverContributorsPic = function (params) {
    return { evid: 186, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationHomePageAutomationTablePreviewAutomationParams
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {boolean} preinstalled - true or false
* @property {GUID} ruleId - rule_id
* @property {string} status - automation current status
* @property {string} type - where the user clicked: ‘button’ / ‘click on row’
**/
/**
 * Name: Automation > home page - automation table - preview automation. src: 5 Evid: 2009.
 * Event description: Automation > home page - automation table - preview automation
the user clicked on the 'preview' button to clicked on item in the automation table.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * preinstalled - Type: bool. Desc: true or false
 *
 * ruleId - Type: guid. Desc: rule_id
 *
 * status - Type: string. Desc: automation current status
 *
 * type - Type: string. Desc: where the user clicked: ‘button’ / ‘click on row’
 * @param {automationHomePageAutomationTablePreviewAutomationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationHomePageAutomationTablePreviewAutomation = function (params) {
    return { evid: 2009, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeInboxViewMessagesParams
* @property {number} countMessages - count_messages
* @property {GUID} msid - null
* @property {string} platform - null
**/
/**
 * Name: CRM Home - inbox - view messages. src: 5 Evid: 1383.
 * Event description: CRM Home - inbox - view messages.

 * countMessages - Type: numeric. Desc: count_messages
 *
 * msid - Type: guid.
 *
 * platform - Type: string.
 * @param {crmHomeInboxViewMessagesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeInboxViewMessages = function (params) {
    return { evid: 1383, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} notificationsEnableToTurnOnOffNotificationsPerChannelParams
* @property {string} channel - desktop/email/ sms/ mobile
* @property {string} group - desktop/ contact form/  subscriber/  becomes a member/requests to be a member
* @property {string} msid - msid
* @property {string} platform - null
* @property {string} section - desktop/general/ wix chat/bookings/...
* @property {boolean} toggle - 1 - on , 0- off
**/
/**
 * Name: Notifications > Enable to turn on/off notifications per channel. src: 5 Evid: 276.
 * Event description: User turned on his desktop notification for the first time for all his sites (actually browser turned on).

 * channel - Type: string. Desc: desktop/email/ sms/ mobile
 *
 * group - Type: string. Desc: desktop/ contact form/  subscriber/  becomes a member/requests to be a member
 *
 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 *
 * section - Type: string. Desc: desktop/general/ wix chat/bookings/...
 *
 * toggle - Type: bool. Desc: 1 - on , 0- off
 * @param {notificationsEnableToTurnOnOffNotificationsPerChannelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var notificationsEnableToTurnOnOffNotificationsPerChannel = function (params) {
    return { evid: 276, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} ssoSettingsChangeActivationStatusParams
* @property {string} action - enable/disable
* @property {boolean} is_mandatory - is SSO mandatory for team member login
* @property {string} platform - null
* @property {GUID} sso_id - sso_id
* @property {string} sso_user_type - DIFM/DIY (is the SSO of type Do It For Me/ Do It Yourself)
**/
/**
 * Name: SSO Settings - Change Activation Status. src: 5 Evid: 1684.
 * Event description: The user enabled or disabled SSO settings.

 * action - Type: string. Desc: enable/disable
 *
 * is_mandatory - Type: bool. Desc: is SSO mandatory for team member login
 *
 * platform - Type: string.
 *
 * sso_id - Type: guid. Desc: sso_id
 *
 * sso_user_type - Type: string. Desc: DIFM/DIY (is the SSO of type Do It For Me/ Do It Yourself)
 * @param {ssoSettingsChangeActivationStatusParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ssoSettingsChangeActivationStatus = function (params) {
    return { evid: 1684, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsGoogleSheetsMatchDataToSheetParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations - google sheets - match data to sheet. src: 5 Evid: 1486.
 * Event description: Automations - google sheets - match data to sheet.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsGoogleSheetsMatchDataToSheetParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsGoogleSheetsMatchDataToSheet = function (params) {
    return { evid: 1486, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesPayInvoiceClick246Params
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} origin - customer for UoU, my invoices for users
* @property {string} paymentType - 'Recurring','One Time'
* @property {string} platform - null
**/
/**
 * Name: Quotes - Pay Invoice Click. src: 5 Evid: 246.
 * Event description: Quotes - Pay Invoice Click.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: customer for UoU, my invoices for users
 *
 * paymentType - Type: string. Desc: 'Recurring','One Time'
 *
 * platform - Type: string.
 * @param {quotesPayInvoiceClick246Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesPayInvoiceClick246 = function (params) {
    return { evid: 246, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesPreviewInvoiceParams
* @property {GUID} invoice_id - invoice guid
* @property {string} invoiceSource - by app_def_id
* @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
* @property {string} msid - msid
* @property {string} origin - my invoices, edit invoice, widget
* @property {string} origin_device - web,native
* @property {string} paymentType - one time, recurring
* @property {string} platform - null
* @property {string} source - from where the invoice open {feed, more-->invoices}
* @property {string} status - Creation form/Draft/Sent/Paid
**/
/**
 * Name: Quotes - Preview invoice -  click on preview button. src: 5 Evid: 422.
 * Event description: preview invoice.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * invoiceSource - Type: string. Desc: by app_def_id
 *
 * invoiceType - Type: string. Desc: ’recurringAutoCharge’/ 'recurring'/ 'one time'
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: my invoices, edit invoice, widget
 *
 * origin_device - Type: string. Desc: web,native
 *
 * paymentType - Type: string. Desc: one time, recurring
 *
 * platform - Type: string.
 *
 * source - Type: string. Desc: from where the invoice open {feed, more-->invoices}
 *
 * status - Type: string. Desc: Creation form/Draft/Sent/Paid
 * @param {quotesPreviewInvoiceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesPreviewInvoice = function (params) {
    return { evid: 422, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesDeleteInvoiceClickParams
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} origin - Preview/my invoices
* @property {string} origin_device - web,native
* @property {string} platform - null
* @property {string} status - Creation form/Draft/Sent/Paid
**/
/**
 * Name: Quotes - Delete invoice click. src: 5 Evid: 430.
 * Event description: delete invoice click.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: Preview/my invoices
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string.
 *
 * status - Type: string. Desc: Creation form/Draft/Sent/Paid
 * @param {quotesDeleteInvoiceClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesDeleteInvoiceClick = function (params) {
    return { evid: 430, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} email2faSetupSendCodeSuccessParams
* @property {string} action - send/resend
* @property {string} platform - null
**/
/**
 * Name: Email 2FA Setup - Send Code Success. src: 5 Evid: 1674.
 * Event description: The code was successfully sent to the user's email after he clicked on send code.

 * action - Type: string. Desc: send/resend
 *
 * platform - Type: string.
 * @param {email2faSetupSendCodeSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var email2faSetupSendCodeSuccess = function (params) {
    return { evid: 1674, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesDeleteTaxPageCancelParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Quotes - Delete tax page - Cancel. src: 5 Evid: 439.
 * Event description: cancel in delete tax page (for every close (cancel, x, background click)).

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {quotesDeleteTaxPageCancelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesDeleteTaxPageCancel = function (params) {
    return { evid: 439, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} apesVersioningUpdateNewVersionParams
* @property {boolean} isPreinstalled - if the automation is pre installed
* @property {GUID} msid - msid
* @property {string} origin - app id
* @property {string} pingTemplateId - pingTemplateId
* @property {string} platform - null
* @property {GUID} ruleId - ruleId
**/
/**
 * Name: APeS - versioning - update new version. src: 5 Evid: 1703.
 * Event description: APeS - versioning - update new version.

 * isPreinstalled - Type: bool. Desc: if the automation is pre installed
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: app id
 *
 * pingTemplateId - Type: string. Desc: pingTemplateId
 *
 * platform - Type: string.
 *
 * ruleId - Type: guid. Desc: ruleId
 * @param {apesVersioningUpdateNewVersionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var apesVersioningUpdateNewVersion = function (params) {
    return { evid: 1703, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardChangeUrlSaveParams
* @property {GUID} msid - site guid
* @property {string} platform - null
**/
/**
 * Name: dashboard> change url -save. src: 5 Evid: 330.
 * Event description: user changed the url and clicked on save  in rename dialog.

 * msid - Type: guid. Desc: site guid
 *
 * platform - Type: string.
 * @param {dashboardChangeUrlSaveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardChangeUrlSave = function (params) {
    return { evid: 330, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} mySitesClickInUnableToMoveSitesToTrashDialogParams
* @property {string} action - cancel/cta
* @property {string} cta - the button actual text/ the url actual title (only in english)
* @property {GUID} msid - the selected site guid, when the action is generic and not related to specific site (exit f.e) send null
* @property {string} origin - my-sites/dashboard
* @property {string} platform - deprecated
**/
/**
 * Name: My Sites - click in Unable to Move Sites to Trash dialog. src: 5 Evid: 2000.


 * action - Type: string. Desc: cancel/cta
 *
 * cta - Type: string. Desc: the button actual text/ the url actual title (only in english)
 *
 * msid - Type: guid. Desc: the selected site guid, when the action is generic and not related to specific site (exit f.e) send null
 *
 * origin - Type: string. Desc: my-sites/dashboard
 *
 * platform - Type: string. Desc: deprecated
 * @param {mySitesClickInUnableToMoveSitesToTrashDialogParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mySitesClickInUnableToMoveSitesToTrashDialog = function (params) {
    return { evid: 2000, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} setupWidgetItemsParams
* @property {string} asset_campaign_guid - dealer placement id
* @property {string} available_items - a list of offering guids that are available in the phase
* @property {string} hosting - ADI/Editor/MA
* @property {string} location - dashboard/sidebar
* @property {GUID} msid - msid
* @property {string} platform - platform
* @property {string} resolved_items - a list of offering guids that were resolved in the phase
* @property {string} setup_location - dashboard/sidebar/popover
* @property {string} skipped_items - a list of offering guids that were skipped in the phase
* @property {string} trigger - normal/hover/click/step-completed
**/
/**
 * Name: Biz Manager - setup widget - OMNI Phase Available in Dashboard. src: 5 Evid: 349.
 * Event description: When a user has an open phase in the dashboard (since they did not complete all tasks in the phase (it is not collapsed), sent each time the user enters the dashboard - home. Following a bug fix, the data is accurate since 25.5.20.

 * asset_campaign_guid - Type: string. Desc: dealer placement id
 *
 * available_items - Type: string. Desc: a list of offering guids that are available in the phase
 *
 * hosting - Type: string. Desc: ADI/Editor/MA
 *
 * location - Type: string. Desc: dashboard/sidebar
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string. Desc: platform
 *
 * resolved_items - Type: string. Desc: a list of offering guids that were resolved in the phase
 *
 * setup_location - Type: string. Desc: dashboard/sidebar/popover
 *
 * skipped_items - Type: string. Desc: a list of offering guids that were skipped in the phase
 *
 * trigger - Type: string. Desc: normal/hover/click/step-completed
 * @param {setupWidgetItemsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var setupWidgetItems = function (params) {
    return { evid: 349, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesEditTaxClickParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Quotes - edit tax click. src: 5 Evid: 436.
 * Event description: edit tax click.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {quotesEditTaxClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesEditTaxClick = function (params) {
    return { evid: 436, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationBannerDisplayCarrouselParams
* @property {GUID} msid - msid
* @property {string} offerIdList - Dealer Offer id list by items order
* @property {string} platform - null
* @property {string} recipeIdList - recipe ids by items order
**/
/**
 * Name: Automation banner display (carrousel). src: 5 Evid: 1260.
 * Event description: Automation banner is displayed on the automation home page.

 * msid - Type: guid. Desc: msid
 *
 * offerIdList - Type: string. Desc: Dealer Offer id list by items order
 *
 * platform - Type: string.
 *
 * recipeIdList - Type: string. Desc: recipe ids by items order
 * @param {automationBannerDisplayCarrouselParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationBannerDisplayCarrousel = function (params) {
    return { evid: 1260, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSelectorClickOnSiteParams
* @property {string} location - the location of the site in the list (0 is first, 1 is second…)
* @property {GUID} msid - metasite id
* @property {GUID} msid_clicked - msid_clicked
* @property {string} page_view - my-sites /dashboard / account settings
* @property {string} platform - null
**/
/**
 * Name: Dashboard > Site  dropdown Click on Site. src: 5 Evid: 1380.
 * Event description: When the user  dropdown in the header on a site in the site selector.

 * location - Type: string. Desc: the location of the site in the list (0 is first, 1 is second…)
 *
 * msid - Type: guid. Desc: metasite id
 *
 * msid_clicked - Type: guid. Desc: msid_clicked
 *
 * page_view - Type: string. Desc: my-sites /dashboard / account settings
 *
 * platform - Type: string.
 * @param {dashboardSiteSelectorClickOnSiteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSelectorClickOnSite = function (params) {
    return { evid: 1380, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} rolesDeleteRoleDeleteClickFailParams
* @property {string} accept_email - accepted email
* @property {string} hosting - MA / Editor
* @property {GUID} msid - msid
* @property {string} origin - name of tab
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: Roles - delete role - delete click fail. src: 5 Evid: 364.
 * Event description: user clicked on 'delete' in the delete role window - fail response.

 * accept_email - Type: string. Desc: accepted email
 *
 * hosting - Type: string. Desc: MA / Editor
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: name of tab
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {rolesDeleteRoleDeleteClickFailParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rolesDeleteRoleDeleteClickFail = function (params) {
    return { evid: 364, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesRecurringClickOnNewRecurringInvoice1587Params
* @property {string} msid - msid
* @property {string} origin - [create new recurring invoice, create first recurring invoice]
* @property {string} platform - null
**/
/**
 * Name: Invoices - recurring- Click on New Recurring Invoice. src: 5 Evid: 1587.
 * Event description: Click on New Recurring Invoice.

 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: [create new recurring invoice, create first recurring invoice]
 *
 * platform - Type: string.
 * @param {invoicesRecurringClickOnNewRecurringInvoice1587Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesRecurringClickOnNewRecurringInvoice1587 = function (params) {
    return { evid: 1587, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} viewFeatureCardParams
* @property {GUID} announcement_id - announcement_id
* @property {number} card_position - position of the announcement
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: New Releases - View feature card. src: 5 Evid: 341.
 * Event description: View is more than 75% of the card and at least 3 seconds. In 3 second I managed to read the header of the announcement.
The event should be fired only once per announcement per sidebar opened (if sidebar is opened again, an announcement that was already viewed can have another view event)..

 * announcement_id - Type: guid. Desc: announcement_id
 *
 * card_position - Type: numeric. Desc: position of the announcement
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {viewFeatureCardParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var viewFeatureCard = function (params) {
    return { evid: 341, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesCreateQuoteSaveDraftClickParams
* @property {string} msid - msid
* @property {string} origin - create quote, edit quote
* @property {string} platform - null
* @property {GUID} quoteId - quote guid
**/
/**
 * Name: Quotes - Create quote - Save draft click. src: 5 Evid: 77.
 * Event description: Create quote - Save draft button click.

 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: create quote, edit quote
 *
 * platform - Type: string.
 *
 * quoteId - Type: guid. Desc: quote guid
 * @param {quotesCreateQuoteSaveDraftClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesCreateQuoteSaveDraftClick = function (params) {
    return { evid: 77, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} ascendCancelWindowApproveCancelParams
* @property {GUID} msid - msid
* @property {string} platform - native or web
* @property {string} premium - premium_id
* @property {string} referralInfo - from where the screen was opened
* @property {string} selection - cancel plan / keep plan
**/
/**
 * Name: Ascend - Cancel Window Approve/Cancel. src: 5 Evid: 1391.
 * Event description: User click on cancel plan or keep alive.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string. Desc: native or web
 *
 * premium - Type: string. Desc: premium_id
 *
 * referralInfo - Type: string. Desc: from where the screen was opened
 *
 * selection - Type: string. Desc: cancel plan / keep plan
 * @param {ascendCancelWindowApproveCancelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ascendCancelWindowApproveCancel = function (params) {
    return { evid: 1391, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesSettingsChangeTabsParams
* @property {string} msid - msid
* @property {string} platform - null
* @property {string} tab - tab name
**/
/**
 * Name: Quotes - Settings - change tabs. src: 5 Evid: 497.
 * Event description: Quotes - Settings - change tabs.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 *
 * tab - Type: string. Desc: tab name
 * @param {quotesSettingsChangeTabsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesSettingsChangeTabs = function (params) {
    return { evid: 497, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardClickToggleSitesListInNavbarParams
* @property {string} action - null
* @property {GUID} msid - null
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: dashboard > click toggle sites list in navbar. src: 5 Evid: 41.


 * action - Type: string.
 *
 * msid - Type: guid.
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {dashboardClickToggleSitesListInNavbarParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardClickToggleSitesListInNavbar = function (params) {
    return { evid: 41, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardCloseConnectDomainPopUpParams
* @property {GUID} msid - null
* @property {string} origin - null
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: dashboard > close connect domain pop-up. src: 5 Evid: 53.


 * msid - Type: guid.
 *
 * origin - Type: string.
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {dashboardCloseConnectDomainPopUpParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardCloseConnectDomainPopUp = function (params) {
    return { evid: 53, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsMoreActionsMyAutomationsParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations > more actions - My Automations. src: 5 Evid: 259.
 * Event description: user click on Send Feedback.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsMoreActionsMyAutomationsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsMoreActionsMyAutomations = function (params) {
    return { evid: 259, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} notificationsClickOnChannelLinkParams
* @property {string} channel - channel section channel section the user clicked on
* @property {boolean} has_settings - Indication if there are settings options for the channel
* @property {string} hosting - MA/editor/ADI
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} url - the url the user is transferred to
**/
/**
 * Name: Notifications > Click on Channel link. src: 5 Evid: 380.
 * Event description: Click on a Channel link via "Set Notifications by Channel" section.

 * channel - Type: string. Desc: channel section channel section the user clicked on
 *
 * has_settings - Type: bool. Desc: Indication if there are settings options for the channel
 *
 * hosting - Type: string. Desc: MA/editor/ADI
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * url - Type: string. Desc: the url the user is transferred to
 * @param {notificationsClickOnChannelLinkParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var notificationsClickOnChannelLink = function (params) {
    return { evid: 380, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} notificationsEnableToTurnOnOffAllSiteNotificationsExpertsParams
* @property {string} msid - msid
* @property {string} platform - null
* @property {boolean} toggle - 1- on , 0- off
**/
/**
 * Name: Notifications > Enable to turn on /off all site notifications (Experts). src: 5 Evid: 275.
 * Event description: expert can enable  / disable all notifications for a specific site.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 *
 * toggle - Type: bool. Desc: 1- on , 0- off
 * @param {notificationsEnableToTurnOnOffAllSiteNotificationsExpertsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var notificationsEnableToTurnOnOffAllSiteNotificationsExperts = function (params) {
    return { evid: 275, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsEditAutomationCloseParams
* @property {string} audience - audience
* @property {string} channels - channels
* @property {string} componentChanged - which component was changed, if more than 1 put as array
* @property {boolean} isEdited - isEdited
* @property {boolean} isVersioning - isVersioning
* @property {GUID} msid - msid
* @property {string} pingTemplateId - pingTemplateId
* @property {string} platform - null
* @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
* @property {boolean} save - is the modal was saved
**/
/**
 * Name: Automations > Edit automation close. src: 5 Evid: 391.
 * Event description: Automations > Edit automation close.

 * audience - Type: string. Desc: audience
 *
 * channels - Type: string. Desc: channels
 *
 * componentChanged - Type: string. Desc: which component was changed, if more than 1 put as array
 *
 * isEdited - Type: bool. Desc: isEdited
 *
 * isVersioning - Type: bool. Desc: isVersioning
 *
 * msid - Type: guid. Desc: msid
 *
 * pingTemplateId - Type: string. Desc: pingTemplateId
 *
 * platform - Type: string.
 *
 * rule_id - Type: guid. Desc: if this trigger all ready customized, null if it first time customization
 *
 * save - Type: bool. Desc: is the modal was saved
 * @param {automationsEditAutomationCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsEditAutomationClose = function (params) {
    return { evid: 391, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} featureWizardTypingBusinessTypeParams
* @property {number} cnt_results - how many results the user sees, 0 for zero matches. (without related)
* @property {string} hosting - dashboard/onboarding/editor
* @property {GUID} msid - --
* @property {string} origin - tag/edit/search
* @property {string} platform - null
* @property {string} sub_category - the last sub-category the site had.
* @property {string} text - searched text. When the results shown from clicking a tag send the event null.
* @property {string} widget_name - on top of which widget the modal is opened
**/
/**
 * Name: Feature Wizard > Typing Business Type. src: 5 Evid: 1226.
 * Event description: When a user is typing the business type.

 * cnt_results - Type: numeric. Desc: how many results the user sees, 0 for zero matches. (without related)
 *
 * hosting - Type: string. Desc: dashboard/onboarding/editor
 *
 * msid - Type: guid. Desc: --
 *
 * origin - Type: string. Desc: tag/edit/search
 *
 * platform - Type: string.
 *
 * sub_category - Type: string. Desc: the last sub-category the site had.
 *
 * text - Type: string. Desc: searched text. When the results shown from clicking a tag send the event null.
 *
 * widget_name - Type: string. Desc: on top of which widget the modal is opened
 * @param {featureWizardTypingBusinessTypeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var featureWizardTypingBusinessType = function (params) {
    return { evid: 1226, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsWebhookV2PayloadStructureParams
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} type - all keys or custom
**/
/**
 * Name: Automations - webhook v2 - payload structure. src: 5 Evid: 1393.
 * Event description: Automations - webhook v2 - payload structure.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * type - Type: string. Desc: all keys or custom
 * @param {automationsWebhookV2PayloadStructureParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsWebhookV2PayloadStructure = function (params) {
    return { evid: 1393, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} analyticsClickOnWidgetButtonsParams
* @property {string} click_name - collapse/expand/customize
* @property {string} hosting - MA/editor/ADI
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Analytics > Click on Widget Buttons. src: 5 Evid: 372.
 * Event description: Click on Widget Buttons.

 * click_name - Type: string. Desc: collapse/expand/customize
 *
 * hosting - Type: string. Desc: MA/editor/ADI
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {analyticsClickOnWidgetButtonsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var analyticsClickOnWidgetButtons = function (params) {
    return { evid: 372, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsHoverOnTheErrorIconParams
* @property {string} errorType - for example: ‘connectZapier’
* @property {GUID} msid - msid
* @property {string} origin - origin
* @property {string} platform - null
* @property {GUID} rule_id - rule_id
**/
/**
 * Name: Automations > hover on the error icon. src: 5 Evid: 8904.
 * Event description: Automations > hover on the error icon.

 * errorType - Type: string. Desc: for example: ‘connectZapier’
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * platform - Type: string.
 *
 * rule_id - Type: guid. Desc: rule_id
 * @param {automationsHoverOnTheErrorIconParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsHoverOnTheErrorIcon = function (params) {
    return { evid: 8904, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} clickOnSuggestionTagsParams
* @property {GUID} msid - msid
* @property {string} origin - page/section (section for widget over home, page for all)
* @property {string} platform - deprecated
* @property {string} tagName - selected tag
**/
/**
 * Name: Click on suggestion tags (suggestion). src: 5 Evid: 8919.
 * Event description: when the user switch between tags.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: page/section (section for widget over home, page for all)
 *
 * platform - Type: string. Desc: deprecated
 *
 * tagName - Type: string. Desc: selected tag
 * @param {clickOnSuggestionTagsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickOnSuggestionTags = function (params) {
    return { evid: 8919, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerSetupProgressBarIsDisplayedParams
* @property {string} asset_campaign_guid - the phase that is displayed to the user (e.g. setup phase)
* @property {number} done_steps - number of done steps in setup
* @property {string} hosting - MA/editor
* @property {GUID} msid - metasite id
* @property {string} platform - null
* @property {number} skipped_steps - number of skipped steps in setup
* @property {number} steps - number of steps in setup
**/
/**
 * Name: Biz Manager - progress bar is displayed. src: 5 Evid: 672.
 * Event description: setup progress bar is displayed in side bar.

 * asset_campaign_guid - Type: string. Desc: the phase that is displayed to the user (e.g. setup phase)
 *
 * done_steps - Type: numeric. Desc: number of done steps in setup
 *
 * hosting - Type: string. Desc: MA/editor
 *
 * msid - Type: guid. Desc: metasite id
 *
 * platform - Type: string.
 *
 * skipped_steps - Type: numeric. Desc: number of skipped steps in setup
 *
 * steps - Type: numeric. Desc: number of steps in setup
 * @param {bizManagerSetupProgressBarIsDisplayedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerSetupProgressBarIsDisplayed = function (params) {
    return { evid: 672, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} sidebarCategoryItemsShown488Params
* @property {string} category_items_list - list of items viewed in the popup menu
* @property {string} disabled - disabled items
* @property {string} hosting - MA/editor/
* @property {GUID} msid - site id
* @property {string} name - the active sidebar item the user hovers on (the unique name)/ click to expand on
* @property {string} origin - tooltip / sidebar
* @property {string} page_view - the page name of the page the user is in (the active page)
* @property {string} platform - --
* @property {string} section_name - deprecated
* @property {string} sidebar_name - the name appears in sidebar
**/
/**
 * Name: Sidebar Navigation > Dropdown is shown. src: 5 Evid: 488.
 * Event description: when a user hovers an item from the sidebar or when click on sidebar to expand and drop down is shown..

 * category_items_list - Type: string. Desc: list of items viewed in the popup menu
 *
 * disabled - Type: string. Desc: disabled items
 *
 * hosting - Type: string. Desc: MA/editor/
 *
 * msid - Type: guid. Desc: site id
 *
 * name - Type: string. Desc: the active sidebar item the user hovers on (the unique name)/ click to expand on
 *
 * origin - Type: string. Desc: tooltip / sidebar
 *
 * page_view - Type: string. Desc: the page name of the page the user is in (the active page)
 *
 * platform - Type: string. Desc: --
 *
 * section_name - Type: string. Desc: deprecated
 *
 * sidebar_name - Type: string. Desc: the name appears in sidebar
 * @param {sidebarCategoryItemsShown488Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sidebarCategoryItemsShown488 = function (params) {
    return { evid: 488, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} transferSiteSiteCanTBeTransferredPopUpViewParams
* @property {string} hosting - MA /Editor
* @property {string} block_from_transfer_reason - null
* @property {GUID} msid - msid
* @property {string} origin - null
* @property {string} platform - null
**/
/**
 * Name: Transfer site - site can't be transferred pop-up view. src: 5 Evid: 1725.
 * Event description: pop-up shown that the site cannot be transferred.

 * hosting - Type: string. Desc: MA /Editor
 *
 * block_from_transfer_reason - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string.
 *
 * platform - Type: string.
 * @param {transferSiteSiteCanTBeTransferredPopUpViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var transferSiteSiteCanTBeTransferredPopUpView = function (params) {
    return { evid: 1725, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeCreateButtonChooseOptionParams
* @property {GUID} msid - msid
* @property {string} option - which option the user choosed
* @property {string} platform - null
* @property {GUID} uuid - uuid
**/
/**
 * Name: CRM Home - create button choose option. src: 5 Evid: 490.
 * Event description: CRM Home - create button choose option.

 * msid - Type: guid. Desc: msid
 *
 * option - Type: string. Desc: which option the user choosed
 *
 * platform - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 * @param {crmHomeCreateButtonChooseOptionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeCreateButtonChooseOption = function (params) {
    return { evid: 490, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerShowUrgentMessagesParams
* @property {string} asset_campaign_guid - ids to be consistent with premium events
* @property {string} asset_campaign_id - ids to be consistent with premium events
* @property {string} hosting - ADI/MA/editor
* @property {GUID} msid - site guid
* @property {string} offering_guid - ids to be consistent with premium events
* @property {string} platform - null
**/
/**
 * Name: Biz Manager - show urgent messages. src: 5 Evid: 593.
 * Event description: show urgent messages.

 * asset_campaign_guid - Type: string. Desc: ids to be consistent with premium events
 *
 * asset_campaign_id - Type: string. Desc: ids to be consistent with premium events
 *
 * hosting - Type: string. Desc: ADI/MA/editor
 *
 * msid - Type: guid. Desc: site guid
 *
 * offering_guid - Type: string. Desc: ids to be consistent with premium events
 *
 * platform - Type: string.
 * @param {bizManagerShowUrgentMessagesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerShowUrgentMessages = function (params) {
    return { evid: 593, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} engageEmailSettingsCancelBackParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Quotes - Settings - delete tax. src: 5 Evid: 544.
 * Event description: Quotes - Settings - delete tax.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {engageEmailSettingsCancelBackParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var engageEmailSettingsCancelBack = function (params) {
    return { evid: 544, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} app2faSetupDisableClickParams
* @property {string} platform - null
**/
/**
 * Name: App 2FA Setup - Disable Click. src: 5 Evid: 1742.


 * platform - Type: string.
 * @param {app2faSetupDisableClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var app2faSetupDisableClick = function (params) {
    return { evid: 1742, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteActivityCenterClickDeleteItemParams
* @property {GUID} feed_id - null
* @property {boolean} is_archived - null
* @property {boolean} is_deleted - null
* @property {GUID} item_id - null
* @property {number} items_count - null
* @property {GUID} msid - null
* @property {string} name - null
* @property {string} origin - null
* @property {string} platform - null
* @property {string} source - null
* @property {number} src - null
* @property {string} type - null
**/
/**
 * Name: dashboard > site -> activity center -> click delete item. src: 5 Evid: 102.


 * feed_id - Type: guid.
 *
 * is_archived - Type: bool.
 *
 * is_deleted - Type: bool.
 *
 * item_id - Type: guid.
 *
 * items_count - Type: numeric.
 *
 * msid - Type: guid.
 *
 * name - Type: string.
 *
 * origin - Type: string.
 *
 * platform - Type: string.
 *
 * source - Type: string.
 *
 * src - Type: numeric.
 *
 * type - Type: string.
 * @param {dashboardSiteActivityCenterClickDeleteItemParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteActivityCenterClickDeleteItem = function (params) {
    return { evid: 102, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSearchParams
* @property {GUID} msid - deprecated
* @property {number} no_of_folders - number of folders
* @property {number} no_of_html_sites - number of html sites
* @property {number} no_of_sites - deprecated
* @property {string} place - where the search took place: site-home, my-sites
* @property {string} platform - null
* @property {string} text - deprecated
* @property {number} src - null
**/
/**
 * Name: dashboard > search. src: 5 Evid: 13.


 * msid - Type: guid. Desc: deprecated
 *
 * no_of_folders - Type: numeric. Desc: number of folders
 *
 * no_of_html_sites - Type: numeric. Desc: number of html sites
 *
 * no_of_sites - Type: numeric. Desc: deprecated
 *
 * place - Type: string. Desc: where the search took place: site-home, my-sites
 *
 * platform - Type: string.
 *
 * text - Type: string. Desc: deprecated
 *
 * src - Type: numeric.
 * @param {dashboardSearchParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSearch = function (params) {
    return { evid: 13, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesCreateInvoiceLeavingCreateInvoicePagePopUpResolutionParams
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} origin - create invoice, edit invoice
* @property {string} platform - platform
* @property {string} source - source
* @property {string} value - save / do not save / X
**/
/**
 * Name: Quotes - Create invoice - Leaving create invoice page pop up- resolution. src: 5 Evid: 1548.
 * Event description: Create invoice - user choose between saving and leaving w/o saving the invoice.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: create invoice, edit invoice
 *
 * platform - Type: string. Desc: platform
 *
 * source - Type: string. Desc: source
 *
 * value - Type: string. Desc: save / do not save / X
 * @param {quotesCreateInvoiceLeavingCreateInvoicePagePopUpResolutionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesCreateInvoiceLeavingCreateInvoicePagePopUpResolution = function (params) {
    return { evid: 1548, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesDateOfIssueUpdatingParams
* @property {DateTime} date_of_issue - date_of_issue
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} platform - null
* @property {GUID} uuid - uuid
**/
/**
 * Name: Quotes - Date of Issue Updating. src: 5 Evid: 464.
 * Event description: Invoice Date of Issue Updating.

 * date_of_issue - Type: datetime. Desc: date_of_issue
 *
 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 * @param {quotesDateOfIssueUpdatingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesDateOfIssueUpdating = function (params) {
    return { evid: 464, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsMissingEmailPhonePartialOnPageParams
* @property {string} actionName - actionName
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} recipeName - recipeName
* @property {GUID} ruleId - ruleId
* @property {string} triggerActivityType - triggerActivityType
**/
/**
 * Name: Automations > missing email/phone - partial on page. src: 5 Evid: 1646.
 * Event description: Automations > missing email/phone - partial on page.

 * actionName - Type: string. Desc: actionName
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * recipeName - Type: string. Desc: recipeName
 *
 * ruleId - Type: guid. Desc: ruleId
 *
 * triggerActivityType - Type: string. Desc: triggerActivityType
 * @param {automationsMissingEmailPhonePartialOnPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsMissingEmailPhonePartialOnPage = function (params) {
    return { evid: 1646, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerBizInfoSaveSuccessParams
* @property {string} category - category of of the new sub-category
* @property {string} fold_name - list of fold names, separated by commas
* @property {string} hosting - MA/editor
* @property {string} industry_id - industry_id of of the new sub-category
* @property {boolean} is_physical_address - true/false
* @property {string} location_details - 0- first location (create), 1-second location (add), 2- third location (add),...
* @property {GUID} msid - metasite id
* @property {string} name - list of fields, separated by commas
* @property {string} origin - app where modal was opened from
* @property {string} page_view - The page where the changes were made (website settings/business info/language and region)
* @property {string} place - place of discard button: header, footer
* @property {string} platform - null
* @property {string} structure_id - structure_id of the new sub-category
* @property {string} sub_category - business type at the end
**/
/**
 * Name: Biz Manager - Biz Info - save success. src: 5 Evid: 553.
 * Event description: changes were saved successfully.

 * category - Type: string. Desc: category of of the new sub-category
 *
 * fold_name - Type: string. Desc: list of fold names, separated by commas
 *
 * hosting - Type: string. Desc: MA/editor
 *
 * industry_id - Type: string. Desc: industry_id of of the new sub-category
 *
 * is_physical_address - Type: bool. Desc: true/false
 *
 * location_details - Type: string. Desc: 0- first location (create), 1-second location (add), 2- third location (add),...
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: list of fields, separated by commas
 *
 * origin - Type: string. Desc: app where modal was opened from
 *
 * page_view - Type: string. Desc: The page where the changes were made (website settings/business info/language and region)
 *
 * place - Type: string. Desc: place of discard button: header, footer
 *
 * platform - Type: string.
 *
 * structure_id - Type: string. Desc: structure_id of the new sub-category
 *
 * sub_category - Type: string. Desc: business type at the end
 * @param {bizManagerBizInfoSaveSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerBizInfoSaveSuccess = function (params) {
    return { evid: 553, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} verticalsEmailNotificationClickedParams
* @property {string} button_name - cta name (in english)
* @property {string} channel - email
* @property {string} contact_id - If the email has been sent to member/contact
* @property {string} deep_link - deep_link
* @property {GUID} msid - msid
* @property {string} notificationid - notification_id
* @property {string} platform - null
* @property {string} template_id - Descriptive name for the type of email. e.g. Identity.Member_Approved
**/
/**
 * Name: Verticals -> email notification -> Clicked. src: 5 Evid: 1272.
 * Event description: When a user clicks on a CTA on a vertical's email notification which doesn't go via Ping!.

 * button_name - Type: string. Desc: cta name (in english)
 *
 * channel - Type: string. Desc: email
 *
 * contact_id - Type: string. Desc: If the email has been sent to member/contact
 *
 * deep_link - Type: string. Desc: deep_link
 *
 * msid - Type: guid. Desc: msid
 *
 * notificationid - Type: string. Desc: notification_id
 *
 * platform - Type: string.
 *
 * template_id - Type: string. Desc: Descriptive name for the type of email. e.g. Identity.Member_Approved
 * @param {verticalsEmailNotificationClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var verticalsEmailNotificationClicked = function (params) {
    return { evid: 1272, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerViewFinishLoadingParams
* @property {string} app_ids - app_ids
* @property {GUID} app_instance_id - --
* @property {string} hosting - ADI/MA/editor
* @property {boolean} initial_load - True if first load
* @property {number} loading_time - loading time of page , sent only if this is first load
* @property {GUID} msid - --
* @property {string} platform - null
* @property {string} prev_sub_view - prev page in app
* @property {string} prev_view - origin view
* @property {string} sub_view - page in app
* @property {string} view - requested view
**/
/**
 * Name: Biz Manager  > View finish loading. src: 5 Evid: 582.
 * Event description: View/Sub View Start loading.

 * app_ids - Type: string. Desc: app_ids
 *
 * app_instance_id - Type: guid. Desc: --
 *
 * hosting - Type: string. Desc: ADI/MA/editor
 *
 * initial_load - Type: bool. Desc: True if first load
 *
 * loading_time - Type: numeric. Desc: loading time of page , sent only if this is first load
 *
 * msid - Type: guid. Desc: --
 *
 * platform - Type: string.
 *
 * prev_sub_view - Type: string. Desc: prev page in app
 *
 * prev_view - Type: string. Desc: origin view
 *
 * sub_view - Type: string. Desc: page in app
 *
 * view - Type: string. Desc: requested view
 * @param {bizManagerViewFinishLoadingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerViewFinishLoading = function (params) {
    return { evid: 582, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} homeAllowBlockBrowserNotificationClickParams
* @property {string} msid - msid
* @property {string} platform - null
* @property {string} user_reply - allow/block/dismiss
**/
/**
 * Name: Home > Allow/Block browser notification click. src: 5 Evid: 255.
 * Event description: User clicks on Allow/Block browser notification setting.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 *
 * user_reply - Type: string. Desc: allow/block/dismiss
 * @param {homeAllowBlockBrowserNotificationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var homeAllowBlockBrowserNotificationClick = function (params) {
    return { evid: 255, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} downloadModalSuccessMessageParams
* @property {string} hosting - Dashboard/editor/ADI
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: download modal success message. src: 5 Evid: 2006.
 * Event description: download modal success message sent.

 * hosting - Type: string. Desc: Dashboard/editor/ADI
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {downloadModalSuccessMessageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var downloadModalSuccessMessage = function (params) {
    return { evid: 2006, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesNonValidPaypalAccountPopupClickLinkParams
* @property {string} link_type - create, upgrade, support
* @property {string} msid - msid
* @property {string} name - name of payment
* @property {string} origin - how user arrived to the flow
* @property {string} platform - null
**/
/**
 * Name: Quotes - Non valid Paypal account popup - Click link. src: 5 Evid: 445.
 * Event description: when a user closes the popup.

 * link_type - Type: string. Desc: create, upgrade, support
 *
 * msid - Type: string. Desc: msid
 *
 * name - Type: string. Desc: name of payment
 *
 * origin - Type: string. Desc: how user arrived to the flow
 *
 * platform - Type: string.
 * @param {quotesNonValidPaypalAccountPopupClickLinkParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesNonValidPaypalAccountPopupClickLink = function (params) {
    return { evid: 445, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsStep2ClickOnLearnMoreParams
* @property {string} button_name - button name
* @property {string} event_name - name of event (action)
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} recipe_name - recipe name
* @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
**/
/**
 * Name: Automations > step 2 > click on learn more. src: 5 Evid: 235.
 * Event description: click on learn more.

 * button_name - Type: string. Desc: button name
 *
 * event_name - Type: string. Desc: name of event (action)
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * recipe_name - Type: string. Desc: recipe name
 *
 * rule_id - Type: guid. Desc: if this trigger all ready customized, null if it first time customization
 * @param {automationsStep2ClickOnLearnMoreParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsStep2ClickOnLearnMore = function (params) {
    return { evid: 235, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsLoyaltyPointsParams
* @property {GUID} msid - msid
* @property {string} origin - origin
* @property {string} platform - null
* @property {number} points - points
* @property {string} recipeName - recipeName
* @property {GUID} ruleId - ruleId
**/
/**
 * Name: Automations - loyalty points. src: 5 Evid: 1585.
 * Event description: Automations - loyalty points.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * platform - Type: string.
 *
 * points - Type: numeric. Desc: points
 *
 * recipeName - Type: string. Desc: recipeName
 *
 * ruleId - Type: guid. Desc: ruleId
 * @param {automationsLoyaltyPointsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsLoyaltyPoints = function (params) {
    return { evid: 1585, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} accountSettingsErrorWhenClickToDisablePartnerDashboardParams
* @property {string} errorReason - Teams/Custom branding
* @property {string} platform - null
**/
/**
 * Name: Account Settings - Error when click to disable Partner Dashboard. src: 5 Evid: 740.
 * Event description: In account setting, the user clicked to disable Partner Dashboard and receive an error because its a teams/custom branding account.

 * errorReason - Type: string. Desc: Teams/Custom branding
 *
 * platform - Type: string.
 * @param {accountSettingsErrorWhenClickToDisablePartnerDashboardParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accountSettingsErrorWhenClickToDisablePartnerDashboard = function (params) {
    return { evid: 740, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} assetViewParams
* @property {string} asset_campaign_guid - Placement Id from dealer
* @property {string} asset_campaign_id - Offering name from dealer
* @property {number} asset_location_from_group_list - item location inside the category
* @property {string} asset_location_on_page - 0,1,2,3 ../hover/bubble (progress bar)
* @property {string} group_id - id of category in setup widget
* @property {string} hosting - ADI/MA/editor
* @property {GUID} item_id - --
* @property {string} item_mode - open , complete,skipped
* @property {GUID} msid - site guid
* @property {string} offering_guid - offer guid
* @property {string} platform - null
* @property {string} premium_badge - the item requires upgrade
* @property {string} promotionAssetType - deprecated
* @property {string} promotion_asset_type - bizMgrNavigation / video / externalUrl
* @property {string} suggestionTags - tag name
* @property {string} visibility_trigger - normal/scrolling to view/ arrow
**/
/**
 * Name: Biz Manager - dashboard asset shown. src: 5 Evid: 590.
 * Event description: what's next asset shown.

 * asset_campaign_guid - Type: string. Desc: Placement Id from dealer
 *
 * asset_campaign_id - Type: string. Desc: Offering name from dealer
 *
 * asset_location_from_group_list - Type: numeric. Desc: item location inside the category
 *
 * asset_location_on_page - Type: string. Desc: 0,1,2,3 ../hover/bubble (progress bar)
 *
 * group_id - Type: string. Desc: id of category in setup widget
 *
 * hosting - Type: string. Desc: ADI/MA/editor
 *
 * item_id - Type: guid. Desc: --
 *
 * item_mode - Type: string. Desc: open , complete,skipped
 *
 * msid - Type: guid. Desc: site guid
 *
 * offering_guid - Type: string. Desc: offer guid
 *
 * platform - Type: string.
 *
 * premium_badge - Type: string. Desc: the item requires upgrade
 *
 * promotionAssetType - Type: string. Desc: deprecated
 *
 * promotion_asset_type - Type: string. Desc: bizMgrNavigation / video / externalUrl
 *
 * suggestionTags - Type: string. Desc: tag name
 *
 * visibility_trigger - Type: string. Desc: normal/scrolling to view/ arrow
 * @param {assetViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var assetView = function (params) {
    return { evid: 590, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesLimit5kCsvDownloadParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Quotes - limit 5K csv download. src: 5 Evid: 738.
 * Event description: Quotes - limit 5K csv download.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {quotesLimit5kCsvDownloadParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesLimit5kCsvDownload = function (params) {
    return { evid: 738, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesWidgetReportsViewReportParams
* @property {GUID} msid - msid
* @property {string} origin - ‘crm home widget/ ‘os-dashboard’
* @property {string} platform - null
**/
/**
 * Name: Invoices - widget - reports - view report. src: 5 Evid: 1327.
 * Event description: Invoices - widget - see all invoices.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: ‘crm home widget/ ‘os-dashboard’
 *
 * platform - Type: string.
 * @param {invoicesWidgetReportsViewReportParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesWidgetReportsViewReport = function (params) {
    return { evid: 1327, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} notificationsClickOnAllSitesTabParams
* @property {string} feed_name - on which tab did he clicked
* @property {string} msid - deprecated
* @property {string} origin - MSID of the site the user is on, my-sites if on Site List. Later on, also account-settings, and other account-level pages.
* @property {string} platform - null
* @property {string} tab_name - deprecated
* @property {string} view - deprecated
**/
/**
 * Name: Notifications > Click on 'all sites' / this site feed. src: 5 Evid: 256.
 * Event description: User clicks navigated between all site / this site tabs.

 * feed_name - Type: string. Desc: on which tab did he clicked
 *
 * msid - Type: string. Desc: deprecated
 *
 * origin - Type: string. Desc: MSID of the site the user is on, my-sites if on Site List. Later on, also account-settings, and other account-level pages.
 *
 * platform - Type: string.
 *
 * tab_name - Type: string. Desc: deprecated
 *
 * view - Type: string. Desc: deprecated
 * @param {notificationsClickOnAllSitesTabParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var notificationsClickOnAllSitesTab = function (params) {
    return { evid: 256, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesSetBusinessInfoModalClickOnCancelParams
* @property {GUID} appDefId - application ID
* @property {string} cancelType - cancel/ close
* @property {string} msid - msid
* @property {string} origin - origin page - from which place this action was made (invoices, contacts full page, crm home...)
* @property {string} platform - null
**/
/**
 * Name: Invoices - Set Business Info Modal - click on cancel. src: 5 Evid: 1465.
 * Event description: Set Business Info Modal - click on cancel.

 * appDefId - Type: guid. Desc: application ID
 *
 * cancelType - Type: string. Desc: cancel/ close
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: origin page - from which place this action was made (invoices, contacts full page, crm home...)
 *
 * platform - Type: string.
 * @param {invoicesSetBusinessInfoModalClickOnCancelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesSetBusinessInfoModalClickOnCancel = function (params) {
    return { evid: 1465, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardTriggersGetTheAppClickFromLearnMoreParams
* @property {GUID} app_id - appid
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: Automations > get the app click (from learn more). src: 5 Evid: 222.
 * Event description: get the app click (from learn more).

 * app_id - Type: guid. Desc: appid
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {dashboardTriggersGetTheAppClickFromLearnMoreParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardTriggersGetTheAppClickFromLearnMore = function (params) {
    return { evid: 222, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} analyticsErrorMessageParams
* @property {string} error_type - type of the error
* @property {string} hosting - MA/editor/ADI
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} widget_name - widget name
**/
/**
 * Name: Widget Loaded Error. src: 5 Evid: 370.
 * Event description: When the user sees an error message on the widgets in the dashboard.

 * error_type - Type: string. Desc: type of the error
 *
 * hosting - Type: string. Desc: MA/editor/ADI
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * widget_name - Type: string. Desc: widget name
 * @param {analyticsErrorMessageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var analyticsErrorMessage = function (params) {
    return { evid: 370, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsFormsChoicesChooseOfSpecificChoicesParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations > forms choices - choose of specific choices. src: 5 Evid: 1695.
 * Event description: Automations > forms choices - choose of specific choices.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsFormsChoicesChooseOfSpecificChoicesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsFormsChoicesChooseOfSpecificChoices = function (params) {
    return { evid: 1695, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardAccountSettingsImageActionSuccessParams
* @property {string} action - {upload, remove}
* @property {string} platform - null
**/
/**
 * Name: dashboard > account settings -> image action success. src: 5 Evid: 46.
 * Event description: image upload / remove success after user chooses action.

 * action - Type: string. Desc: {upload, remove}
 *
 * platform - Type: string.
 * @param {dashboardAccountSettingsImageActionSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardAccountSettingsImageActionSuccess = function (params) {
    return { evid: 46, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} removePhoneNumberPhoneRemovalAskedParams
* @property {string} hashed_phone - hashed phone
* @property {string} platform - null
**/
/**
 * Name: Remove Phone Number - Phone Removal Asked. src: 5 Evid: 99.
 * Event description: After entering a verified password, removing phone process starts.

 * hashed_phone - Type: string. Desc: hashed phone
 *
 * platform - Type: string.
 * @param {removePhoneNumberPhoneRemovalAskedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var removePhoneNumberPhoneRemovalAsked = function (params) {
    return { evid: 99, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesClickIssueDateParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Quotes - click issue date. src: 5 Evid: 385.
 * Event description: Quotes - click issue date.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {quotesClickIssueDateParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesClickIssueDate = function (params) {
    return { evid: 385, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesCreateInvoiceFromQuotes94Params
* @property {boolean} createOrder - create order?
* @property {string} currency - null
* @property {string} depositType - The optional type of the invoice deposit. Possible values: "FLAT"/"PERCENTAGE".
* @property {number} discountPercentage - discountPercentage
* @property {GUID} instanceId - null
* @property {GUID} invoiceId - invoice_guid
* @property {string} invoiceSource - by app_def_id
* @property {string} invoiceTitle - invoiceTitle
* @property {string} msid - msid
* @property {string} origin - null
* @property {string} paymentType - 'one time','recurring'
* @property {string} platform - null
* @property {number} totalAmountLong - Total amount of the invoice, INTEGER multiplied by 100000
* @property {GUID} uuid - uuid
**/
/**
 * Name: Quotes - Create Invoice from Quotes. src: 5 Evid: 94.
 * Event description: user send invoice.

 * createOrder - Type: bool. Desc: create order?
 *
 * currency - Type: string.
 *
 * depositType - Type: string. Desc: The optional type of the invoice deposit. Possible values: "FLAT"/"PERCENTAGE".
 *
 * discountPercentage - Type: numeric. Desc: discountPercentage
 *
 * instanceId - Type: guid.
 *
 * invoiceId - Type: guid. Desc: invoice_guid
 *
 * invoiceSource - Type: string. Desc: by app_def_id
 *
 * invoiceTitle - Type: string. Desc: invoiceTitle
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string.
 *
 * paymentType - Type: string. Desc: 'one time','recurring'
 *
 * platform - Type: string.
 *
 * totalAmountLong - Type: numeric. Desc: Total amount of the invoice, INTEGER multiplied by 100000
 *
 * uuid - Type: guid. Desc: uuid
 * @param {quotesCreateInvoiceFromQuotes94Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesCreateInvoiceFromQuotes94 = function (params) {
    return { evid: 94, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsQuickGoogleSpreadsheetsRecipeActivationChangedGoogleAccountParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations > Quick Google Spreadsheets Recipe Activation - changed google account. src: 5 Evid: 1726.
 * Event description: Triggered when user changes the google account he wants to connect.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsQuickGoogleSpreadsheetsRecipeActivationChangedGoogleAccountParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsQuickGoogleSpreadsheetsRecipeActivationChangedGoogleAccount = function (params) {
    return { evid: 1726, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteClickOnLegalCheckboxInTransferSiteSecondWindowParams
* @property {boolean} check_box - true/false
* @property {string} hosting - ma/editor
* @property {GUID} msid - site id
* @property {string} platform - null
**/
/**
 * Name: dashboard > site -> click on legal checkbox in Transfer Site second window. src: 5 Evid: 49.
 * Event description: legal checkbox on/off.

 * check_box - Type: bool. Desc: true/false
 *
 * hosting - Type: string. Desc: ma/editor
 *
 * msid - Type: guid. Desc: site id
 *
 * platform - Type: string.
 * @param {dashboardSiteClickOnLegalCheckboxInTransferSiteSecondWindowParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteClickOnLegalCheckboxInTransferSiteSecondWindow = function (params) {
    return { evid: 49, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSelectorIsLoadedWithoutScreenshotsParams
* @property {number} loading_time - loading time
* @property {string} page_view - my-sites /dashboard / account settings/partners-dashboard
* @property {string} platform - null
**/
/**
 * Name: Dashboard > Site  dropdown Is Loaded with zero state. src: 5 Evid: 1378.
 * Event description: When the site  dropdown in the header is shown and returns with zero sites.

 * loading_time - Type: numeric. Desc: loading time
 *
 * page_view - Type: string. Desc: my-sites /dashboard / account settings/partners-dashboard
 *
 * platform - Type: string.
 * @param {dashboardSiteSelectorIsLoadedWithoutScreenshotsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSelectorIsLoadedWithoutScreenshots = function (params) {
    return { evid: 1378, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} uouUnsubscribePageViewParams
* @property {string} device - mobile
* @property {GUID} msid - msid
* @property {GUID} notification_Id - notification id of unsubscribe sms
* @property {string} platform - null
* @property {GUID} visitor_id - visitor_id of uou
**/
/**
 * Name: UOU Unsubscribe > Page View. src: 5 Evid: 798.
 * Event description: the page view UOU sees when they click unsubscribe from sms notification.

 * device - Type: string. Desc: mobile
 *
 * msid - Type: guid. Desc: msid
 *
 * notification_Id - Type: guid. Desc: notification id of unsubscribe sms
 *
 * platform - Type: string.
 *
 * visitor_id - Type: guid. Desc: visitor_id of uou
 * @param {uouUnsubscribePageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var uouUnsubscribePageView = function (params) {
    return { evid: 798, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeSuggestionsCarouselClickCtaParams
* @property {string} bannerName - which banner was clicked
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: CRM Home - Suggestions carousel click CTA. src: 5 Evid: 1511.
 * Event description: CRM Home - Suggestions carousel click CTA.

 * bannerName - Type: string. Desc: which banner was clicked
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {crmHomeSuggestionsCarouselClickCtaParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeSuggestionsCarouselClickCta = function (params) {
    return { evid: 1511, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesCreateInvoiceClickOnAddTaxParams
* @property {GUID} invoice_id - invoice guid
* @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
* @property {string} msid - msid
* @property {string} origin - create invoice, edit invoice
* @property {string} platform - deprecated
* @property {string} source - deprecated
**/
/**
 * Name: Quotes - Create invoice - Click on Add Tax. src: 5 Evid: 1543.
 * Event description: Create invoice - user Clicks on Add Tax.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * invoiceType - Type: string. Desc: ’recurringAutoCharge’/ 'recurring'/ 'one time'
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: create invoice, edit invoice
 *
 * platform - Type: string. Desc: deprecated
 *
 * source - Type: string. Desc: deprecated
 * @param {quotesCreateInvoiceClickOnAddTaxParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesCreateInvoiceClickOnAddTax = function (params) {
    return { evid: 1543, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} apesLoadRulesInModalParams
* @property {boolean} isPreinstalled - if the automation is pre installed
* @property {boolean} isVersioning - isVersioning
* @property {GUID} msid - msid
* @property {string} origin - app id
* @property {string} pingTemplateId - pingTemplateId
* @property {string} platform - null
* @property {GUID} ruleId - ruleId
**/
/**
 * Name: APeS - load rules in modal. src: 5 Evid: 1700.
 * Event description: APeS - load rules in modal.

 * isPreinstalled - Type: bool. Desc: if the automation is pre installed
 *
 * isVersioning - Type: bool. Desc: isVersioning
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: app id
 *
 * pingTemplateId - Type: string. Desc: pingTemplateId
 *
 * platform - Type: string.
 *
 * ruleId - Type: guid. Desc: ruleId
 * @param {apesLoadRulesInModalParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var apesLoadRulesInModal = function (params) {
    return { evid: 1700, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} twoFactorAuthenticationSetupEnableClickParams
* @property {string} click_from - security box/main page
* @property {string} origin - account settings page/app modal/email modal/second best
* @property {string} platform - null
**/
/**
 * Name: Phone 2FA Setup - Enable Click. src: 5 Evid: 681.
 * Event description: The user click on 'enable' to enable phone 2fa.

 * click_from - Type: string. Desc: security box/main page
 *
 * origin - Type: string. Desc: account settings page/app modal/email modal/second best
 *
 * platform - Type: string.
 * @param {twoFactorAuthenticationSetupEnableClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var twoFactorAuthenticationSetupEnableClick = function (params) {
    return { evid: 681, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} email2faSetupCodeErrorMessageParams
* @property {number} error_code - error numeric code
* @property {string} error_reason - reason for error message
* @property {string} platform - null
**/
/**
 * Name: Email 2FA Setup - Code Error Message. src: 5 Evid: 1678.
 * Event description: The user sees an error message after entering a code in the email 2fa setup modal.

 * error_code - Type: numeric. Desc: error numeric code
 *
 * error_reason - Type: string. Desc: reason for error message
 *
 * platform - Type: string.
 * @param {email2faSetupCodeErrorMessageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var email2faSetupCodeErrorMessage = function (params) {
    return { evid: 1678, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardAccountSettingsClickLearnMoreInIParams
* @property {string} platform - null
**/
/**
 * Name: dashboard > account settings -> click 'learn more' in i. src: 5 Evid: 67.
 * Event description: user clicks 'learn more' in i.

 * platform - Type: string.
 * @param {dashboardAccountSettingsClickLearnMoreInIParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardAccountSettingsClickLearnMoreInI = function (params) {
    return { evid: 67, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesNewQuoteClickParams
* @property {string} msid - msid
* @property {string} origin - origin page
* @property {GUID} original_quoteId - in case of duplicate: original quote guid
* @property {string} platform - null
* @property {GUID} quoteId - quote_guid
**/
/**
 * Name: Quotes - New Quote click. src: 5 Evid: 65.
 * Event description: Click on create new quote.

 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: origin page
 *
 * original_quoteId - Type: guid. Desc: in case of duplicate: original quote guid
 *
 * platform - Type: string.
 *
 * quoteId - Type: guid. Desc: quote_guid
 * @param {quotesNewQuoteClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesNewQuoteClick = function (params) {
    return { evid: 65, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsFormsChoicesMainOptionsParams
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} type - form,field,choices
**/
/**
 * Name: Automations > forms choices - main options. src: 5 Evid: 1696.
 * Event description: Automations > forms choices - choose of specific choices.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * type - Type: string. Desc: form,field,choices
 * @param {automationsFormsChoicesMainOptionsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsFormsChoicesMainOptions = function (params) {
    return { evid: 1696, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} ascendClickOnUpgradeAscendParams
* @property {string} appName - BM App
* @property {string} button_name - upgrade/upgrade business tools / ascend info / learn more
* @property {GUID} msid - msid
* @property {string} origin - web/native
* @property {string} platform - null
* @property {GUID} uuid - uuid
**/
/**
 * Name: Ascend - Click on Upgrade Ascend. src: 5 Evid: 189.
 * Event description: Click on Upgrade Ascend.

 * appName - Type: string. Desc: BM App
 *
 * button_name - Type: string. Desc: upgrade/upgrade business tools / ascend info / learn more
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: web/native
 *
 * platform - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 * @param {ascendClickOnUpgradeAscendParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ascendClickOnUpgradeAscend = function (params) {
    return { evid: 189, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsMoreActionsClickParams
* @property {GUID} msid - msid
* @property {string} page - my automation / automations
* @property {string} platform - null
**/
/**
 * Name: Automations > more actions click. src: 5 Evid: 258.
 * Event description: user click on the 3 dots icon.

 * msid - Type: guid. Desc: msid
 *
 * page - Type: string. Desc: my automation / automations
 *
 * platform - Type: string.
 * @param {automationsMoreActionsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsMoreActionsClick = function (params) {
    return { evid: 258, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteNewsClickItemParams
* @property {GUID} campaignId - unique identifier of CMS items
* @property {GUID} feed_id - null
* @property {boolean} is_archived - null
* @property {boolean} is_deleted - null
* @property {GUID} item_id - null
* @property {string} lang - null
* @property {GUID} msid - null
* @property {string} name - null
* @property {string} msg_origin - null
* @property {string} origin - null
* @property {string} platform - null
* @property {string} source - null
* @property {number} src - null
* @property {string} title - title of tip
* @property {string} feed_type - null
* @property {string} type - null
* @property {string} url - null
**/
/**
 * Name: dashboard > site -> news -> click item. src: 5 Evid: 19.


 * campaignId - Type: guid. Desc: unique identifier of CMS items
 *
 * feed_id - Type: guid.
 *
 * is_archived - Type: bool.
 *
 * is_deleted - Type: bool.
 *
 * item_id - Type: guid.
 *
 * lang - Type: string.
 *
 * msid - Type: guid.
 *
 * name - Type: string.
 *
 * msg_origin - Type: string.
 *
 * origin - Type: string.
 *
 * platform - Type: string.
 *
 * source - Type: string.
 *
 * src - Type: numeric.
 *
 * title - Type: string. Desc: title of tip
 *
 * feed_type - Type: string.
 *
 * type - Type: string.
 *
 * url - Type: string.
 * @param {dashboardSiteNewsClickItemParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteNewsClickItem = function (params) {
    return { evid: 19, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardTriggersUseThisTriggerClickParams
* @property {string} group_name - group name of recommended triggers
* @property {GUID} msid - msid
* @property {string} multistep - multistep if it's multistep, null if not
* @property {string} origin - origin page
* @property {string} originUrl - originUrl
* @property {string} platform - null
* @property {string} recipe_name - recipe name
* @property {string} referral_info - indicate which vertical is the dacomponent triggered from
* @property {string} section_name - section_name
* @property {number} src - null
**/
/**
 * Name: Automations > Start to create Automation from Recommendation. src: 5 Evid: 201.
 * Event description: Use this trigger click.

 * group_name - Type: string. Desc: group name of recommended triggers
 *
 * msid - Type: guid. Desc: msid
 *
 * multistep - Type: string. Desc: multistep if it's multistep, null if not
 *
 * origin - Type: string. Desc: origin page
 *
 * originUrl - Type: string. Desc: originUrl
 *
 * platform - Type: string.
 *
 * recipe_name - Type: string. Desc: recipe name
 *
 * referral_info - Type: string. Desc: indicate which vertical is the dacomponent triggered from
 *
 * section_name - Type: string. Desc: section_name
 *
 * src - Type: numeric.
 * @param {dashboardTriggersUseThisTriggerClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardTriggersUseThisTriggerClick = function (params) {
    return { evid: 201, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} accountSettingsClickOnManagePreferencesParams
* @property {string} platform - null
**/
/**
 * Name: Account Settings - Manage Preferences. src: 5 Evid: 679.
 * Event description: The user clicks on 'manage preferences' in account settings (redesign).

 * platform - Type: string.
 * @param {accountSettingsClickOnManagePreferencesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accountSettingsClickOnManagePreferences = function (params) {
    return { evid: 679, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsDeleteActionStepParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations > delete action step. src: 5 Evid: 737.
 * Event description: Automations > delete action step.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsDeleteActionStepParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsDeleteActionStep = function (params) {
    return { evid: 737, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} teamManagementPickLogoParams
* @property {string} action_type - replace/remove/add/upload/purchase
* @property {string} platform - null
**/
/**
 * Name: Team management > pick logo. src: 5 Evid: 172.
 * Event description: when a user clicks to add/remove/replace/upload logo in edit team dialog.

 * action_type - Type: string. Desc: replace/remove/add/upload/purchase
 *
 * platform - Type: string.
 * @param {teamManagementPickLogoParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teamManagementPickLogo = function (params) {
    return { evid: 172, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} wixInvoicesRequestPaymentClickInAutomationParams
* @property {string} msid - msid
* @property {string} origin - Chosen app in which this automation was clicked (Now only Bookings)
* @property {string} origin_device - web,native
* @property {string} platform - platform
**/
/**
 * Name: Wix Invoices Request Payment click in Automation. src: 5 Evid: 8958.
 * Event description: Wix Invoices Request Payment click in Automation.

 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: Chosen app in which this automation was clicked (Now only Bookings)
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string. Desc: platform
 * @param {wixInvoicesRequestPaymentClickInAutomationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var wixInvoicesRequestPaymentClickInAutomation = function (params) {
    return { evid: 8958, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSelectorPopupCloseParams
* @property {GUID} msid - site guid
* @property {string} name - popup name
* @property {string} platform - null
* @property {string} siteTypeName - ADI/Editor
**/
/**
 * Name: dashboard > site selector popup close. src: 5 Evid: 82.
 * Event description: when a user closed ADI popup.

 * msid - Type: guid. Desc: site guid
 *
 * name - Type: string. Desc: popup name
 *
 * platform - Type: string.
 *
 * siteTypeName - Type: string. Desc: ADI/Editor
 * @param {dashboardSiteSelectorPopupCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSelectorPopupClose = function (params) {
    return { evid: 82, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesDepositRequestDepositParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Invoices - Deposit - Request Deposit. src: 5 Evid: 1692.
 * Event description: Invoices - Deposit - Request Deposit.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {invoicesDepositRequestDepositParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesDepositRequestDeposit = function (params) {
    return { evid: 1692, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} foldersClickOnCreateNewFolderParams
* @property {string} hosting - MA
* @property {number} nesting_level - 0 (my-sites)/1 (folder) /2/3...
* @property {string} platform - null
* @property {string} source - top-bar/dialog/topbar-folder-dropdown
* @property {string} sub_view - grid / list-view
* @property {string} view - sites-list-enterprise-page/ enterprise-folder-view
* @property {string} view_level - search/filter/folder/root
**/
/**
 * Name: Folders> Click on Create New Folder. src: 5 Evid: 122.
 * Event description: when a user clicks on the 'Create New Folder' button from my-site or dialog.

 * hosting - Type: string. Desc: MA
 *
 * nesting_level - Type: numeric. Desc: 0 (my-sites)/1 (folder) /2/3...
 *
 * platform - Type: string.
 *
 * source - Type: string. Desc: top-bar/dialog/topbar-folder-dropdown
 *
 * sub_view - Type: string. Desc: grid / list-view
 *
 * view - Type: string. Desc: sites-list-enterprise-page/ enterprise-folder-view
 *
 * view_level - Type: string. Desc: search/filter/folder/root
 * @param {foldersClickOnCreateNewFolderParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var foldersClickOnCreateNewFolder = function (params) {
    return { evid: 122, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsScrollHomePageTillTheEndParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations > scroll home page till the end. src: 5 Evid: 146.
 * Event description: scroll home to end of page.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsScrollHomePageTillTheEndParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsScrollHomePageTillTheEnd = function (params) {
    return { evid: 146, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardTriggersSendTriggerTestClickParams
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} recipe_name - recipe name
* @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
* @property {number} src - null
**/
/**
 * Name: Automations > Send Trigger Test Click. src: 5 Evid: 215.
 * Event description: Send Trigger Test Click.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * recipe_name - Type: string. Desc: recipe name
 *
 * rule_id - Type: guid. Desc: if this trigger all ready customized, null if it first time customization
 *
 * src - Type: numeric.
 * @param {dashboardTriggersSendTriggerTestClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardTriggersSendTriggerTestClick = function (params) {
    return { evid: 215, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} teamManagementClickToLearnMoreParams
* @property {string} origin - team_onboarding/team_management_page/team profile dialog/MA/invite_members_dialog
* @property {string} platform - null
**/
/**
 * Name: Team management - click to learn more. src: 5 Evid: 170.
 * Event description: User clicks on 'Learn More'.

 * origin - Type: string. Desc: team_onboarding/team_management_page/team profile dialog/MA/invite_members_dialog
 *
 * platform - Type: string.
 * @param {teamManagementClickToLearnMoreParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teamManagementClickToLearnMore = function (params) {
    return { evid: 170, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizmgrComponentComponentWasShownParams
* @property {string} app_id - The app_id of the page which hosts the component
* @property {string} component_app_id - The app_id of the component
* @property {string} component_id - the Id of the component
* @property {string} component_name - The component name
* @property {string} host_id - the host id (meaningful string - f.e. ‘sidebar’,’settings-lobby’)
* @property {string} hosting - MA/Editor/onboarding
* @property {GUID} msid - msid
* @property {string} platform - platform
* @property {string} state - The expected state of the component -  regular/empty_state/no_permission
* @property {string} sub_view - The sub_view of the hosted page in Bizmgr
* @property {string} view - The view of the hosted page in Bizmgr
**/
/**
 * Name: Bizmgr -> Component -> component was shown. src: 5 Evid: 1462.
 * Event description: Generic loading component event in the Bizmgr- When the component is shown (if it's below the fold it is sent only when the user scrolls down).

 * app_id - Type: string. Desc: The app_id of the page which hosts the component
 *
 * component_app_id - Type: string. Desc: The app_id of the component
 *
 * component_id - Type: string. Desc: the Id of the component
 *
 * component_name - Type: string. Desc: The component name
 *
 * host_id - Type: string. Desc: the host id (meaningful string - f.e. ‘sidebar’,’settings-lobby’)
 *
 * hosting - Type: string. Desc: MA/Editor/onboarding
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string. Desc: platform
 *
 * state - Type: string. Desc: The expected state of the component -  regular/empty_state/no_permission
 *
 * sub_view - Type: string. Desc: The sub_view of the hosted page in Bizmgr
 *
 * view - Type: string. Desc: The view of the hosted page in Bizmgr
 * @param {bizmgrComponentComponentWasShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizmgrComponentComponentWasShown = function (params) {
    return { evid: 1462, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardUserClickedOnContactSNameFromUserActivityParams
* @property {GUID} feed_id - null
* @property {GUID} item_id - null
* @property {GUID} msid - null
* @property {string} name - null
* @property {string} origin - null
* @property {string} platform - null
* @property {string} source - null
* @property {number} src - null
* @property {string} type - null
**/
/**
 * Name: dashboard > user clicked on Contact's name from userActivity. src: 5 Evid: 105.
 * Event description: Click on contact's name in a feed that was added from a TPA due to UoU activity.

 * feed_id - Type: guid.
 *
 * item_id - Type: guid.
 *
 * msid - Type: guid.
 *
 * name - Type: string.
 *
 * origin - Type: string.
 *
 * platform - Type: string.
 *
 * source - Type: string.
 *
 * src - Type: numeric.
 *
 * type - Type: string.
 * @param {dashboardUserClickedOnContactSNameFromUserActivityParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardUserClickedOnContactSNameFromUserActivity = function (params) {
    return { evid: 105, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeIntegrationsFinanceConnectParams
* @property {string} connectTab - which connection the user choose
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: CRM Home - integrations - finance connect. src: 5 Evid: 1116.
 * Event description: CRM Home - integrations - finance connect.

 * connectTab - Type: string. Desc: which connection the user choose
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {crmHomeIntegrationsFinanceConnectParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeIntegrationsFinanceConnect = function (params) {
    return { evid: 1116, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesEditModesEditInvoiceParams
* @property {boolean} hasViewedInvoice - if the uou seen the invoice
* @property {boolean} ifOrderExist - if order exist
* @property {string} invoiceStatus - status of the invoice
* @property {GUID} msid - msid
* @property {string} origin - origin of the invoice
* @property {string} platform - null
**/
/**
 * Name: Invoices - edit modes - edit invoice. src: 5 Evid: 1329.
 * Event description: Invoices - edit invoice.

 * hasViewedInvoice - Type: bool. Desc: if the uou seen the invoice
 *
 * ifOrderExist - Type: bool. Desc: if order exist
 *
 * invoiceStatus - Type: string. Desc: status of the invoice
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin of the invoice
 *
 * platform - Type: string.
 * @param {invoicesEditModesEditInvoiceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesEditModesEditInvoice = function (params) {
    return { evid: 1329, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerSetupWidgetClickCtaAfterShowMessageCompleteParams
* @property {string} asset_campaign_guid - asset_campaign_guid
* @property {string} click_type - click/ close
* @property {string} hosting - ADI/MA/editor
* @property {string} module_id - module name
* @property {GUID} msid - metasite id
* @property {string} origin - light_box/progress_bar_popup
* @property {string} platform - null
**/
/**
 * Name: Biz Manager - setup widget - Click CTA after show message complete. src: 5 Evid: 576.
 * Event description: Click CTA after show message complete.

 * asset_campaign_guid - Type: string. Desc: asset_campaign_guid
 *
 * click_type - Type: string. Desc: click/ close
 *
 * hosting - Type: string. Desc: ADI/MA/editor
 *
 * module_id - Type: string. Desc: module name
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: light_box/progress_bar_popup
 *
 * platform - Type: string.
 * @param {bizManagerSetupWidgetClickCtaAfterShowMessageCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerSetupWidgetClickCtaAfterShowMessageComplete = function (params) {
    return { evid: 576, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} financialServicesSettingsInvoicesClickCardParams
* @property {string} card - which card was clicked
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Financial Services Settings - invoices - click card. src: 5 Evid: 1302.
 * Event description: Financial Services Settings - invoices - click card.

 * card - Type: string. Desc: which card was clicked
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {financialServicesSettingsInvoicesClickCardParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var financialServicesSettingsInvoicesClickCard = function (params) {
    return { evid: 1302, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesMoreActionsClickParams
* @property {string} msid - msid
* @property {string} origin - origin page
* @property {string} platform - null
**/
/**
 * Name: Invoices - More Actions - Click. src: 5 Evid: 193.
 * Event description: Invoices - More Actions - Click.

 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: origin page
 *
 * platform - Type: string.
 * @param {invoicesMoreActionsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesMoreActionsClick = function (params) {
    return { evid: 193, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} apesMoreActionsParams
* @property {boolean} isPreinstalled - if the automation was preinstalled
* @property {GUID} msid - msid
* @property {string} origin - which origin was this action made from
* @property {string} platform - null
* @property {GUID} rule_id - rule id
**/
/**
 * Name: Automations - Widget- more actions. src: 5 Evid: 1236.
 * Event description: APeS - Save edited notification.

 * isPreinstalled - Type: bool. Desc: if the automation was preinstalled
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: which origin was this action made from
 *
 * platform - Type: string.
 *
 * rule_id - Type: guid. Desc: rule id
 * @param {apesMoreActionsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var apesMoreActions = function (params) {
    return { evid: 1236, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerBusinessInfoMergeDialogApproveParams
* @property {string} hosting - MA/editor/ADI
* @property {string} merged_apps - merged app def id, use delimiter "," between each app_id
* @property {GUID} msid - metasite id
* @property {string} platform - null
**/
/**
 * Name: Biz Manager - Business Info Merge Dialog - Approve. src: 5 Evid: 586.
 * Event description: This dialog will alert the user about the change to his settings.
It will be displayed only in case of a conflict (my account and other verticals) in the merge process. This event represents approval of merging.

 * hosting - Type: string. Desc: MA/editor/ADI
 *
 * merged_apps - Type: string. Desc: merged app def id, use delimiter "," between each app_id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * platform - Type: string.
 * @param {bizManagerBusinessInfoMergeDialogApproveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerBusinessInfoMergeDialogApprove = function (params) {
    return { evid: 586, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesCreateInvoiceSaveDraftFailedParams
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} origin - create invoice, edit invoice
* @property {string} platform - null
* @property {string} reason - failure reason
**/
/**
 * Name: Quotes - Create invoice - Save draft failed. src: 5 Evid: 410.
 * Event description: Create invoice - Save draft failed.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: create invoice, edit invoice
 *
 * platform - Type: string.
 *
 * reason - Type: string. Desc: failure reason
 * @param {quotesCreateInvoiceSaveDraftFailedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesCreateInvoiceSaveDraftFailed = function (params) {
    return { evid: 410, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationCloseAscendBannerParams
* @property {GUID} msid - msid
* @property {string} origin - web/native
* @property {string} platform - null
* @property {GUID} uuid - uuid
**/
/**
 * Name: Automation > close Ascend banner. src: 5 Evid: 2011.
 * Event description: Automation > user click on X and close the Ascend banner.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: web/native
 *
 * platform - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 * @param {automationCloseAscendBannerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationCloseAscendBanner = function (params) {
    return { evid: 2011, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSelectorSearchParams
* @property {string} device - mobile / desktop
* @property {string} filtered_by - premium/published/adi / none
* @property {string} platform - null
* @property {string} selectionType - single / multi
* @property {number} site_type_enriched - site_type
* @property {undefined} site_type - HtmlWeb / modal
* @property {string} siteType - HtmlWeb / modal
**/
/**
 * Name: dashboard > site selector search. src: 5 Evid: 1597.
 * Event description: when users searches in site selector.

 * device - Type: string. Desc: mobile / desktop
 *
 * filtered_by - Type: string. Desc: premium/published/adi / none
 *
 * platform - Type: string.
 *
 * selectionType - Type: string. Desc: single / multi
 *
 * site_type_enriched - Type: numeric. Desc: site_type
 *
 * site_type - Type: map. Desc: HtmlWeb / modal
 *
 * siteType - Type: string. Desc: HtmlWeb / modal
 * @param {dashboardSiteSelectorSearchParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSelectorSearch = function (params) {
    return { evid: 1597, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerBizInfoApproveDiscardParams
* @property {string} context - name of modal: discard modal, navigate away modal
* @property {string} hosting - MA/editor
* @property {GUID} msid - metasite id
* @property {string} page_view - hosting: MA/editor/onboarding msid context: name of modal: discard modal, navigate away modal page_view: The page where the changes were made (website settings/business info/language and region)
* @property {string} platform - null
**/
/**
 * Name: Biz Manager - Biz Info - approve discard. src: 5 Evid: 555.
 * Event description: user approves to discard changes in the discard modal
or
user navigates away and doesn't want to keep changes.

 * context - Type: string. Desc: name of modal: discard modal, navigate away modal
 *
 * hosting - Type: string. Desc: MA/editor
 *
 * msid - Type: guid. Desc: metasite id
 *
 * page_view - Type: string. Desc: hosting: MA/editor/onboarding msid context: name of modal: discard modal, navigate away modal page_view: The page where the changes were made (website settings/business info/language and region)
 *
 * platform - Type: string.
 * @param {bizManagerBizInfoApproveDiscardParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerBizInfoApproveDiscard = function (params) {
    return { evid: 555, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} downloadModalErrorMessageParams
* @property {string} hosting - Dashboard/editor/ADI
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: download modal error message. src: 5 Evid: 2007.
 * Event description: download modal error message sent.

 * hosting - Type: string. Desc: Dashboard/editor/ADI
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {downloadModalErrorMessageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var downloadModalErrorMessage = function (params) {
    return { evid: 2007, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} sapir1Params
* @property {string} device - mobile / desktop
* @property {string} errorType - the error type. f.e: Sites failed to load/Site screenshots failed to load
* @property {number} loadingTime - in ms
* @property {string} platform - deprecated
* @property {string} referral - refferral
* @property {string} siteType - HtmlWeb / modal
**/
/**
 * Name: dashboard > Error message is shown in Site Selector. src: 5 Evid: 1748.
 * Event description: When error message is shown in Site Selector.

 * device - Type: string. Desc: mobile / desktop
 *
 * errorType - Type: string. Desc: the error type. f.e: Sites failed to load/Site screenshots failed to load
 *
 * loadingTime - Type: numeric. Desc: in ms
 *
 * platform - Type: string. Desc: deprecated
 *
 * referral - Type: string. Desc: refferral
 *
 * siteType - Type: string. Desc: HtmlWeb / modal
 * @param {sapir1Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sapir1 = function (params) {
    return { evid: 1748, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesSubscriptionViewPaymentsParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Quotes - Subscription - view payments. src: 5 Evid: 389.
 * Event description: Quotes - Subscription - view payments.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {quotesSubscriptionViewPaymentsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesSubscriptionViewPayments = function (params) {
    return { evid: 389, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardCreateNewSiteParams
* @property {string} origin - sites-list-enterprise
* @property {string} platform - deprecated
**/
/**
 * Name: dashboard > create new site. src: 5 Evid: 80.
 * Event description: user adds a new site from different origins (site_list_top, site_list_bottom, top_bar, account_templates), where account_templates = account -> temlpates.

 * origin - Type: string. Desc: sites-list-enterprise
 *
 * platform - Type: string. Desc: deprecated
 * @param {dashboardCreateNewSiteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardCreateNewSite = function (params) {
    return { evid: 80, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardCloseBannerParams
* @property {GUID} msid - msid
* @property {string} name - of banner
* @property {string} origin - where is the banner displayed
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: dashboard > close banner. src: 5 Evid: 36.
 * Event description: send each time user see banner.

 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: of banner
 *
 * origin - Type: string. Desc: where is the banner displayed
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {dashboardCloseBannerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardCloseBanner = function (params) {
    return { evid: 36, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsUserChangeRuleNameParams
* @property {GUID} msid - msid
* @property {string} newName - new rule name
* @property {string} origin - automation table, wizard etc.
* @property {string} platform - null
* @property {string} previousName - previous rule name
* @property {string} recipeName - recipeName
* @property {GUID} ruleId - rule id
**/
/**
 * Name: Automations > user change rule name. src: 5 Evid: 8905.
 * Event description: Automations > user change rule (automation) name.

 * msid - Type: guid. Desc: msid
 *
 * newName - Type: string. Desc: new rule name
 *
 * origin - Type: string. Desc: automation table, wizard etc.
 *
 * platform - Type: string.
 *
 * previousName - Type: string. Desc: previous rule name
 *
 * recipeName - Type: string. Desc: recipeName
 *
 * ruleId - Type: guid. Desc: rule id
 * @param {automationsUserChangeRuleNameParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsUserChangeRuleName = function (params) {
    return { evid: 8905, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesCreateInvoiceAddRemoveDiscountParams
* @property {GUID} invoice_id - invoice guid
* @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
* @property {string} msid - msid
* @property {string} origin - create invoice, edit invoice
* @property {string} platform - platform
* @property {string} source - source
* @property {string} value - add/remove
**/
/**
 * Name: Quotes - Create invoice - Add/Remove Discount. src: 5 Evid: 1546.
 * Event description: Create invoice - user adding or removing discounts.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * invoiceType - Type: string. Desc: ’recurringAutoCharge’/ 'recurring'/ 'one time'
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: create invoice, edit invoice
 *
 * platform - Type: string. Desc: platform
 *
 * source - Type: string. Desc: source
 *
 * value - Type: string. Desc: add/remove
 * @param {quotesCreateInvoiceAddRemoveDiscountParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesCreateInvoiceAddRemoveDiscount = function (params) {
    return { evid: 1546, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesAddDiscountParams
* @property {string} discount - discount percentage
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} platform - null
* @property {GUID} uuid - uuid
**/
/**
 * Name: Quotes - Add Discount. src: 5 Evid: 465.
 * Event description: user finish to add a discount.

 * discount - Type: string. Desc: discount percentage
 *
 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 * @param {quotesAddDiscountParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesAddDiscount = function (params) {
    return { evid: 465, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} financialServicesSettingsInvoicesDefaultsNotesPreviewInvoiceParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Financial Services Settings - invoices - defaults notes - preview invoice. src: 5 Evid: 1309.
 * Event description: Financial Services Settings - invoices - defaults notes - preview invoice.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {financialServicesSettingsInvoicesDefaultsNotesPreviewInvoiceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var financialServicesSettingsInvoicesDefaultsNotesPreviewInvoice = function (params) {
    return { evid: 1309, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesCreateInvoiceToggleRecurringParams
* @property {string} msid - msid
* @property {string} platform - null
* @property {boolean} toggle - true if it's Recurring on, false for oposite
**/
/**
 * Name: Quotes - Create invoice - Toggle Recurring. src: 5 Evid: 480.
 * Event description: Quotes - Create invoice - Toggle Recurring.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 *
 * toggle - Type: bool. Desc: true if it's Recurring on, false for oposite
 * @param {quotesCreateInvoiceToggleRecurringParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesCreateInvoiceToggleRecurring = function (params) {
    return { evid: 480, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesVoidClickParams
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} origin - origin
* @property {string} origin_device - web,native
* @property {string} platform - null
**/
/**
 * Name: Quotes - Void click. src: 5 Evid: 427.
 * Event description: make invoice Void click.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string.
 * @param {quotesVoidClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesVoidClick = function (params) {
    return { evid: 427, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeWorkflowsWidgetUseTemplateParams
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} template - which template the user chosen
**/
/**
 * Name: CRM Home - workflows widget - use template. src: 5 Evid: 852.
 * Event description: CRM Home - workflows widget - use template.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * template - Type: string. Desc: which template the user chosen
 * @param {crmHomeWorkflowsWidgetUseTemplateParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeWorkflowsWidgetUseTemplate = function (params) {
    return { evid: 852, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardTriggersStep1TriggerSelectedParams
* @property {string} event_name - name of event (action)
* @property {string} flowType - flow in which the save happens: {create, edit}
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} recipe_name - recipe name
* @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
* @property {number} src - null
**/
/**
 * Name: Automations > step 1 > trigger selected. src: 5 Evid: 212.
 * Event description: selecting visitor action trigger.

 * event_name - Type: string. Desc: name of event (action)
 *
 * flowType - Type: string. Desc: flow in which the save happens: {create, edit}
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * recipe_name - Type: string. Desc: recipe name
 *
 * rule_id - Type: guid. Desc: if this trigger all ready customized, null if it first time customization
 *
 * src - Type: numeric.
 * @param {dashboardTriggersStep1TriggerSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardTriggersStep1TriggerSelected = function (params) {
    return { evid: 212, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSettingsChangeValueFailureParams
* @property {string} experience - user's experience
* @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
* @property {GUID} msid - msid
* @property {string} name - name of the field that was changed
* @property {string} origin - name of current tab
* @property {string} platform - null
* @property {number} src - null
* @property {string} value - field's value
**/
/**
 * Name: dashboard > site settings > change value failure. src: 5 Evid: 314.
 * Event description: user changed a value in the dashboard > site settings > failed.

 * experience - Type: string. Desc: user's experience
 *
 * hosting - Type: string. Desc: from where user arrived to sitesettings (Editor/MA/...)
 *
 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: name of the field that was changed
 *
 * origin - Type: string. Desc: name of current tab
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 *
 * value - Type: string. Desc: field's value
 * @param {dashboardSiteSettingsChangeValueFailureParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSettingsChangeValueFailure = function (params) {
    return { evid: 314, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeAddNewContactWidgetParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: CRM Home - add new contact widget. src: 5 Evid: 746.
 * Event description: CRM Home - add new contact widget.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {crmHomeAddNewContactWidgetParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeAddNewContactWidget = function (params) {
    return { evid: 746, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsWebhookV2CustomizeStructureSaveParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations - webhook v2 - customize structure - save. src: 5 Evid: 1398.
 * Event description: Automations - webhook v2 - customize structure - save.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsWebhookV2CustomizeStructureSaveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsWebhookV2CustomizeStructureSave = function (params) {
    return { evid: 1398, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeGeneralVideoParams
* @property {GUID} msid - msid
* @property {string} origin - origin of the video
* @property {string} platform - null
**/
/**
 * Name: CRM Home - General Video. src: 5 Evid: 1314.
 * Event description: CRM Home - General Video.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin of the video
 *
 * platform - Type: string.
 * @param {crmHomeGeneralVideoParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeGeneralVideo = function (params) {
    return { evid: 1314, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizmgrComponentLoadingStartParams
* @property {string} app_id - The app_id of the page which hosts the component
* @property {string} component_app_id - The app_id of the component
* @property {string} component_id - the Id of the component
* @property {string} component_name - The component name
* @property {string} component_type - page/widget/modal/sidebar/header
* @property {string} host_id - the host id (meaningful string - f.e. ‘sidebar’,’settings-lobby’)
* @property {string} hosting - MA/Editor/onboarding
* @property {string} hosting_platform - accountmanagr/bizmanagr/devcenter/etc.
* @property {string} hosting_platform_context_id - context id: when the context is site - msid, when the context is app_id (like in devCenter f.e) - appDefId. In account manager is null
* @property {GUID} msid - msid
* @property {string} page_id - the page id, please send always the page_id, no matter what is the type of the component
* @property {string} platform - platform
* @property {string} state - The expected state of the component -  regular/empty_state/no_permission
* @property {string} sub_view - The sub_view of the hosted page in Bizmgr
* @property {string} view - The view of the hosted page in Bizmgr
**/
/**
 * Name: Bizmgr -> Component -> Loading start. src: 5 Evid: 1459.
 * Event description: Generic loading component event in the Bizmgr- When the component start loading.

 * app_id - Type: string. Desc: The app_id of the page which hosts the component
 *
 * component_app_id - Type: string. Desc: The app_id of the component
 *
 * component_id - Type: string. Desc: the Id of the component
 *
 * component_name - Type: string. Desc: The component name
 *
 * component_type - Type: string. Desc: page/widget/modal/sidebar/header
 *
 * host_id - Type: string. Desc: the host id (meaningful string - f.e. ‘sidebar’,’settings-lobby’)
 *
 * hosting - Type: string. Desc: MA/Editor/onboarding
 *
 * hosting_platform - Type: string. Desc: accountmanagr/bizmanagr/devcenter/etc.
 *
 * hosting_platform_context_id - Type: string. Desc: context id: when the context is site - msid, when the context is app_id (like in devCenter f.e) - appDefId. In account manager is null
 *
 * msid - Type: guid. Desc: msid
 *
 * page_id - Type: string. Desc: the page id, please send always the page_id, no matter what is the type of the component
 *
 * platform - Type: string. Desc: platform
 *
 * state - Type: string. Desc: The expected state of the component -  regular/empty_state/no_permission
 *
 * sub_view - Type: string. Desc: The sub_view of the hosted page in Bizmgr
 *
 * view - Type: string. Desc: The view of the hosted page in Bizmgr
 * @param {bizmgrComponentLoadingStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizmgrComponentLoadingStart = function (params) {
    return { evid: 1459, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerSetupWidgetPhaseCompletedParams
* @property {string} asset_campaign_guid - omni setup phase id
* @property {string} hosting - ADI/Editor/MA
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Biz Manager - setup widget - Phase Completed. src: 5 Evid: 169.
 * Event description: When a phase is completed in the OMNI Widget.

 * asset_campaign_guid - Type: string. Desc: omni setup phase id
 *
 * hosting - Type: string. Desc: ADI/Editor/MA
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {bizManagerSetupWidgetPhaseCompletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerSetupWidgetPhaseCompleted = function (params) {
    return { evid: 169, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} email2faSetupEnterCodeParams
* @property {boolean} is_valid - did the user enter the correct code sent to his email
* @property {string} platform - null
**/
/**
 * Name: Email 2FA Setup - Enter code. src: 5 Evid: 1677.
 * Event description: The user clicks on 'ok' in the email 2fa setup modal after entering the 6-digit code he received by email.

 * is_valid - Type: bool. Desc: did the user enter the correct code sent to his email
 *
 * platform - Type: string.
 * @param {email2faSetupEnterCodeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var email2faSetupEnterCode = function (params) {
    return { evid: 1677, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} analyticsClickOnKpiParams
* @property {string} hosting - MA/editor/ADI
* @property {number} kpi_location - 0-left 1-middle 2-right
* @property {string} kpi_name - kpi's name
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Analytics > click on KPI. src: 5 Evid: 373.
 * Event description: click on KPI from Analytics Widget.

 * hosting - Type: string. Desc: MA/editor/ADI
 *
 * kpi_location - Type: numeric. Desc: 0-left 1-middle 2-right
 *
 * kpi_name - Type: string. Desc: kpi's name
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {analyticsClickOnKpiParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var analyticsClickOnKpi = function (params) {
    return { evid: 373, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesCreateInvoiceChangingEmailOfAContactForPaidInvoiceParams
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} origin - create invoice, edit invoice
* @property {string} platform - platform
* @property {string} source - source
* @property {string} value - proceed / cancel / X
**/
/**
 * Name: Quotes - Create invoice - Changing email of a contact for paid invoice. src: 5 Evid: 1554.
 * Event description: Create invoice - user Changing email of a contact for paid invoice - pop up resolution.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: create invoice, edit invoice
 *
 * platform - Type: string. Desc: platform
 *
 * source - Type: string. Desc: source
 *
 * value - Type: string. Desc: proceed / cancel / X
 * @param {quotesCreateInvoiceChangingEmailOfAContactForPaidInvoiceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesCreateInvoiceChangingEmailOfAContactForPaidInvoice = function (params) {
    return { evid: 1554, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsClickOnLearnMoreFromErrorIconParams
* @property {string} errorType - for example: ‘connectZapier’
* @property {GUID} msid - msid
* @property {string} origin - origin
* @property {string} platform - null
* @property {GUID} rule_id - rule_id
**/
/**
 * Name: Automations > click on ‘learn more’ from error icon. src: 5 Evid: 8903.
 * Event description: Automations > click on ‘learn more’ from error icon.

 * errorType - Type: string. Desc: for example: ‘connectZapier’
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * platform - Type: string.
 *
 * rule_id - Type: guid. Desc: rule_id
 * @param {automationsClickOnLearnMoreFromErrorIconParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsClickOnLearnMoreFromErrorIcon = function (params) {
    return { evid: 8903, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} transferSiteReceiverOpenCompleteTransferDialogParams
* @property {string} hosting - MA/Editor
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Transfer site - receiver open complete transfer dialog. src: 5 Evid: 64.
 * Event description: receiver clicked on accept transfer from mail, the dashboard is open and an complete transfer dialog is open.

 * hosting - Type: string. Desc: MA/Editor
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {transferSiteReceiverOpenCompleteTransferDialogParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var transferSiteReceiverOpenCompleteTransferDialog = function (params) {
    return { evid: 64, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} rolesDeleteRoleDeleteClickSuccessParams
* @property {string} accept_email - accepted email
* @property {string} hosting - MA / Editor
* @property {GUID} msid - msid
* @property {string} origin - name of tab
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: Roles - delete role - delete click success. src: 5 Evid: 363.
 * Event description: user clicked on 'delete' in the delete role window - success response.

 * accept_email - Type: string. Desc: accepted email
 *
 * hosting - Type: string. Desc: MA / Editor
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: name of tab
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {rolesDeleteRoleDeleteClickSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rolesDeleteRoleDeleteClickSuccess = function (params) {
    return { evid: 363, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeTopCarouselClickParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: CRM Home - Top carousel click. src: 5 Evid: 1384.
 * Event description: CRM Home - Top carousel click.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {crmHomeTopCarouselClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeTopCarouselClick = function (params) {
    return { evid: 1384, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} notificationsEnableDesktopNotificationsFirstTimeParams
* @property {string} feed_name - All Sites/This Site / settings
* @property {string} msid - deprecated
* @property {string} origin - (Msid/my-site) MSID of the site the user is on, my-sites if on Site List. Later on, also account-settings, and other account-level pages.
* @property {string} platform - null
**/
/**
 * Name: Notifications > Enable Desktop Notifications (first time). src: 5 Evid: 273.
 * Event description: User turned on his desktop notification for the first time for all his sites (actually browser turned on).

 * feed_name - Type: string. Desc: All Sites/This Site / settings
 *
 * msid - Type: string. Desc: deprecated
 *
 * origin - Type: string. Desc: (Msid/my-site) MSID of the site the user is on, my-sites if on Site List. Later on, also account-settings, and other account-level pages.
 *
 * platform - Type: string.
 * @param {notificationsEnableDesktopNotificationsFirstTimeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var notificationsEnableDesktopNotificationsFirstTime = function (params) {
    return { evid: 273, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} accountSettingsForgotPasswordClickParams
* @property {string} platform - null
**/
/**
 * Name: Account Settings - Forgot Password Click. src: 5 Evid: 691.
 * Event description: When a user clicks on "forgot password" in account settings.

 * platform - Type: string.
 * @param {accountSettingsForgotPasswordClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accountSettingsForgotPasswordClick = function (params) {
    return { evid: 691, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardMySitesSiteSelectionPageNumberViewParams
* @property {GUID} msid - msid
* @property {number} no_of_html_sites - number of html sites
* @property {number} no_of_sites - number of sites user have
* @property {number} page_number - פשעק מוצנקר
* @property {string} platform - null
* @property {number} prev_page - previous page
**/
/**
 * Name: dashboard > My Sites - site selection page number view. src: 5 Evid: 152.
 * Event description: my sites selection page.

 * msid - Type: guid. Desc: msid
 *
 * no_of_html_sites - Type: numeric. Desc: number of html sites
 *
 * no_of_sites - Type: numeric. Desc: number of sites user have
 *
 * page_number - Type: numeric. Desc: פשעק מוצנקר
 *
 * platform - Type: string.
 *
 * prev_page - Type: numeric. Desc: previous page
 * @param {dashboardMySitesSiteSelectionPageNumberViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardMySitesSiteSelectionPageNumberView = function (params) {
    return { evid: 152, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} wixInvoicesSavingItemDescriptionParams
* @property {string} msid - msid
* @property {string} origin - create product, edit product
* @property {string} platform - platform
* @property {string} productSource - product source
**/
/**
 * Name: Wix Invoices: Saving Item Description. src: 5 Evid: 8938.
 * Event description: Wix Invoices: Saving Item Description.

 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: create product, edit product
 *
 * platform - Type: string. Desc: platform
 *
 * productSource - Type: string. Desc: product source
 * @param {wixInvoicesSavingItemDescriptionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var wixInvoicesSavingItemDescription = function (params) {
    return { evid: 8938, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsGoogleSheetsChooseSpreadsheetParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations - google sheets - choose spreadsheet. src: 5 Evid: 1485.
 * Event description: Automations - google sheets - choose spreadsheet.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsGoogleSheetsChooseSpreadsheetParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsGoogleSheetsChooseSpreadsheet = function (params) {
    return { evid: 1485, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} accountSettingsOnRequestToUnlockFieldParams
* @property {string} click_from - security box/main page
* @property {string} field_name - username/email address/2FA enable/2FA disable/2FA edit
* @property {string} platform - null
**/
/**
 * Name: Account Settings - OnRequest to Unlock Field. src: 5 Evid: 689.
 * Event description: The user clicks in 'username' or 'email address' fields in account settings  (these fields are locked and the user must enter the account password). Once the user enters the correct password, these fields stay unlocked for the next 5 minutes and this event will not be sent again for those 5 minutes..

 * click_from - Type: string. Desc: security box/main page
 *
 * field_name - Type: string. Desc: username/email address/2FA enable/2FA disable/2FA edit
 *
 * platform - Type: string.
 * @param {accountSettingsOnRequestToUnlockFieldParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accountSettingsOnRequestToUnlockField = function (params) {
    return { evid: 689, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardChangeSiteDisplayNameSaveParams
* @property {GUID} msid - site guid
* @property {string} platform - null
**/
/**
 * Name: dashboard> change site display name - save. src: 5 Evid: 329.
 * Event description: user changed site display name and clicked on save in rename dialog.

 * msid - Type: guid. Desc: site guid
 *
 * platform - Type: string.
 * @param {dashboardChangeSiteDisplayNameSaveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardChangeSiteDisplayNameSave = function (params) {
    return { evid: 329, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesMoreActionsChooseOptionParams
* @property {string} msid - msid
* @property {string} option - 'Products', 'Reports','Accept Payments', 'Invoice Settings','Feedback'
* @property {string} origin - originPage
* @property {string} platform - null
**/
/**
 * Name: Invoices - More Actions - Choose option. src: 5 Evid: 194.
 * Event description: Invoices - More Actions - Choose option.

 * msid - Type: string. Desc: msid
 *
 * option - Type: string. Desc: 'Products', 'Reports','Accept Payments', 'Invoice Settings','Feedback'
 *
 * origin - Type: string. Desc: originPage
 *
 * platform - Type: string.
 * @param {invoicesMoreActionsChooseOptionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesMoreActionsChooseOption = function (params) {
    return { evid: 194, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesEditQuoteParams
* @property {string} msid - msid
* @property {string} origin - my quotes, preview
* @property {string} platform - null
* @property {GUID} quoteId - quote guid
**/
/**
 * Name: Quotes - Edit Quote. src: 5 Evid: 75.
 * Event description: edit quote.

 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: my quotes, preview
 *
 * platform - Type: string.
 *
 * quoteId - Type: guid. Desc: quote guid
 * @param {quotesEditQuoteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesEditQuote = function (params) {
    return { evid: 75, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerShowTooltipParams
* @property {string} app_ids - all apps in dashboard (array)
* @property {string} asset_campaign_guid - when whats next then place
* @property {string} hosting - MA/editor
* @property {boolean} is_hover - true if tooltip shown upon hover
* @property {GUID} msid - metasite id
* @property {string} name - tooltip name
* @property {string} place - where tooltip was shown (sidebar, rename dialog)
* @property {string} platform - null
* @property {string} template_id - ping template id
**/
/**
 * Name: Biz Manager - show tooltip. src: 5 Evid: 583.
 * Event description: tooltip is shown.

 * app_ids - Type: string. Desc: all apps in dashboard (array)
 *
 * asset_campaign_guid - Type: string. Desc: when whats next then place
 *
 * hosting - Type: string. Desc: MA/editor
 *
 * is_hover - Type: bool. Desc: true if tooltip shown upon hover
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: tooltip name
 *
 * place - Type: string. Desc: where tooltip was shown (sidebar, rename dialog)
 *
 * platform - Type: string.
 *
 * template_id - Type: string. Desc: ping template id
 * @param {bizManagerShowTooltipParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerShowTooltip = function (params) {
    return { evid: 583, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerSetupWidgetShowMessageCompleteParams
* @property {string} asset_campaign_guid - id for phase is setup- ids to be consistent with premium events
* @property {string} hosting - ADI/MA/editor
* @property {string} module_id - module name
* @property {GUID} msid - metasite id
* @property {string} origin - light_box/progress_bar_popup
* @property {string} platform - null
* @property {string} sub_view - page in app
* @property {string} view - requested view
**/
/**
 * Name: Biz Manager - setup widget show message complete. src: 5 Evid: 575.
 * Event description: setup widget show message complete.

 * asset_campaign_guid - Type: string. Desc: id for phase is setup- ids to be consistent with premium events
 *
 * hosting - Type: string. Desc: ADI/MA/editor
 *
 * module_id - Type: string. Desc: module name
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: light_box/progress_bar_popup
 *
 * platform - Type: string.
 *
 * sub_view - Type: string. Desc: page in app
 *
 * view - Type: string. Desc: requested view
 * @param {bizManagerSetupWidgetShowMessageCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerSetupWidgetShowMessageComplete = function (params) {
    return { evid: 575, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardTriggersSaveOrUpdateTriggerParams
* @property {string} action_service_name - 'Send email to visitors' / 'Send a chat message' / 'Create a task' / ....
* @property {string} custom_name - custom name
* @property {string} flowType - flow in which the save happens: {create, edit}
* @property {boolean} is_suspended - will be suspended if user don't has Ascend and already has 3 active rules
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} recipe_name - recipe name
* @property {string} referral_info - indicate which vertical is the dacomponent triggered from
* @property {GUID} rule_id - if this trigger already customized, null if it first time customization
* @property {number} src - deprecated
* @property {string} trigger_activity_type - 'Members Area' / 'Contact Form' / 'Price Quotes' / 'Wix Forms' / ...
* @property {string} units - units of rule
* @property {string} value - value of rule
**/
/**
 * Name: Automations > save or update trigger. src: 5 Evid: 209.
 * Event description: Name your recipe click.

 * action_service_name - Type: string. Desc: 'Send email to visitors' / 'Send a chat message' / 'Create a task' / ....
 *
 * custom_name - Type: string. Desc: custom name
 *
 * flowType - Type: string. Desc: flow in which the save happens: {create, edit}
 *
 * is_suspended - Type: bool. Desc: will be suspended if user don't has Ascend and already has 3 active rules
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * recipe_name - Type: string. Desc: recipe name
 *
 * referral_info - Type: string. Desc: indicate which vertical is the dacomponent triggered from
 *
 * rule_id - Type: guid. Desc: if this trigger already customized, null if it first time customization
 *
 * src - Type: numeric. Desc: deprecated
 *
 * trigger_activity_type - Type: string. Desc: 'Members Area' / 'Contact Form' / 'Price Quotes' / 'Wix Forms' / ...
 *
 * units - Type: string. Desc: units of rule
 *
 * value - Type: string. Desc: value of rule
 * @param {dashboardTriggersSaveOrUpdateTriggerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardTriggersSaveOrUpdateTrigger = function (params) {
    return { evid: 209, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsShowSuggestionsBannerToggleParams
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {boolean} show - show or hide suggestions
**/
/**
 * Name: Automations > show suggestions (banner) toggle. src: 5 Evid: 8902.
 * Event description: show  or hide suggestions (carousal banner) toggle.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * show - Type: bool. Desc: show or hide suggestions
 * @param {automationsShowSuggestionsBannerToggleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsShowSuggestionsBannerToggle = function (params) {
    return { evid: 8902, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} wixInvoicesPaymentMethodClickParams
* @property {GUID} appDefId - appDefId of the source
* @property {boolean} fully_paid - true for fully paid selected, false for partial payment selected
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} origin - my invoices,preview
* @property {string} origin_device - web,native
* @property {string} platform - platform
**/
/**
 * Name: Wix Invoices Payment method click. src: 5 Evid: 8956.
 * Event description: Wix Invoices Payment method click in modal.

 * appDefId - Type: guid. Desc: appDefId of the source
 *
 * fully_paid - Type: bool. Desc: true for fully paid selected, false for partial payment selected
 *
 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: my invoices,preview
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string. Desc: platform
 * @param {wixInvoicesPaymentMethodClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var wixInvoicesPaymentMethodClick = function (params) {
    return { evid: 8956, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} notificationsShowMobileDialogParams
* @property {boolean} is_installed_oneapp - true , false
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Notifications > Show Mobile dialog. src: 5 Evid: 277.
 * Event description: allow to enable desktop notifications after clicking on "turn on".

 * is_installed_oneapp - Type: bool. Desc: true , false
 *
 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {notificationsShowMobileDialogParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var notificationsShowMobileDialog = function (params) {
    return { evid: 277, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} errorPageClick295Params
* @property {string} error_location - specifies the location in page: header/sidebar/app/sidepanel etc. includes error type. different for refresh/load types of actions
* @property {string} error_name - null when it's a system error, permissions when the error is permission related (user has no permission for the page)
* @property {string} hosting - --
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Giza - error page click. src: 5 Evid: 295.
 * Event description: When a user clicks on the CTA in the error page.

 * error_location - Type: string. Desc: specifies the location in page: header/sidebar/app/sidepanel etc. includes error type. different for refresh/load types of actions
 *
 * error_name - Type: string. Desc: null when it's a system error, permissions when the error is permission related (user has no permission for the page)
 *
 * hosting - Type: string. Desc: --
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {errorPageClick295Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var errorPageClick295 = function (params) {
    return { evid: 295, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} rolesAddRoleInviteClickSuccessParams
* @property {string} hosting - Editor / MA
* @property {string} invite_email - invited email
* @property {string} invite_role - invited role
* @property {boolean} is_blog_shown - deprecated from 2/6/19 and replaced by roles_displayed field
* @property {GUID} msid - msid
* @property {string} origin - name of tab dashboard/authorization/my sites
* @property {string} platform - null
* @property {string} roles_displayed - list of roles displayed to the user
* @property {number} src - null
**/
/**
 * Name: Roles - add role - invite click success. src: 5 Evid: 353.
 * Event description: user clicked on 'invite' in the add role window - success response.

 * hosting - Type: string. Desc: Editor / MA
 *
 * invite_email - Type: string. Desc: invited email
 *
 * invite_role - Type: string. Desc: invited role
 *
 * is_blog_shown - Type: bool. Desc: deprecated from 2/6/19 and replaced by roles_displayed field
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: name of tab dashboard/authorization/my sites
 *
 * platform - Type: string.
 *
 * roles_displayed - Type: string. Desc: list of roles displayed to the user
 *
 * src - Type: numeric.
 * @param {rolesAddRoleInviteClickSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rolesAddRoleInviteClickSuccess = function (params) {
    return { evid: 353, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} accountSettingsDisableSocialAccountConfirmationModalLoadParams
* @property {string} platform - null
* @property {string} provider_id - the social provider the user tried to disable (apple/google/facebook)
**/
/**
 * Name: Account Settings -  Disable Social Account - Confirmation Modal Load. src: 5 Evid: 1119.
 * Event description: When the user clicks on "disable" Apple social login, and they don't have any other social login connected, he will see a modal with confirmation message.

 * platform - Type: string.
 *
 * provider_id - Type: string. Desc: the social provider the user tried to disable (apple/google/facebook)
 * @param {accountSettingsDisableSocialAccountConfirmationModalLoadParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accountSettingsDisableSocialAccountConfirmationModalLoad = function (params) {
    return { evid: 1119, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesPreviewQuoteParams
* @property {string} msid - msid
* @property {string} origin - my quotes, edit quotes
* @property {string} origin_device - web,native
* @property {string} platform - null
* @property {GUID} quoteId - quote guid
* @property {string} source - from where the quote open {feed, more-->quotes}
**/
/**
 * Name: Quotes - Preview Quote. src: 5 Evid: 76.
 * Event description: preview quote.

 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: my quotes, edit quotes
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string.
 *
 * quoteId - Type: guid. Desc: quote guid
 *
 * source - Type: string. Desc: from where the quote open {feed, more-->quotes}
 * @param {quotesPreviewQuoteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesPreviewQuote = function (params) {
    return { evid: 76, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardTriggersServerSaveOrUpdateTriggerFailedParams
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} recipe_name - recipe_name
* @property {GUID} rule_id - rule
* @property {number} src - null
**/
/**
 * Name: Automations Server > save or update trigger failed. src: 5 Evid: 221.
 * Event description: save or update trigger failed.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * recipe_name - Type: string. Desc: recipe_name
 *
 * rule_id - Type: guid. Desc: rule
 *
 * src - Type: numeric.
 * @param {dashboardTriggersServerSaveOrUpdateTriggerFailedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardTriggersServerSaveOrUpdateTriggerFailed = function (params) {
    return { evid: 221, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} teamManagementAddMembersInviteClickSuccessParams
* @property {string} invite_role - (please note that using the toggle changes role desc) the role the user sends to the invitees
* @property {string} origin - where the dialog is opened from
* @property {string} platform - null
**/
/**
 * Name: Team Management - add members - invite click success. src: 5 Evid: 176.
 * Event description: When a user clicks on 'send invites' in the add member window - success response.

 * invite_role - Type: string. Desc: (please note that using the toggle changes role desc) the role the user sends to the invitees
 *
 * origin - Type: string. Desc: where the dialog is opened from
 *
 * platform - Type: string.
 * @param {teamManagementAddMembersInviteClickSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teamManagementAddMembersInviteClickSuccess = function (params) {
    return { evid: 176, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesPrintInvoice245Params
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} origin - customer for UoU, my invoices for users
* @property {string} paymentType - 'Recurring','One Time'
* @property {string} platform - null
**/
/**
 * Name: Quotes - Print Invoice. src: 5 Evid: 245.
 * Event description: Quotes - Print Invoice.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: customer for UoU, my invoices for users
 *
 * paymentType - Type: string. Desc: 'Recurring','One Time'
 *
 * platform - Type: string.
 * @param {quotesPrintInvoice245Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesPrintInvoice245 = function (params) {
    return { evid: 245, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsAddFollowUpActionClickParams
* @property {number} index - action added index
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations > Add follow up action click. src: 5 Evid: 736.
 * Event description: Automations > Add follow up action click.

 * index - Type: numeric. Desc: action added index
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsAddFollowUpActionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsAddFollowUpActionClick = function (params) {
    return { evid: 736, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsBanner3PresentedMembersChatParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations -> Banner 3 presented - members=>chat. src: 5 Evid: 239.
 * Event description: Automations -> Banner presented - members=>chat.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsBanner3PresentedMembersChatParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsBanner3PresentedMembersChat = function (params) {
    return { evid: 239, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesRemoveProductParams
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} platform - null
* @property {number} product_id - product_id
* @property {GUID} uuid - uuid
**/
/**
 * Name: Quotes - remove Product. src: 5 Evid: 467.
 * Event description: Quotes - remove Product.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 *
 * product_id - Type: numeric. Desc: product_id
 *
 * uuid - Type: guid. Desc: uuid
 * @param {quotesRemoveProductParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesRemoveProduct = function (params) {
    return { evid: 467, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesOwnerappClickOnTabsParams
* @property {string} button_name - most recent / overdue / manage invoices
* @property {string} msid - msid
* @property {string} origin - my invoices, edit invoice, widget
* @property {string} origin_device - web,native
* @property {string} platform - null
**/
/**
 * Name: Invoices - Ownerapp-  click on tabs. src: 5 Evid: 1595.
 * Event description: Click on  tabs in owner app widget.

 * button_name - Type: string. Desc: most recent / overdue / manage invoices
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: my invoices, edit invoice, widget
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string.
 * @param {invoicesOwnerappClickOnTabsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesOwnerappClickOnTabs = function (params) {
    return { evid: 1595, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} rolesEditRoleUpdateClickParams
* @property {string} hosting - Editor / MA
* @property {boolean} is_accepted - true if edit is after invite was accepted
* @property {boolean} is_blog_shown - true if shown (blog manager appears only for sites with blog)
* @property {GUID} msid - msid
* @property {string} new_role - new role
* @property {string} origin - origin page
* @property {string} platform - null
* @property {string} prev_role - previous role
* @property {string} roles_displayed - list of roles displayed to the user
**/
/**
 * Name: Roles - edit role - update click. src: 5 Evid: 367.
 * Event description: user clicked on 'update' in the edit role window - success response.

 * hosting - Type: string. Desc: Editor / MA
 *
 * is_accepted - Type: bool. Desc: true if edit is after invite was accepted
 *
 * is_blog_shown - Type: bool. Desc: true if shown (blog manager appears only for sites with blog)
 *
 * msid - Type: guid. Desc: msid
 *
 * new_role - Type: string. Desc: new role
 *
 * origin - Type: string. Desc: origin page
 *
 * platform - Type: string.
 *
 * prev_role - Type: string. Desc: previous role
 *
 * roles_displayed - Type: string. Desc: list of roles displayed to the user
 * @param {rolesEditRoleUpdateClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rolesEditRoleUpdateClick = function (params) {
    return { evid: 367, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} notificationsDisplayDesktopNotificationsBannerParams
* @property {string} feed_name - All Sites/This Site /Float
* @property {string} origin - (Msid/my-site) MSID of the site the user is on, my-sites if on Site List. Later on, also account-settings, and other account-level pages.
* @property {string} platform - null
**/
/**
 * Name: Notifications > display desktop notifications banner. src: 5 Evid: 280.
 * Event description: display desktop notifications banner.

 * feed_name - Type: string. Desc: All Sites/This Site /Float
 *
 * origin - Type: string. Desc: (Msid/my-site) MSID of the site the user is on, my-sites if on Site List. Later on, also account-settings, and other account-level pages.
 *
 * platform - Type: string.
 * @param {notificationsDisplayDesktopNotificationsBannerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var notificationsDisplayDesktopNotificationsBanner = function (params) {
    return { evid: 280, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} closeTooltipPopUpParams
* @property {GUID} msid - msid
* @property {string} name - New released feature's name
* @property {string} origin - web, mobile
* @property {string} platform - null
**/
/**
 * Name: New Releases - Close tooltip pop up. src: 5 Evid: 339.
 * Event description: Event fires when users closes the tooltip..

 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: New released feature's name
 *
 * origin - Type: string. Desc: web, mobile
 *
 * platform - Type: string.
 * @param {closeTooltipPopUpParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var closeTooltipPopUp = function (params) {
    return { evid: 339, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} financialServicesSettingsInvoicesSettingsClickParams
* @property {GUID} msid - msid
* @property {string} origin - holds the origin of click
* @property {string} platform - null
**/
/**
 * Name: Financial Services Settings - Invoices - Settings click. src: 5 Evid: 1313.
 * Event description: Financial Services Settings - Invoices - Settings click.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: holds the origin of click
 *
 * platform - Type: string.
 * @param {financialServicesSettingsInvoicesSettingsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var financialServicesSettingsInvoicesSettingsClick = function (params) {
    return { evid: 1313, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSettingsSeoClickEnterAddressManuallyParams
* @property {string} experience - user's experience
* @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
* @property {GUID} msid - msid
* @property {string} origin - name of current tab
* @property {string} platform - null
* @property {string} value - Link URL
**/
/**
 * Name: dashboard > site settings > seo > click enter address Manually. src: 5 Evid: 323.
 * Event description: user clicked on a link 'Enter address manually' in SEO section.

 * experience - Type: string. Desc: user's experience
 *
 * hosting - Type: string. Desc: from where user arrived to sitesettings (Editor/MA/...)
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: name of current tab
 *
 * platform - Type: string.
 *
 * value - Type: string. Desc: Link URL
 * @param {dashboardSiteSettingsSeoClickEnterAddressManuallyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSettingsSeoClickEnterAddressManually = function (params) {
    return { evid: 323, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSettingsExperienceDisplayedParams
* @property {string} experience - user's experience
* @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
* @property {GUID} msid - msid
* @property {string} origin - name of previous tab
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: dashboard > site settings > experience displayed. src: 5 Evid: 311.
 * Event description: what is the experience of the user when he sees the page.

 * experience - Type: string. Desc: user's experience
 *
 * hosting - Type: string. Desc: from where user arrived to sitesettings (Editor/MA/...)
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: name of previous tab
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {dashboardSiteSettingsExperienceDisplayedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSettingsExperienceDisplayed = function (params) {
    return { evid: 311, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} clickStartGuideOrCloseDoItWithMeToolParams
* @property {string} msid - msid
* @property {string} origin - origin page - from which place this action was made (Invoice Dashboard/ Invoice Form/Watch Tutorial)
* @property {string} platform - null
* @property {string} type - Start Guide/cancel
**/
/**
 * Name: Click ‘Start Guide’ or ‘Close’ Do it with me tool. src: 5 Evid: 8949.
 * Event description: Start to use ‘Do it with me’ Tool.

 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: origin page - from which place this action was made (Invoice Dashboard/ Invoice Form/Watch Tutorial)
 *
 * platform - Type: string.
 *
 * type - Type: string. Desc: Start Guide/cancel
 * @param {clickStartGuideOrCloseDoItWithMeToolParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickStartGuideOrCloseDoItWithMeTool = function (params) {
    return { evid: 8949, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} apesVersioningSaveAnUpdateErrorParams
* @property {string} errorReason - errorReason
* @property {boolean} isPreinstalled - if the automation is pre installed
* @property {GUID} msid - msid
* @property {string} origin - app id
* @property {string} pingTemplateId - pingTemplateId
* @property {string} platform - null
* @property {GUID} ruleId - ruleId
**/
/**
 * Name: APeS - versioning - save an update - error. src: 5 Evid: 1705.
 * Event description: APeS - versioning - save an update - error.

 * errorReason - Type: string. Desc: errorReason
 *
 * isPreinstalled - Type: bool. Desc: if the automation is pre installed
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: app id
 *
 * pingTemplateId - Type: string. Desc: pingTemplateId
 *
 * platform - Type: string.
 *
 * ruleId - Type: guid. Desc: ruleId
 * @param {apesVersioningSaveAnUpdateErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var apesVersioningSaveAnUpdateError = function (params) {
    return { evid: 1705, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesEditProductClickParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Quotes - Edit product click. src: 5 Evid: 417.
 * Event description: edit product.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {quotesEditProductClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesEditProductClick = function (params) {
    return { evid: 417, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} ascendPagePageNavigationClickParams
* @property {string} category - marketing / customer
* @property {string} item_name - inbox /chat/seo wiz/ coupons etc.
* @property {number} loading_time - loading_time
* @property {string} platform - null
* @property {string} prev_view - prev_view
* @property {string} referral_info - referral_info
**/
/**
 * Name: ascend page - Page navigation - click. src: 5 Evid: 120.
 * Event description: click on one of the items in the page.

 * category - Type: string. Desc: marketing / customer
 *
 * item_name - Type: string. Desc: inbox /chat/seo wiz/ coupons etc.
 *
 * loading_time - Type: numeric. Desc: loading_time
 *
 * platform - Type: string.
 *
 * prev_view - Type: string. Desc: prev_view
 *
 * referral_info - Type: string. Desc: referral_info
 * @param {ascendPagePageNavigationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ascendPagePageNavigationClick = function (params) {
    return { evid: 120, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerFinishLoadingParams
* @property {string} app_id - --
* @property {string} hosting - from where the user opened Biz manager
* @property {boolean} initial_load - first load
* @property {number} loading_time - loading time of page
* @property {GUID} msid - metasite id
* @property {string} platform - null
**/
/**
 * Name: Biz Manager - finish loading. src: 5 Evid: 562.
 * Event description: Biz Manager loaded successfully.

 * app_id - Type: string. Desc: --
 *
 * hosting - Type: string. Desc: from where the user opened Biz manager
 *
 * initial_load - Type: bool. Desc: first load
 *
 * loading_time - Type: numeric. Desc: loading time of page
 *
 * msid - Type: guid. Desc: metasite id
 *
 * platform - Type: string.
 * @param {bizManagerFinishLoadingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerFinishLoading = function (params) {
    return { evid: 562, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesCreateInvoiceEnterItemDescriptionParams
* @property {GUID} invoice_id - invoice guid
* @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
* @property {string} msid - msid
* @property {string} origin - create invoice, edit invoice
* @property {string} platform - platform
**/
/**
 * Name: Quotes - Create invoice - Enter Item Description. src: 5 Evid: 1540.
 * Event description: Create invoice - Enter Item Description.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * invoiceType - Type: string. Desc: ’recurringAutoCharge’/ 'recurring'/ 'one time'
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: create invoice, edit invoice
 *
 * platform - Type: string. Desc: platform
 * @param {quotesCreateInvoiceEnterItemDescriptionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesCreateInvoiceEnterItemDescription = function (params) {
    return { evid: 1540, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} managerFullStoryRecordingStartedParams
* @property {string} full_story_url - FullStory url
* @property {GUID} msid - metasite id
* @property {string} platform - null
**/
/**
 * Name: Biz Manager - FullStory recording started. src: 5 Evid: 588.
 * Event description: FullStory started recording session.

 * full_story_url - Type: string. Desc: FullStory url
 *
 * msid - Type: guid. Desc: metasite id
 *
 * platform - Type: string.
 * @param {managerFullStoryRecordingStartedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var managerFullStoryRecordingStarted = function (params) {
    return { evid: 588, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} rolesAddRoleInviteClickFailParams
* @property {string} error_desc - error description
* @property {string} hosting - MA / Editor
* @property {string} invite_email - invited email, empty if email isn't valid
* @property {string} invite_role - invited role
* @property {GUID} msid - msid
* @property {string} origin - name of tab dashboard/authorization/my sites
* @property {string} platform - null
* @property {string} roles_displayed - list of roles displayed to the user
* @property {number} src - null
**/
/**
 * Name: Roles - add role - invite click fail. src: 5 Evid: 355.
 * Event description: user clicked on 'invite' in the add role window - fail response.

 * error_desc - Type: string. Desc: error description
 *
 * hosting - Type: string. Desc: MA / Editor
 *
 * invite_email - Type: string. Desc: invited email, empty if email isn't valid
 *
 * invite_role - Type: string. Desc: invited role
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: name of tab dashboard/authorization/my sites
 *
 * platform - Type: string.
 *
 * roles_displayed - Type: string. Desc: list of roles displayed to the user
 *
 * src - Type: numeric.
 * @param {rolesAddRoleInviteClickFailParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rolesAddRoleInviteClickFail = function (params) {
    return { evid: 355, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesFirstTimeExpirienceLearnMoreParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Invoices - First time expirience - learn more. src: 5 Evid: 1690.
 * Event description: Invoices - First time expirience - learn more.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {invoicesFirstTimeExpirienceLearnMoreParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesFirstTimeExpirienceLearnMore = function (params) {
    return { evid: 1690, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesMarkAsAccepted93Params
* @property {boolean} createOrder - null
* @property {string} currency - currency
* @property {GUID} instanceId - null
* @property {GUID} invoiceId - null
* @property {string} msid - msid
* @property {string} origin - create invoice, edit invoice
* @property {string} paymentType - 'one time','recurring'
* @property {string} platform - null
* @property {number} totalAmountLong - Total amount of the invoice, INTEGER multiplied by 100000
* @property {GUID} uuid - uuid
**/
/**
 * Name: Quotes - Mark as accepted. src: 5 Evid: 93.
 * Event description: Click on the 'send invoice' button (before the actual sending).

 * createOrder - Type: bool.
 *
 * currency - Type: string. Desc: currency
 *
 * instanceId - Type: guid.
 *
 * invoiceId - Type: guid.
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: create invoice, edit invoice
 *
 * paymentType - Type: string. Desc: 'one time','recurring'
 *
 * platform - Type: string.
 *
 * totalAmountLong - Type: numeric. Desc: Total amount of the invoice, INTEGER multiplied by 100000
 *
 * uuid - Type: guid. Desc: uuid
 * @param {quotesMarkAsAccepted93Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesMarkAsAccepted93 = function (params) {
    return { evid: 93, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} myAccountEditSite715Params
* @property {string} ds_origin - null
* @property {GUID} esi - null
* @property {string} hosting - hosting
* @property {number} src - null
* @property {GUID} msid - null
* @property {string} origin - {site_list_top, site_list_bottom, top_bar, account_templates,...}
* @property {string} place - origin inside page
* @property {string} platform - null
* @property {GUID} site_id - null
* @property {number} site_type_enriched - null
* @property {number} artificial_src - null
**/
/**
 * Name: my account -> Edit site. src: 5 Evid: 71.
 * Event description: events from 5/71 are mapped into 2/71 - don't use!.

 * ds_origin - Type: string.
 *
 * esi - Type: guid.
 *
 * hosting - Type: string. Desc: hosting
 *
 * src - Type: numeric.
 *
 * msid - Type: guid.
 *
 * origin - Type: string. Desc: {site_list_top, site_list_bottom, top_bar, account_templates,...}
 *
 * place - Type: string. Desc: origin inside page
 *
 * platform - Type: string.
 *
 * site_id - Type: guid.
 *
 * site_type_enriched - Type: numeric.
 *
 * artificial_src - Type: numeric.
 * @param {myAccountEditSite715Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var myAccountEditSite715 = function (params) {
    return { evid: 71, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesCancelFromInsideTheInvoiceCreationParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Quotes - Cancel from inside the invoice creation. src: 5 Evid: 483.


 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {quotesCancelFromInsideTheInvoiceCreationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesCancelFromInsideTheInvoiceCreation = function (params) {
    return { evid: 483, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesDepositChooseFlatOrPercentageDepositParams
* @property {string} msid - msid
* @property {string} platform - null
* @property {boolean} toggle - true if it's flat, false if it's percentage
**/
/**
 * Name: Invoices - Deposit - choose flat or percentage deposit. src: 5 Evid: 1693.


 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 *
 * toggle - Type: bool. Desc: true if it's flat, false if it's percentage
 * @param {invoicesDepositChooseFlatOrPercentageDepositParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesDepositChooseFlatOrPercentageDeposit = function (params) {
    return { evid: 1693, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} engageEmailSettingsSaveChangesClickParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Quotes - Settings - edit tax. src: 5 Evid: 542.
 * Event description: Quotes - Settings - edit tax.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {engageEmailSettingsSaveChangesClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var engageEmailSettingsSaveChangesClick = function (params) {
    return { evid: 542, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesDownloadPdfParams
* @property {GUID} invoice_id - invoice guid
* @property {string} invoiceSource - by def_app_id
* @property {string} msid - msid
* @property {string} origin - customer for UoU, my invoices for users
* @property {string} paymentType - 'Recurring','One Time'
* @property {string} platform - null
**/
/**
 * Name: Quotes - Download PDF. src: 5 Evid: 449.
 * Event description: click on save as PDF.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * invoiceSource - Type: string. Desc: by def_app_id
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: customer for UoU, my invoices for users
 *
 * paymentType - Type: string. Desc: 'Recurring','One Time'
 *
 * platform - Type: string.
 * @param {quotesDownloadPdfParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesDownloadPdf = function (params) {
    return { evid: 449, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardTriggersGetTheAppPopUpGoParams
* @property {GUID} app_id - app_id
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} recipe_name - recipe name
* @property {number} src - null
**/
/**
 * Name: Automations > Get the app PopUp Go. src: 5 Evid: 204.
 * Event description: Get the app PopUp Go.

 * app_id - Type: guid. Desc: app_id
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * recipe_name - Type: string. Desc: recipe name
 *
 * src - Type: numeric.
 * @param {dashboardTriggersGetTheAppPopUpGoParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardTriggersGetTheAppPopUpGo = function (params) {
    return { evid: 204, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesCreateInvoiceTaxSelectedParams
* @property {GUID} invoice_id - invoice guid
* @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
* @property {string} msid - msid
* @property {string} origin - create invoice, edit invoice
* @property {string} platform - deprecated
* @property {string} source - deprecated
* @property {string} value - value of tax
**/
/**
 * Name: Quotes - Create invoice - Tax Selected. src: 5 Evid: 1544.
 * Event description: Create invoice - user Clicks on Add Tax.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * invoiceType - Type: string. Desc: ’recurringAutoCharge’/ 'recurring'/ 'one time'
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: create invoice, edit invoice
 *
 * platform - Type: string. Desc: deprecated
 *
 * source - Type: string. Desc: deprecated
 *
 * value - Type: string. Desc: value of tax
 * @param {quotesCreateInvoiceTaxSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesCreateInvoiceTaxSelected = function (params) {
    return { evid: 1544, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} ascendPpThankYouPageParams
* @property {GUID} app_id - app_id
* @property {number} cycleId - cycle id
* @property {string} cycle_name - Cycle bought
* @property {GUID} packageId - package id
* @property {string} package_id - deprecated
* @property {string} package_name - package bought
* @property {string} platform - web/native
* @property {string} type - Page View / Click go to Dashboard
**/
/**
 * Name: Ascend PP - Thank you Page. src: 5 Evid: 191.
 * Event description: Thank you page after purchasing Ascend PP.

 * app_id - Type: guid. Desc: app_id
 *
 * cycleId - Type: numeric. Desc: cycle id
 *
 * cycle_name - Type: string. Desc: Cycle bought
 *
 * packageId - Type: guid. Desc: package id
 *
 * package_id - Type: string. Desc: deprecated
 *
 * package_name - Type: string. Desc: package bought
 *
 * platform - Type: string. Desc: web/native
 *
 * type - Type: string. Desc: Page View / Click go to Dashboard
 * @param {ascendPpThankYouPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ascendPpThankYouPage = function (params) {
    return { evid: 191, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeIntegrationsMarketingViewAllParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: CRM Home - integrations - marketing view all. src: 5 Evid: 860.
 * Event description: CRM Home - integrations - marketing view all.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {crmHomeIntegrationsMarketingViewAllParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeIntegrationsMarketingViewAll = function (params) {
    return { evid: 860, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesGetTheWixAppBannerDisplayedParams
* @property {GUID} msid - msid
* @property {string} name - banner name {get wix app}
* @property {string} platform - null
**/
/**
 * Name: Quotes - Get the Wix app banner displayed. src: 5 Evid: 474.
 * Event description: Get the Wix app banner is displayed in invoices app.

 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: banner name {get wix app}
 *
 * platform - Type: string.
 * @param {quotesGetTheWixAppBannerDisplayedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesGetTheWixAppBannerDisplayed = function (params) {
    return { evid: 474, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeChooseContactFromWidgetParams
* @property {GUID} contactId - contactId
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: CRM Home - choose contact from widget. src: 5 Evid: 747.
 * Event description: CRM Home - choose contact from widget.

 * contactId - Type: guid. Desc: contactId
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {crmHomeChooseContactFromWidgetParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeChooseContactFromWidget = function (params) {
    return { evid: 747, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeWorkflowsWidgetGoToWorkflowsParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: CRM Home - workflows widget - go to workflows. src: 5 Evid: 844.
 * Event description: CRM Home - workflows widget - go to workflows.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {crmHomeWorkflowsWidgetGoToWorkflowsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeWorkflowsWidgetGoToWorkflows = function (params) {
    return { evid: 844, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} generalExposureEventParams
* @property {string} exposure_name - exposure_name
* @property {string} hosting - MA/editor
* @property {string} label_name - A is spec=false , B is spec=true
* @property {GUID} msid - metasite id
* @property {string} platform - null
**/
/**
 * Name: General - Exposure event. src: 5 Evid: 149.
 * Event description: general exposure event . can be used in several cases.

 * exposure_name - Type: string. Desc: exposure_name
 *
 * hosting - Type: string. Desc: MA/editor
 *
 * label_name - Type: string. Desc: A is spec=false , B is spec=true
 *
 * msid - Type: guid. Desc: metasite id
 *
 * platform - Type: string.
 * @param {generalExposureEventParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var generalExposureEvent = function (params) {
    return { evid: 149, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} rolesAddRoleCloseWindowParams
* @property {string} hosting - Editor / MA
* @property {GUID} msid - msid
* @property {string} origin - name of tab dashboard/authorization/my sites
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: Roles - add role - close window. src: 5 Evid: 351.
 * Event description: user closed add role window.

 * hosting - Type: string. Desc: Editor / MA
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: name of tab dashboard/authorization/my sites
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {rolesAddRoleCloseWindowParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rolesAddRoleCloseWindow = function (params) {
    return { evid: 351, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} mobileDashboardCreateNewSiteParams
* @property {string} platform - null
* @property {string} view - siteless/ my-sites
**/
/**
 * Name: Mobile Dashboard > create new site. src: 5 Evid: 108.
 * Event description: when a user creates a new site from the mobile dashboard.

 * platform - Type: string.
 *
 * view - Type: string. Desc: siteless/ my-sites
 * @param {mobileDashboardCreateNewSiteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mobileDashboardCreateNewSite = function (params) {
    return { evid: 108, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} financialServicesSettingsPriceQuotesBusinessDetailsSiteSettingsParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Financial Services Settings - Price Quotes - business details - site settings. src: 5 Evid: 1310.
 * Event description: Financial Services Settings - Price Quotes - business details - site settings.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {financialServicesSettingsPriceQuotesBusinessDetailsSiteSettingsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var financialServicesSettingsPriceQuotesBusinessDetailsSiteSettings = function (params) {
    return { evid: 1310, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteClickCancelBackOnTransferSiteActionWindowParams
* @property {string} hosting - ma/editor
* @property {GUID} msid - --
* @property {string} name - name of quick action (transfer,etc.)
* @property {string} origin - --
* @property {string} stage_process - {transfer_details_summary, transfer_options_select}
* @property {string} platform - null
**/
/**
 * Name: dashboard > site -> click cancel/back on transfer site action window. src: 5 Evid: 47.
 * Event description: when user click on quick action, and then click on cancel when the quick action window is opened.

 * hosting - Type: string. Desc: ma/editor
 *
 * msid - Type: guid. Desc: --
 *
 * name - Type: string. Desc: name of quick action (transfer,etc.)
 *
 * origin - Type: string. Desc: --
 *
 * stage_process - Type: string. Desc: {transfer_details_summary, transfer_options_select}
 *
 * platform - Type: string.
 * @param {dashboardSiteClickCancelBackOnTransferSiteActionWindowParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteClickCancelBackOnTransferSiteActionWindow = function (params) {
    return { evid: 47, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesAddAProductVariantOpenModalParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Invoices - Add a product Variant - open modal. src: 5 Evid: 1209.
 * Event description: Invoices - Add a product Variant - open modal.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {invoicesAddAProductVariantOpenModalParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesAddAProductVariantOpenModal = function (params) {
    return { evid: 1209, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSelectorIsOpenParams
* @property {number} loading_time - loading_time
* @property {GUID} msid - metasite id
* @property {string} page_view - my-sites /dashboard / account settings
* @property {string} platform - null
* @property {string} site_list - a list with all the msids shown to the user, the first item is the first item, second item is the second msid and so on…)
**/
/**
 * Name: Dashboard > Site Dropdown Is Open. src: 5 Evid: 1377.
 * Event description: When the site dropdown in the header is opened successfully (the image is loaded and there is no error).

 * loading_time - Type: numeric. Desc: loading_time
 *
 * msid - Type: guid. Desc: metasite id
 *
 * page_view - Type: string. Desc: my-sites /dashboard / account settings
 *
 * platform - Type: string.
 *
 * site_list - Type: string. Desc: a list with all the msids shown to the user, the first item is the first item, second item is the second msid and so on…)
 * @param {dashboardSiteSelectorIsOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSelectorIsOpen = function (params) {
    return { evid: 1377, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeTopCarouselMainCtaClickParams
* @property {string} bannerName - which banner was clicked
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: CRM Home - Top carousel main CTA click. src: 5 Evid: 1385.
 * Event description: CRM Home - Top carousel main CTA click.

 * bannerName - Type: string. Desc: which banner was clicked
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {crmHomeTopCarouselMainCtaClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeTopCarouselMainCtaClick = function (params) {
    return { evid: 1385, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesRecurringSiteOfClientSelectedParams
* @property {string} clientBillingMsids - Comma separated, the msids of the site associated to a client billing subscription included in the recurring invoice, if exist.
* @property {string} msid - msid
* @property {string} platform - platform
* @property {GUID} uuid - uuid
**/
/**
 * Name: Invoices - Site of client selected. src: 5 Evid: 1652.
 * Event description: Quotes - recurring -  Client selected.

 * clientBillingMsids - Type: string. Desc: Comma separated, the msids of the site associated to a client billing subscription included in the recurring invoice, if exist.
 *
 * msid - Type: string. Desc: msid
 *
 * platform - Type: string. Desc: platform
 *
 * uuid - Type: guid. Desc: uuid
 * @param {invoicesRecurringSiteOfClientSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesRecurringSiteOfClientSelected = function (params) {
    return { evid: 1652, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} notificationsResolveAlertNotificationParams
* @property {string} channel - deprecated
* @property {string} msid - deprecated
* @property {string} notificationid - notificationid
* @property {string} platform - null
* @property {string} resolve_type - resolve/ revoke
* @property {string} template_id - template_id
**/
/**
 * Name: Notifications > Resolve alert notification. src: 5 Evid: 282.
 * Event description: display desktop notifications banner.

 * channel - Type: string. Desc: deprecated
 *
 * msid - Type: string. Desc: deprecated
 *
 * notificationid - Type: string. Desc: notificationid
 *
 * platform - Type: string.
 *
 * resolve_type - Type: string. Desc: resolve/ revoke
 *
 * template_id - Type: string. Desc: template_id
 * @param {notificationsResolveAlertNotificationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var notificationsResolveAlertNotification = function (params) {
    return { evid: 282, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsChooseSpecificServiceOutOfTriggerDropdownParams
* @property {string} conditionKeys - conditionKey
* @property {number} inputLevel - how many dropdowns parents
* @property {string} inputName - the key name of the dropdown
* @property {string} inputType - null
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} triggerApp - trigger vertical / app / TPA
* @property {string} triggerName - triggerName
**/
/**
 * Name: Automations  - Trigger -  user open the condition dropdown. src: 5 Evid: 1514.
 * Event description: Automations - open condition dropdown.

 * conditionKeys - Type: string. Desc: conditionKey
 *
 * inputLevel - Type: numeric. Desc: how many dropdowns parents
 *
 * inputName - Type: string. Desc: the key name of the dropdown
 *
 * inputType - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * triggerApp - Type: string. Desc: trigger vertical / app / TPA
 *
 * triggerName - Type: string. Desc: triggerName
 * @param {automationsChooseSpecificServiceOutOfTriggerDropdownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsChooseSpecificServiceOutOfTriggerDropdown = function (params) {
    return { evid: 1514, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} wixInvoicesBannerToConnectPaymentMethodClickParams
* @property {GUID} msid - msid
* @property {string} name - banner name
* @property {string} origin - origin page, my invoices ( on mobile, when creating from list), create invoice - on web, when creating for the first time
* @property {string} origin_device - web,native
* @property {string} platform - null
**/
/**
 * Name: Wix Invoices - Banner to connect Payment Method click. src: 5 Evid: 8970.
 * Event description: Wix Invoices - Banner to connect Payment Method click.

 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: banner name
 *
 * origin - Type: string. Desc: origin page, my invoices ( on mobile, when creating from list), create invoice - on web, when creating for the first time
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string.
 * @param {wixInvoicesBannerToConnectPaymentMethodClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var wixInvoicesBannerToConnectPaymentMethodClick = function (params) {
    return { evid: 8970, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsGoogleSheetsMatchDataToSheetSaveModalParams
* @property {number} matchedColumnsCount - matchedColumnsCount
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations - google sheets - match data to sheet - save modal. src: 5 Evid: 1487.
 * Event description: Automations - google sheets - match data to sheet - save modal.

 * matchedColumnsCount - Type: numeric. Desc: matchedColumnsCount
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsGoogleSheetsMatchDataToSheetSaveModalParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsGoogleSheetsMatchDataToSheetSaveModal = function (params) {
    return { evid: 1487, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesSettingsNewTaxPageSaveParams
* @property {GUID} invoice_id - invoice guid
* @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
* @property {string} msid - msid
* @property {string} origin - create,edit
* @property {string} platform - null
* @property {string} source - source
**/
/**
 * Name: Quotes - Settings - New tax page - Save. src: 5 Evid: 434.
 * Event description: Settings - New tax page - Save successful.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * invoiceType - Type: string. Desc: ’recurringAutoCharge’/ 'recurring'/ 'one time'
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: create,edit
 *
 * platform - Type: string.
 *
 * source - Type: string. Desc: source
 * @param {quotesSettingsNewTaxPageSaveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesSettingsNewTaxPageSave = function (params) {
    return { evid: 434, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSettingsPageViewParams
* @property {string} alert_sections - json of sections and sub-items that were loaded to settings with the red badge. For example: { ‘Site-details’: ‘connect-domain,compare-plans,get a business email’, ’General’: ‘website settings, business info, language and region’, ‘Ecommerce’: ‘accept payments, store shipping...’ ‘Bookings’:... ‘Communication’:... ... }
* @property {string} alertStatus - If the red badge is shown in the sidebar then "true", if not "false"
* @property {string} available_sections - json of sections and sub-items that were loaded to settings. For example:  { ‘Site-details’: ‘connect-domain,compare-plans,get a business email’, ’General’: ‘website settings, business info, language and region’, ‘Ecommerce’: ‘accept payments, store shipping...’ ‘Bookings’:... ‘Communication’:... ... }
* @property {string} focus_section - section name of the automatic scrolling if null then the page wasn't automated scrolled
* @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
* @property {GUID} msid - msid
* @property {string} name - name of tab
* @property {string} origin - name of previous tab
* @property {string} place - deprecated
* @property {string} platform - null
* @property {string} seen_sections - list of sections the user sees above the fold
* @property {number} src - null
* @property {string} subscriptions - json of sections and sub-items that were loaded to settings in the premium bar
* @property {string} unseen_sections - list of sections that loaded in settings lobby but the user is not seeing in the page loading separated by comma
**/
/**
 * Name: dashboard > site settings > page view. src: 5 Evid: 310.
 * Event description: site settings page view.

 * alert_sections - Type: string. Desc: json of sections and sub-items that were loaded to settings with the red badge. For example: { ‘Site-details’: ‘connect-domain,compare-plans,get a business email’, ’General’: ‘website settings, business info, language and region’, ‘Ecommerce’: ‘accept payments, store shipping...’ ‘Bookings’:... ‘Communication’:... ... }
 *
 * alertStatus - Type: string. Desc: If the red badge is shown in the sidebar then "true", if not "false"
 *
 * available_sections - Type: string. Desc: json of sections and sub-items that were loaded to settings. For example:  { ‘Site-details’: ‘connect-domain,compare-plans,get a business email’, ’General’: ‘website settings, business info, language and region’, ‘Ecommerce’: ‘accept payments, store shipping...’ ‘Bookings’:... ‘Communication’:... ... }
 *
 * focus_section - Type: string. Desc: section name of the automatic scrolling if null then the page wasn't automated scrolled
 *
 * hosting - Type: string. Desc: from where user arrived to sitesettings (Editor/MA/...)
 *
 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: name of tab
 *
 * origin - Type: string. Desc: name of previous tab
 *
 * place - Type: string. Desc: deprecated
 *
 * platform - Type: string.
 *
 * seen_sections - Type: string. Desc: list of sections the user sees above the fold
 *
 * src - Type: numeric.
 *
 * subscriptions - Type: string. Desc: json of sections and sub-items that were loaded to settings in the premium bar
 *
 * unseen_sections - Type: string. Desc: list of sections that loaded in settings lobby but the user is not seeing in the page loading separated by comma
 * @param {dashboardSiteSettingsPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSettingsPageView = function (params) {
    return { evid: 310, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardAccountSettingsClickSendConfirmationParams
* @property {string} platform - null
**/
/**
 * Name: dashboard > account settings -> click 'send confirmation'. src: 5 Evid: 68.
 * Event description: user click send confirmation in account settings.

 * platform - Type: string.
 * @param {dashboardAccountSettingsClickSendConfirmationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardAccountSettingsClickSendConfirmation = function (params) {
    return { evid: 68, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardFinishLoadingParams
* @property {string} app_id - application id
* @property {string} app_ids - all applications installed on Biz Mgr
* @property {string} hosting - dashboard/editor/onboarding
* @property {boolean} initial_load - intial load
* @property {boolean} is_account_mgr - true/ false
* @property {boolean} is_biz_mgr - true if page is loaded when Biz mgr is active
* @property {boolean} is_pro - not in use
* @property {number} loading_time - loading time of page (from 300 )
* @property {number} loading_time_from_first_interaction - loading_time_from_first_interaction (309)
* @property {number} loading_time_from_module - Loading time from module start loading (from 564)
* @property {number} loading_time_from_performance_now - loading_time_from_performance_now  when server start to load. the real beginning
* @property {number} loading_time_from_start - loading time from start loading Bizmgr (from 561)
* @property {string} module_id - *not in use*
* @property {GUID} msid - null
* @property {string} origin - origin
* @property {string} origin_app_id - origin_app_id (what app opened the bizmgr)
* @property {string} pageComponentId - the page component id, will be reliable only when page has an entry point from sidebar. was added on 22/08/22
* @property {string} platform - null
* @property {string} prevPageComponentId - the previous page component id, will be reliable only when page has an entry point from sidebar.
* @property {string} prev_sub_view - previous sub view
* @property {string} prev_view - origin view
* @property {string} referral_info - specific button triggered the the view loading
* @property {number} screen_height - screen height
* @property {number} screen_width - screen width
* @property {number} src - null
* @property {string} sub_view - --
* @property {string} view - requested view
* @property {string} view_mode - grid/list-view
* @property {number} window_height - --
* @property {number} window_width - --
* @property {string} wixsession - authentication token. if the session exists, then the user is logged in.
**/
/**
 * Name: dashboard > finish loading. src: 5 Evid: 302.


 * app_id - Type: string. Desc: application id
 *
 * app_ids - Type: string. Desc: all applications installed on Biz Mgr
 *
 * hosting - Type: string. Desc: dashboard/editor/onboarding
 *
 * initial_load - Type: bool. Desc: intial load
 *
 * is_account_mgr - Type: bool. Desc: true/ false
 *
 * is_biz_mgr - Type: bool. Desc: true if page is loaded when Biz mgr is active
 *
 * is_pro - Type: bool. Desc: not in use
 *
 * loading_time - Type: numeric. Desc: loading time of page (from 300 )
 *
 * loading_time_from_first_interaction - Type: numeric. Desc: loading_time_from_first_interaction (309)
 *
 * loading_time_from_module - Type: numeric. Desc: Loading time from module start loading (from 564)
 *
 * loading_time_from_performance_now - Type: numeric. Desc: loading_time_from_performance_now  when server start to load. the real beginning
 *
 * loading_time_from_start - Type: numeric. Desc: loading time from start loading Bizmgr (from 561)
 *
 * module_id - Type: string. Desc: *not in use*
 *
 * msid - Type: guid.
 *
 * origin - Type: string. Desc: origin
 *
 * origin_app_id - Type: string. Desc: origin_app_id (what app opened the bizmgr)
 *
 * pageComponentId - Type: string. Desc: the page component id, will be reliable only when page has an entry point from sidebar. was added on 22/08/22
 *
 * platform - Type: string.
 *
 * prevPageComponentId - Type: string. Desc: the previous page component id, will be reliable only when page has an entry point from sidebar.
 *
 * prev_sub_view - Type: string. Desc: previous sub view
 *
 * prev_view - Type: string. Desc: origin view
 *
 * referral_info - Type: string. Desc: specific button triggered the the view loading
 *
 * screen_height - Type: numeric. Desc: screen height
 *
 * screen_width - Type: numeric. Desc: screen width
 *
 * src - Type: numeric.
 *
 * sub_view - Type: string. Desc: --
 *
 * view - Type: string. Desc: requested view
 *
 * view_mode - Type: string. Desc: grid/list-view
 *
 * window_height - Type: numeric. Desc: --
 *
 * window_width - Type: numeric. Desc: --
 *
 * wixsession - Type: string. Desc: authentication token. if the session exists, then the user is logged in.
 * @param {dashboardFinishLoadingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardFinishLoading = function (params) {
    return { evid: 302, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardMySitesSiteHomeAlertMessageFromPremiumDisplayParams
* @property {GUID} alert_id - deprecated
* @property {string} alert_type - alert_message
* @property {string} hosting - MA/editor
* @property {string} platform - null
* @property {string} premium_alert_id - alert received from premium
**/
/**
 * Name: dashboard > My Sites/site-home - alert message from premium display. src: 5 Evid: 157.
 * Event description: when a user opens my-sites/site-home he receives a message based on notifications that transferred from premiums. This event collects  about what shown to user.

 * alert_id - Type: guid. Desc: deprecated
 *
 * alert_type - Type: string. Desc: alert_message
 *
 * hosting - Type: string. Desc: MA/editor
 *
 * platform - Type: string.
 *
 * premium_alert_id - Type: string. Desc: alert received from premium
 * @param {dashboardMySitesSiteHomeAlertMessageFromPremiumDisplayParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardMySitesSiteHomeAlertMessageFromPremiumDisplay = function (params) {
    return { evid: 157, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} badgeNotificationParams
* @property {GUID} msid - msid
* @property {number} new_notifications - number in the badge
* @property {string} platform - null
**/
/**
 * Name: New Releases - Badge notification. src: 5 Evid: 340.
 * Event description: a badge with new notifications is shown to the user.

 * msid - Type: guid. Desc: msid
 *
 * new_notifications - Type: numeric. Desc: number in the badge
 *
 * platform - Type: string.
 * @param {badgeNotificationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var badgeNotification = function (params) {
    return { evid: 340, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesAddPaymentPageCancelParams
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} origin - my invoices,preview
* @property {string} origin_device - web,native
* @property {string} platform - null
**/
/**
 * Name: Quotes - Add payment page - Cancel. src: 5 Evid: 426.
 * Event description: cancel in add payment page (for every close (cancel, x, background click)).

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: my invoices,preview
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string.
 * @param {quotesAddPaymentPageCancelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesAddPaymentPageCancel = function (params) {
    return { evid: 426, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardShowSideBarParams
* @property {string} action - open/close
* @property {boolean} alwaysOpen - if the side bar always open at application (not relevant anymore)
* @property {GUID} msid - msid
* @property {string} selectedItem - name of application ('mobile sidebar' in case of mobile web)
* @property {string} page_view - my sites/site home
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: dashboard > show side bar. src: 5 Evid: 35.
 * Event description: send event each time the side bar is being shown ( repurposed for mobile web sidebar).

 * action - Type: string. Desc: open/close
 *
 * alwaysOpen - Type: bool. Desc: if the side bar always open at application (not relevant anymore)
 *
 * msid - Type: guid. Desc: msid
 *
 * selectedItem - Type: string. Desc: name of application ('mobile sidebar' in case of mobile web)
 *
 * page_view - Type: string. Desc: my sites/site home
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {dashboardShowSideBarParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardShowSideBar = function (params) {
    return { evid: 35, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesDepositDropDepositParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Invoices - Deposit - drop deposit. src: 5 Evid: 1697.
 * Event description: Copy of Invoices - Deposit - drop deposit.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {invoicesDepositDropDepositParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesDepositDropDeposit = function (params) {
    return { evid: 1697, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSettingsDomainSslOptionParams
* @property {string} experience - user's experience
* @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
* @property {string} mode - {Turn on SSL,Remove SSL}
* @property {GUID} msid - msid
* @property {string} name - name of the field that was changed
* @property {string} origin - name of current tab
* @property {string} platform - null
**/
/**
 * Name: dashboard > site settings > Domain > SSL Option. src: 5 Evid: 321.
 * Event description: User choose to Activate/ Deactivate the  HTTPS option.

 * experience - Type: string. Desc: user's experience
 *
 * hosting - Type: string. Desc: from where user arrived to sitesettings (Editor/MA/...)
 *
 * mode - Type: string. Desc: {Turn on SSL,Remove SSL}
 *
 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: name of the field that was changed
 *
 * origin - Type: string. Desc: name of current tab
 *
 * platform - Type: string.
 * @param {dashboardSiteSettingsDomainSslOptionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSettingsDomainSslOption = function (params) {
    return { evid: 321, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardTriggersGetTheAppPopUpCloseParams
* @property {GUID} app_id - app_id
* @property {GUID} msid - msid
* @property {string} origin - origin page
* @property {string} platform - null
* @property {string} recipe_name - recipe name
* @property {number} src - null
**/
/**
 * Name: Automations > Get the app PopUp close. src: 5 Evid: 203.
 * Event description: Get the app PopUp close.

 * app_id - Type: guid. Desc: app_id
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin page
 *
 * platform - Type: string.
 *
 * recipe_name - Type: string. Desc: recipe name
 *
 * src - Type: numeric.
 * @param {dashboardTriggersGetTheAppPopUpCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardTriggersGetTheAppPopUpClose = function (params) {
    return { evid: 203, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} siteHistoryViewerNotLoadedParams
* @property {string} platform - null
* @property {string} referralInfo - editor / home
**/
/**
 * Name: Site History - Viewer not loaded. src: 5 Evid: 56.
 * Event description: error on loading of the viewer iframe in site history.

 * platform - Type: string.
 *
 * referralInfo - Type: string. Desc: editor / home
 * @param {siteHistoryViewerNotLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteHistoryViewerNotLoaded = function (params) {
    return { evid: 56, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesWidgetMoreActionChooseAnActionParams
* @property {string} action - action name
* @property {GUID} contactId - contact id
* @property {GUID} invoiceId - invoice id
* @property {GUID} msid - msid
* @property {string} origin - ‘crm home widget/ ‘os-dashboard’
* @property {string} platform - null
**/
/**
 * Name: Invoices - widget - more action - choose an action. src: 5 Evid: 1321.
 * Event description: Invoices - widget - more action - choose an action.

 * action - Type: string. Desc: action name
 *
 * contactId - Type: guid. Desc: contact id
 *
 * invoiceId - Type: guid. Desc: invoice id
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: ‘crm home widget/ ‘os-dashboard’
 *
 * platform - Type: string.
 * @param {invoicesWidgetMoreActionChooseAnActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesWidgetMoreActionChooseAnAction = function (params) {
    return { evid: 1321, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesBulkActionsDownloadPdfParams
* @property {string} filter - type of filter
* @property {string} msid - msid
* @property {string} number - number of invoices choose or all
* @property {string} platform - null
**/
/**
 * Name: Quotes - bulk actions - Download PDF. src: 5 Evid: 397.
 * Event description: Quotes - Create invoice - Toggle Recurring.

 * filter - Type: string. Desc: type of filter
 *
 * msid - Type: string. Desc: msid
 *
 * number - Type: string. Desc: number of invoices choose or all
 *
 * platform - Type: string.
 * @param {quotesBulkActionsDownloadPdfParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesBulkActionsDownloadPdf = function (params) {
    return { evid: 397, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} notificationGroupNotificationIsDisplayedParams
* @property {string} channel - null
* @property {string} contact_id - contact_id guid
* @property {string} feed_name - All sites/This site /float
* @property {string} notification_id_shown - the shown notification id
* @property {string} notification_ids - list of the notification ids
* @property {string} origin - MSID of the site the user is on, my-sites if on Site List. Later on, also account-settings, and other account-level pages.
* @property {number} page_number - page number - each page is limited to 30 notifications
* @property {string} platform - --
**/
/**
 * Name: Notification -Group Notification is displayed. src: 5 Evid: 387.
 * Event description: user opens the dialog and group notification is seen..

 * channel - Type: string.
 *
 * contact_id - Type: string. Desc: contact_id guid
 *
 * feed_name - Type: string. Desc: All sites/This site /float
 *
 * notification_id_shown - Type: string. Desc: the shown notification id
 *
 * notification_ids - Type: string. Desc: list of the notification ids
 *
 * origin - Type: string. Desc: MSID of the site the user is on, my-sites if on Site List. Later on, also account-settings, and other account-level pages.
 *
 * page_number - Type: numeric. Desc: page number - each page is limited to 30 notifications
 *
 * platform - Type: string. Desc: --
 * @param {notificationGroupNotificationIsDisplayedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var notificationGroupNotificationIsDisplayed = function (params) {
    return { evid: 387, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} rolesAddRoleInviteClickParams
* @property {string} hosting - MA / Editor
* @property {string} invite_email - not reported (PII)
* @property {string} invite_role - invited role
* @property {boolean} is_valid_email - email validation
* @property {GUID} msid - msid
* @property {string} origin - name of tab dashboard/authorization/my sites
* @property {string} platform - null
* @property {string} roles_displayed - list of roles displayed to the user
* @property {number} src - null
**/
/**
 * Name: Roles - add role - invite click. src: 5 Evid: 352.
 * Event description: user clicked on 'invite' in the add role window.

 * hosting - Type: string. Desc: MA / Editor
 *
 * invite_email - Type: string. Desc: not reported (PII)
 *
 * invite_role - Type: string. Desc: invited role
 *
 * is_valid_email - Type: bool. Desc: email validation
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: name of tab dashboard/authorization/my sites
 *
 * platform - Type: string.
 *
 * roles_displayed - Type: string. Desc: list of roles displayed to the user
 *
 * src - Type: numeric.
 * @param {rolesAddRoleInviteClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rolesAddRoleInviteClick = function (params) {
    return { evid: 352, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesClickOnCreateLinkFromMoreActionsParams
* @property {GUID} invoiceId - invoiceId
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: dummy-name. src: 5 Evid: 729.
 * Event description: Quotes - click on create link from more actions.

 * invoiceId - Type: guid. Desc: invoiceId
 *
 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {quotesClickOnCreateLinkFromMoreActionsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesClickOnCreateLinkFromMoreActions = function (params) {
    return { evid: 729, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardUserSeeFeedParams
* @property {boolean} aboveTheFold - was the item full viewed above the fold
* @property {GUID} campaignId - unique identifier of CMS items
* @property {GUID} feedId - feed id
* @property {GUID} feed_id - feed id
* @property {boolean} more3sec - if the item was full displayed for 3 sec or more
* @property {GUID} msid - msid
* @property {string} origin - origin
* @property {string} platform - null
* @property {string} source - the application/CMS that sent the feed. send the application ID.
* @property {number} src - null
* @property {string} title - title of feed
* @property {string} type - type
* @property {string} url - the link of the action
**/
/**
 * Name: dashboard > user see feed. src: 5 Evid: 20.
 * Event description: whenever a news item is a fully displayed in the newsfeed send a bi-feed so I will be able to know that a user saw the feed.

 * aboveTheFold - Type: bool. Desc: was the item full viewed above the fold
 *
 * campaignId - Type: guid. Desc: unique identifier of CMS items
 *
 * feedId - Type: guid. Desc: feed id
 *
 * feed_id - Type: guid. Desc: feed id
 *
 * more3sec - Type: bool. Desc: if the item was full displayed for 3 sec or more
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * platform - Type: string.
 *
 * source - Type: string. Desc: the application/CMS that sent the feed. send the application ID.
 *
 * src - Type: numeric.
 *
 * title - Type: string. Desc: title of feed
 *
 * type - Type: string. Desc: type
 *
 * url - Type: string. Desc: the link of the action
 * @param {dashboardUserSeeFeedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardUserSeeFeed = function (params) {
    return { evid: 20, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} accountSettingsChangeEmailAddressClickOnSureParams
* @property {string} platform - null
**/
/**
 * Name: Account Settings - Change Email Address - Click on Sure. src: 5 Evid: 1682.
 * Event description: The user tries to change email address while email 2FA is enabled, sees the email 2FA modal warning him it will be disabled and clicks on 'sure'.

 * platform - Type: string.
 * @param {accountSettingsChangeEmailAddressClickOnSureParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accountSettingsChangeEmailAddressClickOnSure = function (params) {
    return { evid: 1682, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesPageViewParams
* @property {GUID} msid - null
* @property {number} num_of_contacts - null
* @property {number} num_of_invoices - null
* @property {string} origin - deprecated
* @property {string} platform - null
* @property {string} referral - the origin of navigation to this page {invoice card preview,direct}
**/
/**
 * Name: Quotes - page view. src: 5 Evid: 454.
 * Event description: viewing invoices page in Oneapp.

 * msid - Type: guid.
 *
 * num_of_contacts - Type: numeric.
 *
 * num_of_invoices - Type: numeric.
 *
 * origin - Type: string. Desc: deprecated
 *
 * platform - Type: string.
 *
 * referral - Type: string. Desc: the origin of navigation to this page {invoice card preview,direct}
 * @param {quotesPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesPageView = function (params) {
    return { evid: 454, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} app2faSetupEnableClickParams
* @property {string} origin - account settings page/phone modal/email modal/second best
* @property {string} platform - null
**/
/**
 * Name: App 2FA Setup - Enable Click. src: 5 Evid: 1738.
 * Event description: The user clicked on 'enable' in the account settings page, or clicked on 'Add app verification' in the phone/email 2FA setup modals..

 * origin - Type: string. Desc: account settings page/phone modal/email modal/second best
 *
 * platform - Type: string.
 * @param {app2faSetupEnableClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var app2faSetupEnableClick = function (params) {
    return { evid: 1738, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsBanner4PresentedFormsTaskParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations -> Banner 4 presented - forms=>task. src: 5 Evid: 240.
 * Event description: Automations -> Banner presented - forms=>task.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsBanner4PresentedFormsTaskParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsBanner4PresentedFormsTask = function (params) {
    return { evid: 240, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeIntegrationsFinanceViewAllParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: CRM Home - integrations - finance view all. src: 5 Evid: 1115.
 * Event description: CRM Home - integrations - marketing view all.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {crmHomeIntegrationsFinanceViewAllParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeIntegrationsFinanceViewAll = function (params) {
    return { evid: 1115, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} needsYourActionItemIsShownParams
* @property {string} hosting - MA/editor/ADI
* @property {string} item_id - id of the specific item
* @property {number} item_location_on_page - item location appear on page
* @property {GUID} msid - msid
* @property {number} num_of_items - num of NYA items appears to users
* @property {string} platform - null
* @property {string} template_id - template id of the action
**/
/**
 * Name: Needs Your Action > item is shown. src: 5 Evid: 332.
 * Event description: show 1 Needs Your Action item.

 * hosting - Type: string. Desc: MA/editor/ADI
 *
 * item_id - Type: string. Desc: id of the specific item
 *
 * item_location_on_page - Type: numeric. Desc: item location appear on page
 *
 * msid - Type: guid. Desc: msid
 *
 * num_of_items - Type: numeric. Desc: num of NYA items appears to users
 *
 * platform - Type: string.
 *
 * template_id - Type: string. Desc: template id of the action
 * @param {needsYourActionItemIsShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var needsYourActionItemIsShown = function (params) {
    return { evid: 332, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsDaComponentRecommendationClick293Params
* @property {string} action - which action was presented
* @property {string} asset_campaign_guid - asset_campaign_guid
* @property {number} countAutomations - how many automations was presented in the widget
* @property {GUID} msid - msid
* @property {string} name - Name of the recommendation
* @property {number} offer_location - offer_location
* @property {string} origin - button, link, header, success creation dialog
* @property {string} platform - null
* @property {string} referral_info - indicate which vertical is the dacomponent triggered from
**/
/**
 * Name: Automations >  Recommendation Widget > Recommendation Click. src: 5 Evid: 293.
 * Event description: Automations > DaComponent > Recommendation Click.

 * action - Type: string. Desc: which action was presented
 *
 * asset_campaign_guid - Type: string. Desc: asset_campaign_guid
 *
 * countAutomations - Type: numeric. Desc: how many automations was presented in the widget
 *
 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: Name of the recommendation
 *
 * offer_location - Type: numeric. Desc: offer_location
 *
 * origin - Type: string. Desc: button, link, header, success creation dialog
 *
 * platform - Type: string.
 *
 * referral_info - Type: string. Desc: indicate which vertical is the dacomponent triggered from
 * @param {automationsDaComponentRecommendationClick293Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsDaComponentRecommendationClick293 = function (params) {
    return { evid: 293, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesCreateInvoiceFromQuotes96Params
* @property {string} msid - msid
* @property {string} platform - null
* @property {GUID} quoteId - quote guid
**/
/**
 * Name: Quotes - Create Invoice from Quotes. src: 5 Evid: 96.
 * Event description: User click on Create Invoice (from Price Quotes).

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 *
 * quoteId - Type: guid. Desc: quote guid
 * @param {quotesCreateInvoiceFromQuotes96Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesCreateInvoiceFromQuotes96 = function (params) {
    return { evid: 96, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsCreationModalCategorySelectedParams
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} recipeCategory - recipe Category
* @property {string} type - null
**/
/**
 * Name: Automations > Creation modal - category selected. src: 5 Evid: 1261.
 * Event description: Automations > user click on a category in the creation modal or scroll down to a category.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * recipeCategory - Type: string. Desc: recipe Category
 *
 * type - Type: string.
 * @param {automationsCreationModalCategorySelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsCreationModalCategorySelected = function (params) {
    return { evid: 1261, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardDuplicateSiteActionWindowNavigationClickParams
* @property {string} cta - duplicate / cancel
* @property {string} hosting - ma/editor
* @property {GUID} msid - --
* @property {string} origin - my sites / dashboard
* @property {string} platform - relevant only for mobile view
**/
/**
 * Name: dashboard > duplicate site action window navigation click. src: 5 Evid: 1627.
 * Event description: when user click on quick action, and then approve the duplication options from the popped window.

 * cta - Type: string. Desc: duplicate / cancel
 *
 * hosting - Type: string. Desc: ma/editor
 *
 * msid - Type: guid. Desc: --
 *
 * origin - Type: string. Desc: my sites / dashboard
 *
 * platform - Type: string. Desc: relevant only for mobile view
 * @param {dashboardDuplicateSiteActionWindowNavigationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardDuplicateSiteActionWindowNavigationClick = function (params) {
    return { evid: 1627, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesCreateInvoiceClickOnSeeMoreItemsParams
* @property {GUID} invoice_id - invoice guid
* @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
* @property {string} msid - msid
* @property {string} origin - create invoice, edit invoice
* @property {string} platform - platform
* @property {string} productSource - product source
**/
/**
 * Name: Quotes - Create invoice - Click on “See More Items”. src: 5 Evid: 1541.
 * Event description: Create invoice - Click on “See More Items”.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * invoiceType - Type: string. Desc: ’recurringAutoCharge’/ 'recurring'/ 'one time'
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: create invoice, edit invoice
 *
 * platform - Type: string. Desc: platform
 *
 * productSource - Type: string. Desc: product source
 * @param {quotesCreateInvoiceClickOnSeeMoreItemsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesCreateInvoiceClickOnSeeMoreItems = function (params) {
    return { evid: 1541, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsCreationModalUserClickOnSearchParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations > creation modal - user click on search. src: 5 Evid: 1268.
 * Event description: Removed Forms - click on More actions of a specific form.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsCreationModalUserClickOnSearchParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsCreationModalUserClickOnSearch = function (params) {
    return { evid: 1268, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSettingsSelectValueParams
* @property {string} adding_method - manually(pop-up),drop-down
* @property {string} experience - user's experience
* @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
* @property {GUID} msid - msid
* @property {string} name - name of the field that was selected
* @property {string} origin - name of current tab
* @property {string} place - UI type (picture/button/select/input...)
* @property {string} platform - null
* @property {number} src - null
* @property {string} value - user's selection
**/
/**
 * Name: dashboard > site settings > select value. src: 5 Evid: 319.
 * Event description: user selected a value and didn't change it (drop down and select image).

 * adding_method - Type: string. Desc: manually(pop-up),drop-down
 *
 * experience - Type: string. Desc: user's experience
 *
 * hosting - Type: string. Desc: from where user arrived to sitesettings (Editor/MA/...)
 *
 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: name of the field that was selected
 *
 * origin - Type: string. Desc: name of current tab
 *
 * place - Type: string. Desc: UI type (picture/button/select/input...)
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 *
 * value - Type: string. Desc: user's selection
 * @param {dashboardSiteSettingsSelectValueParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSettingsSelectValue = function (params) {
    return { evid: 319, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardAccountSettingsImageActionParams
* @property {string} action - {upload, remove}
* @property {string} platform - null
**/
/**
 * Name: dashboard > account settings -> image action click. src: 5 Evid: 45.
 * Event description: user changes profile image in account settings - can choose upload / remove image.

 * action - Type: string. Desc: {upload, remove}
 *
 * platform - Type: string.
 * @param {dashboardAccountSettingsImageActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardAccountSettingsImageAction = function (params) {
    return { evid: 45, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesRecurringSetPaymentTermsPageClickOnCancelParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Invoices - recurring - Set Payment Terms page - click on Cancel. src: 5 Evid: 1573.
 * Event description: Invoices - recurring - Set Payment Terms page - click on Cancel.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {invoicesRecurringSetPaymentTermsPageClickOnCancelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesRecurringSetPaymentTermsPageClickOnCancel = function (params) {
    return { evid: 1573, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesAddPaymentPageOkParams
* @property {boolean} fully_paid - true for fully paid selected, false for partial payment selected
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} origin - my invoices,preview
* @property {string} origin_device - web,native
* @property {string} paymentMethod - payment method chosen
* @property {string} platform - null
**/
/**
 * Name: Quotes - Add payment page - Ok. src: 5 Evid: 425.
 * Event description: OK clicked in add payment page, fully_paid is true when the full amount is paid in one payment.

 * fully_paid - Type: bool. Desc: true for fully paid selected, false for partial payment selected
 *
 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: my invoices,preview
 *
 * origin_device - Type: string. Desc: web,native
 *
 * paymentMethod - Type: string. Desc: payment method chosen
 *
 * platform - Type: string.
 * @param {quotesAddPaymentPageOkParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesAddPaymentPageOk = function (params) {
    return { evid: 425, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSettingsDeleteValueSuccessParams
* @property {string} experience - user's experience
* @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
* @property {GUID} msid - msid
* @property {string} name - name of the field that was changed
* @property {string} origin - name of current tab
* @property {string} platform - null
* @property {number} src - null
* @property {string} value - delete/clear value
**/
/**
 * Name: dashboard > site settings > delete value success. src: 5 Evid: 317.
 * Event description: user deleted/cleared a value from field - success.

 * experience - Type: string. Desc: user's experience
 *
 * hosting - Type: string. Desc: from where user arrived to sitesettings (Editor/MA/...)
 *
 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: name of the field that was changed
 *
 * origin - Type: string. Desc: name of current tab
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 *
 * value - Type: string. Desc: delete/clear value
 * @param {dashboardSiteSettingsDeleteValueSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSettingsDeleteValueSuccess = function (params) {
    return { evid: 317, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeSendMessageToInboxParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: CRM Home - send message to inbox. src: 5 Evid: 745.
 * Event description: CRM Home - send message to inbox.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {crmHomeSendMessageToInboxParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeSendMessageToInbox = function (params) {
    return { evid: 745, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesEditInvoiceParams
* @property {GUID} appDefId - appDefId of the source
* @property {GUID} externalId - An external id of an entity, relevant to the invoiceSource application
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} origin - my invoices, preview, deposit paid
* @property {string} platform - null
* @property {string} status - Creation form/Draft/Sent/Paid
**/
/**
 * Name: Quotes - Edit invoice. src: 5 Evid: 421.
 * Event description: edit invoice.

 * appDefId - Type: guid. Desc: appDefId of the source
 *
 * externalId - Type: guid. Desc: An external id of an entity, relevant to the invoiceSource application
 *
 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: my invoices, preview, deposit paid
 *
 * platform - Type: string.
 *
 * status - Type: string. Desc: Creation form/Draft/Sent/Paid
 * @param {quotesEditInvoiceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesEditInvoice = function (params) {
    return { evid: 421, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} email2faSetupChangeAccountEmailParams
* @property {string} platform - null
**/
/**
 * Name: Email 2FA Setup - Change Account Email. src: 5 Evid: 1676.
 * Event description: The user clicks on 'change account email' in the email 2fa setup modal.

 * platform - Type: string.
 * @param {email2faSetupChangeAccountEmailParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var email2faSetupChangeAccountEmail = function (params) {
    return { evid: 1676, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} twoFactorAuthenticationSetupConfirmCodeClickParams
* @property {boolean} is_valid - did the user enter the correct code sent to his mobile device
* @property {string} mode - enable/edit
* @property {string} platform - null
**/
/**
 * Name: Phone 2FA Setup - Confirm Code Click. src: 5 Evid: 684.
 * Event description: The user clicks on 'confirm' after entering the 6-digit code he received in an sms.

 * is_valid - Type: bool. Desc: did the user enter the correct code sent to his mobile device
 *
 * mode - Type: string. Desc: enable/edit
 *
 * platform - Type: string.
 * @param {twoFactorAuthenticationSetupConfirmCodeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var twoFactorAuthenticationSetupConfirmCodeClick = function (params) {
    return { evid: 684, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} app2faSetupCodeErrorMessageParams
* @property {number} error_code - error_code
* @property {string} error_reason - reason for error
* @property {string} mode - change app/enable
* @property {string} platform - null
**/
/**
 * Name: App 2FA Setup - Code Error Message. src: 5 Evid: 1746.
 * Event description: An error message shown to a user who entered an invalid 6-digit code in the 2FA app setup.

 * error_code - Type: numeric. Desc: error_code
 *
 * error_reason - Type: string. Desc: reason for error
 *
 * mode - Type: string. Desc: change app/enable
 *
 * platform - Type: string.
 * @param {app2faSetupCodeErrorMessageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var app2faSetupCodeErrorMessage = function (params) {
    return { evid: 1746, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesDeleteQuoteClickParams
* @property {string} msid - msid
* @property {string} origin_device - web,native
* @property {string} platform - null
* @property {GUID} quoteId - quote guid
**/
/**
 * Name: Quotes - Delete Quote click. src: 5 Evid: 90.
 * Event description: delete quote click.

 * msid - Type: string. Desc: msid
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string.
 *
 * quoteId - Type: guid. Desc: quote guid
 * @param {quotesDeleteQuoteClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesDeleteQuoteClick = function (params) {
    return { evid: 90, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} settingsLobbySectionIsSeenParams
* @property {string} hosting - MA/editor/onboarding
* @property {GUID} msid - --
* @property {string} platform - null
* @property {string} section_loaction_on_page - the location of section in page (order from 0,1,..)
* @property {string} section_name - site-details/general/ecommerce/..
**/
/**
 * Name: Settings Lobby > Section is Seen. src: 5 Evid: 1156.
 * Event description: when a section is seen (actually) in setting lobby page.

 * hosting - Type: string. Desc: MA/editor/onboarding
 *
 * msid - Type: guid. Desc: --
 *
 * platform - Type: string.
 *
 * section_loaction_on_page - Type: string. Desc: the location of section in page (order from 0,1,..)
 *
 * section_name - Type: string. Desc: site-details/general/ecommerce/..
 * @param {settingsLobbySectionIsSeenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var settingsLobbySectionIsSeen = function (params) {
    return { evid: 1156, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} errorPage297Params
* @property {string} error_location - specifies the location in page: header/sidebar/app/sidepanel etc. includes error type
* @property {string} error_name - null when it's a system error, permission when the error is permission related (user has no permission for the page)
* @property {string} hosting - --
* @property {GUID} msid - msid
* @property {string} page_url - page_url
* @property {string} platform - null
**/
/**
 * Name: Giza - error page is shown. src: 5 Evid: 297.
 * Event description: an error page is displayed in one of Giza's hosting platforms (Business Manager/Account Manager/Dev Center/etc.)  in case of BizMgr it's not reported from Giza yet - to get all errors from BizMgr you should filter 'host' field is not null..

 * error_location - Type: string. Desc: specifies the location in page: header/sidebar/app/sidepanel etc. includes error type
 *
 * error_name - Type: string. Desc: null when it's a system error, permission when the error is permission related (user has no permission for the page)
 *
 * hosting - Type: string. Desc: --
 *
 * msid - Type: guid. Desc: msid
 *
 * page_url - Type: string. Desc: page_url
 *
 * platform - Type: string.
 * @param {errorPage297Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var errorPage297 = function (params) {
    return { evid: 297, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} wixInvoicesClickOnTabsToChoseProductFromParams
* @property {string} button_name - Invoice, Store, Bookings
* @property {string} msid - msid
* @property {string} platform - null
* @property {string} productSource - app_deff_id
**/
/**
 * Name: Wix Invoices - click on tabs to chose product from. src: 5 Evid: 8936.
 * Event description: Wix Invoices - click on tabs to chose product from.

 * button_name - Type: string. Desc: Invoice, Store, Bookings
 *
 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 *
 * productSource - Type: string. Desc: app_deff_id
 * @param {wixInvoicesClickOnTabsToChoseProductFromParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var wixInvoicesClickOnTabsToChoseProductFrom = function (params) {
    return { evid: 8936, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} toolcastHoverOnTheSpeakerParams
* @property {string} campaignId - from dealer
* @property {boolean} firstStep - If the toolcast is first step and the user see the text
* @property {string} offeringGuid - offer guid
* @property {string} origin - from Panel or Dashboard steps or bubble
* @property {string} platform - null
* @property {string} stepName - The name of the toolcast step
**/
/**
 * Name: Toolcast- Hover on the speaker. src: 5 Evid: 1364.
 * Event description: when user hover and if the toolcast in the first step
and if the hover is from the focus widget or panel.

 * campaignId - Type: string. Desc: from dealer
 *
 * firstStep - Type: bool. Desc: If the toolcast is first step and the user see the text
 *
 * offeringGuid - Type: string. Desc: offer guid
 *
 * origin - Type: string. Desc: from Panel or Dashboard steps or bubble
 *
 * platform - Type: string.
 *
 * stepName - Type: string. Desc: The name of the toolcast step
 * @param {toolcastHoverOnTheSpeakerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var toolcastHoverOnTheSpeaker = function (params) {
    return { evid: 1364, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesCreateInvoiceClickOnInvoiceSettingsParams
* @property {GUID} invoice_id - invoice guid
* @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
* @property {string} msid - msid
* @property {string} origin - null
* @property {string} platform - platform
* @property {string} source - source
**/
/**
 * Name: Quotes - Create invoice - click on invoice settings. src: 5 Evid: 1545.


 * invoice_id - Type: guid. Desc: invoice guid
 *
 * invoiceType - Type: string. Desc: ’recurringAutoCharge’/ 'recurring'/ 'one time'
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string.
 *
 * platform - Type: string. Desc: platform
 *
 * source - Type: string. Desc: source
 * @param {quotesCreateInvoiceClickOnInvoiceSettingsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesCreateInvoiceClickOnInvoiceSettings = function (params) {
    return { evid: 1545, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesRecurringTableActionsCancelModalClickParams
* @property {string} action - keep/cancel
* @property {GUID} invoiceId - instanceId
* @property {string} msid - msid
* @property {string} platform - BM/client billing
**/
/**
 * Name: Invoices - recurring-  table actions - Cancel modal click. src: 5 Evid: 1636.
 * Event description: Cancel modal click by user.

 * action - Type: string. Desc: keep/cancel
 *
 * invoiceId - Type: guid. Desc: instanceId
 *
 * msid - Type: string. Desc: msid
 *
 * platform - Type: string. Desc: BM/client billing
 * @param {invoicesRecurringTableActionsCancelModalClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesRecurringTableActionsCancelModalClick = function (params) {
    return { evid: 1636, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesOpenFirstCardParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Quotes - open first card. src: 5 Evid: 733.
 * Event description: Quotes - Header Preview.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {quotesOpenFirstCardParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesOpenFirstCard = function (params) {
    return { evid: 733, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesRecurringClickOnNewRecurringInvoice1581Params
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Invoices - recurring- click on New Recurring Invoice. src: 5 Evid: 1581.
 * Event description: User clicks on New Recurring Invoice.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {invoicesRecurringClickOnNewRecurringInvoice1581Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesRecurringClickOnNewRecurringInvoice1581 = function (params) {
    return { evid: 1581, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} financialServicesSettingsInvoicesEditLogoParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Financial Services Settings - invoices - edit logo. src: 5 Evid: 1304.
 * Event description: Financial Services Settings - invoices - edit logo.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {financialServicesSettingsInvoicesEditLogoParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var financialServicesSettingsInvoicesEditLogo = function (params) {
    return { evid: 1304, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeSuggestionsCarouselClickOnCarouselParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: CRM Home - Suggestions carousel click on carousel. src: 5 Evid: 1513.
 * Event description: CRM Home - Suggestions carousel click on carousel.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {crmHomeSuggestionsCarouselClickOnCarouselParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeSuggestionsCarouselClickOnCarousel = function (params) {
    return { evid: 1513, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} wixInvoicesClickingOnGroupsDropDownInSettingsParams
* @property {string} card - Header details, Business Info, Tax settings, Footer Notes)
* @property {GUID} msid - msid
* @property {string} platform - mobile/web
* @property {string} value - open/close
**/
/**
 * Name: Wix Invoices: Clicking on Groups DropDown in Settings. src: 5 Evid: 8929.
 * Event description: Clicking on Particular drop down ( Header details, Business Info, Tax settings, Footer Notes).

 * card - Type: string. Desc: Header details, Business Info, Tax settings, Footer Notes)
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string. Desc: mobile/web
 *
 * value - Type: string. Desc: open/close
 * @param {wixInvoicesClickingOnGroupsDropDownInSettingsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var wixInvoicesClickingOnGroupsDropDownInSettings = function (params) {
    return { evid: 8929, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesCreateInvoiceUserClickOnSendInvoiceParams
* @property {GUID} invoice_id - invoice guid
* @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
* @property {string} msid - msid
* @property {string} origin - create invoice, edit invoice
* @property {string} platform - platform
* @property {string} source - source
**/
/**
 * Name: Quotes - Create invoice - user click on send invoice. src: 5 Evid: 1550.
 * Event description: Create invoice -user click on send invoice.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * invoiceType - Type: string. Desc: ’recurringAutoCharge’/ 'recurring'/ 'one time'
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: create invoice, edit invoice
 *
 * platform - Type: string. Desc: platform
 *
 * source - Type: string. Desc: source
 * @param {quotesCreateInvoiceUserClickOnSendInvoiceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesCreateInvoiceUserClickOnSendInvoice = function (params) {
    return { evid: 1550, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesOwnerappClickOnViewAllInvoiceParams
* @property {string} msid - msid
* @property {string} origin - my invoices, edit invoice, widget
* @property {string} origin_device - web,native
* @property {string} platform - null
* @property {string} tabName - most recent / overdue
**/
/**
 * Name: Invoices - Ownerapp-  click on view all invoice. src: 5 Evid: 1594.
 * Event description: Click on  view all invoice in owner app widget.

 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: my invoices, edit invoice, widget
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string.
 *
 * tabName - Type: string. Desc: most recent / overdue
 * @param {invoicesOwnerappClickOnViewAllInvoiceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesOwnerappClickOnViewAllInvoice = function (params) {
    return { evid: 1594, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteAppPromoParams
* @property {string} name - null
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: dashboard > site -> app promo. src: 5 Evid: 17.


 * name - Type: string.
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {dashboardSiteAppPromoParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteAppPromo = function (params) {
    return { evid: 17, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsDuplicateStepParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations > duplicate step. src: 5 Evid: 743.
 * Event description: Automations > end of steps quota upgrade ascend.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsDuplicateStepParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsDuplicateStep = function (params) {
    return { evid: 743, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesWidgetPreviewInvoiceParams
* @property {GUID} contactId - contact id
* @property {GUID} invoiceId - invoice Id
* @property {GUID} msid - msid
* @property {string} origin - ‘crm home widget/ ‘os-dashboard'
* @property {string} platform - null
**/
/**
 * Name: Invoices - widget - preview invoice. src: 5 Evid: 1325.
 * Event description: Invoices - widget - Create New.

 * contactId - Type: guid. Desc: contact id
 *
 * invoiceId - Type: guid. Desc: invoice Id
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: ‘crm home widget/ ‘os-dashboard'
 *
 * platform - Type: string.
 * @param {invoicesWidgetPreviewInvoiceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesWidgetPreviewInvoice = function (params) {
    return { evid: 1325, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} suggestionsFeedbackClickOnNavigationButtonInPopupParams
* @property {string} hosting - hosting
* @property {string} hosting_platform - Deprecated - will be implicit in the future
* @property {string} logo_value - null
* @property {GUID} msid - msid
* @property {string} platform - platform
* @property {string} platformName - account managr/BM/devcenter/etc. (biPageView )
**/
/**
 * Name: Header Logo Type. src: 5 Evid: 1240.
 * Event description: When the header is loaded with a logo.

 * hosting - Type: string. Desc: hosting
 *
 * hosting_platform - Type: string. Desc: Deprecated - will be implicit in the future
 *
 * logo_value - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string. Desc: platform
 *
 * platformName - Type: string. Desc: account managr/BM/devcenter/etc. (biPageView )
 * @param {suggestionsFeedbackClickOnNavigationButtonInPopupParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var suggestionsFeedbackClickOnNavigationButtonInPopup = function (params) {
    return { evid: 1240, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} financialServicesSettingsInvoicesDefaultsNotesLegalTermsParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Financial Services Settings - invoices - defaults notes - legal terms. src: 5 Evid: 1308.
 * Event description: Financial Services Settings - invoices - defaults notes - legal terms.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {financialServicesSettingsInvoicesDefaultsNotesLegalTermsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var financialServicesSettingsInvoicesDefaultsNotesLegalTerms = function (params) {
    return { evid: 1308, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardNewsClickViewAllParams
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: dashboard > news -> click view all. src: 5 Evid: 38.
 * Event description: clicking view all. leads to the News Feed.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {dashboardNewsClickViewAllParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardNewsClickViewAll = function (params) {
    return { evid: 38, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardClickOnItemFromHeaderParams
* @property {string} hosting - MA
* @property {GUID} msid - --
* @property {string} name - the item clicked name (my-sites/partner dashors'
* @property {string} page_view - my-sites /dashboard / account settings
* @property {string} platform - null
**/
/**
 * Name: dashboard > click on item from Header. src: 5 Evid: 147.
 * Event description: When a user clicks on an item in the header that redirects him to another page.

 * hosting - Type: string. Desc: MA
 *
 * msid - Type: guid. Desc: --
 *
 * name - Type: string. Desc: the item clicked name (my-sites/partner dashors'
 *
 * page_view - Type: string. Desc: my-sites /dashboard / account settings
 *
 * platform - Type: string.
 * @param {dashboardClickOnItemFromHeaderParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardClickOnItemFromHeader = function (params) {
    return { evid: 147, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsEndOfQuotaAscendPopUpParams
* @property {GUID} msid - null
* @property {string} platform - null
**/
/**
 * Name: Automations > end of quota Ascend pop up. src: 5 Evid: 487.


 * msid - Type: guid.
 *
 * platform - Type: string.
 * @param {automationsEndOfQuotaAscendPopUpParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsEndOfQuotaAscendPopUp = function (params) {
    return { evid: 487, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardMySitesSiteSelectionPageViewParams
* @property {GUID} msid - msid
* @property {number} no_of_html_sites - number of html sites
* @property {number} no_of_sites - number of sites user have
* @property {string} origin - origin of page
* @property {string} platform - null
**/
/**
 * Name: dashboard > My Sites - site selection page view. src: 5 Evid: 151.
 * Event description: my sites selection page.

 * msid - Type: guid. Desc: msid
 *
 * no_of_html_sites - Type: numeric. Desc: number of html sites
 *
 * no_of_sites - Type: numeric. Desc: number of sites user have
 *
 * origin - Type: string. Desc: origin of page
 *
 * platform - Type: string.
 * @param {dashboardMySitesSiteSelectionPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardMySitesSiteSelectionPageView = function (params) {
    return { evid: 151, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardDashboardHomeIsFullyLoadedParams
* @property {string} hosting - MA/editor
* @property {number} loading_time - loading time of page (from 300 )
* @property {number} loading_time_from_first_interaction - deprecated
* @property {number} loading_time_from_module - Loading time from module start loading (from 564)
* @property {number} loading_time_from_performance_now - loading_time_from_performance_now  when server start to load. the real beginning
* @property {number} loading_time_from_start - loading time from start loading Bizmgr (from 561)
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} prev_sub_view - prev page in app
* @property {string} prev_view - origin view
* @property {string} referral_info - specific button triggered the the view loading
* @property {number} screen_height - screen_height
* @property {number} screen_width - screen_width
* @property {string} sub_view - page in app
* @property {string} view - requested view
* @property {number} window_height - window_height
* @property {number} window_width - window_width
**/
/**
 * Name: dashboard > dashboard (home) is interactive. src: 5 Evid: 309.
 * Event description: dashboard (home) is fully loaded.

 * hosting - Type: string. Desc: MA/editor
 *
 * loading_time - Type: numeric. Desc: loading time of page (from 300 )
 *
 * loading_time_from_first_interaction - Type: numeric. Desc: deprecated
 *
 * loading_time_from_module - Type: numeric. Desc: Loading time from module start loading (from 564)
 *
 * loading_time_from_performance_now - Type: numeric. Desc: loading_time_from_performance_now  when server start to load. the real beginning
 *
 * loading_time_from_start - Type: numeric. Desc: loading time from start loading Bizmgr (from 561)
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * prev_sub_view - Type: string. Desc: prev page in app
 *
 * prev_view - Type: string. Desc: origin view
 *
 * referral_info - Type: string. Desc: specific button triggered the the view loading
 *
 * screen_height - Type: numeric. Desc: screen_height
 *
 * screen_width - Type: numeric. Desc: screen_width
 *
 * sub_view - Type: string. Desc: page in app
 *
 * view - Type: string. Desc: requested view
 *
 * window_height - Type: numeric. Desc: window_height
 *
 * window_width - Type: numeric. Desc: window_width
 * @param {dashboardDashboardHomeIsFullyLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardDashboardHomeIsFullyLoaded = function (params) {
    return { evid: 309, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesViewInvoicePageViewParams
* @property {GUID} invoice_id - invoice guid
* @property {string} invoiceSource - by app_def_id
* @property {boolean} is_visible - true if the pay invoice button is shown
* @property {string} msid - msid
* @property {string} no_of_payments - number of online payments available for this invoice
* @property {string} origin - origin page
* @property {boolean} paid - true if invoice was paid
* @property {string} paymentType - null
* @property {string} platform - null
* @property {string} source - null
* @property {string} view - other/desktop/tablet/smartphone
**/
/**
 * Name: Quotes - View Invoice page view. src: 5 Evid: 406.
 * Event description: view invoice page view.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * invoiceSource - Type: string. Desc: by app_def_id
 *
 * is_visible - Type: bool. Desc: true if the pay invoice button is shown
 *
 * msid - Type: string. Desc: msid
 *
 * no_of_payments - Type: string. Desc: number of online payments available for this invoice
 *
 * origin - Type: string. Desc: origin page
 *
 * paid - Type: bool. Desc: true if invoice was paid
 *
 * paymentType - Type: string.
 *
 * platform - Type: string.
 *
 * source - Type: string.
 *
 * view - Type: string. Desc: other/desktop/tablet/smartphone
 * @param {quotesViewInvoicePageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesViewInvoicePageView = function (params) {
    return { evid: 406, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} financialServicesSettingsInvoicesEditNumberingParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Financial Services Settings - invoices - edit numbering. src: 5 Evid: 1303.
 * Event description: Financial Services Settings - invoices - edit numbering.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {financialServicesSettingsInvoicesEditNumberingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var financialServicesSettingsInvoicesEditNumbering = function (params) {
    return { evid: 1303, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} accountSettingsDisabledEnabledPartnerDashboardParams
* @property {string} action - ENABLE/DISABLE
* @property {string} platform - null
**/
/**
 * Name: Account Settings - disabled/enabled Partner Dashboard. src: 5 Evid: 741.
 * Event description: enable or disable successfully the Partners Dashboard from account settings.

 * action - Type: string. Desc: ENABLE/DISABLE
 *
 * platform - Type: string.
 * @param {accountSettingsDisabledEnabledPartnerDashboardParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accountSettingsDisabledEnabledPartnerDashboard = function (params) {
    return { evid: 741, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesCreateInvoiceRearrangeItemsParams
* @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
* @property {string} msid - null
* @property {string} origin - create invoice, edit invoice
* @property {string} platform - platform
**/
/**
 * Name: Quotes - Create invoice - Rearrange Items. src: 5 Evid: 1542.


 * invoiceType - Type: string. Desc: ’recurringAutoCharge’/ 'recurring'/ 'one time'
 *
 * msid - Type: string.
 *
 * origin - Type: string. Desc: create invoice, edit invoice
 *
 * platform - Type: string. Desc: platform
 * @param {quotesCreateInvoiceRearrangeItemsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesCreateInvoiceRearrangeItems = function (params) {
    return { evid: 1542, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} needsYourActionNyaWidgetShownParams
* @property {string} hosting - MA/editor/ADI
* @property {GUID} msid - msid
* @property {number} num_of_items - num of NYA items appears to users
* @property {string} platform - null
**/
/**
 * Name: Needs Your Action > NYA Widget shown. src: 5 Evid: 331.
 * Event description: When a user entered into the dashboard and has at least 1 NYA item.

 * hosting - Type: string. Desc: MA/editor/ADI
 *
 * msid - Type: guid. Desc: msid
 *
 * num_of_items - Type: numeric. Desc: num of NYA items appears to users
 *
 * platform - Type: string.
 * @param {needsYourActionNyaWidgetShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var needsYourActionNyaWidgetShown = function (params) {
    return { evid: 331, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardUserSeeFeedMoreThen3secParams
* @property {boolean} aboveTheFold - aboveTheFold
* @property {GUID} campaignId - unique identifier of CMS items
* @property {GUID} feedId - feedId
* @property {GUID} feed_id - feed id
* @property {GUID} msid - msid
* @property {string} origin - origin
* @property {string} platform - null
* @property {string} source - source
* @property {number} src - null
* @property {string} title - title
* @property {string} type - type
* @property {string} url - url
**/
/**
 * Name: dashboard > user see feed more then 3sec. src: 5 Evid: 33.
 * Event description: whenever a news item is a fully displayed in the newsfeed more then 3 sec send a bi-feed so I will be able to know that a user saw the feed.

 * aboveTheFold - Type: bool. Desc: aboveTheFold
 *
 * campaignId - Type: guid. Desc: unique identifier of CMS items
 *
 * feedId - Type: guid. Desc: feedId
 *
 * feed_id - Type: guid. Desc: feed id
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * platform - Type: string.
 *
 * source - Type: string. Desc: source
 *
 * src - Type: numeric.
 *
 * title - Type: string. Desc: title
 *
 * type - Type: string. Desc: type
 *
 * url - Type: string. Desc: url
 * @param {dashboardUserSeeFeedMoreThen3secParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardUserSeeFeedMoreThen3sec = function (params) {
    return { evid: 33, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesDeleteQuotePageOkParams
* @property {string} msid - msid
* @property {string} origin_device - web,native
* @property {string} platform - null
* @property {GUID} quoteId - quote guid
**/
/**
 * Name: Quotes - Delete quote page - Ok. src: 5 Evid: 91.
 * Event description: OK clicked in delete page.

 * msid - Type: string. Desc: msid
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string.
 *
 * quoteId - Type: guid. Desc: quote guid
 * @param {quotesDeleteQuotePageOkParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesDeleteQuotePageOk = function (params) {
    return { evid: 91, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} rolesDeleteRoleDeleteClickParams
* @property {string} accept_email - accepted email
* @property {string} hosting - MA / Editor
* @property {GUID} msid - msid
* @property {string} origin - name of tab
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: Roles - delete role - delete click. src: 5 Evid: 362.
 * Event description: user clicked on 'delete' in the delete role window.

 * accept_email - Type: string. Desc: accepted email
 *
 * hosting - Type: string. Desc: MA / Editor
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: name of tab
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {rolesDeleteRoleDeleteClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rolesDeleteRoleDeleteClick = function (params) {
    return { evid: 362, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesRecurringSelectNumberOfOccurrencesParams
* @property {string} msid - msid
* @property {string} platform - null
* @property {string} value - selected value of occurrences
**/
/**
 * Name: Invoices - recurring - select number of occurrences. src: 5 Evid: 1567.
 * Event description: Quotes - recurring - select number of occurrences.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 *
 * value - Type: string. Desc: selected value of occurrences
 * @param {invoicesRecurringSelectNumberOfOccurrencesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesRecurringSelectNumberOfOccurrences = function (params) {
    return { evid: 1567, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeCreateButtonClickParams
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {GUID} uuid - uuid
**/
/**
 * Name: CRM Home - create button click. src: 5 Evid: 489.
 * Event description: CRM Home - create button click.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 * @param {crmHomeCreateButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeCreateButtonClick = function (params) {
    return { evid: 489, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardAfterSiteSelectorStartedLoadingAndBeforeFinishedParams
* @property {string} device - mobile / desktop
* @property {string} filtered - premium/published/adi / none
* @property {Url} page_url - the full URL of the page
* @property {string} place_description - The place in the code the event being sent from
* @property {string} platform - null
* @property {string} referral - from where the screen was open
* @property {string} selectionType - single / multi
* @property {number} site_type_enriched - site_type
* @property {string} status - no thumbnails / empty state / success
* @property {string} siteType - htmlWeb / modal
**/
/**
 * Name: dashboard > After site selector started loading and before finished. src: 5 Evid: 1706.
 * Event description: send after site selector started loading and before site selector loaded successfully. this event is for debugging purposes..

 * device - Type: string. Desc: mobile / desktop
 *
 * filtered - Type: string. Desc: premium/published/adi / none
 *
 * page_url - Type: url. Desc: the full URL of the page
 *
 * place_description - Type: string. Desc: The place in the code the event being sent from
 *
 * platform - Type: string.
 *
 * referral - Type: string. Desc: from where the screen was open
 *
 * selectionType - Type: string. Desc: single / multi
 *
 * site_type_enriched - Type: numeric. Desc: site_type
 *
 * status - Type: string. Desc: no thumbnails / empty state / success
 *
 * siteType - Type: string. Desc: htmlWeb / modal
 * @param {dashboardAfterSiteSelectorStartedLoadingAndBeforeFinishedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardAfterSiteSelectorStartedLoadingAndBeforeFinished = function (params) {
    return { evid: 1706, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} foldersClickOnFolderSQuickActionsParams
* @property {string} cta - top menu/folder
* @property {string} name - name of quick action
* @property {number} nesting_level - 0 (my-sites)/1/2/3… the number define the nested folder number.
* @property {string} origin - sites-list-enterprise\site-list
* @property {string} platform - null
* @property {string} view_level - page(ROOT)/ folder/ search/filter
* @property {string} view_mode - grid/list-view
**/
/**
 * Name: Folders > click on quick actions. src: 5 Evid: 125.
 * Event description: click folder's quick actions.

 * cta - Type: string. Desc: top menu/folder
 *
 * name - Type: string. Desc: name of quick action
 *
 * nesting_level - Type: numeric. Desc: 0 (my-sites)/1/2/3… the number define the nested folder number.
 *
 * origin - Type: string. Desc: sites-list-enterprise\site-list
 *
 * platform - Type: string.
 *
 * view_level - Type: string. Desc: page(ROOT)/ folder/ search/filter
 *
 * view_mode - Type: string. Desc: grid/list-view
 * @param {foldersClickOnFolderSQuickActionsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var foldersClickOnFolderSQuickActions = function (params) {
    return { evid: 125, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesNewInvoiceClickParams
* @property {boolean} create_order - true / false -  indicates the type of the flow (in case of type= duplicate it will indicate the type of invoice)
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} origin - origin page, my invoices ( on mobile, when creating from list), create invoice - on web, when creating for the first time, widget (mobile), quick actions (mobile)
* @property {GUID} originalInvoiceId - in case of duplicate: original invoice guid
* @property {string} platform - null
* @property {string} status - Creation form/Draft/Sent/Paid
* @property {string} type - [invoice / invoice&order/ duplicate / get started / without menu]
**/
/**
 * Name: Quotes - New invoice click. src: 5 Evid: 403.
 * Event description: Quotes - New invoice click.

 * create_order - Type: bool. Desc: true / false -  indicates the type of the flow (in case of type= duplicate it will indicate the type of invoice)
 *
 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: origin page, my invoices ( on mobile, when creating from list), create invoice - on web, when creating for the first time, widget (mobile), quick actions (mobile)
 *
 * originalInvoiceId - Type: guid. Desc: in case of duplicate: original invoice guid
 *
 * platform - Type: string.
 *
 * status - Type: string. Desc: Creation form/Draft/Sent/Paid
 *
 * type - Type: string. Desc: [invoice / invoice&order/ duplicate / get started / without menu]
 * @param {quotesNewInvoiceClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesNewInvoiceClick = function (params) {
    return { evid: 403, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} ascendPpClickOnPackageInPpParams
* @property {string} buttonType - regular/hover/swipe_reg/swipe_hover
* @property {boolean} isChecked - is most popular
* @property {string} origin - product name open PP
* @property {GUID} packageId - package id
* @property {string} package_name - package name
* @property {string} platform - null
* @property {string} referralInfo - button name open PP
* @property {number} timeInPage - in milisec
**/
/**
 * Name: Ascend PP - Click on Package in PP. src: 5 Evid: 134.
 * Event description: User click on select in pp.

 * buttonType - Type: string. Desc: regular/hover/swipe_reg/swipe_hover
 *
 * isChecked - Type: bool. Desc: is most popular
 *
 * origin - Type: string. Desc: product name open PP
 *
 * packageId - Type: guid. Desc: package id
 *
 * package_name - Type: string. Desc: package name
 *
 * platform - Type: string.
 *
 * referralInfo - Type: string. Desc: button name open PP
 *
 * timeInPage - Type: numeric. Desc: in milisec
 * @param {ascendPpClickOnPackageInPpParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ascendPpClickOnPackageInPp = function (params) {
    return { evid: 134, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerBusinessInfoMergeDialogShownParams
* @property {string} hosting - MA/editor/ADI
* @property {string} merged_apps - merged app def id, use delimiter "," between each app_id
* @property {GUID} msid - metasite id
* @property {string} platform - null
**/
/**
 * Name: Biz Manager - Business Info Merge Dialog - Shown. src: 5 Evid: 585.
 * Event description: This dialog will alert the user about the change to his settings.
It will be displayed only in case of a conflict (my account and other verticals) in the merge process.

 * hosting - Type: string. Desc: MA/editor/ADI
 *
 * merged_apps - Type: string. Desc: merged app def id, use delimiter "," between each app_id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * platform - Type: string.
 * @param {bizManagerBusinessInfoMergeDialogShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerBusinessInfoMergeDialogShown = function (params) {
    return { evid: 585, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} accountManagerPageComponentStartLoadingAccountManagerParams
* @property {string} platform - null
* @property {string} prev_sub_view - prev_sub_view
* @property {string} prev_view - prev_view
* @property {string} referral_info - referral_info
* @property {string} sub_view - sub_view
* @property {string} view - view
**/
/**
 * Name: account manager - page component start loading account manager. src: 5 Evid: 112.
 * Event description: page component start loading account manager module.

 * platform - Type: string.
 *
 * prev_sub_view - Type: string. Desc: prev_sub_view
 *
 * prev_view - Type: string. Desc: prev_view
 *
 * referral_info - Type: string. Desc: referral_info
 *
 * sub_view - Type: string. Desc: sub_view
 *
 * view - Type: string. Desc: view
 * @param {accountManagerPageComponentStartLoadingAccountManagerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accountManagerPageComponentStartLoadingAccountManager = function (params) {
    return { evid: 112, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardStartLoadingParams
* @property {string} app_id - application id
* @property {string} app_ids - all application ids installed on Biz Mgr
* @property {string} hosting - MA/editor
* @property {boolean} initial_load - deprecated
* @property {boolean} is_account_mgr - true / false
* @property {boolean} is_biz_mgr - true if page is loaded when Biz mgr is active
* @property {string} module_id - deprecated
* @property {GUID} msid - null
* @property {string} origin - specific button triggered the the view loading (== referral info from editor)
* @property {string} origin_app_id - origin_app_id (what app opened the bizmgr)
* @property {string} pageComponentId - the page component id, will be reliable only when page has an entry point from sidebar. was added on 22/08/22
* @property {string} platform - null
* @property {string} prev_module_id - deprecated
* @property {string} prevPageComponentId - the previous page component id, will be reliable only when page has an entry point from sidebar.
* @property {string} prev_sub_view - previous page in app/module
* @property {string} prev_view - origin view / module / app
* @property {string} referral_info - specific button triggered the the view loading
* @property {number} screen_height - screen_height
* @property {number} screen_width - screen_width
* @property {number} src - null
* @property {string} sub_view - page in app/module
* @property {string} view - requested view/ module/ app
* @property {number} window_height - window_height
* @property {number} window_width - window_width
* @property {string} wixsession - authentication token. if the session exists, then the user is logged in.
**/
/**
 * Name: dashboard > start loading. src: 5 Evid: 300.


 * app_id - Type: string. Desc: application id
 *
 * app_ids - Type: string. Desc: all application ids installed on Biz Mgr
 *
 * hosting - Type: string. Desc: MA/editor
 *
 * initial_load - Type: bool. Desc: deprecated
 *
 * is_account_mgr - Type: bool. Desc: true / false
 *
 * is_biz_mgr - Type: bool. Desc: true if page is loaded when Biz mgr is active
 *
 * module_id - Type: string. Desc: deprecated
 *
 * msid - Type: guid.
 *
 * origin - Type: string. Desc: specific button triggered the the view loading (== referral info from editor)
 *
 * origin_app_id - Type: string. Desc: origin_app_id (what app opened the bizmgr)
 *
 * pageComponentId - Type: string. Desc: the page component id, will be reliable only when page has an entry point from sidebar. was added on 22/08/22
 *
 * platform - Type: string.
 *
 * prev_module_id - Type: string. Desc: deprecated
 *
 * prevPageComponentId - Type: string. Desc: the previous page component id, will be reliable only when page has an entry point from sidebar.
 *
 * prev_sub_view - Type: string. Desc: previous page in app/module
 *
 * prev_view - Type: string. Desc: origin view / module / app
 *
 * referral_info - Type: string. Desc: specific button triggered the the view loading
 *
 * screen_height - Type: numeric. Desc: screen_height
 *
 * screen_width - Type: numeric. Desc: screen_width
 *
 * src - Type: numeric.
 *
 * sub_view - Type: string. Desc: page in app/module
 *
 * view - Type: string. Desc: requested view/ module/ app
 *
 * window_height - Type: numeric. Desc: window_height
 *
 * window_width - Type: numeric. Desc: window_width
 *
 * wixsession - Type: string. Desc: authentication token. if the session exists, then the user is logged in.
 * @param {dashboardStartLoadingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardStartLoading = function (params) {
    return { evid: 300, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesEmailQuotePageCancelClickParams
* @property {string} msid - msid
* @property {string} origin - origin page
* @property {string} origin_device - web,native
* @property {string} platform - null
* @property {GUID} quoteId - quote guid
* @property {boolean} resend - resend mode?
**/
/**
 * Name: Quotes - Email Quote page - Cancel click. src: 5 Evid: 87.
 * Event description: email quote - clicked on cancel.

 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: origin page
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string.
 *
 * quoteId - Type: guid. Desc: quote guid
 *
 * resend - Type: bool. Desc: resend mode?
 * @param {quotesEmailQuotePageCancelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesEmailQuotePageCancelClick = function (params) {
    return { evid: 87, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesDeleteTaxClickParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Quotes - Delete tax click. src: 5 Evid: 437.
 * Event description: Delete tax click.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {quotesDeleteTaxClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesDeleteTaxClick = function (params) {
    return { evid: 437, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsVideoBannerClickParams
* @property {GUID} msid - msid
* @property {string} offerId - Dealer Offer id
* @property {string} origin - origin
* @property {string} platform - null
* @property {string} tipTitle - tip name
* @property {string} tipType - video / kb / external
**/
/**
 * Name: Automations > click on tip from banner. src: 5 Evid: 346.
 * Event description: User click on a tip from the banner on Automation home page.

 * msid - Type: guid. Desc: msid
 *
 * offerId - Type: string. Desc: Dealer Offer id
 *
 * origin - Type: string. Desc: origin
 *
 * platform - Type: string.
 *
 * tipTitle - Type: string. Desc: tip name
 *
 * tipType - Type: string. Desc: video / kb / external
 * @param {automationsVideoBannerClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsVideoBannerClick = function (params) {
    return { evid: 346, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardLessPopularShortcutsClickParams
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: dashboard > 'less' popular shortcuts click. src: 5 Evid: 29.
 * Event description: each time user clicks the 'less' link.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {dashboardLessPopularShortcutsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardLessPopularShortcutsClick = function (params) {
    return { evid: 29, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} needsYourActionClickOnItemParams
* @property {string} click_type - click/close/hide
* @property {string} hosting - MA/editor/ADI
* @property {string} item_id - item id
* @property {number} item_location_on_page - item location num onpage
* @property {string} item_name - item name appear
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} template_id - template id
**/
/**
 * Name: Needs Your Action > click on item. src: 5 Evid: 333.
 * Event description: Click on 'Needs Your Action' item.

 * click_type - Type: string. Desc: click/close/hide
 *
 * hosting - Type: string. Desc: MA/editor/ADI
 *
 * item_id - Type: string. Desc: item id
 *
 * item_location_on_page - Type: numeric. Desc: item location num onpage
 *
 * item_name - Type: string. Desc: item name appear
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * template_id - Type: string. Desc: template id
 * @param {needsYourActionClickOnItemParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var needsYourActionClickOnItem = function (params) {
    return { evid: 333, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} transferSiteResendTransferEmailClickParams
* @property {string} hosting - MA /Editor
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Transfer site - resend transfer email - click. src: 5 Evid: 58.
 * Event description: user clicked on resend transfer email.

 * hosting - Type: string. Desc: MA /Editor
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {transferSiteResendTransferEmailClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var transferSiteResendTransferEmailClick = function (params) {
    return { evid: 58, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesRecurringIsAutoChargeParams
* @property {boolean} chargeAutomatically - true/ false
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Invoices - recurring - is auto charge. src: 5 Evid: 1569.
 * Event description: user selects if to charge the customer automatically or user will pay for each time.

 * chargeAutomatically - Type: bool. Desc: true/ false
 *
 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {invoicesRecurringIsAutoChargeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesRecurringIsAutoCharge = function (params) {
    return { evid: 1569, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bookingAnywhereNoPermissionParams
* @property {string} buttonName - share services or manage calendar
* @property {GUID} msid - --
* @property {string} platform - depercated
**/
/**
 * Name: Booking anywhere no permission. src: 5 Evid: 8920.
 * Event description: when the user dont have the permissio and he hover.

 * buttonName - Type: string. Desc: share services or manage calendar
 *
 * msid - Type: guid. Desc: --
 *
 * platform - Type: string. Desc: depercated
 * @param {bookingAnywhereNoPermissionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingAnywhereNoPermission = function (params) {
    return { evid: 8920, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationHomePageSortAutomationTableParams
* @property {string} field - rule / status / last_updated
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} sortType - null
**/
/**
 * Name: Automation > home page - sort automation table. src: 5 Evid: 1351.
 * Event description: Automation > home page -  sort automation table.

 * field - Type: string. Desc: rule / status / last_updated
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * sortType - Type: string.
 * @param {automationHomePageSortAutomationTableParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationHomePageSortAutomationTable = function (params) {
    return { evid: 1351, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationUserCloseSidebarPanelParams
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} sidebar - null
**/
/**
 * Name: Automation > user close sidebar panel. src: 5 Evid: 2014.
 * Event description: Automation > user close sidebar panel.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * sidebar - Type: string.
 * @param {automationUserCloseSidebarPanelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationUserCloseSidebarPanel = function (params) {
    return { evid: 2014, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} wixInvoicesChargeWithCreditCardClickInTheModalMotoParams
* @property {boolean} fully_paid - true for fully paid selected, false for partial payment selected
* @property {GUID} invoice_id - invoice guid
* @property {GUID} invoiceSource - invoice_source_id
* @property {boolean} is_new - New or Edited Invoice (True Or False)
* @property {string} msid - msid
* @property {string} origin - my invoices,preview,create invoice
* @property {string} origin_device - web,native
* @property {string} platform - plstform
**/
/**
 * Name: Wix Invoices - Charge with credit card click in the modal MOTO. src: 5 Evid: 8959.
 * Event description: Charge with credit card in modal click (MOTO).

 * fully_paid - Type: bool. Desc: true for fully paid selected, false for partial payment selected
 *
 * invoice_id - Type: guid. Desc: invoice guid
 *
 * invoiceSource - Type: guid. Desc: invoice_source_id
 *
 * is_new - Type: bool. Desc: New or Edited Invoice (True Or False)
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: my invoices,preview,create invoice
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string. Desc: plstform
 * @param {wixInvoicesChargeWithCreditCardClickInTheModalMotoParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var wixInvoicesChargeWithCreditCardClickInTheModalMoto = function (params) {
    return { evid: 8959, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} uouUnsubscribeClickParams
* @property {string} click_type - click/cancel
* @property {string} device - mobile
* @property {GUID} msid - msid
* @property {GUID} notification_Id - notification id of unsubscribe sms
* @property {string} platform - null
* @property {GUID} visitor_id - visitor_id of uou
**/
/**
 * Name: UOU Unsubscribe > Click. src: 5 Evid: 799.
 * Event description: when UOU click unsubscribe/cancel from unsubscribe page view.

 * click_type - Type: string. Desc: click/cancel
 *
 * device - Type: string. Desc: mobile
 *
 * msid - Type: guid. Desc: msid
 *
 * notification_Id - Type: guid. Desc: notification id of unsubscribe sms
 *
 * platform - Type: string.
 *
 * visitor_id - Type: guid. Desc: visitor_id of uou
 * @param {uouUnsubscribeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var uouUnsubscribeClick = function (params) {
    return { evid: 799, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsMoreActionsChooseOptionParams
* @property {GUID} msid - msid
* @property {string} option - which option the user choose
* @property {string} origin - in more actions or in my automations
* @property {string} platform - null
**/
/**
 * Name: Automations - more actions - choose option. src: 5 Evid: 1456.
 * Event description: Automations - more actions - choose option.

 * msid - Type: guid. Desc: msid
 *
 * option - Type: string. Desc: which option the user choose
 *
 * origin - Type: string. Desc: in more actions or in my automations
 *
 * platform - Type: string.
 * @param {automationsMoreActionsChooseOptionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsMoreActionsChooseOption = function (params) {
    return { evid: 1456, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardTriggersShoutOutDidnTSendTalkenParams
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} recipe_name - name of recipie
* @property {GUID} rule_id - unique identifier of ID
**/
/**
 * Name: Automations > ShoutOut didn't send token. src: 5 Evid: 223.
 * Event description: send this event each time user click next at ShouOut custom phase, and don't have any token ID..

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * recipe_name - Type: string. Desc: name of recipie
 *
 * rule_id - Type: guid. Desc: unique identifier of ID
 * @param {dashboardTriggersShoutOutDidnTSendTalkenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardTriggersShoutOutDidnTSendTalken = function (params) {
    return { evid: 223, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} customerNotificationsSettingsPageLoadParams
* @property {string} available_sections - all the components loaded to the user
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: customer notifications settings > page load. src: 5 Evid: 1253.
 * Event description: When the page is loaded.

 * available_sections - Type: string. Desc: all the components loaded to the user
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {customerNotificationsSettingsPageLoadParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var customerNotificationsSettingsPageLoad = function (params) {
    return { evid: 1253, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} rolesAcceptFailParams
* @property {string} invite_email - invited email
* @property {string} invite_id - invite id
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: Roles - accept fail. src: 5 Evid: 358.
 * Event description: post login signup accept response fail.

 * invite_email - Type: string. Desc: invited email
 *
 * invite_id - Type: string. Desc: invite id
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {rolesAcceptFailParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rolesAcceptFail = function (params) {
    return { evid: 358, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesRecurringSetPaymentTermsPageClickOnNextParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Invoices - recurring - Set Payment Terms page - click on Next. src: 5 Evid: 1572.
 * Event description: Invoices - recurring - Set Payment Terms page - click on Next.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {invoicesRecurringSetPaymentTermsPageClickOnNextParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesRecurringSetPaymentTermsPageClickOnNext = function (params) {
    return { evid: 1572, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsGoogleSheetsChooseSheetParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations - google sheets - choose sheet. src: 5 Evid: 1488.
 * Event description: Automations - google sheets - choose spreadsheet.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsGoogleSheetsChooseSheetParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsGoogleSheetsChooseSheet = function (params) {
    return { evid: 1488, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesRecurringSearchInvoicesParams
* @property {string} msid - msid
* @property {number} num_of_invoices - number of invoices the user has
* @property {number} num_of_results - number of returned results
* @property {string} origin_device - web,native
* @property {string} platform - null
* @property {string} text - text searched
**/
/**
 * Name: Invoices - recurring - search invoices. src: 5 Evid: 1579.
 * Event description: user searches in the invoices view.

 * msid - Type: string. Desc: msid
 *
 * num_of_invoices - Type: numeric. Desc: number of invoices the user has
 *
 * num_of_results - Type: numeric. Desc: number of returned results
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string.
 *
 * text - Type: string. Desc: text searched
 * @param {invoicesRecurringSearchInvoicesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesRecurringSearchInvoices = function (params) {
    return { evid: 1579, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesNewProductSaveParams
* @property {string} description - description of the product
* @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
* @property {string} msid - msid
* @property {string} origin - create,edit,select
* @property {string} platform - null
* @property {number} price_long - product price
* @property {string} product_name - name of the product
**/
/**
 * Name: Quotes - New product - Save. src: 5 Evid: 415.
 * Event description: new product -save successful.

 * description - Type: string. Desc: description of the product
 *
 * invoiceType - Type: string. Desc: ’recurringAutoCharge’/ 'recurring'/ 'one time'
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: create,edit,select
 *
 * platform - Type: string.
 *
 * price_long - Type: numeric. Desc: product price
 *
 * product_name - Type: string. Desc: name of the product
 * @param {quotesNewProductSaveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesNewProductSave = function (params) {
    return { evid: 415, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} customerNotificationsSettingsClickInsidePageWithoutEmailsSectionsParams
* @property {GUID} msid - msid
* @property {string} name - button name - f.e. "go to events"
* @property {string} page_id - page id of the next page - f.e. page_id of stores settings
* @property {string} platform - null
* @property {string} section_name - name of the component - f.e. "More notifications"
**/
/**
 * Name: customer notifications settings > click inside page (without emails sections). src: 5 Evid: 1250.
 * Event description: Click on the main page
without sections -
Automated emails you created,
Recommended automated emails,
System Notifications.

 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: button name - f.e. "go to events"
 *
 * page_id - Type: string. Desc: page id of the next page - f.e. page_id of stores settings
 *
 * platform - Type: string.
 *
 * section_name - Type: string. Desc: name of the component - f.e. "More notifications"
 * @param {customerNotificationsSettingsClickInsidePageWithoutEmailsSectionsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var customerNotificationsSettingsClickInsidePageWithoutEmailsSections = function (params) {
    return { evid: 1250, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesPreviewFromInsideTheInvoiceCreationParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Quotes - Preview from inside the invoice creation. src: 5 Evid: 482.
 * Event description: Quotes - Preview from inside the invoice creation.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {quotesPreviewFromInsideTheInvoiceCreationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesPreviewFromInsideTheInvoiceCreation = function (params) {
    return { evid: 482, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationRemoveAscendDisclaimerParams
* @property {string} action - close / okay / display
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} type - until 31/12 OR after 31/12 OR test
**/
/**
 * Name: Automation - remove Ascend disclaimer. src: 5 Evid: 8953.
 * Event description: pop up that will display when users enter to automation home page.

 * action - Type: string. Desc: close / okay / display
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * type - Type: string. Desc: until 31/12 OR after 31/12 OR test
 * @param {automationRemoveAscendDisclaimerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationRemoveAscendDisclaimer = function (params) {
    return { evid: 8953, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesRecurringClickOnBackToastInNewRecurringInvoicesCreationPageParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Invoices - recurring - click on back toast in New Recurring Invoices creation page. src: 5 Evid: 1574.
 * Event description: user clicks on back toast in the New Recurring Invoices creation page.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {invoicesRecurringClickOnBackToastInNewRecurringInvoicesCreationPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesRecurringClickOnBackToastInNewRecurringInvoicesCreationPage = function (params) {
    return { evid: 1574, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerBizInfoNavigateAwayLeaveThisPageParams
* @property {string} hosting - MA/editor
* @property {GUID} msid - metasite id
* @property {string} platform - null
**/
/**
 * Name: Biz Manager - Biz Info - navigate away - leave this page. src: 5 Evid: 560.
 * Event description: user chooses to leave the page when the navigate away modal is shown.

 * hosting - Type: string. Desc: MA/editor
 *
 * msid - Type: guid. Desc: metasite id
 *
 * platform - Type: string.
 * @param {bizManagerBizInfoNavigateAwayLeaveThisPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerBizInfoNavigateAwayLeaveThisPage = function (params) {
    return { evid: 560, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} assetClickParams
* @property {GUID} assetCampaignGuid - deprecated
* @property {string} asset_campaign_guid - placement id
* @property {string} asset_campaign_id - Offer name
* @property {number} asset_location_from_group_list - item location inside the category
* @property {string} bannerLocationOnPage - deprecated
* @property {string} asset_location_on_page - (0,1,2,3)
* @property {string} clickType - deprecated
* @property {string} click_type - click/skip/complete-step/manage-options
* @property {string} group_id - id of category in setup widget
* @property {string} hosting - ADI/MA/editor
* @property {GUID} item_id - assets guid
* @property {GUID} msid - site guid
* @property {string} offeringGuid - deprecated
* @property {string} offering_guid - offer guid
* @property {string} origin - page/section/dash (page/section for suggestions widget)
* @property {string} platform - null
* @property {string} premium_badge - the item requires upgrade
* @property {string} promotionAssetType - deprecated
* @property {string} promotion_asset_type - bizMgrNavigation / video / externalUrl
* @property {string} suggestionTags - tag name
* @property {string} visibility_trigger - normal/step_completed
**/
/**
 * Name: Biz Manager - dashboard asset click. src: 5 Evid: 591.
 * Event description: what's next asset clicked.

 * assetCampaignGuid - Type: guid. Desc: deprecated
 *
 * asset_campaign_guid - Type: string. Desc: placement id
 *
 * asset_campaign_id - Type: string. Desc: Offer name
 *
 * asset_location_from_group_list - Type: numeric. Desc: item location inside the category
 *
 * bannerLocationOnPage - Type: string. Desc: deprecated
 *
 * asset_location_on_page - Type: string. Desc: (0,1,2,3)
 *
 * clickType - Type: string. Desc: deprecated
 *
 * click_type - Type: string. Desc: click/skip/complete-step/manage-options
 *
 * group_id - Type: string. Desc: id of category in setup widget
 *
 * hosting - Type: string. Desc: ADI/MA/editor
 *
 * item_id - Type: guid. Desc: assets guid
 *
 * msid - Type: guid. Desc: site guid
 *
 * offeringGuid - Type: string. Desc: deprecated
 *
 * offering_guid - Type: string. Desc: offer guid
 *
 * origin - Type: string. Desc: page/section/dash (page/section for suggestions widget)
 *
 * platform - Type: string.
 *
 * premium_badge - Type: string. Desc: the item requires upgrade
 *
 * promotionAssetType - Type: string. Desc: deprecated
 *
 * promotion_asset_type - Type: string. Desc: bizMgrNavigation / video / externalUrl
 *
 * suggestionTags - Type: string. Desc: tag name
 *
 * visibility_trigger - Type: string. Desc: normal/step_completed
 * @param {assetClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var assetClick = function (params) {
    return { evid: 591, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} homeClickNotificationCtaParams
* @property {string} activity_type - the notification / activity type
* @property {GUID} app_id - app that sent the notification - not sent
* @property {string} app_def_id - app that sent the notification
* @property {GUID} msid - msid
* @property {GUID} notification_id - notification id
* @property {number} num_of_new - number of new notifications - number in badge
* @property {string} platform - null
**/
/**
 * Name: Home > click notification cta- old event . now deprecated. src: 5 Evid: 250.
 * Event description: user clicks on a notification and opens app (test).

 * activity_type - Type: string. Desc: the notification / activity type
 *
 * app_id - Type: guid. Desc: app that sent the notification - not sent
 *
 * app_def_id - Type: string. Desc: app that sent the notification
 *
 * msid - Type: guid. Desc: msid
 *
 * notification_id - Type: guid. Desc: notification id
 *
 * num_of_new - Type: numeric. Desc: number of new notifications - number in badge
 *
 * platform - Type: string.
 * @param {homeClickNotificationCtaParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var homeClickNotificationCta = function (params) {
    return { evid: 250, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} analyticsTooltipParams
* @property {string} hosting - Dashboard/editor/ADI
* @property {GUID} msid - msid
* @property {string} name - The tooltip name. Till July 2020 was not populated  (only "info" was reported).
* @property {string} platform - null
**/
/**
 * Name: Analytics > Tooltip. src: 5 Evid: 371.
 * Event description: Tooltip for Analytics.

 * hosting - Type: string. Desc: Dashboard/editor/ADI
 *
 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: The tooltip name. Till July 2020 was not populated  (only "info" was reported).
 *
 * platform - Type: string.
 * @param {analyticsTooltipParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var analyticsTooltip = function (params) {
    return { evid: 371, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsQuickGoogleSpreadsheetsRecipeActivationClickParams
* @property {string} buttonName - The name of the button clicked
* @property {GUID} msid - msid
* @property {string} originPage - The name of the page the button was placed
* @property {string} platform - null
**/
/**
 * Name: Automations > Quick Google Spreadsheets Recipe Activation - Click. src: 5 Evid: 1723.
 * Event description: Nearly all click's in 'quick google spreadsheets recipe activation' funnel triggers this event.

 * buttonName - Type: string. Desc: The name of the button clicked
 *
 * msid - Type: guid. Desc: msid
 *
 * originPage - Type: string. Desc: The name of the page the button was placed
 *
 * platform - Type: string.
 * @param {automationsQuickGoogleSpreadsheetsRecipeActivationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsQuickGoogleSpreadsheetsRecipeActivationClick = function (params) {
    return { evid: 1723, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsDaComponentRecommendationClick288Params
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Quotes - Invoice Table - Manage Plan. src: 5 Evid: 288.
 * Event description: Quotes - Invoice Table - Manage Plan.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsDaComponentRecommendationClick288Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsDaComponentRecommendationClick288 = function (params) {
    return { evid: 288, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardClickBuyDomainFirstParams
* @property {GUID} msid - null
* @property {string} platform - null
* @property {string} referral_info - null
* @property {number} src - null
**/
/**
 * Name: dashboard > click buy domain first. src: 5 Evid: 52.


 * msid - Type: guid.
 *
 * platform - Type: string.
 *
 * referral_info - Type: string.
 *
 * src - Type: numeric.
 * @param {dashboardClickBuyDomainFirstParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardClickBuyDomainFirst = function (params) {
    return { evid: 52, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} searchSearchInDialogParams
* @property {GUID} msid - msid
* @property {string} origin - settings lobby / bizmgr
* @property {string} platform - null
* @property {string} query - the users's query search
* @property {string} results - send all results who return on time in the following way -> section: number of results: time to load
* @property {string} seen_results - send only results who were seen in search -> section: number of results: time to load
* @property {string} sub_view - page in app
* @property {string} triggred_from - search/show_all
* @property {string} view - requested view
**/
/**
 * Name: Search > typed. src: 5 Evid: 162.
 * Event description: when a user is searching in search dialog send event at the end of the results.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: settings lobby / bizmgr
 *
 * platform - Type: string.
 *
 * query - Type: string. Desc: the users's query search
 *
 * results - Type: string. Desc: send all results who return on time in the following way -> section: number of results: time to load
 *
 * seen_results - Type: string. Desc: send only results who were seen in search -> section: number of results: time to load
 *
 * sub_view - Type: string. Desc: page in app
 *
 * triggred_from - Type: string. Desc: search/show_all
 *
 * view - Type: string. Desc: requested view
 * @param {searchSearchInDialogParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var searchSearchInDialog = function (params) {
    return { evid: 162, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} ascendPpPurchasePageSubmitPurchaseParams
* @property {GUID} app_id - app_id
* @property {number} cycleId - cycle id
* @property {string} cycle_name - cycle name
* @property {string} origin - product name open PP
* @property {GUID} packageId - package id
* @property {string} package_name - package name
* @property {string} platform - null
* @property {string} referralInfo - button name open PP
**/
/**
 * Name: Ascend PP - Purchase Page Submit Purchase. src: 5 Evid: 141.
 * Event description: User click on Submit Purchase.

 * app_id - Type: guid. Desc: app_id
 *
 * cycleId - Type: numeric. Desc: cycle id
 *
 * cycle_name - Type: string. Desc: cycle name
 *
 * origin - Type: string. Desc: product name open PP
 *
 * packageId - Type: guid. Desc: package id
 *
 * package_name - Type: string. Desc: package name
 *
 * platform - Type: string.
 *
 * referralInfo - Type: string. Desc: button name open PP
 * @param {ascendPpPurchasePageSubmitPurchaseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ascendPpPurchasePageSubmitPurchase = function (params) {
    return { evid: 141, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerClickOnHelpCenterInDashboardFooterParams
* @property {string} app_id - app_id installed on biz mgr [deprecated]
* @property {string} hosting - ADI/MA/editor
* @property {string} name - the item that was clicked {Help/Send feedback}
* @property {string} platform - null
**/
/**
 * Name: Biz Manager - click on help center in dashboard footer. src: 5 Evid: 578.
 * Event description: user click on help center in dashboard footer.

 * app_id - Type: string. Desc: app_id installed on biz mgr [deprecated]
 *
 * hosting - Type: string. Desc: ADI/MA/editor
 *
 * name - Type: string. Desc: the item that was clicked {Help/Send feedback}
 *
 * platform - Type: string.
 * @param {bizManagerClickOnHelpCenterInDashboardFooterParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerClickOnHelpCenterInDashboardFooter = function (params) {
    return { evid: 578, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesRemoveCustomerParams
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} platform - null
* @property {GUID} uuid - uuid
**/
/**
 * Name: Quotes - Remove Customer. src: 5 Evid: 462.
 * Event description: User remove customer from the invoice.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 * @param {quotesRemoveCustomerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesRemoveCustomer = function (params) {
    return { evid: 462, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerHtmlLoadedParams
* @property {string} app_ids - app_ids
* @property {GUID} app_instance_id - --
* @property {string} hosting - from where the user opened Biz manager {ADI/MA/Editor}
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Biz Manager > HTML loaded. src: 5 Evid: 580.
 * Event description: Biz Mgr Html loaded after user click to open an app.

 * app_ids - Type: string. Desc: app_ids
 *
 * app_instance_id - Type: guid. Desc: --
 *
 * hosting - Type: string. Desc: from where the user opened Biz manager {ADI/MA/Editor}
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {bizManagerHtmlLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerHtmlLoaded = function (params) {
    return { evid: 580, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesManagePaymentsBannerDisplayedParams
* @property {GUID} msid - msid
* @property {string} name - banner name {manage payments}
* @property {string} platform - null
**/
/**
 * Name: Quotes - manage payments banner displayed. src: 5 Evid: 455.
 * Event description: manage payments banner is displayed in invoices app.

 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: banner name {manage payments}
 *
 * platform - Type: string.
 * @param {quotesManagePaymentsBannerDisplayedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesManagePaymentsBannerDisplayed = function (params) {
    return { evid: 455, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizmgrComponentRequestToLoadParams
* @property {string} app_id - The app_id of the page which hosts the component
* @property {string} component_app_id - The app_id of the component
* @property {string} component_id - the Id of the component
* @property {string} component_name - The component name
* @property {string} hosting - MA/Editor/onboarding
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} state - The expected state of the component -  regular/empty_state/no_permission
* @property {string} sub_view - The sub_view of the hosted page in Bizmgr
* @property {string} view - The view of the hosted page in Bizmgr
**/
/**
 * Name: Bizmgr -> Component -> Request to load. src: 5 Evid: 1458.
 * Event description: Generic component event - When the component is suppose to be loaded (before the loading starts).

 * app_id - Type: string. Desc: The app_id of the page which hosts the component
 *
 * component_app_id - Type: string. Desc: The app_id of the component
 *
 * component_id - Type: string. Desc: the Id of the component
 *
 * component_name - Type: string. Desc: The component name
 *
 * hosting - Type: string. Desc: MA/Editor/onboarding
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * state - Type: string. Desc: The expected state of the component -  regular/empty_state/no_permission
 *
 * sub_view - Type: string. Desc: The sub_view of the hosted page in Bizmgr
 *
 * view - Type: string. Desc: The view of the hosted page in Bizmgr
 * @param {bizmgrComponentRequestToLoadParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizmgrComponentRequestToLoad = function (params) {
    return { evid: 1458, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} accountSettingsChangeEmailAddressModalCancelChangesParams
* @property {string} platform - null
**/
/**
 * Name: Account Settings - Change Email Address Modal - Cancel Changes. src: 5 Evid: 1787.
 * Event description: The user clicked on 'cancel' to confirm that the change email address action was canceled.

 * platform - Type: string.
 * @param {accountSettingsChangeEmailAddressModalCancelChangesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accountSettingsChangeEmailAddressModalCancelChanges = function (params) {
    return { evid: 1787, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesClickOnSendInvoiceButtonParams
* @property {boolean} createOrder - create order?
* @property {string} currency - null
* @property {GUID} instanceId - instance_id
* @property {GUID} invoiceId - invoice_guid
* @property {boolean} isValid - is the invoice form valid
* @property {GUID} msid - msid
* @property {string} origin - create invoice, edit invoice
* @property {string} paymentType - 'one time','recurring'
* @property {string} platform - null
* @property {string} status - Creation form/Draft/Sent/Paid
* @property {number} totalAmountLong - Total amount of the invoice, INTEGER multiplied by 100,000
* @property {GUID} uuid - uuid
**/
/**
 * Name: Invoices - user click on 'send invoice' button. src: 5 Evid: 270.
 * Event description: Click on the 'send invoice' button (before the actual sending), the event is triggered also when the invoice form is not valid, please use is_valid field.

 * createOrder - Type: bool. Desc: create order?
 *
 * currency - Type: string.
 *
 * instanceId - Type: guid. Desc: instance_id
 *
 * invoiceId - Type: guid. Desc: invoice_guid
 *
 * isValid - Type: bool. Desc: is the invoice form valid
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: create invoice, edit invoice
 *
 * paymentType - Type: string. Desc: 'one time','recurring'
 *
 * platform - Type: string.
 *
 * status - Type: string. Desc: Creation form/Draft/Sent/Paid
 *
 * totalAmountLong - Type: numeric. Desc: Total amount of the invoice, INTEGER multiplied by 100,000
 *
 * uuid - Type: guid. Desc: uuid
 * @param {invoicesClickOnSendInvoiceButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesClickOnSendInvoiceButton = function (params) {
    return { evid: 270, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsTryItOutMultistepAutomationParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations > try it out multistep automation. src: 5 Evid: 735.
 * Event description: Automations > try it out multistep automation.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsTryItOutMultistepAutomationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsTryItOutMultistepAutomation = function (params) {
    return { evid: 735, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsWebhookV2ViewStructureParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations - webhook v2 - view structure. src: 5 Evid: 1394.
 * Event description: Automations - webhook v2 - view structure.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsWebhookV2ViewStructureParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsWebhookV2ViewStructure = function (params) {
    return { evid: 1394, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSelectorErrorLoadingParams
* @property {number} loading_time - from click to error
* @property {GUID} msid - metasite id
* @property {string} page_view - my-sites /dashboard / account settings
* @property {string} platform - null
**/
/**
 * Name: Dashboard > Site  dropdown error Loading. src: 5 Evid: 1379.
 * Event description: When the site  dropdown in the header list failed to load (error is presented).

 * loading_time - Type: numeric. Desc: from click to error
 *
 * msid - Type: guid. Desc: metasite id
 *
 * page_view - Type: string. Desc: my-sites /dashboard / account settings
 *
 * platform - Type: string.
 * @param {dashboardSiteSelectorErrorLoadingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSelectorErrorLoading = function (params) {
    return { evid: 1379, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} clickOnShowAllButtonParams
* @property {GUID} msid - msid
* @property {string} origin - bizmgr / settings lobby
* @property {string} platform - null
* @property {string} query - query
* @property {string} result - send all results who return on time in the following way -> section: number of results: time to load
* @property {string} section - result's section
* @property {number} section_index - the index of the section in results
* @property {string} sub_view - page in app
* @property {string} title - result's title
* @property {string} title_id - result's title id
* @property {string} view - requested view
**/
/**
 * Name: Click on 'Go To ' relevant page button. src: 5 Evid: 168.
 * Event description: When a user clicks on 'Go To ' relevant page button.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: bizmgr / settings lobby
 *
 * platform - Type: string.
 *
 * query - Type: string. Desc: query
 *
 * result - Type: string. Desc: send all results who return on time in the following way -> section: number of results: time to load
 *
 * section - Type: string. Desc: result's section
 *
 * section_index - Type: numeric. Desc: the index of the section in results
 *
 * sub_view - Type: string. Desc: page in app
 *
 * title - Type: string. Desc: result's title
 *
 * title_id - Type: string. Desc: result's title id
 *
 * view - Type: string. Desc: requested view
 * @param {clickOnShowAllButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickOnShowAllButton = function (params) {
    return { evid: 168, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesCreateAnAccountOfPaymentProviderParams
* @property {string} msid - msid
* @property {string} name - name of payment
* @property {string} origin - how user arrived to the flow onboarding/payments
* @property {string} platform - null
**/
/**
 * Name: Quotes - Create an account (of payment provider). src: 5 Evid: 442.
 * Event description: user clicks on 'create an account' from the payment popup page.

 * msid - Type: string. Desc: msid
 *
 * name - Type: string. Desc: name of payment
 *
 * origin - Type: string. Desc: how user arrived to the flow onboarding/payments
 *
 * platform - Type: string.
 * @param {quotesCreateAnAccountOfPaymentProviderParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesCreateAnAccountOfPaymentProvider = function (params) {
    return { evid: 442, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardNewsUserClickReadMoreParams
* @property {GUID} feedId - unique identifier of the feed
* @property {GUID} msid - unique identifier of the site
* @property {string} origin - of read more
* @property {string} platform - null
* @property {string} source - the app that sent the feed
* @property {number} src - null
* @property {string} title - of the feed
* @property {string} type - of activity
**/
/**
 * Name: dashboard > news -> user click read more. src: 5 Evid: 37.
 * Event description: each time user clicks reed more send. in the Dashboard, the news link can lead only to the News Feed.

 * feedId - Type: guid. Desc: unique identifier of the feed
 *
 * msid - Type: guid. Desc: unique identifier of the site
 *
 * origin - Type: string. Desc: of read more
 *
 * platform - Type: string.
 *
 * source - Type: string. Desc: the app that sent the feed
 *
 * src - Type: numeric.
 *
 * title - Type: string. Desc: of the feed
 *
 * type - Type: string. Desc: of activity
 * @param {dashboardNewsUserClickReadMoreParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardNewsUserClickReadMore = function (params) {
    return { evid: 37, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerClickLinkFromTooltipParams
* @property {string} click_type - click link / close
* @property {string} hosting - Editor/MA
* @property {GUID} msid - msid
* @property {string} name - link name
* @property {string} origin - The component that the tooltip appears on
* @property {string} platform - null
* @property {string} template_id - ping template id
* @property {string} value - Link URL
**/
/**
 * Name: Biz Manager - click link from tooltip/ close tooltip. src: 5 Evid: 584.
 * Event description: user clicked on a link from the tooltip.

 * click_type - Type: string. Desc: click link / close
 *
 * hosting - Type: string. Desc: Editor/MA
 *
 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: link name
 *
 * origin - Type: string. Desc: The component that the tooltip appears on
 *
 * platform - Type: string.
 *
 * template_id - Type: string. Desc: ping template id
 *
 * value - Type: string. Desc: Link URL
 * @param {bizManagerClickLinkFromTooltipParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerClickLinkFromTooltip = function (params) {
    return { evid: 584, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} wixInvoicesMotoPaidModalParams
* @property {GUID} invoice_id - null
* @property {boolean} is_deposit - true/false
* @property {GUID} msid - metasite id
* @property {string} origin - origin
* @property {string} origin_device - web,native
* @property {string} platform - platform
**/
/**
 * Name: Wix Invoices - MOTO paid modal. src: 5 Evid: 8961.
 * Event description: When a user paid invoice with MOTO and modal (Deposit or full amount is shown).

 * invoice_id - Type: guid.
 *
 * is_deposit - Type: bool. Desc: true/false
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: origin
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string. Desc: platform
 * @param {wixInvoicesMotoPaidModalParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var wixInvoicesMotoPaidModal = function (params) {
    return { evid: 8961, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeSendMessageViaContactsWidgetParams
* @property {GUID} contactId - contactId
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: CRM Home - send message via contacts widget. src: 5 Evid: 748.
 * Event description: CRM Home - send message via contacts widget.

 * contactId - Type: guid. Desc: contactId
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {crmHomeSendMessageViaContactsWidgetParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeSendMessageViaContactsWidget = function (params) {
    return { evid: 748, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} finishLoading8900Params
* @property {string} hosting_platform - accountmanagr/bizmanagr/devcenter/etc.
* @property {string} hosting_platform_context_id - context id: when the context is site - msid, when the context is app_id (like in devCenter f.e) - appDefId. In account manager is null
* @property {number} loading_time - loading time of the platform in ms (time from Giza start loading event)
* @property {string} platform - null
* @property {number} screen_height - the screen hight
* @property {number} screen_width - the screen width
* @property {number} window_height - the window height
* @property {number} window_width - the window width
**/
/**
 * Name: Giza - finish loading. src: 5 Evid: 8900.
 * Event description: when Giza finish loading.

 * hosting_platform - Type: string. Desc: accountmanagr/bizmanagr/devcenter/etc.
 *
 * hosting_platform_context_id - Type: string. Desc: context id: when the context is site - msid, when the context is app_id (like in devCenter f.e) - appDefId. In account manager is null
 *
 * loading_time - Type: numeric. Desc: loading time of the platform in ms (time from Giza start loading event)
 *
 * platform - Type: string.
 *
 * screen_height - Type: numeric. Desc: the screen hight
 *
 * screen_width - Type: numeric. Desc: the screen width
 *
 * window_height - Type: numeric. Desc: the window height
 *
 * window_width - Type: numeric. Desc: the window width
 * @param {finishLoading8900Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var finishLoading8900 = function (params) {
    return { evid: 8900, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesPrintInvoice477Params
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} origin - customer for UoU, my invoices for users
* @property {string} paymentType - 'Recurring','One Time'
* @property {string} platform - null
**/
/**
 * Name: Quotes - Print Invoice. src: 5 Evid: 477.
 * Event description: Quotes - Print Invoice.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: customer for UoU, my invoices for users
 *
 * paymentType - Type: string. Desc: 'Recurring','One Time'
 *
 * platform - Type: string.
 * @param {quotesPrintInvoice477Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesPrintInvoice477 = function (params) {
    return { evid: 477, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardMySitesActionSelectionPageViewParams
* @property {GUID} msid - msid
* @property {number} no_of_html_sites - number of html sites
* @property {number} no_of_sites - number of sites user have
* @property {string} origin - origin of page
* @property {string} platform - null
**/
/**
 * Name: dashboard > My Sites - action selection page view. src: 5 Evid: 150.
 * Event description: my sites selection page.

 * msid - Type: guid. Desc: msid
 *
 * no_of_html_sites - Type: numeric. Desc: number of html sites
 *
 * no_of_sites - Type: numeric. Desc: number of sites user have
 *
 * origin - Type: string. Desc: origin of page
 *
 * platform - Type: string.
 * @param {dashboardMySitesActionSelectionPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardMySitesActionSelectionPageView = function (params) {
    return { evid: 150, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} locationModalFloatingNotificationParams
* @property {string} hosting - dashboard/editor/ADI
* @property {GUID} msid - metasite id
* @property {string} name - notification name
* @property {string} origin - which app the modal is opened from
* @property {string} page_view - locations-modal
* @property {string} platform - null
* @property {string} type - error
**/
/**
 * Name: Location Modal > Floating Notification. src: 5 Evid: 1225.
 * Event description: If the server returns an error for adding a new location, we should show an error notification while keeping the modal with all the same input values before the add action..

 * hosting - Type: string. Desc: dashboard/editor/ADI
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: notification name
 *
 * origin - Type: string. Desc: which app the modal is opened from
 *
 * page_view - Type: string. Desc: locations-modal
 *
 * platform - Type: string.
 *
 * type - Type: string. Desc: error
 * @param {locationModalFloatingNotificationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var locationModalFloatingNotification = function (params) {
    return { evid: 1225, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSettingsClickLinkParams
* @property {string} experience - user's experience
* @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
* @property {GUID} msid - msid
* @property {string} name - link name
* @property {string} origin - name of current tab
* @property {string} platform - null
* @property {number} src - null
* @property {string} value - Link URL
**/
/**
 * Name: dashboard > site settings > click link. src: 5 Evid: 315.
 * Event description: user clicked on a link.

 * experience - Type: string. Desc: user's experience
 *
 * hosting - Type: string. Desc: from where user arrived to sitesettings (Editor/MA/...)
 *
 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: link name
 *
 * origin - Type: string. Desc: name of current tab
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 *
 * value - Type: string. Desc: Link URL
 * @param {dashboardSiteSettingsClickLinkParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSettingsClickLink = function (params) {
    return { evid: 315, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} engageEmailSettingsUpdateValueParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Quotes - Settings - add new tax. src: 5 Evid: 541.
 * Event description: Quotes - Settings - add new tax.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {engageEmailSettingsUpdateValueParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var engageEmailSettingsUpdateValue = function (params) {
    return { evid: 541, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} apesVersioningUpdateNewVersionErrorParams
* @property {string} errorReason - errorReason
* @property {boolean} isPreinstalled - if the automation is pre installed
* @property {GUID} msid - msid
* @property {string} origin - app id
* @property {string} pingTemplateId - pingTemplateId
* @property {string} platform - null
* @property {GUID} ruleId - ruleId
**/
/**
 * Name: APeS - versioning - update new version - error. src: 5 Evid: 1704.
 * Event description: APeS - versioning - update new version.

 * errorReason - Type: string. Desc: errorReason
 *
 * isPreinstalled - Type: bool. Desc: if the automation is pre installed
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: app id
 *
 * pingTemplateId - Type: string. Desc: pingTemplateId
 *
 * platform - Type: string.
 *
 * ruleId - Type: guid. Desc: ruleId
 * @param {apesVersioningUpdateNewVersionErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var apesVersioningUpdateNewVersionError = function (params) {
    return { evid: 1704, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} searchCloseSearchDialogParams
* @property {GUID} msid - msid
* @property {string} origin - settings lobby / bizmgr
* @property {string} platform - null
* @property {string} query - query
* @property {string} reason - click on result/ click somewhere else/ click on x
* @property {string} result - send all results who return on time in the following way -> section: number of results: time to load
* @property {string} sub_view - page in app
* @property {number} time_in_dialog - show in seconds the time spent in the dialog
* @property {string} view - requested view
**/
/**
 * Name: Search > Close search dialog. src: 5 Evid: 166.
 * Event description: send an event when a user's scroll in search's results.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: settings lobby / bizmgr
 *
 * platform - Type: string.
 *
 * query - Type: string. Desc: query
 *
 * reason - Type: string. Desc: click on result/ click somewhere else/ click on x
 *
 * result - Type: string. Desc: send all results who return on time in the following way -> section: number of results: time to load
 *
 * sub_view - Type: string. Desc: page in app
 *
 * time_in_dialog - Type: numeric. Desc: show in seconds the time spent in the dialog
 *
 * view - Type: string. Desc: requested view
 * @param {searchCloseSearchDialogParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var searchCloseSearchDialog = function (params) {
    return { evid: 166, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dummyEventForSiteMembersParams
* @property {string} hosting - MA/editor
* @property {string} initiator - contact name/ i button
* @property {GUID} msid - msid
* @property {string} panel_name - the panel that was opened
* @property {string} platform - null
* @property {string} source - X button / app / navigation
* @property {string} sub_view - page in app
* @property {string} view - requested view
**/
/**
 * Name: Biz Manager > Close panel. src: 5 Evid: 600.
 * Event description: user / app closed the panel.

 * hosting - Type: string. Desc: MA/editor
 *
 * initiator - Type: string. Desc: contact name/ i button
 *
 * msid - Type: guid. Desc: msid
 *
 * panel_name - Type: string. Desc: the panel that was opened
 *
 * platform - Type: string.
 *
 * source - Type: string. Desc: X button / app / navigation
 *
 * sub_view - Type: string. Desc: page in app
 *
 * view - Type: string. Desc: requested view
 * @param {dummyEventForSiteMembersParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dummyEventForSiteMembers = function (params) {
    return { evid: 600, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsGlobalErrorForMissingRecipeParams
* @property {string} errorReason - errorReason
* @property {GUID} msid - msid
* @property {string} origin - from where the automation error was made
* @property {string} platform - null
* @property {string} receipt_id - receipt_id
**/
/**
 * Name: Automations - global error for missing recipe. src: 5 Evid: 1466.
 * Event description: Automations - global error for missing recipe.

 * errorReason - Type: string. Desc: errorReason
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: from where the automation error was made
 *
 * platform - Type: string.
 *
 * receipt_id - Type: string. Desc: receipt_id
 * @param {automationsGlobalErrorForMissingRecipeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsGlobalErrorForMissingRecipe = function (params) {
    return { evid: 1466, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsScrollAutomationParams
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {GUID} rule_id - the rule_id that the user started/edited
**/
/**
 * Name: Automations > Scroll Automation. src: 5 Evid: 231.
 * Event description: user scroll in automation page.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * rule_id - Type: guid. Desc: the rule_id that the user started/edited
 * @param {automationsScrollAutomationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsScrollAutomation = function (params) {
    return { evid: 231, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} wixInvoicesOpenShareLinkModalParams
* @property {GUID} appdefid - appdefid of the source
* @property {GUID} externalId - An external id of an entity, relevant to the invoiceSource application
* @property {GUID} invoiceId - invoiceId
* @property {string} msid - msid
* @property {string} origin - more actions/invoice preview
* @property {string} platform - platform
* @property {string} status - Creation form/Draft/Sent/Paid
**/
/**
 * Name: Wix Invoices - open share link modal. src: 5 Evid: 8968.
 * Event description: When share link modal is opened.

 * appdefid - Type: guid. Desc: appdefid of the source
 *
 * externalId - Type: guid. Desc: An external id of an entity, relevant to the invoiceSource application
 *
 * invoiceId - Type: guid. Desc: invoiceId
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: more actions/invoice preview
 *
 * platform - Type: string. Desc: platform
 *
 * status - Type: string. Desc: Creation form/Draft/Sent/Paid
 * @param {wixInvoicesOpenShareLinkModalParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var wixInvoicesOpenShareLinkModal = function (params) {
    return { evid: 8968, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} apesLoadSystemNotificationsModalStartParams
* @property {boolean} isPreinstalled - if the automation is pre-installed
* @property {GUID} msid - msid
* @property {string} origin - app id
* @property {string} platform - null
**/
/**
 * Name: APeS - load system notifications modal - start. src: 5 Evid: 1276.
 * Event description: APeS - load system notifications modal - start.

 * isPreinstalled - Type: bool. Desc: if the automation is pre-installed
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: app id
 *
 * platform - Type: string.
 * @param {apesLoadSystemNotificationsModalStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var apesLoadSystemNotificationsModalStart = function (params) {
    return { evid: 1276, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerBizInfoNavigateAwayStayInPageParams
* @property {string} hosting - MA/editor
* @property {GUID} msid - metasite id
* @property {string} platform - null
**/
/**
 * Name: Biz Manager - Biz Info - navigate away - stay in page. src: 5 Evid: 558.
 * Event description: user chooses to stay in page when the navigate away modal is shown.

 * hosting - Type: string. Desc: MA/editor
 *
 * msid - Type: guid. Desc: metasite id
 *
 * platform - Type: string.
 * @param {bizManagerBizInfoNavigateAwayStayInPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerBizInfoNavigateAwayStayInPage = function (params) {
    return { evid: 558, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerBizInfoClickOnButtonParams
* @property {string} fold_name - name of fold: basic info, contact info, location language and region,
* @property {string} hosting - MA/editor
* @property {GUID} msid - metasite id
* @property {string} name - name of field (key): business name, description, main category, sub category, etc
* @property {string} platform - null
**/
/**
 * Name: Biz Manager - Biz Info - click on button. src: 5 Evid: 559.
 * Event description: user clicks a button, e.g "add logo", "add payment",  "edit shipping", etc..

 * fold_name - Type: string. Desc: name of fold: basic info, contact info, location language and region,
 *
 * hosting - Type: string. Desc: MA/editor
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: name of field (key): business name, description, main category, sub category, etc
 *
 * platform - Type: string.
 * @param {bizManagerBizInfoClickOnButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerBizInfoClickOnButton = function (params) {
    return { evid: 559, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} teamManagementResendInviteClickParams
* @property {GUID} invite_id - the invite id
* @property {string} invite_role - the role on the invite
* @property {string} invite_status - pending/expired
* @property {string} origin - where the user opened the dialog from
* @property {string} platform - null
**/
/**
 * Name: Team Management - resend invite - click. src: 5 Evid: 185.
 * Event description: When a user clicks on resend invite.

 * invite_id - Type: guid. Desc: the invite id
 *
 * invite_role - Type: string. Desc: the role on the invite
 *
 * invite_status - Type: string. Desc: pending/expired
 *
 * origin - Type: string. Desc: where the user opened the dialog from
 *
 * platform - Type: string.
 * @param {teamManagementResendInviteClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teamManagementResendInviteClick = function (params) {
    return { evid: 185, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesRecurringBackToRecurringInvoiceFromConnectPaymentParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Invoices - recurring- back to recurring invoice from connect payment. src: 5 Evid: 1583.
 * Event description: Invoices - recurring- back to recurring invoice from connect payment.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {invoicesRecurringBackToRecurringInvoiceFromConnectPaymentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesRecurringBackToRecurringInvoiceFromConnectPayment = function (params) {
    return { evid: 1583, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} notificationClickOnAccountNotificationParams
* @property {string} channel - Web / browser / mobile / SMS / email
* @property {string} contact_id - contact_id
* @property {string} feed_name - account notifications
* @property {string} grouped_sites - json {site:<msid> , badge:<num of unread notifications>}>
* @property {GUID} msid - msid of the notification
* @property {string} platform - -
**/
/**
 * Name: Notification - Click on account notification. src: 5 Evid: 1556.
 * Event description: user clicks on a account notification and opens app.

 * channel - Type: string. Desc: Web / browser / mobile / SMS / email
 *
 * contact_id - Type: string. Desc: contact_id
 *
 * feed_name - Type: string. Desc: account notifications
 *
 * grouped_sites - Type: string. Desc: json {site:<msid> , badge:<num of unread notifications>}>
 *
 * msid - Type: guid. Desc: msid of the notification
 *
 * platform - Type: string. Desc: -
 * @param {notificationClickOnAccountNotificationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var notificationClickOnAccountNotification = function (params) {
    return { evid: 1556, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} analyticsChooseKpiFromCustomizationListParams
* @property {string} added_kpi - the kpi the user tried to add when they got the error
* @property {string} added_kpi_location - the location of the kpi the user tried to add when they got the error
* @property {string} error_desc - the error the user received
* @property {string} hosting - MA/editor/ADI
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} selected_kpis - the chosen kpis in the following way -> kpi: location: (json)
**/
/**
 * Name: Analytics > choose KPI from customization list. src: 5 Evid: 374.
 * Event description: When a user gets an error in the dialog (e.g. picks a 4th item).

 * added_kpi - Type: string. Desc: the kpi the user tried to add when they got the error
 *
 * added_kpi_location - Type: string. Desc: the location of the kpi the user tried to add when they got the error
 *
 * error_desc - Type: string. Desc: the error the user received
 *
 * hosting - Type: string. Desc: MA/editor/ADI
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * selected_kpis - Type: string. Desc: the chosen kpis in the following way -> kpi: location: (json)
 * @param {analyticsChooseKpiFromCustomizationListParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var analyticsChooseKpiFromCustomizationList = function (params) {
    return { evid: 374, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} myAccountClickOnExpertDashboardParams
* @property {string} origin - header
* @property {string} page_view - my-sites / dashboard / account settings
* @property {string} platform - null
**/
/**
 * Name: My Account --> Click on Expert Dashboard. src: 5 Evid: 308.
 * Event description: User clicks on Expert Dashboard.

 * origin - Type: string. Desc: header
 *
 * page_view - Type: string. Desc: my-sites / dashboard / account settings
 *
 * platform - Type: string.
 * @param {myAccountClickOnExpertDashboardParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var myAccountClickOnExpertDashboard = function (params) {
    return { evid: 308, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsRenameTriggerClick378Params
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} recipe_name - recipe name
* @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
**/
/**
 * Name: Automations > Rename trigger click. src: 5 Evid: 378.
 * Event description: Automations > Rename Automation click.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * recipe_name - Type: string. Desc: recipe name
 *
 * rule_id - Type: guid. Desc: if this trigger all ready customized, null if it first time customization
 * @param {automationsRenameTriggerClick378Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsRenameTriggerClick378 = function (params) {
    return { evid: 378, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsWebhookV2CustomizeStructureAddKeyValueParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations - webhook v2 - customize structure - add key-value. src: 5 Evid: 1396.
 * Event description: Copy of Automations - webhook v2 - customize structure - add key-value.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsWebhookV2CustomizeStructureAddKeyValueParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsWebhookV2CustomizeStructureAddKeyValue = function (params) {
    return { evid: 1396, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardFetchDealerLayoutFailedParams
* @property {string} dashboard_type - old/new
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} type - fallback/cached
**/
/**
 * Name: dashboard > fetch dealer layout failed. src: 5 Evid: 1999.
 * Event description: when fetching from dealer layout is failed.

 * dashboard_type - Type: string. Desc: old/new
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * type - Type: string. Desc: fallback/cached
 * @param {dashboardFetchDealerLayoutFailedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardFetchDealerLayoutFailed = function (params) {
    return { evid: 1999, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} financialServicesSettingsInvoicesDefaultsNotesEditNotesParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Financial Services Settings - invoices - defaults notes - edit notes. src: 5 Evid: 1307.
 * Event description: Financial Services Settings - invoices - defaults notes - edit notes.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {financialServicesSettingsInvoicesDefaultsNotesEditNotesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var financialServicesSettingsInvoicesDefaultsNotesEditNotes = function (params) {
    return { evid: 1307, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} cardCtaParams
* @property {GUID} announcement_id - announcement_id
* @property {string} button_name - cta name
* @property {string} button_type - main/secondary
* @property {number} card_position - position of the announcement
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: New Releases - Card CTA. src: 5 Evid: 342.
 * Event description: CTA button.

 * announcement_id - Type: guid. Desc: announcement_id
 *
 * button_name - Type: string. Desc: cta name
 *
 * button_type - Type: string. Desc: main/secondary
 *
 * card_position - Type: numeric. Desc: position of the announcement
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {cardCtaParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var cardCta = function (params) {
    return { evid: 342, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} ssoSettingsUpdateSsoSettingsParams
* @property {boolean} is_first_update - Is it the first time the user updates SSO settings. The first time will not have sso_id.
* @property {string} platform - null
* @property {GUID} sso_id - sso_id
* @property {string} sso_user_type - DIFM/DIY (is the SSO of type Do It For Me/ Do It Yourself)
**/
/**
 * Name: SSO Settings - Update SSO Settings. src: 5 Evid: 1683.
 * Event description: The user updated the SSO settings page.

 * is_first_update - Type: bool. Desc: Is it the first time the user updates SSO settings. The first time will not have sso_id.
 *
 * platform - Type: string.
 *
 * sso_id - Type: guid. Desc: sso_id
 *
 * sso_user_type - Type: string. Desc: DIFM/DIY (is the SSO of type Do It For Me/ Do It Yourself)
 * @param {ssoSettingsUpdateSsoSettingsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ssoSettingsUpdateSsoSettings = function (params) {
    return { evid: 1683, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesNonValidPaypalAccountPopupCloseParams
* @property {string} msid - msid
* @property {string} name - name of payment
* @property {string} origin - how user arrived to the flow
* @property {string} platform - null
**/
/**
 * Name: Quotes - Non valid Paypal account popup - Close. src: 5 Evid: 444.
 * Event description: when a user closes the popup.

 * msid - Type: string. Desc: msid
 *
 * name - Type: string. Desc: name of payment
 *
 * origin - Type: string. Desc: how user arrived to the flow
 *
 * platform - Type: string.
 * @param {quotesNonValidPaypalAccountPopupCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesNonValidPaypalAccountPopupClose = function (params) {
    return { evid: 444, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} mobilePhoneNumberConfirmationOpenPopUpParams
* @property {string} platform - null
**/
/**
 * Name: Mobile Phone Number Confirmation - Click on "Add your phone number". src: 5 Evid: 667.
 * Event description: the first trigger to open the confirmation pop up. can come from "save changes" or by "confirm your phone".

 * platform - Type: string.
 * @param {mobilePhoneNumberConfirmationOpenPopUpParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mobilePhoneNumberConfirmationOpenPopUp = function (params) {
    return { evid: 667, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerMinimizeExpandSetupWidgetParams
* @property {string} app_id - app def id
* @property {number} done_steps - number of done steps in setup
* @property {string} hosting - MA/editor
* @property {string} module_id - module name
* @property {GUID} msid - metasite id
* @property {string} platform - null
* @property {number} skipped_steps - skipped_steps
* @property {number} steps - number of steps in setup
* @property {string} widget_state - minimized/expanded
**/
/**
 * Name: Biz Manager - minimize/expand setup widget. src: 5 Evid: 574.
 * Event description: user minimizes/expands TPA setup widget in biz mgr.

 * app_id - Type: string. Desc: app def id
 *
 * done_steps - Type: numeric. Desc: number of done steps in setup
 *
 * hosting - Type: string. Desc: MA/editor
 *
 * module_id - Type: string. Desc: module name
 *
 * msid - Type: guid. Desc: metasite id
 *
 * platform - Type: string.
 *
 * skipped_steps - Type: numeric. Desc: skipped_steps
 *
 * steps - Type: numeric. Desc: number of steps in setup
 *
 * widget_state - Type: string. Desc: minimized/expanded
 * @param {bizManagerMinimizeExpandSetupWidgetParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerMinimizeExpandSetupWidget = function (params) {
    return { evid: 574, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} mySitesHoverSiteParams
* @property {string} ds_origin - editor/ adi
* @property {boolean} is_premium - is_premium
* @property {boolean} is_published - is_published
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: My Sites - hover site. src: 5 Evid: 161.
 * Event description: send when a users hover site.

 * ds_origin - Type: string. Desc: editor/ adi
 *
 * is_premium - Type: bool. Desc: is_premium
 *
 * is_published - Type: bool. Desc: is_published
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {mySitesHoverSiteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mySitesHoverSite = function (params) {
    return { evid: 161, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsClickOnExistingAutomationParams
* @property {GUID} msid - msid
* @property {string} origin - 'home' / 'my automations page'
* @property {string} platform - null
* @property {GUID} rule_id - rule_id
* @property {string} rule_name - rule_name
**/
/**
 * Name: Automations > click on existing automation. src: 5 Evid: 144.
 * Event description: user click on existing automation.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: 'home' / 'my automations page'
 *
 * platform - Type: string.
 *
 * rule_id - Type: guid. Desc: rule_id
 *
 * rule_name - Type: string. Desc: rule_name
 * @param {automationsClickOnExistingAutomationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsClickOnExistingAutomation = function (params) {
    return { evid: 144, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} financialServicesSettingsInvoicesBusinessInfoEditFieldParams
* @property {string} field - field
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Financial Services Settings - invoices - business info - edit field. src: 5 Evid: 1306.
 * Event description: Financial Services Settings - invoices - business info - edit field.

 * field - Type: string. Desc: field
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {financialServicesSettingsInvoicesBusinessInfoEditFieldParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var financialServicesSettingsInvoicesBusinessInfoEditField = function (params) {
    return { evid: 1306, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesPreviewInvoiceClickInPreviewPageMenuParams
* @property {GUID} externalId - null
* @property {GUID} invoice_id - invoice guid
* @property {GUID} invoiceSource - null
* @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
* @property {string} msid - msid
* @property {string} origin - create invoice, edit invoice
* @property {string} platform - platform
* @property {string} source - (invoices/ crm home/ os dashboard)
* @property {string} value - share / print / edit / resend via email/ send via email
**/
/**
 * Name: Quotes - Preview invoice - click in preview page menu. src: 5 Evid: 1549.
 * Event description: Create invoice - user click in preview page menu.

 * externalId - Type: guid.
 *
 * invoice_id - Type: guid. Desc: invoice guid
 *
 * invoiceSource - Type: guid.
 *
 * invoiceType - Type: string. Desc: ’recurringAutoCharge’/ 'recurring'/ 'one time'
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: create invoice, edit invoice
 *
 * platform - Type: string. Desc: platform
 *
 * source - Type: string. Desc: (invoices/ crm home/ os dashboard)
 *
 * value - Type: string. Desc: share / print / edit / resend via email/ send via email
 * @param {quotesPreviewInvoiceClickInPreviewPageMenuParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesPreviewInvoiceClickInPreviewPageMenu = function (params) {
    return { evid: 1549, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesClickCtaInManagePaymentsBannerParams
* @property {GUID} msid - msid
* @property {string} name - banner name {manage payments}
* @property {string} platform - null
**/
/**
 * Name: Quotes - click CTA in manage payments banner. src: 5 Evid: 457.
 * Event description: User clicks on CTA (Payments) in manage payments banner.

 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: banner name {manage payments}
 *
 * platform - Type: string.
 * @param {quotesClickCtaInManagePaymentsBannerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesClickCtaInManagePaymentsBanner = function (params) {
    return { evid: 457, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationMainTableUserSearchFocusOutParams
* @property {GUID} msid - msid
* @property {number} numOfResults - number of results the user get
* @property {string} platform - null
* @property {string} searchText - the text the user search for
**/
/**
 * Name: Automation > main table > user search focus out. src: 5 Evid: 2008.
 * Event description: main table > user search focus out.

 * msid - Type: guid. Desc: msid
 *
 * numOfResults - Type: numeric. Desc: number of results the user get
 *
 * platform - Type: string.
 *
 * searchText - Type: string. Desc: the text the user search for
 * @param {automationMainTableUserSearchFocusOutParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationMainTableUserSearchFocusOut = function (params) {
    return { evid: 2008, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesCreateInvoiceCancelClickParams
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} origin - button, navigation
* @property {string} platform - null
**/
/**
 * Name: Quotes - Create invoice - Cancel click. src: 5 Evid: 411.
 * Event description: Create invoice - cancel click.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: button, navigation
 *
 * platform - Type: string.
 * @param {quotesCreateInvoiceCancelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesCreateInvoiceCancelClick = function (params) {
    return { evid: 411, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesRecurringCancelSubscriptionParams
* @property {string} value - ’cancel subscription’ / ‘cancel’ / ‘X’
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Invoices - recurring- cancel subscription. src: 5 Evid: 1580.
 * Event description: Invoices - recurring- cancel subscription.

 * value - Type: string. Desc: ’cancel subscription’ / ‘cancel’ / ‘X’
 *
 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {invoicesRecurringCancelSubscriptionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesRecurringCancelSubscription = function (params) {
    return { evid: 1580, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} phoneVerificationPhoneValidationParams
* @property {string} platform - null
**/
/**
 * Name: Add Phone Number - Wizard Opened. src: 5 Evid: 665.
 * Event description: after inserting the password, the wizard opens..

 * platform - Type: string.
 * @param {phoneVerificationPhoneValidationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var phoneVerificationPhoneValidation = function (params) {
    return { evid: 665, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesErrorGenerateLinkFromMoreActionsParams
* @property {GUID} invoiceId - invoiceId
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Quotes - error generate link from more actions. src: 5 Evid: 728.
 * Event description: Quotes - error generate link from more actions.

 * invoiceId - Type: guid. Desc: invoiceId
 *
 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {quotesErrorGenerateLinkFromMoreActionsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesErrorGenerateLinkFromMoreActions = function (params) {
    return { evid: 728, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesSettingsSuccessToastParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Quotes - Settings - success toast. src: 5 Evid: 498.
 * Event description: Quotes - Settings - success toast.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {quotesSettingsSuccessToastParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesSettingsSuccessToast = function (params) {
    return { evid: 498, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardTriggersFailedOnLoadShouOutParams
* @property {GUID} msid - msid
* @property {string} name - name of error
* @property {string} platform - null
* @property {string} recipe_name - recipe_name
* @property {GUID} rule_id - rule
* @property {number} src - null
**/
/**
 * Name: Automations > Failed On-Load ShouOut. src: 5 Evid: 219.
 * Event description: after customize the action user might get this event, because the shoutout customization was failed.

 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: name of error
 *
 * platform - Type: string.
 *
 * recipe_name - Type: string. Desc: recipe_name
 *
 * rule_id - Type: guid. Desc: rule
 *
 * src - Type: numeric.
 * @param {dashboardTriggersFailedOnLoadShouOutParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardTriggersFailedOnLoadShouOut = function (params) {
    return { evid: 219, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationFilterMenuAutomationTableExitClearParams
* @property {GUID} msid - msid
* @property {string} origin - from where this action was called
* @property {string} platform - null
* @property {string} type - clear_filter / exit_filter
**/
/**
 * Name: Automation > filter automation table - exit / clear. src: 5 Evid: 1355.
 * Event description: Automation > filter automation table - exit / clear.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: from where this action was called
 *
 * platform - Type: string.
 *
 * type - Type: string. Desc: clear_filter / exit_filter
 * @param {automationFilterMenuAutomationTableExitClearParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationFilterMenuAutomationTableExitClear = function (params) {
    return { evid: 1355, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} homeBizMgrEligibleParams
* @property {boolean} is_eligible - deprecated
* @property {GUID} msid - metasite id
* @property {number} phase_number - phase number
* @property {string} platform - null
**/
/**
 * Name: Home > biz mgr eligible. src: 5 Evid: 306.
 * Event description: checked if a user is eligible for biz mgr, phase=4 is for main funnel sites.

 * is_eligible - Type: bool. Desc: deprecated
 *
 * msid - Type: guid. Desc: metasite id
 *
 * phase_number - Type: numeric. Desc: phase number
 *
 * platform - Type: string.
 * @param {homeBizMgrEligibleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var homeBizMgrEligible = function (params) {
    return { evid: 306, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeTopCarouselLoadStartParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: CRM Home - Top carousel load start. src: 5 Evid: 1386.
 * Event description: CRM Home - Top carousel main CTA click.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {crmHomeTopCarouselLoadStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeTopCarouselLoadStart = function (params) {
    return { evid: 1386, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeViewContactViaContactsWidgetParams
* @property {GUID} contactId - contactId
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: CRM Home - view contact via contacts widget. src: 5 Evid: 819.
 * Event description: CRM Home - view contact via contacts widget.

 * contactId - Type: guid. Desc: contactId
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {crmHomeViewContactViaContactsWidgetParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeViewContactViaContactsWidget = function (params) {
    return { evid: 819, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} ascendPpCyclePageViewParams
* @property {GUID} app_id - app_id
* @property {string} origin - product name open PP
* @property {GUID} packageId - package id
* @property {string} package_name - package name
* @property {string} platform - null
* @property {string} referralInfo - button name open PP
**/
/**
 * Name: Ascend PP - Cycle Page view. src: 5 Evid: 135.
 * Event description: User view Ascend cycle page.

 * app_id - Type: guid. Desc: app_id
 *
 * origin - Type: string. Desc: product name open PP
 *
 * packageId - Type: guid. Desc: package id
 *
 * package_name - Type: string. Desc: package name
 *
 * platform - Type: string.
 *
 * referralInfo - Type: string. Desc: button name open PP
 * @param {ascendPpCyclePageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ascendPpCyclePageView = function (params) {
    return { evid: 135, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsSavingActivatingAnAutomationParams
* @property {string} actionName - action name
* @property {string} custom_name - rule custom name
* @property {string} flowType - if it's create or update
* @property {boolean} isPartial - isPartial
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} recipeName - IF not recipe put placeholder
* @property {GUID} rule_id - rule ID
* @property {string} successFlow - where the success happen.
* @property {string} triggerActivityType - trigger name
**/
/**
 * Name: Automations > Success saving/updating a rule. src: 5 Evid: 1558.
 * Event description: Automations > Saving/activating an automation.

 * actionName - Type: string. Desc: action name
 *
 * custom_name - Type: string. Desc: rule custom name
 *
 * flowType - Type: string. Desc: if it's create or update
 *
 * isPartial - Type: bool. Desc: isPartial
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * recipeName - Type: string. Desc: IF not recipe put placeholder
 *
 * rule_id - Type: guid. Desc: rule ID
 *
 * successFlow - Type: string. Desc: where the success happen.
 *
 * triggerActivityType - Type: string. Desc: trigger name
 * @param {automationsSavingActivatingAnAutomationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsSavingActivatingAnAutomation = function (params) {
    return { evid: 1558, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} foldersTooltipShownParams
* @property {string} hosting - MA
* @property {string} name - trash_tooltip
* @property {string} platform - null
* @property {string} sub_view - grid/list
* @property {string} view - my-sites
**/
/**
 * Name: Folders > Tooltip Shown. src: 5 Evid: 118.
 * Event description: When a user moves a site to Trash for the first time show a tooltip..

 * hosting - Type: string. Desc: MA
 *
 * name - Type: string. Desc: trash_tooltip
 *
 * platform - Type: string.
 *
 * sub_view - Type: string. Desc: grid/list
 *
 * view - Type: string. Desc: my-sites
 * @param {foldersTooltipShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var foldersTooltipShown = function (params) {
    return { evid: 118, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} ascendPpPurchasePageChangeCardParams
* @property {GUID} app_id - app_id
* @property {number} cycleId - cycle id
* @property {string} cycle_name - cycle name
* @property {string} origin - product name open PP
* @property {GUID} packageId - package id
* @property {string} package_name - package name
* @property {string} platform - null
* @property {string} referralInfo - button name open PP
* @property {string} selection - saved card / another card
**/
/**
 * Name: Ascend PP - Purchase Page Change Card. src: 5 Evid: 139.
 * Event description: User click on credit card option.

 * app_id - Type: guid. Desc: app_id
 *
 * cycleId - Type: numeric. Desc: cycle id
 *
 * cycle_name - Type: string. Desc: cycle name
 *
 * origin - Type: string. Desc: product name open PP
 *
 * packageId - Type: guid. Desc: package id
 *
 * package_name - Type: string. Desc: package name
 *
 * platform - Type: string.
 *
 * referralInfo - Type: string. Desc: button name open PP
 *
 * selection - Type: string. Desc: saved card / another card
 * @param {ascendPpPurchasePageChangeCardParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ascendPpPurchasePageChangeCard = function (params) {
    return { evid: 139, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} toolcastClickOnTheSpeakerParams
* @property {string} campaignId - from dealer
* @property {string} clickType - deprecated
* @property {boolean} firstStep - if the toolcast in the first step he can see text, bool.
* @property {string} offeringGuid - offer guid from dealer
* @property {string} origin - From where the user click panel or dashboard
* @property {string} platform - null
* @property {string} stepName - The name of the toolcast step
**/
/**
 * Name: Toolcast- Click on the speaker. src: 5 Evid: 1365.
 * Event description: when user click and if the toolcast in the first step and if the click is from the focus widget or panel.

 * campaignId - Type: string. Desc: from dealer
 *
 * clickType - Type: string. Desc: deprecated
 *
 * firstStep - Type: bool. Desc: if the toolcast in the first step he can see text, bool.
 *
 * offeringGuid - Type: string. Desc: offer guid from dealer
 *
 * origin - Type: string. Desc: From where the user click panel or dashboard
 *
 * platform - Type: string.
 *
 * stepName - Type: string. Desc: The name of the toolcast step
 * @param {toolcastClickOnTheSpeakerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var toolcastClickOnTheSpeaker = function (params) {
    return { evid: 1365, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesAddingBusinessNameParams
* @property {string} msid - msid
* @property {string} platform - null
* @property {GUID} uuid - uuid
**/
/**
 * Name: Quotes - Adding Business Name. src: 5 Evid: 471.
 * Event description: User added business logo (mobile).

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 * @param {quotesAddingBusinessNameParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesAddingBusinessName = function (params) {
    return { evid: 471, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsWebhookV2CustomizeStructureInsertVariableParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations - webhook v2 - customize structure - insert variable. src: 5 Evid: 1397.
 * Event description: Automations - webhook v2 - customize structure - insert variable.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsWebhookV2CustomizeStructureInsertVariableParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsWebhookV2CustomizeStructureInsertVariable = function (params) {
    return { evid: 1397, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} priorityAEssentialShownParams
* @property {boolean} isCarousel - true if he have carousel (more than 4 offers)
* @property {GUID} msid - msid
* @property {number} numOffer - how many offers he have in the section
* @property {string} platform - null
**/
/**
 * Name: Priority A (Essential) Section shown. src: 5 Evid: 8975.
 * Event description: when the users see the section.

 * isCarousel - Type: bool. Desc: true if he have carousel (more than 4 offers)
 *
 * msid - Type: guid. Desc: msid
 *
 * numOffer - Type: numeric. Desc: how many offers he have in the section
 *
 * platform - Type: string.
 * @param {priorityAEssentialShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var priorityAEssentialShown = function (params) {
    return { evid: 8975, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeSecondaryCtaClickParams
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} tabName - which tab the user choosed
* @property {GUID} uuid - uuid
**/
/**
 * Name: CRM Home - secondary CTA click. src: 5 Evid: 491.


 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * tabName - Type: string. Desc: which tab the user choosed
 *
 * uuid - Type: guid. Desc: uuid
 * @param {crmHomeSecondaryCtaClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeSecondaryCtaClick = function (params) {
    return { evid: 491, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardAccountSettingsRenderedWithShowProBoxValueParams
* @property {string} platform - null
* @property {boolean} show_pro_box - true if box is shown
**/
/**
 * Name: dashboard > Account settings rendered - with show_pro_box value. src: 5 Evid: 156.
 * Event description: Account settings rendered with indicator if pro-account box is shown.

 * platform - Type: string.
 *
 * show_pro_box - Type: bool. Desc: true if box is shown
 * @param {dashboardAccountSettingsRenderedWithShowProBoxValueParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardAccountSettingsRenderedWithShowProBoxValue = function (params) {
    return { evid: 156, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} foldersApproveActionFromFolderSQuickActionPopupParams
* @property {string} cta - folder’s quick action / quick actions button
* @property {string} folder_name - the name of the folder
* @property {number} nesting_level - 0 (my-sites)/1 (folder) /2/3...
* @property {string} origin - site-list \ site-list-enterprise
* @property {string} platform - null
* @property {string} popup_name - delete_folder/rename_folder
**/
/**
 * Name: Folders > approve action from quick action popup. src: 5 Evid: 126.
 * Event description: approve action from folder's quick action popup.

 * cta - Type: string. Desc: folder’s quick action / quick actions button
 *
 * folder_name - Type: string. Desc: the name of the folder
 *
 * nesting_level - Type: numeric. Desc: 0 (my-sites)/1 (folder) /2/3...
 *
 * origin - Type: string. Desc: site-list \ site-list-enterprise
 *
 * platform - Type: string.
 *
 * popup_name - Type: string. Desc: delete_folder/rename_folder
 * @param {foldersApproveActionFromFolderSQuickActionPopupParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var foldersApproveActionFromFolderSQuickActionPopup = function (params) {
    return { evid: 126, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} apesEditNotificationSelectAudienceParams
* @property {string} audience - which audience was chosen
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {GUID} rule_id - rule id
**/
/**
 * Name: APeS - edit notification - select audience. src: 5 Evid: 1238.
 * Event description: APeS - Save edited notification.

 * audience - Type: string. Desc: which audience was chosen
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * rule_id - Type: guid. Desc: rule id
 * @param {apesEditNotificationSelectAudienceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var apesEditNotificationSelectAudience = function (params) {
    return { evid: 1238, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} foldersClickOnMoveToFolderFromDialogParams
* @property {number} destination_nesting_level - 0 (my-sites), 1 (folder), 2(folder in 1 folder) etc
* @property {string} folder - the name of the chosen folder
* @property {number} origin_nesting_level - 0 (my-sites), 1 (folder), 2(folder in 1 folder)
* @property {string} moved_item_type - folder \ site
* @property {string} msid - The site msid
* @property {number} num_folders_moved - number of folders move to the folder
* @property {number} num_sites_moved - number of sites move to the folder
* @property {string} origin - site-list \ site-list-enterprise
* @property {string} platform - null
* @property {Url} referral_url - The url of the current page
**/
/**
 * Name: Folders > click on 'Move to Folder' from dialog. src: 5 Evid: 124.
 * Event description: When a user clicks on ‘Move to Folder’ from the dialog shown.

 * destination_nesting_level - Type: numeric. Desc: 0 (my-sites), 1 (folder), 2(folder in 1 folder) etc
 *
 * folder - Type: string. Desc: the name of the chosen folder
 *
 * origin_nesting_level - Type: numeric. Desc: 0 (my-sites), 1 (folder), 2(folder in 1 folder)
 *
 * moved_item_type - Type: string. Desc: folder \ site
 *
 * msid - Type: string. Desc: The site msid
 *
 * num_folders_moved - Type: numeric. Desc: number of folders move to the folder
 *
 * num_sites_moved - Type: numeric. Desc: number of sites move to the folder
 *
 * origin - Type: string. Desc: site-list \ site-list-enterprise
 *
 * platform - Type: string.
 *
 * referral_url - Type: url. Desc: The url of the current page
 * @param {foldersClickOnMoveToFolderFromDialogParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var foldersClickOnMoveToFolderFromDialog = function (params) {
    return { evid: 124, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} notificationsClickOnDesktopNotificationsBannerParams
* @property {string} feed_name - All Sites/This Site /Float
* @property {string} origin - (Msid/my-site) MSID of the site the user is on, my-sites if on Site List. Later on, also account-settings, and other account-level pages.
* @property {string} platform - null
**/
/**
 * Name: Notifications > close desktop notifications banner. src: 5 Evid: 281.
 * Event description: display desktop notifications banner.

 * feed_name - Type: string. Desc: All Sites/This Site /Float
 *
 * origin - Type: string. Desc: (Msid/my-site) MSID of the site the user is on, my-sites if on Site List. Later on, also account-settings, and other account-level pages.
 *
 * platform - Type: string.
 * @param {notificationsClickOnDesktopNotificationsBannerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var notificationsClickOnDesktopNotificationsBanner = function (params) {
    return { evid: 281, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} myAccountSelectSiteFromSiteListPopup1295Params
* @property {string} hosting - MA
* @property {number} src - null
* @property {GUID} msid - null
* @property {number} num_selected_sites - number of sites selected
* @property {string} origin - null
* @property {string} place - null
* @property {string} platform - null
* @property {GUID} site_id - null
* @property {number} artificial_src - null
* @property {string} sub_view - grid/list-view
* @property {string} view - my-sites
**/
/**
 * Name: my account -> select site from site-list popup. src: 5 Evid: 129.
 * Event description: multi selection 'Move to Folder' button (mapped to 2/129).

 * hosting - Type: string. Desc: MA
 *
 * src - Type: numeric.
 *
 * msid - Type: guid.
 *
 * num_selected_sites - Type: numeric. Desc: number of sites selected
 *
 * origin - Type: string.
 *
 * place - Type: string.
 *
 * platform - Type: string.
 *
 * site_id - Type: guid.
 *
 * artificial_src - Type: numeric.
 *
 * sub_view - Type: string. Desc: grid/list-view
 *
 * view - Type: string. Desc: my-sites
 * @param {myAccountSelectSiteFromSiteListPopup1295Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var myAccountSelectSiteFromSiteListPopup1295 = function (params) {
    return { evid: 129, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} pingPingWidgetLoadedInEditNotificationDialogParams
* @property {string} config - JSON field of the configuration, contains ape details
* @property {boolean} isPMFlow - is pm flow
* @property {GUID} msid - site guid
* @property {string} platform - null
* @property {string} ruleId - the rule id
**/
/**
 * Name: Ping > Ping Widget loaded in Edit Notification dialog. src: 5 Evid: 1698.
 * Event description: Apes - Ping widget loaded in Edit Notification dialog after Automations opened that dialog when user click on Preview & Edit. this Event is for debugging purposes.

 * config - Type: string. Desc: JSON field of the configuration, contains ape details
 *
 * isPMFlow - Type: bool. Desc: is pm flow
 *
 * msid - Type: guid. Desc: site guid
 *
 * platform - Type: string.
 *
 * ruleId - Type: string. Desc: the rule id
 * @param {pingPingWidgetLoadedInEditNotificationDialogParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pingPingWidgetLoadedInEditNotificationDialog = function (params) {
    return { evid: 1698, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} needsYourActionClickOnUndoHidingAnItemParams
* @property {string} hosting - MA/editor/ADI
* @property {string} item_id - item id
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} template_id - template id of the action
**/
/**
 * Name: Needs Your Action > click on undo hiding an item. src: 5 Evid: 334.
 * Event description: Click on hide after hiding an item.

 * hosting - Type: string. Desc: MA/editor/ADI
 *
 * item_id - Type: string. Desc: item id
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * template_id - Type: string. Desc: template id of the action
 * @param {needsYourActionClickOnUndoHidingAnItemParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var needsYourActionClickOnUndoHidingAnItem = function (params) {
    return { evid: 334, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesSettingsChangeNumberingParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Quotes - settings - change numbering. src: 5 Evid: 730.
 * Event description: Quotes - settings - change numbering.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {quotesSettingsChangeNumberingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesSettingsChangeNumbering = function (params) {
    return { evid: 730, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsLoadCardInAutomationsPageParams
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} provider - provider
* @property {number} registerTime - time that take to register
**/
/**
 * Name: Automations > load card in automations page. src: 5 Evid: 1561.
 * Event description: Automations > load card in automations page.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * provider - Type: string. Desc: provider
 *
 * registerTime - Type: numeric. Desc: time that take to register
 * @param {automationsLoadCardInAutomationsPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsLoadCardInAutomationsPage = function (params) {
    return { evid: 1561, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesNewRecurrentInvoiceClickParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Invoices - New Recurrent invoice click. src: 5 Evid: 1564.
 * Event description: Invoices - New Recurrent invoice click.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {invoicesNewRecurrentInvoiceClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesNewRecurrentInvoiceClick = function (params) {
    return { evid: 1564, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} contactEnrichmentTemporaryEventParams
* @property {string} contact_id - contact id
* @property {boolean} hasContacts - ignore this field
* @property {GUID} msid - msid
* @property {string} origin - app that requested the enrichment
* @property {string} pageView - ignore this field
* @property {string} platform - null
**/
/**
 * Name: Contact Enrichment - temporary event. src: 5 Evid: 499.
 * Event description: contact enrichment requset.

 * contact_id - Type: string. Desc: contact id
 *
 * hasContacts - Type: bool. Desc: ignore this field
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: app that requested the enrichment
 *
 * pageView - Type: string. Desc: ignore this field
 *
 * platform - Type: string.
 * @param {contactEnrichmentTemporaryEventParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contactEnrichmentTemporaryEvent = function (params) {
    return { evid: 499, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesSearchQuotesParams
* @property {string} msid - msid
* @property {number} num_of_quotes - number of quotes the user has
* @property {number} num_of_results - number of returned results
* @property {string} origin_device - web,native
* @property {string} platform - null
* @property {string} text - text searched
**/
/**
 * Name: Quotes - search Quotes. src: 5 Evid: 74.
 * Event description: user searches  in the Quotes view.

 * msid - Type: string. Desc: msid
 *
 * num_of_quotes - Type: numeric. Desc: number of quotes the user has
 *
 * num_of_results - Type: numeric. Desc: number of returned results
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string.
 *
 * text - Type: string. Desc: text searched
 * @param {quotesSearchQuotesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesSearchQuotes = function (params) {
    return { evid: 74, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} removePhoneNumberRemoveNumberClickedParams
* @property {string} platform - null
**/
/**
 * Name: Remove Phone Number - Remove Phone Clicked. src: 5 Evid: 98.
 * Event description: First button for remove phone number (in account settings page).

 * platform - Type: string.
 * @param {removePhoneNumberRemoveNumberClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var removePhoneNumberRemoveNumberClicked = function (params) {
    return { evid: 98, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} homeMarkNotificationUnreadParams
* @property {string} app_id - app that sent the notification
* @property {GUID} msid - msid
* @property {GUID} notification_id - notification id
* @property {string} platform - null
**/
/**
 * Name: Home > mark notification unread old event . now deprecated. src: 5 Evid: 251.
 * Event description: user clicks on mark as unread.

 * app_id - Type: string. Desc: app that sent the notification
 *
 * msid - Type: guid. Desc: msid
 *
 * notification_id - Type: guid. Desc: notification id
 *
 * platform - Type: string.
 * @param {homeMarkNotificationUnreadParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var homeMarkNotificationUnread = function (params) {
    return { evid: 251, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesRecurringSelectPremiumPlanIncludedOnlyServicesParams
* @property {string} msid - msid
* @property {string} platform - BM/ client billing
* @property {GUID} uuid - uuid
* @property {string} value - null
**/
/**
 * Name: Invoices - recurring - select Premium Plan included/only services. src: 5 Evid: 1632.
 * Event description: Quotes - recurring - select Premium Plan included/only services.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string. Desc: BM/ client billing
 *
 * uuid - Type: guid. Desc: uuid
 *
 * value - Type: string.
 * @param {invoicesRecurringSelectPremiumPlanIncludedOnlyServicesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesRecurringSelectPremiumPlanIncludedOnlyServices = function (params) {
    return { evid: 1632, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardTriggersBrowseTriggersParams
* @property {GUID} msid - msid
* @property {string} origin - button, link, header, success creation dialog
* @property {string} page - FT/ browse triggers
* @property {string} platform - null
* @property {string} referral_info - indicate which vertical is the dacomponent triggered from
* @property {number} src - null
**/
/**
 * Name: Automations > Start to create Automation from Scratch. src: 5 Evid: 200.
 * Event description: start now click.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: button, link, header, success creation dialog
 *
 * page - Type: string. Desc: FT/ browse triggers
 *
 * platform - Type: string.
 *
 * referral_info - Type: string. Desc: indicate which vertical is the dacomponent triggered from
 *
 * src - Type: numeric.
 * @param {dashboardTriggersBrowseTriggersParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardTriggersBrowseTriggers = function (params) {
    return { evid: 200, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardTriggersDeleteParams
* @property {GUID} msid - msid
* @property {string} origin - all triggers / create trigger
* @property {string} platform - null
* @property {string} recipe_name - recipe name
* @property {GUID} rule_id - rule_id
* @property {number} src - null
**/
/**
 * Name: Automations > Delete. src: 5 Evid: 216.
 * Event description: Delete.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: all triggers / create trigger
 *
 * platform - Type: string.
 *
 * recipe_name - Type: string. Desc: recipe name
 *
 * rule_id - Type: guid. Desc: rule_id
 *
 * src - Type: numeric.
 * @param {dashboardTriggersDeleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardTriggersDelete = function (params) {
    return { evid: 216, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesCreateInvoiceSendInvoiceModalResolutionParams
* @property {GUID} invoice_id - invoice guid
* @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
* @property {string} msid - msid
* @property {string} origin - create invoice, edit invoice
* @property {string} platform - platform
* @property {string} source - source
* @property {string} value - send / cancel / X
**/
/**
 * Name: Quotes - Create invoice - Send invoice modal resolution. src: 5 Evid: 1551.
 * Event description: Create invoice - user choose between Send or cancel in invoice final modal.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * invoiceType - Type: string. Desc: ’recurringAutoCharge’/ 'recurring'/ 'one time'
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: create invoice, edit invoice
 *
 * platform - Type: string. Desc: platform
 *
 * source - Type: string. Desc: source
 *
 * value - Type: string. Desc: send / cancel / X
 * @param {quotesCreateInvoiceSendInvoiceModalResolutionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesCreateInvoiceSendInvoiceModalResolution = function (params) {
    return { evid: 1551, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsStoresChooseSpecificProductDropdownParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations - choose specific product dropdown. src: 5 Evid: 1318.
 * Event description: Automations -  choose specific product dropdown.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsStoresChooseSpecificProductDropdownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsStoresChooseSpecificProductDropdown = function (params) {
    return { evid: 1318, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesChooseACustomerParams
* @property {GUID} invoice_id - invoice guid
* @property {boolean} is_new_contact - is_new_contact
* @property {string} msid - msid
* @property {string} platform - null
* @property {GUID} uuid - uuid
**/
/**
 * Name: Quotes - Choose a Customer. src: 5 Evid: 461.
 * Event description: User Choose a Customer.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * is_new_contact - Type: bool. Desc: is_new_contact
 *
 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 * @param {quotesChooseACustomerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesChooseACustomer = function (params) {
    return { evid: 461, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesRecurringHoverOnNextWhenNotConnectedToPaymentMethodParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Invoices - recurring- hover on next when not connected to payment method. src: 5 Evid: 1582.
 * Event description: Hover on next when user is not connected to a supported payment method.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {invoicesRecurringHoverOnNextWhenNotConnectedToPaymentMethodParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesRecurringHoverOnNextWhenNotConnectedToPaymentMethod = function (params) {
    return { evid: 1582, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardBannerLoadingCompleteParams
* @property {GUID} msid - msid
* @property {string} name - banner name for identification
* @property {string} origin - origin
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: dashboard > banner loading complete. src: 5 Evid: 55.
 * Event description: Please add event for banners loading completion (as we have for seeing, clicking and closing banners events src= 5 evid=14,34,36).

 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: banner name for identification
 *
 * origin - Type: string. Desc: origin
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {dashboardBannerLoadingCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardBannerLoadingComplete = function (params) {
    return { evid: 55, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesDropdownOptionParams
* @property {string} msid - msid
* @property {string} option - which option was choosen
* @property {string} platform - null
* @property {string} text - if custom was picked which test added, in other options put null
**/
/**
 * Name: Quotes - dropdown option. src: 5 Evid: 734.
 * Event description: Quotes - dropdown option.

 * msid - Type: string. Desc: msid
 *
 * option - Type: string. Desc: which option was choosen
 *
 * platform - Type: string.
 *
 * text - Type: string. Desc: if custom was picked which test added, in other options put null
 * @param {quotesDropdownOptionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesDropdownOption = function (params) {
    return { evid: 734, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} searchClickOnSearchResultParams
* @property {number} item_index - item's index in all results
* @property {number} item_index_in_section - the item's index in it's section
* @property {GUID} msid - msid
* @property {string} origin - settings lobby / bizmgr
* @property {string} platform - null
* @property {string} query - query
* @property {string} section - result's section
* @property {number} section_index - the index of the section in results
* @property {string} sub_view - page in app
* @property {string} title - result's title
* @property {string} title_id - result's title id
* @property {string} view - requested view
**/
/**
 * Name: Search > Click on search result. src: 5 Evid: 165.
 * Event description: when a user is focused on a result.

 * item_index - Type: numeric. Desc: item's index in all results
 *
 * item_index_in_section - Type: numeric. Desc: the item's index in it's section
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: settings lobby / bizmgr
 *
 * platform - Type: string.
 *
 * query - Type: string. Desc: query
 *
 * section - Type: string. Desc: result's section
 *
 * section_index - Type: numeric. Desc: the index of the section in results
 *
 * sub_view - Type: string. Desc: page in app
 *
 * title - Type: string. Desc: result's title
 *
 * title_id - Type: string. Desc: result's title id
 *
 * view - Type: string. Desc: requested view
 * @param {searchClickOnSearchResultParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var searchClickOnSearchResult = function (params) {
    return { evid: 165, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesGetPaymentClickParams
* @property {string} msid - msid
* @property {string} name - name of payment
* @property {string} origin - how user arrived to the flow
* @property {string} platform - null
* @property {string} type - connect/disconnect
**/
/**
 * Name: Quotes - Get payment click. src: 5 Evid: 402.
 * Event description: site owner payment funnel - get payment click.

 * msid - Type: string. Desc: msid
 *
 * name - Type: string. Desc: name of payment
 *
 * origin - Type: string. Desc: how user arrived to the flow
 *
 * platform - Type: string.
 *
 * type - Type: string. Desc: connect/disconnect
 * @param {quotesGetPaymentClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesGetPaymentClick = function (params) {
    return { evid: 402, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesRunReportClickGenerateReportClickParams
* @property {string} basis - accural, cash
* @property {string} msid - msid
* @property {string} name - tax, revenue
* @property {string} platform - null
**/
/**
 * Name: Quotes - Run report click (generate report click). src: 5 Evid: 451.
 * Event description: user clicks on run report in tax/revenue summary, this initiates the creation of a report. use 'name'  to choose tax or revenue..

 * basis - Type: string. Desc: accural, cash
 *
 * msid - Type: string. Desc: msid
 *
 * name - Type: string. Desc: tax, revenue
 *
 * platform - Type: string.
 * @param {quotesRunReportClickGenerateReportClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesRunReportClickGenerateReportClick = function (params) {
    return { evid: 451, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardNewSiteParams
* @property {number} src - null
* @property {string} platform - null
* @property {number} artificial_src - null
**/
/**
 * Name: dashboard > new site. src: 5 Evid: 70.


 * src - Type: numeric.
 *
 * platform - Type: string.
 *
 * artificial_src - Type: numeric.
 * @param {dashboardNewSiteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardNewSite = function (params) {
    return { evid: 70, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerSidebarItemSelectedHighlightedParams
* @property {string} app_id - app_id of the item
* @property {number} counter - The value inside the counter clicked (if counter exists)
* @property {string} hosting - MA/editor
* @property {GUID} msid - metasite id
* @property {string} name - unique name that doesn't change when changing the name on the side bar
* @property {string} platform - null
* @property {string} sidebar_name - the name that appears in the sidebar - can be changed
**/
/**
 * Name: Biz Manager - Sidebar Item Selected (Highlighted). src: 5 Evid: 1649.
 * Event description: User has some BM Sidebar item selected (highlighted - user is on a page).

 * app_id - Type: string. Desc: app_id of the item
 *
 * counter - Type: numeric. Desc: The value inside the counter clicked (if counter exists)
 *
 * hosting - Type: string. Desc: MA/editor
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: unique name that doesn't change when changing the name on the side bar
 *
 * platform - Type: string.
 *
 * sidebar_name - Type: string. Desc: the name that appears in the sidebar - can be changed
 * @param {bizManagerSidebarItemSelectedHighlightedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerSidebarItemSelectedHighlighted = function (params) {
    return { evid: 1649, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesDeleteProductPageOkParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Quotes - Delete product page - Ok. src: 5 Evid: 419.
 * Event description: OK click in delete product page.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {quotesDeleteProductPageOkParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesDeleteProductPageOk = function (params) {
    return { evid: 419, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} toolcastClickContinueInTheGuideParams
* @property {string} campaignId - from dealer
* @property {string} ctaName - cta name
* @property {string} offeringGuid - offer guid
* @property {string} platform - null
**/
/**
 * Name: Toolcast- click continue in the guide. src: 5 Evid: 1371.
 * Event description: when user click continue on the guide.

 * campaignId - Type: string. Desc: from dealer
 *
 * ctaName - Type: string. Desc: cta name
 *
 * offeringGuid - Type: string. Desc: offer guid
 *
 * platform - Type: string.
 * @param {toolcastClickContinueInTheGuideParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var toolcastClickContinueInTheGuide = function (params) {
    return { evid: 1371, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesEditModesEditCustomerInfoModalChooseParams
* @property {string} invoiceStatus - which status was the invoice
* @property {GUID} msid - msid
* @property {string} option - option chosen - cancel or proceed
* @property {string} platform - null
**/
/**
 * Name: Invoices - edit modes - edit customer info modal - choose. src: 5 Evid: 1330.
 * Event description: Invoices - edit modes - edit customer info modal.

 * invoiceStatus - Type: string. Desc: which status was the invoice
 *
 * msid - Type: guid. Desc: msid
 *
 * option - Type: string. Desc: option chosen - cancel or proceed
 *
 * platform - Type: string.
 * @param {invoicesEditModesEditCustomerInfoModalChooseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesEditModesEditCustomerInfoModalChoose = function (params) {
    return { evid: 1330, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesWidgetChangeTabParams
* @property {GUID} msid - msid
* @property {string} origin - ‘crm home widget/ ‘os-dashboard’
* @property {string} platform - null
* @property {string} tabFrom - tab from
* @property {string} tabTo - tab to
**/
/**
 * Name: Invoices - widget - Change tab. src: 5 Evid: 1323.
 * Event description: Invoices - widget - Change tab.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: ‘crm home widget/ ‘os-dashboard’
 *
 * platform - Type: string.
 *
 * tabFrom - Type: string. Desc: tab from
 *
 * tabTo - Type: string. Desc: tab to
 * @param {invoicesWidgetChangeTabParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesWidgetChangeTab = function (params) {
    return { evid: 1323, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} email2faSetupEnableClickParams
* @property {string} origin - account settings page/phone modal/app modal/second best
* @property {string} platform - null
**/
/**
 * Name: Email 2FA Setup - Enable Click. src: 5 Evid: 1672.
 * Event description: The user click on 'enable' to enable Email 2FA.

 * origin - Type: string. Desc: account settings page/phone modal/app modal/second best
 *
 * platform - Type: string.
 * @param {email2faSetupEnableClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var email2faSetupEnableClick = function (params) {
    return { evid: 1672, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} transferSiteCancelTransferClickApproveParams
* @property {string} hosting - MA /Editor
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Transfer site - cancel transfer - click approve. src: 5 Evid: 61.
 * Event description: user clicks approve cancel transfer.

 * hosting - Type: string. Desc: MA /Editor
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {transferSiteCancelTransferClickApproveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var transferSiteCancelTransferClickApprove = function (params) {
    return { evid: 61, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} renameSiteOpenRenameDialogParams
* @property {string} cta - ‘sidepanel’ / ‘menu’
* @property {GUID} msid - msid
* @property {string} origin - site-list \ site-list-enterprise
* @property {string} platform - null
**/
/**
 * Name: Rename site  - open rename dialog. src: 5 Evid: 328.
 * Event description: rename dialog is opened.

 * cta - Type: string. Desc: ‘sidepanel’ / ‘menu’
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: site-list \ site-list-enterprise
 *
 * platform - Type: string.
 * @param {renameSiteOpenRenameDialogParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var renameSiteOpenRenameDialog = function (params) {
    return { evid: 328, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizmgrComponentLoadingWithAnErrorParams
* @property {string} app_id - The app_id of the page which hosts the component
* @property {string} component_app_id - The app_id of the component
* @property {string} component_id - the Id of the component
* @property {string} component_name - The component name
* @property {string} component_type - page/widget/sidebar/header
* @property {string} context - when the context is site - send msid, when the context is app for example (like in devCenter) send appDefId, etc.
* @property {string} error_type - the type of the error (f.e: permissions, system error, etc.)
* @property {string} host_id - the host id (meaningful string - f.e. ‘sidebar’,’settings-lobby’)
* @property {string} hosting - MA/Editor/onboarding
* @property {string} hosting_platform - accountmanagr/bizmanagr/devcenter/etc.
* @property {number} interval_load_time - load time of this component until it crashed in ms
* @property {number} loading_time_from_host_load - loading time from the start loading of the page which hosting the component until the component crashed (in ms)
* @property {number} loading_time_from_host_platform_load - loading time from the start loading of the hosting platform until the component crashed (in ms)
* @property {GUID} msid - msid
* @property {string} platform - platform
* @property {string} state - error
* @property {string} sub_view - The sub_view of the hosted page in Bizmgr
* @property {string} view - The view of the hosted page in Bizmgr
**/
/**
 * Name: Bizmgr -> Component -> Component crashed. src: 5 Evid: 1461.
 * Event description: When component crashed for some reason.

 * app_id - Type: string. Desc: The app_id of the page which hosts the component
 *
 * component_app_id - Type: string. Desc: The app_id of the component
 *
 * component_id - Type: string. Desc: the Id of the component
 *
 * component_name - Type: string. Desc: The component name
 *
 * component_type - Type: string. Desc: page/widget/sidebar/header
 *
 * context - Type: string. Desc: when the context is site - send msid, when the context is app for example (like in devCenter) send appDefId, etc.
 *
 * error_type - Type: string. Desc: the type of the error (f.e: permissions, system error, etc.)
 *
 * host_id - Type: string. Desc: the host id (meaningful string - f.e. ‘sidebar’,’settings-lobby’)
 *
 * hosting - Type: string. Desc: MA/Editor/onboarding
 *
 * hosting_platform - Type: string. Desc: accountmanagr/bizmanagr/devcenter/etc.
 *
 * interval_load_time - Type: numeric. Desc: load time of this component until it crashed in ms
 *
 * loading_time_from_host_load - Type: numeric. Desc: loading time from the start loading of the page which hosting the component until the component crashed (in ms)
 *
 * loading_time_from_host_platform_load - Type: numeric. Desc: loading time from the start loading of the hosting platform until the component crashed (in ms)
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string. Desc: platform
 *
 * state - Type: string. Desc: error
 *
 * sub_view - Type: string. Desc: The sub_view of the hosted page in Bizmgr
 *
 * view - Type: string. Desc: The view of the hosted page in Bizmgr
 * @param {bizmgrComponentLoadingWithAnErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizmgrComponentLoadingWithAnError = function (params) {
    return { evid: 1461, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsBanner2PresentedMembersMailParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations -> Banner 2 presented - members=>mail. src: 5 Evid: 238.
 * Event description: Automations -> Banner presented - members=>mail.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsBanner2PresentedMembersMailParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsBanner2PresentedMembersMail = function (params) {
    return { evid: 238, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} foldersClickOnChangeViewModeParams
* @property {string} click_name - list-view/grid
* @property {string} hosting - MA/editor
* @property {string} platform - null
* @property {string} view - my-sites
* @property {string} view_mode - list-view/grid - shows the previous mode
**/
/**
 * Name: Folders > click on change view mode. src: 5 Evid: 117.
 * Event description: sort list view.

 * click_name - Type: string. Desc: list-view/grid
 *
 * hosting - Type: string. Desc: MA/editor
 *
 * platform - Type: string.
 *
 * view - Type: string. Desc: my-sites
 *
 * view_mode - Type: string. Desc: list-view/grid - shows the previous mode
 * @param {foldersClickOnChangeViewModeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var foldersClickOnChangeViewMode = function (params) {
    return { evid: 117, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeCustomerManagementToolsChooseParams
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} tabName - null
* @property {GUID} uuid - null
**/
/**
 * Name: CRM Home - customer management tools - choose. src: 5 Evid: 494.


 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * tabName - Type: string.
 *
 * uuid - Type: guid.
 * @param {crmHomeCustomerManagementToolsChooseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeCustomerManagementToolsChoose = function (params) {
    return { evid: 494, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} mySitesTooltipCloseParams
* @property {string} name - tooltip name
* @property {string} num_of_sites - num of sites on screen
* @property {string} platform - null
**/
/**
 * Name: My Sites - tooltip close. src: 5 Evid: 160.
 * Event description: close the tooltip.

 * name - Type: string. Desc: tooltip name
 *
 * num_of_sites - Type: string. Desc: num of sites on screen
 *
 * platform - Type: string.
 * @param {mySitesTooltipCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mySitesTooltipClose = function (params) {
    return { evid: 160, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} clickInDashboardParams
* @property {string} hosting - ma
* @property {GUID} msid - --
* @property {string} name - the site details' item: Connect Domain, Manage Plan...
* @property {string} platform - null
* @property {string} widget_name - the widget name in dashboard (this field added only in new dashboard)
**/
/**
 * Name: dashboard > click in dashboard. src: 5 Evid: 195.
 * Event description: Click on the action in dashboard widgets. (in the beginning this event was only for site details and in the new dashboard we added other clicks in different widgets.).

 * hosting - Type: string. Desc: ma
 *
 * msid - Type: guid. Desc: --
 *
 * name - Type: string. Desc: the site details' item: Connect Domain, Manage Plan...
 *
 * platform - Type: string.
 *
 * widget_name - Type: string. Desc: the widget name in dashboard (this field added only in new dashboard)
 * @param {clickInDashboardParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickInDashboard = function (params) {
    return { evid: 195, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} wixInvoicesLeavingSettingsWithoutSavingPopUpParams
* @property {string} fieldName - where user clicked to go
* @property {string} modal_name - weather its ‘Discard modal’, clicking on discard or clicking anywhere else, getting ‘Save changes’ modal
* @property {string} msid - msid
* @property {string} platform - platform
**/
/**
 * Name: Wix Invoices: Leaving Settings without saving pop up. src: 5 Evid: 8934.
 * Event description: Wix Invoices: Leaving Settings without saving pop up. Discard Changes Modal.

 * fieldName - Type: string. Desc: where user clicked to go
 *
 * modal_name - Type: string. Desc: weather its ‘Discard modal’, clicking on discard or clicking anywhere else, getting ‘Save changes’ modal
 *
 * msid - Type: string. Desc: msid
 *
 * platform - Type: string. Desc: platform
 * @param {wixInvoicesLeavingSettingsWithoutSavingPopUpParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var wixInvoicesLeavingSettingsWithoutSavingPopUp = function (params) {
    return { evid: 8934, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsBanner1PresentedFormsMailParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations -> Banner 1 presented - forms=>mail. src: 5 Evid: 237.
 * Event description: Automations -> Banner presented - forms=>mail.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsBanner1PresentedFormsMailParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsBanner1PresentedFormsMail = function (params) {
    return { evid: 237, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesRecurringMessagePresentedWhenUserReachesMaxNumberOfRecurringInvoicesParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Invoices - recurring- message presented when user reaches max number of recurring invoices. src: 5 Evid: 1602.


 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {invoicesRecurringMessagePresentedWhenUserReachesMaxNumberOfRecurringInvoicesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesRecurringMessagePresentedWhenUserReachesMaxNumberOfRecurringInvoices = function (params) {
    return { evid: 1602, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} twoFactorAuthenticationSetupSendCodeParams
* @property {string} action - send/resend
* @property {string} mode - enable/edit
* @property {string} phone_type - new phone/account phone
* @property {string} platform - null
**/
/**
 * Name: Phone 2FA Setup - Send Code Click. src: 5 Evid: 683.
 * Event description: The user clicks on 'send code' or 'resend verification code' in the verify phone dialog box, after entering a phone number.

 * action - Type: string. Desc: send/resend
 *
 * mode - Type: string. Desc: enable/edit
 *
 * phone_type - Type: string. Desc: new phone/account phone
 *
 * platform - Type: string.
 * @param {twoFactorAuthenticationSetupSendCodeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var twoFactorAuthenticationSetupSendCode = function (params) {
    return { evid: 683, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} notificationCloseAHighPriorityNotificationsParams
* @property {string} channel - Web / browser / mobile / SMS / email
* @property {string} feed_name - All Sites/This Site /Float
* @property {GUID} msid - msid of the notification
* @property {string} notification_ids - deprecated
* @property {string} notificationid - notificationid
* @property {string} origin - MSID of the site the user is on, my-sites if on Site List. Later on, also account-settings, and other account-level pages.
* @property {string} platform - null
**/
/**
 * Name: Notification - Close a High priority Notifications. src: 5 Evid: 279.
 * Event description: Close a High priority Notifications- not in the dialog.

 * channel - Type: string. Desc: Web / browser / mobile / SMS / email
 *
 * feed_name - Type: string. Desc: All Sites/This Site /Float
 *
 * msid - Type: guid. Desc: msid of the notification
 *
 * notification_ids - Type: string. Desc: deprecated
 *
 * notificationid - Type: string. Desc: notificationid
 *
 * origin - Type: string. Desc: MSID of the site the user is on, my-sites if on Site List. Later on, also account-settings, and other account-level pages.
 *
 * platform - Type: string.
 * @param {notificationCloseAHighPriorityNotificationsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var notificationCloseAHighPriorityNotifications = function (params) {
    return { evid: 279, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsErrorOnSavingActivatingAnAutomationParams
* @property {string} actionName - action name
* @property {string} custom_name - rule custom name
* @property {string} errorReason - errorReason
* @property {string} failedFlow - where the failed happen
* @property {string} flowType - if it's create or update
* @property {boolean} isPartial - isPartial
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} recipe_name - IF not recipe put placeholder
* @property {GUID} rule_id - rule ID
* @property {string} triggerActivityType - trigger name
**/
/**
 * Name: Automations > error on saving/updating a rule. src: 5 Evid: 1559.
 * Event description: Automations > Saving/activating an automation.

 * actionName - Type: string. Desc: action name
 *
 * custom_name - Type: string. Desc: rule custom name
 *
 * errorReason - Type: string. Desc: errorReason
 *
 * failedFlow - Type: string. Desc: where the failed happen
 *
 * flowType - Type: string. Desc: if it's create or update
 *
 * isPartial - Type: bool. Desc: isPartial
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * recipe_name - Type: string. Desc: IF not recipe put placeholder
 *
 * rule_id - Type: guid. Desc: rule ID
 *
 * triggerActivityType - Type: string. Desc: trigger name
 * @param {automationsErrorOnSavingActivatingAnAutomationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsErrorOnSavingActivatingAnAutomation = function (params) {
    return { evid: 1559, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} teamManagementAddMembersOpenDialogParams
* @property {string} origin - where the dialog is opened from
* @property {string} platform - null
* @property {string} roles_displayed - list of roles displayed to the user
**/
/**
 * Name: Team management - add members - open dialog. src: 5 Evid: 174.
 * Event description: When a user clicks to Invite/add People on account level - Team Management page.

 * origin - Type: string. Desc: where the dialog is opened from
 *
 * platform - Type: string.
 *
 * roles_displayed - Type: string. Desc: list of roles displayed to the user
 * @param {teamManagementAddMembersOpenDialogParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teamManagementAddMembersOpenDialog = function (params) {
    return { evid: 174, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesRecurringSelectCustomNumberOfOccurrencesParams
* @property {string} msid - msid
* @property {string} platform - null
* @property {string} value - selected value of occurrences
**/
/**
 * Name: Invoices - recurring - select custom number of occurrences. src: 5 Evid: 1568.
 * Event description: Quotes - recurring - select custom number of occurrences.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 *
 * value - Type: string. Desc: selected value of occurrences
 * @param {invoicesRecurringSelectCustomNumberOfOccurrencesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesRecurringSelectCustomNumberOfOccurrences = function (params) {
    return { evid: 1568, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} pingSaveInEditNotificationDialogParams
* @property {string} componentChanged - JSON field of the components that were changed
* @property {string} config - JSON field of the configuration, contains ape details. only for debugging usage
* @property {string} currentStatus - JSON field of the current status of muted/unmuted channels and audience
* @property {string} eventInfo - JSON field of schema parametrs and action recommendations - debugging purposes.
* @property {boolean} isPMFlow - is pm flow
* @property {boolean} isWidgetless - True - when user activates/deactivates the ape from apes list, False - when user clicks save in the widget
* @property {GUID} msid - site guid
* @property {string} pingTemplateId - pingTemplateId
* @property {string} platform - deprecated
* @property {string} previousStatus - JSON field of the previous status of muted/unmuted channels and audience
* @property {string} ruleId - the rule id
**/
/**
 * Name: Ping > save in Edit Notification dialog or changing apes toggle status. src: 5 Evid: 1699.
 * Event description: Apes - save in Edit Notification dialog. in order to get save in the dialog itself we should filter isWidgetless=false, otherwise this event will report also deactivate/activate ape action from outside the dialog..

 * componentChanged - Type: string. Desc: JSON field of the components that were changed
 *
 * config - Type: string. Desc: JSON field of the configuration, contains ape details. only for debugging usage
 *
 * currentStatus - Type: string. Desc: JSON field of the current status of muted/unmuted channels and audience
 *
 * eventInfo - Type: string. Desc: JSON field of schema parametrs and action recommendations - debugging purposes.
 *
 * isPMFlow - Type: bool. Desc: is pm flow
 *
 * isWidgetless - Type: bool. Desc: True - when user activates/deactivates the ape from apes list, False - when user clicks save in the widget
 *
 * msid - Type: guid. Desc: site guid
 *
 * pingTemplateId - Type: string. Desc: pingTemplateId
 *
 * platform - Type: string. Desc: deprecated
 *
 * previousStatus - Type: string. Desc: JSON field of the previous status of muted/unmuted channels and audience
 *
 * ruleId - Type: string. Desc: the rule id
 * @param {pingSaveInEditNotificationDialogParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pingSaveInEditNotificationDialog = function (params) {
    return { evid: 1699, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesCloseManagePlanBillingTooltipParams
* @property {string} choose - 'Got it','Close'
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Quotes - Close manage plan billing tooltip. src: 5 Evid: 479.
 * Event description: Quotes - Close manage plan billing tooltip.

 * choose - Type: string. Desc: 'Got it','Close'
 *
 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {quotesCloseManagePlanBillingTooltipParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesCloseManagePlanBillingTooltip = function (params) {
    return { evid: 479, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} engageEmailSettingsUnsavedChangesDialogParams
* @property {GUID} appdefid - appdefid of the source
* @property {GUID} externalId - An external id of an entity, relevant to the invoiceSource application
* @property {GUID} invoiceId - invoiceId
* @property {string} msid - msid
* @property {string} origin - more actions/invoice preview
* @property {string} platform - null
* @property {string} status - Creation form/Draft/Sent/Paid
**/
/**
 * Name: Quotes - click on share link. src: 5 Evid: 546.
 * Event description: Quotes - click on share link.

 * appdefid - Type: guid. Desc: appdefid of the source
 *
 * externalId - Type: guid. Desc: An external id of an entity, relevant to the invoiceSource application
 *
 * invoiceId - Type: guid. Desc: invoiceId
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: more actions/invoice preview
 *
 * platform - Type: string.
 *
 * status - Type: string. Desc: Creation form/Draft/Sent/Paid
 * @param {engageEmailSettingsUnsavedChangesDialogParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var engageEmailSettingsUnsavedChangesDialog = function (params) {
    return { evid: 546, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} mobilePhoneNumberConfirmationClickOnEditParams
* @property {string} platform - null
**/
/**
 * Name: Recovery Phone Number - Edit Number. src: 5 Evid: 678.
 * Event description: Update recovery phone number (account settings redesign) - click on edit number.

 * platform - Type: string.
 * @param {mobilePhoneNumberConfirmationClickOnEditParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mobilePhoneNumberConfirmationClickOnEdit = function (params) {
    return { evid: 678, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesCreateInvoiceSaveDraftCompleteParams
* @property {GUID} invoice_id - invoice guid
* @property {string} invoiceSource - by app_def_id
* @property {string} msid - msid
* @property {string} origin - create invoice, edit invoice
* @property {string} paymentType - 'one time','recurring'
* @property {string} platform - null
**/
/**
 * Name: Quotes - Create invoice - Save draft complete. src: 5 Evid: 409.
 * Event description: Create invoice - Save draft completed.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * invoiceSource - Type: string. Desc: by app_def_id
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: create invoice, edit invoice
 *
 * paymentType - Type: string. Desc: 'one time','recurring'
 *
 * platform - Type: string.
 * @param {quotesCreateInvoiceSaveDraftCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesCreateInvoiceSaveDraftComplete = function (params) {
    return { evid: 409, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesRecurringClickOnGetStartedParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Invoices - recurring - click on Get Started. src: 5 Evid: 1570.
 * Event description: Quotes - recurring - click on Get Started.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {invoicesRecurringClickOnGetStartedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesRecurringClickOnGetStarted = function (params) {
    return { evid: 1570, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesCreateInvoiceLeavingCreateInvoicePagePopUpAppearsParams
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} origin - create invoice, edit invoice
* @property {string} platform - platform
* @property {string} source - source
**/
/**
 * Name: Quotes - Create invoice - Leaving create invoice page pop up appears. src: 5 Evid: 1547.
 * Event description: Create invoice - user leaving the create invoice page leading to a pop up appearance.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: create invoice, edit invoice
 *
 * platform - Type: string. Desc: platform
 *
 * source - Type: string. Desc: source
 * @param {quotesCreateInvoiceLeavingCreateInvoicePagePopUpAppearsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesCreateInvoiceLeavingCreateInvoicePagePopUpAppears = function (params) {
    return { evid: 1547, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsCreationModalClearSearchParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations > creation modal - clear search. src: 5 Evid: 1273.
 * Event description: the user click on 'clear search' button.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsCreationModalClearSearchParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsCreationModalClearSearch = function (params) {
    return { evid: 1273, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} customerNotificationsSettingsPreviewEditChooseAudienceParams
* @property {GUID} msid - msid
* @property {string} name - the audience selection in english. f.e "site members"
* @property {string} platform - null
* @property {GUID} rule_id - automations rule id
* @property {string} template_id - ping template id
**/
/**
 * Name: customer notifications settings > preview&edit > choose audience. src: 5 Evid: 1375.
 * Event description: When the user chooses an audience for blog.

 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: the audience selection in english. f.e "site members"
 *
 * platform - Type: string.
 *
 * rule_id - Type: guid. Desc: automations rule id
 *
 * template_id - Type: string. Desc: ping template id
 * @param {customerNotificationsSettingsPreviewEditChooseAudienceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var customerNotificationsSettingsPreviewEditChooseAudience = function (params) {
    return { evid: 1375, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsGoogleSheetsConnectToGoogleAccountStartParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations - google sheets - connect to google account - start. src: 5 Evid: 1483.
 * Event description: Automations - google sheets - connect to google account.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsGoogleSheetsConnectToGoogleAccountStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsGoogleSheetsConnectToGoogleAccountStart = function (params) {
    return { evid: 1483, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsActionUserClickOnItemActionOptionParams
* @property {GUID} actionAppId - action provider app id
* @property {string} actionKey - action English key
* @property {number} inputLevel - how many dropdowns parents
* @property {string} inputName - display name / button name
* @property {string} inputType - input_type
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations - Action - user click on item action option. src: 5 Evid: 8950.
 * Event description: User click on button/link/dropdown option in the follow up item (component) in the action options.
In automation wizard.

 * actionAppId - Type: guid. Desc: action provider app id
 *
 * actionKey - Type: string. Desc: action English key
 *
 * inputLevel - Type: numeric. Desc: how many dropdowns parents
 *
 * inputName - Type: string. Desc: display name / button name
 *
 * inputType - Type: string. Desc: input_type
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsActionUserClickOnItemActionOptionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsActionUserClickOnItemActionOption = function (params) {
    return { evid: 8950, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} notificationDeleteNotificationParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations > Collapse Created by You. src: 5 Evid: 485.
 * Event description: Automations > Collapse Created by You.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {notificationDeleteNotificationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var notificationDeleteNotification = function (params) {
    return { evid: 485, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} accountSettingsChangeEmailAddressModalClickOnNextParams
* @property {string} platform - null
**/
/**
 * Name: Account Settings - Change Email Address Modal - Click on Next. src: 5 Evid: 1784.
 * Event description: The user clicks on next in the modal that opens when he wants to change email address.

 * platform - Type: string.
 * @param {accountSettingsChangeEmailAddressModalClickOnNextParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accountSettingsChangeEmailAddressModalClickOnNext = function (params) {
    return { evid: 1784, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerOpenPanelFinishParams
* @property {string} contact_id - contact_id
* @property {string} hosting - MA/editor
* @property {string} initiator - click on contact name/ i button
* @property {number} loading_time - time from start opening the panel till end
* @property {number} loading_time_from_interactive - loading_time_from_interactive (from 657)
* @property {GUID} msid - msid
* @property {string} panel_name - the panel that was opened
* @property {string} platform - null
* @property {string} sub_view - page in app
* @property {string} view - requested view
**/
/**
 * Name: Biz Manager > Open panel finish. src: 5 Evid: 599.
 * Event description: panel is starting to load.

 * contact_id - Type: string. Desc: contact_id
 *
 * hosting - Type: string. Desc: MA/editor
 *
 * initiator - Type: string. Desc: click on contact name/ i button
 *
 * loading_time - Type: numeric. Desc: time from start opening the panel till end
 *
 * loading_time_from_interactive - Type: numeric. Desc: loading_time_from_interactive (from 657)
 *
 * msid - Type: guid. Desc: msid
 *
 * panel_name - Type: string. Desc: the panel that was opened
 *
 * platform - Type: string.
 *
 * sub_view - Type: string. Desc: page in app
 *
 * view - Type: string. Desc: requested view
 * @param {bizManagerOpenPanelFinishParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerOpenPanelFinish = function (params) {
    return { evid: 599, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} accountSettingsTwoFactorAuthenticationSetupSendCodeSuccessParams
* @property {string} action - send/resend
* @property {string} mode - enable/edit
* @property {string} platform - null
**/
/**
 * Name: Account Settings - Phone 2FA Setup - Send Code Success. src: 5 Evid: 696.
 * Event description: The code was successfully sent to the user's phone after he clicked on send code.

 * action - Type: string. Desc: send/resend
 *
 * mode - Type: string. Desc: enable/edit
 *
 * platform - Type: string.
 * @param {accountSettingsTwoFactorAuthenticationSetupSendCodeSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accountSettingsTwoFactorAuthenticationSetupSendCodeSuccess = function (params) {
    return { evid: 696, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} homeMarkAllUnreadNotificationsParams
* @property {string} channel - Web / browser / mobile / SMS / email
* @property {string} msid - deprecated
* @property {string} notification_ids - all notifications that were marked as read in the page ( separated with a comma)
* @property {number} num_of_unread - number of unread messages
* @property {string} origin - MSID of the site the user is on, my-sites if on Site List. Later on, also account-settings, and other account-level pages.
* @property {string} platform - null
**/
/**
 * Name: Home > mark all as read notifications. src: 5 Evid: 253.
 * Event description: user clicks mark all unread.

 * channel - Type: string. Desc: Web / browser / mobile / SMS / email
 *
 * msid - Type: string. Desc: deprecated
 *
 * notification_ids - Type: string. Desc: all notifications that were marked as read in the page ( separated with a comma)
 *
 * num_of_unread - Type: numeric. Desc: number of unread messages
 *
 * origin - Type: string. Desc: MSID of the site the user is on, my-sites if on Site List. Later on, also account-settings, and other account-level pages.
 *
 * platform - Type: string.
 * @param {homeMarkAllUnreadNotificationsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var homeMarkAllUnreadNotifications = function (params) {
    return { evid: 253, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} accountSettingsUpdatesConfirmPasswordModalLoadParams
* @property {string} action - 2FA enable/2FA disable/2FA edit/add recovery phone/remove recovery phone/edit recovery phone/username/email address
* @property {string} platform - null
**/
/**
 * Name: Account Settings Updates - Confirm Password Modal Load. src: 5 Evid: 690.
 * Event description: Confirm password modal loads successfully after the user tries to make changes in account settings.

 * action - Type: string. Desc: 2FA enable/2FA disable/2FA edit/add recovery phone/remove recovery phone/edit recovery phone/username/email address
 *
 * platform - Type: string.
 * @param {accountSettingsUpdatesConfirmPasswordModalLoadParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accountSettingsUpdatesConfirmPasswordModalLoad = function (params) {
    return { evid: 690, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardUpgradeLinkParams
* @property {string} name - null
* @property {string} origin - upgrade button
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: dashboard > upgrade link. src: 5 Evid: 12.
 * Event description: click on upgrade from my account.

 * name - Type: string.
 *
 * origin - Type: string. Desc: upgrade button
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {dashboardUpgradeLinkParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardUpgradeLink = function (params) {
    return { evid: 12, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} accountSettingsChangeEmailAddressModalResendCodeParams
* @property {string} platform - null
**/
/**
 * Name: Account Settings - Change Email Address Modal - Resend Code. src: 5 Evid: 1786.
 * Event description: The user clicks on resend code in the change email address modal.

 * platform - Type: string.
 * @param {accountSettingsChangeEmailAddressModalResendCodeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accountSettingsChangeEmailAddressModalResendCode = function (params) {
    return { evid: 1786, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerDisplayAnalyticsWidgetParams
* @property {string} app_id - app id of the vertical that displays the widget.
* @property {string} hosting - ADI/MA/editor
* @property {string} module_id - module name
* @property {GUID} msid - metasite id
* @property {string} platform - null
**/
/**
 * Name: Biz Manager - Display Analytics Widget. src: 5 Evid: 577.
 * Event description: Display the Widget only after Setup is complete or doesn't exist..

 * app_id - Type: string. Desc: app id of the vertical that displays the widget.
 *
 * hosting - Type: string. Desc: ADI/MA/editor
 *
 * module_id - Type: string. Desc: module name
 *
 * msid - Type: guid. Desc: metasite id
 *
 * platform - Type: string.
 * @param {bizManagerDisplayAnalyticsWidgetParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerDisplayAnalyticsWidget = function (params) {
    return { evid: 577, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsEditAutomationSTitleParams
* @property {string} flowType - flow in which the dialog is shown: {create, edit}
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} recipe_name - recipe name
* @property {GUID} rule_id - the rule_id that the user started/edited
**/
/**
 * Name: Automations > Edit Automation's title. src: 5 Evid: 228.
 * Event description: editing the title of the automation.

 * flowType - Type: string. Desc: flow in which the dialog is shown: {create, edit}
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * recipe_name - Type: string. Desc: recipe name
 *
 * rule_id - Type: guid. Desc: the rule_id that the user started/edited
 * @param {automationsEditAutomationSTitleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsEditAutomationSTitle = function (params) {
    return { evid: 228, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSettingsSeoClickOnGetStartedParams
* @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
* @property {string} origin - name of current tab
* @property {string} platform - null
**/
/**
 * Name: dashboard > site settings > SEO > click on Get started. src: 5 Evid: 325.
 * Event description: user clicked on get started button.

 * hosting - Type: string. Desc: from where user arrived to sitesettings (Editor/MA/...)
 *
 * origin - Type: string. Desc: name of current tab
 *
 * platform - Type: string.
 * @param {dashboardSiteSettingsSeoClickOnGetStartedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSettingsSeoClickOnGetStarted = function (params) {
    return { evid: 325, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesItemsListAddNewProductParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Invoices - Items List - add new product. src: 5 Evid: 1316.
 * Event description: Invoices - Items List - add new product.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {invoicesItemsListAddNewProductParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesItemsListAddNewProduct = function (params) {
    return { evid: 1316, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardTourUserSeesTourBannerParams
* @property {string} experiment_name - null
* @property {GUID} msid - null
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: dashboard tour > user sees tour banner. src: 5 Evid: 30.


 * experiment_name - Type: string.
 *
 * msid - Type: guid.
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {dashboardTourUserSeesTourBannerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardTourUserSeesTourBanner = function (params) {
    return { evid: 30, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsQuickGoogleSpreadsheetsRecipeActivationErrorActivateClickedWhileDetailsEmptyParams
* @property {string} missingField - The missing field when activate was pressed
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations > Quick Google Spreadsheets Recipe Activation -  error activate clicked while details empty. src: 5 Evid: 1734.
 * Event description: Triggered when the user click's the activate while the fields are empty.

 * missingField - Type: string. Desc: The missing field when activate was pressed
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsQuickGoogleSpreadsheetsRecipeActivationErrorActivateClickedWhileDetailsEmptyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsQuickGoogleSpreadsheetsRecipeActivationErrorActivateClickedWhileDetailsEmpty = function (params) {
    return { evid: 1734, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsExportAutomationForDevOrPmParams
* @property {GUID} msid - msid
* @property {string} origin - automation table
* @property {string} platform - null
* @property {GUID} ruleId - rule_id
**/
/**
 * Name: Automations - export automation (for dev or PM). src: 5 Evid: 8925.
 * Event description: Automations - export automation (for dev or PM), export automation to create a new preinstalled automation.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: automation table
 *
 * platform - Type: string.
 *
 * ruleId - Type: guid. Desc: rule_id
 * @param {automationsExportAutomationForDevOrPmParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsExportAutomationForDevOrPm = function (params) {
    return { evid: 8925, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsUserCloseCreationModalParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations > User close creation modal. src: 5 Evid: 1262.
 * Event description: Automations > user click on the X and close the creation modal.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsUserCloseCreationModalParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsUserCloseCreationModal = function (params) {
    return { evid: 1262, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesViewPaymentsParams
* @property {string} msid - null
* @property {string} platform - null
**/
/**
 * Name: Quotes - view payments. src: 5 Evid: 388.
 * Event description: Quotes - view payments.

 * msid - Type: string.
 *
 * platform - Type: string.
 * @param {quotesViewPaymentsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesViewPayments = function (params) {
    return { evid: 388, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsWidgetSeenWidgetParams
* @property {string} asset_campaign_guid - asset_campaign_guid
* @property {string} item_list - item_list
* @property {GUID} msid - msid
* @property {string} origin - button, link, header, success creation dialog
* @property {string} platform - null
* @property {string} referral_info - indicate which vertical is the dacomponent triggered from
* @property {string} widget_name - dashboard/rows/recommendations
**/
/**
 * Name: Automations > widget > seen widget. src: 5 Evid: 1619.
 * Event description: Automations > widget > seen widget.

 * asset_campaign_guid - Type: string. Desc: asset_campaign_guid
 *
 * item_list - Type: string. Desc: item_list
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: button, link, header, success creation dialog
 *
 * platform - Type: string.
 *
 * referral_info - Type: string. Desc: indicate which vertical is the dacomponent triggered from
 *
 * widget_name - Type: string. Desc: dashboard/rows/recommendations
 * @param {automationsWidgetSeenWidgetParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsWidgetSeenWidget = function (params) {
    return { evid: 1619, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeIntegrationsMarketingConnectParams
* @property {string} connectTab - which connection the user choose
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: CRM Home - integrations - marketing connect. src: 5 Evid: 1114.
 * Event description: CRM Home - integrations - marketing view all.

 * connectTab - Type: string. Desc: which connection the user choose
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {crmHomeIntegrationsMarketingConnectParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeIntegrationsMarketingConnect = function (params) {
    return { evid: 1114, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSettingsSeoCloseEnterAddressManuallyPopUpParams
* @property {string} experience - user's experience
* @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
* @property {GUID} msid - msid
* @property {string} origin - name of current tab
* @property {string} platform - null
* @property {string} value - Link URL
**/
/**
 * Name: dashboard > site settings > seo > close enter address Manually pop up. src: 5 Evid: 324.
 * Event description: user closed  pop up 'Enter address manually' in SEO section.

 * experience - Type: string. Desc: user's experience
 *
 * hosting - Type: string. Desc: from where user arrived to sitesettings (Editor/MA/...)
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: name of current tab
 *
 * platform - Type: string.
 *
 * value - Type: string. Desc: Link URL
 * @param {dashboardSiteSettingsSeoCloseEnterAddressManuallyPopUpParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSettingsSeoCloseEnterAddressManuallyPopUp = function (params) {
    return { evid: 324, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesMarkAsAccepted95Params
* @property {string} msid - msid
* @property {string} platform - null
* @property {GUID} quoteId - quote guid
**/
/**
 * Name: Quotes - Mark as accepted. src: 5 Evid: 95.
 * Event description: User click on Mark as accepted.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 *
 * quoteId - Type: guid. Desc: quote guid
 * @param {quotesMarkAsAccepted95Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesMarkAsAccepted95 = function (params) {
    return { evid: 95, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} headerStartLoadingParams
* @property {boolean} is_partner - true/false
* @property {GUID} msid - in account level/my-sites send null
* @property {string} page_view - name of the page - my-sites/bizmgr/account manager/partner dashboard
* @property {string} platform - platform
**/
/**
 * Name: Header start Loading. src: 5 Evid: 1601.
 * Event description: when the header started loading in my-sites/bizmgr/account manager/partner dashboard the event is sent.

 * is_partner - Type: bool. Desc: true/false
 *
 * msid - Type: guid. Desc: in account level/my-sites send null
 *
 * page_view - Type: string. Desc: name of the page - my-sites/bizmgr/account manager/partner dashboard
 *
 * platform - Type: string. Desc: platform
 * @param {headerStartLoadingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var headerStartLoading = function (params) {
    return { evid: 1601, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesHeaderPreviewParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Quotes - Header Preview. src: 5 Evid: 732.


 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {quotesHeaderPreviewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesHeaderPreview = function (params) {
    return { evid: 732, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerBizInfoCancelDiscardParams
* @property {string} hosting - MA/editor
* @property {string} location_details - 0- first location (create), 1-second location (add), 2- third location (add),...
* @property {GUID} msid - metasite id
* @property {string} origin - app
* @property {string} page_view - The page where the changes were made (website settings/business info/language and region)
* @property {string} platform - null
**/
/**
 * Name: Biz Manager - Biz Info - cancel discard. src: 5 Evid: 556.
 * Event description: user clicks on X or Cancel in the discard modal.

 * hosting - Type: string. Desc: MA/editor
 *
 * location_details - Type: string. Desc: 0- first location (create), 1-second location (add), 2- third location (add),...
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: app
 *
 * page_view - Type: string. Desc: The page where the changes were made (website settings/business info/language and region)
 *
 * platform - Type: string.
 * @param {bizManagerBizInfoCancelDiscardParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerBizInfoCancelDiscard = function (params) {
    return { evid: 556, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesEmailQuotesPageParams
* @property {string} msid - msid
* @property {string} origin - origin page
* @property {string} origin_device - web,native
* @property {string} platform - null
* @property {GUID} quoteId - quote guid
* @property {boolean} resend - resend mode?
**/
/**
 * Name: Quotes - Email quotes page. src: 5 Evid: 84.
 * Event description: email invoice pop up.

 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: origin page
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string.
 *
 * quoteId - Type: guid. Desc: quote guid
 *
 * resend - Type: bool. Desc: resend mode?
 * @param {quotesEmailQuotesPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesEmailQuotesPage = function (params) {
    return { evid: 84, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} rolesResendInviteClickParams
* @property {string} hosting - MA /Editor
* @property {string} invite_email - invited email
* @property {string} invite_role - invited role
* @property {GUID} msid - msid
* @property {string} origin - name of tab
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: Roles - resend invite - click. src: 5 Evid: 359.
 * Event description: user clicked on resend invite.

 * hosting - Type: string. Desc: MA /Editor
 *
 * invite_email - Type: string. Desc: invited email
 *
 * invite_role - Type: string. Desc: invited role
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: name of tab
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {rolesResendInviteClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rolesResendInviteClick = function (params) {
    return { evid: 359, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} rolesLoginPageLoadCompleteParams
* @property {string} invite_email - invited email
* @property {string} invite_id - invite_id
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: Roles - login page load complete. src: 5 Evid: 357.
 * Event description: before login component is loaded - page load complete.

 * invite_email - Type: string. Desc: invited email
 *
 * invite_id - Type: string. Desc: invite_id
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {rolesLoginPageLoadCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rolesLoginPageLoadComplete = function (params) {
    return { evid: 357, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardClickOnUpgradeParams
* @property {string} hosting - (Editor/MA/...)
* @property {GUID} msid - msid
* @property {string} origin - where it was clicked from
* @property {string} platform - null
**/
/**
 * Name: dashboard - click on upgrade. src: 5 Evid: 73.
 * Event description: click on upgrade button in biz mgr.

 * hosting - Type: string. Desc: (Editor/MA/...)
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: where it was clicked from
 *
 * platform - Type: string.
 * @param {dashboardClickOnUpgradeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardClickOnUpgrade = function (params) {
    return { evid: 73, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesNewProductCancelParams
* @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
* @property {string} msid - msid
* @property {string} origin - create,edit
* @property {string} platform - null
**/
/**
 * Name: Quotes - New product - Cancel. src: 5 Evid: 416.
 * Event description: new product -cancel (for every close (cancel, x, background click)).

 * invoiceType - Type: string. Desc: ’recurringAutoCharge’/ 'recurring'/ 'one time'
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: create,edit
 *
 * platform - Type: string.
 * @param {quotesNewProductCancelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesNewProductCancel = function (params) {
    return { evid: 416, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesChooseDueDateParams
* @property {DateTime} dueDate - Due date added
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Quotes - choose due date. src: 5 Evid: 384.
 * Event description: Quotes - choose due date.

 * dueDate - Type: datetime. Desc: Due date added
 *
 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {quotesChooseDueDateParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesChooseDueDate = function (params) {
    return { evid: 384, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} foldersMarkASiteParams
* @property {string} hosting - MA
* @property {GUID} msid - msid
* @property {string} name - mark/unmark
* @property {string} platform - null
* @property {string} sub_view - grid/ list-view
* @property {string} view - my-sites
**/
/**
 * Name: Folders > Mark/Unmark a site. src: 5 Evid: 128.
 * Event description: marking a site.

 * hosting - Type: string. Desc: MA
 *
 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: mark/unmark
 *
 * platform - Type: string.
 *
 * sub_view - Type: string. Desc: grid/ list-view
 *
 * view - Type: string. Desc: my-sites
 * @param {foldersMarkASiteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var foldersMarkASite = function (params) {
    return { evid: 128, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardViewSiteParams
* @property {number} src - null
* @property {GUID} msid - null
* @property {string} origin - null
* @property {string} platform - null
* @property {GUID} site_id - null
* @property {number} artificial_src - null
**/
/**
 * Name: dashboard > view site. src: 5 Evid: 72.


 * src - Type: numeric.
 *
 * msid - Type: guid.
 *
 * origin - Type: string.
 *
 * platform - Type: string.
 *
 * site_id - Type: guid.
 *
 * artificial_src - Type: numeric.
 * @param {dashboardViewSiteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardViewSite = function (params) {
    return { evid: 72, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} app2faSetupClickOnChangeAppParams
* @property {string} platform - null
**/
/**
 * Name: App 2FA Setup - Click on Change App. src: 5 Evid: 1744.
 * Event description: The user clicks on 'Change App' to change the authenticator app.

 * platform - Type: string.
 * @param {app2faSetupClickOnChangeAppParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var app2faSetupClickOnChangeApp = function (params) {
    return { evid: 1744, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesFirstTimeExpirienceGetStartedParams
* @property {string} msid - null
* @property {string} name - ‘Get started’ or ‘Watch Tutorial’
* @property {string} platform - null
**/
/**
 * Name: Invoices - First time expirience - get started. src: 5 Evid: 1689.
 * Event description: Invoices - First time expirience - get started.

 * msid - Type: string.
 *
 * name - Type: string. Desc: ‘Get started’ or ‘Watch Tutorial’
 *
 * platform - Type: string.
 * @param {invoicesFirstTimeExpirienceGetStartedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesFirstTimeExpirienceGetStarted = function (params) {
    return { evid: 1689, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsClientErrorParams
* @property {string} action_name - in case the step is "action", in which action the error is: {email to visitors, email to owner, chat message}
* @property {string} desc - more details about the error (e.g. which fields are causing the error)
* @property {string} flowType - flow in which the dialog is shown: {create, edit}
* @property {number} index - index for drip campaign
* @property {GUID} msid - msid
* @property {string} name - name of error: {missingInfo}
* @property {string} phase_name - which step in the automation flow: {trigger type, action, timing}
* @property {string} platform - null
* @property {string} recipe_name - recipe name
* @property {GUID} rule_id - the rule_id that the user started/edited
* @property {boolean} withTriggersCatalog - withTriggersCatalog
**/
/**
 * Name: Automations > error in creation automation. src: 5 Evid: 227.
 * Event description: error in automations in creation flow (and created by the user). errors: in trigger in action etc.

 * action_name - Type: string. Desc: in case the step is "action", in which action the error is: {email to visitors, email to owner, chat message}
 *
 * desc - Type: string. Desc: more details about the error (e.g. which fields are causing the error)
 *
 * flowType - Type: string. Desc: flow in which the dialog is shown: {create, edit}
 *
 * index - Type: numeric. Desc: index for drip campaign
 *
 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: name of error: {missingInfo}
 *
 * phase_name - Type: string. Desc: which step in the automation flow: {trigger type, action, timing}
 *
 * platform - Type: string.
 *
 * recipe_name - Type: string. Desc: recipe name
 *
 * rule_id - Type: guid. Desc: the rule_id that the user started/edited
 *
 * withTriggersCatalog - Type: bool. Desc: withTriggersCatalog
 * @param {automationsClientErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsClientError = function (params) {
    return { evid: 227, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} customerNotificationsSettingsPreviewEditLoadingTimeParams
* @property {number} loadingTime - The time between page was loaded and the modal was loaded
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: customer notifications settings > preview&edit > loading time. src: 5 Evid: 1455.
 * Event description: When the user come back from shoutout composer the event is send when the modal is fully loaded..

 * loadingTime - Type: numeric. Desc: The time between page was loaded and the modal was loaded
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {customerNotificationsSettingsPreviewEditLoadingTimeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var customerNotificationsSettingsPreviewEditLoadingTime = function (params) {
    return { evid: 1455, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsGoogleSheetsMatchDataToSheetSelectDataParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations - google sheets - match data to sheet - select data. src: 5 Evid: 1530.
 * Event description: Automations - google sheets - match data to sheet - refresh data.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsGoogleSheetsMatchDataToSheetSelectDataParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsGoogleSheetsMatchDataToSheetSelectData = function (params) {
    return { evid: 1530, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsMissingEmailPhoneLearnMoreParams
* @property {string} actionName - actionName
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations > missing email/phone - learn more. src: 5 Evid: 1645.
 * Event description: Automations > missing email/phone - learn more.

 * actionName - Type: string. Desc: actionName
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsMissingEmailPhoneLearnMoreParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsMissingEmailPhoneLearnMore = function (params) {
    return { evid: 1645, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesChooseAProductParams
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} platform - null
* @property {string} productId - product_id
* @property {string} productName - product_name
* @property {string} productSource - which vertical product was choosen ( Stores, Invoices, Bookings) App_def_id
* @property {GUID} uuid - uuid
**/
/**
 * Name: Quotes - Choose a Product. src: 5 Evid: 466.
 * Event description: Quotes - Choose a Product.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 *
 * productId - Type: string. Desc: product_id
 *
 * productName - Type: string. Desc: product_name
 *
 * productSource - Type: string. Desc: which vertical product was choosen ( Stores, Invoices, Bookings) App_def_id
 *
 * uuid - Type: guid. Desc: uuid
 * @param {quotesChooseAProductParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesChooseAProduct = function (params) {
    return { evid: 466, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteQuickActionClickParams
* @property {string} cta - ‘sidepanel’ \ ‘menu’
* @property {GUID} esi - editing session id -  is generated when clicking edit site, it will remain until the url is changed, by navigating to another page or closing the tab
* @property {string} hosting - editor/ma
* @property {GUID} msid - The site guid the user opened the menu for
* @property {string} name - The quick action name (quick_actions.rename_site, quick_actions.move_to_trash, etc.)
* @property {string} origin - sites-list-enterprise\site-list
* @property {string} platform - deprecated
* @property {string} referral - --
* @property {number} src - null
**/
/**
 * Name: dashboard > quick action click. src: 5 Evid: 16.


 * cta - Type: string. Desc: ‘sidepanel’ \ ‘menu’
 *
 * esi - Type: guid. Desc: editing session id -  is generated when clicking edit site, it will remain until the url is changed, by navigating to another page or closing the tab
 *
 * hosting - Type: string. Desc: editor/ma
 *
 * msid - Type: guid. Desc: The site guid the user opened the menu for
 *
 * name - Type: string. Desc: The quick action name (quick_actions.rename_site, quick_actions.move_to_trash, etc.)
 *
 * origin - Type: string. Desc: sites-list-enterprise\site-list
 *
 * platform - Type: string. Desc: deprecated
 *
 * referral - Type: string. Desc: --
 *
 * src - Type: numeric.
 * @param {dashboardSiteQuickActionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteQuickActionClick = function (params) {
    return { evid: 16, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} ascendPpClickOnMoveToWixPremiumPpParams
* @property {string} button_name - premium / compare
* @property {string} origin - product name open PP
* @property {string} platform - web/mobile
* @property {string} referralInfo - button name open PP
* @property {number} timeInPage - in milisec
**/
/**
 * Name: Ascend PP - Click in Ascend PP. src: 5 Evid: 190.
 * Event description: User clicks on buttons in Ascend PP.

 * button_name - Type: string. Desc: premium / compare
 *
 * origin - Type: string. Desc: product name open PP
 *
 * platform - Type: string. Desc: web/mobile
 *
 * referralInfo - Type: string. Desc: button name open PP
 *
 * timeInPage - Type: numeric. Desc: in milisec
 * @param {ascendPpClickOnMoveToWixPremiumPpParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ascendPpClickOnMoveToWixPremiumPp = function (params) {
    return { evid: 190, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} mySitesWhenDialogPopsUpParams
* @property {string} hosting - MA
* @property {string} name - dialog's name: move to trash etc...
* @property {number} num_selected_sites - number of sites selected
* @property {string} origin - sites-list/ sites-list-enterprise
* @property {string} platform - deprecated
* @property {string} view_mode - grid/list
**/
/**
 * Name: My sites -> when dialog pops up. src: 5 Evid: 1732.
 * Event description: when user triggers a dialog to open.

 * hosting - Type: string. Desc: MA
 *
 * name - Type: string. Desc: dialog's name: move to trash etc...
 *
 * num_selected_sites - Type: numeric. Desc: number of sites selected
 *
 * origin - Type: string. Desc: sites-list/ sites-list-enterprise
 *
 * platform - Type: string. Desc: deprecated
 *
 * view_mode - Type: string. Desc: grid/list
 * @param {mySitesWhenDialogPopsUpParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mySitesWhenDialogPopsUp = function (params) {
    return { evid: 1732, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerClickOnSetupSkipUndoParams
* @property {string} app_id - app_id
* @property {string} click_type - skip/undo
* @property {number} done_steps - number of done steps in setup
* @property {string} hosting - MA/editor
* @property {string} module_id - module name
* @property {GUID} msid - metasite id
* @property {string} platform - null
* @property {number} skipped_steps - skipped_steps
* @property {string} step - step id
* @property {GUID} step_guid - deprecated
* @property {number} step_id - deprecated
* @property {number} steps - number of steps in setup
**/
/**
 * Name: Biz Manager - click on setup skip/undo. src: 5 Evid: 656.
 * Event description: user clicked on a CTA in TPA setup widget in biz mgr.

 * app_id - Type: string. Desc: app_id
 *
 * click_type - Type: string. Desc: skip/undo
 *
 * done_steps - Type: numeric. Desc: number of done steps in setup
 *
 * hosting - Type: string. Desc: MA/editor
 *
 * module_id - Type: string. Desc: module name
 *
 * msid - Type: guid. Desc: metasite id
 *
 * platform - Type: string.
 *
 * skipped_steps - Type: numeric. Desc: skipped_steps
 *
 * step - Type: string. Desc: step id
 *
 * step_guid - Type: guid. Desc: deprecated
 *
 * step_id - Type: numeric. Desc: deprecated
 *
 * steps - Type: numeric. Desc: number of steps in setup
 * @param {bizManagerClickOnSetupSkipUndoParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerClickOnSetupSkipUndo = function (params) {
    return { evid: 656, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerWhatSNextCloseVideoAssetParams
* @property {string} asset_campaign_guid - ids to be consistent with premium events
* @property {string} asset_campaign_id - ids to be consistent with premium events
* @property {number} asset_location_from_group_list - the priority of the asset (from 30)
* @property {string} asset_location_on_page - (0,1,2,3)
* @property {GUID} group_id - the dealers group from which the asset is being chosen
* @property {string} hosting - ADI/MA/editor
* @property {GUID} item_id - assets guid
* @property {GUID} msid - meta site guid
* @property {string} offering_guid - ids to be consistent with premium events
* @property {number} percentage - percentage watched 0-100
* @property {string} platform - null
* @property {string} promotion_asset_type - video
**/
/**
 * Name: Biz Manager - what's next close video asset. src: 5 Evid: 592.
 * Event description: what's next video asset closed, with percentage watched.

 * asset_campaign_guid - Type: string. Desc: ids to be consistent with premium events
 *
 * asset_campaign_id - Type: string. Desc: ids to be consistent with premium events
 *
 * asset_location_from_group_list - Type: numeric. Desc: the priority of the asset (from 30)
 *
 * asset_location_on_page - Type: string. Desc: (0,1,2,3)
 *
 * group_id - Type: guid. Desc: the dealers group from which the asset is being chosen
 *
 * hosting - Type: string. Desc: ADI/MA/editor
 *
 * item_id - Type: guid. Desc: assets guid
 *
 * msid - Type: guid. Desc: meta site guid
 *
 * offering_guid - Type: string. Desc: ids to be consistent with premium events
 *
 * percentage - Type: numeric. Desc: percentage watched 0-100
 *
 * platform - Type: string.
 *
 * promotion_asset_type - Type: string. Desc: video
 * @param {bizManagerWhatSNextCloseVideoAssetParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerWhatSNextCloseVideoAsset = function (params) {
    return { evid: 592, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} wixInvoicesChargeWithCreditCardClickParams
* @property {boolean} fully_paid - true for fully paid selected, false for partial payment selected
* @property {GUID} invoice_id - invoice guid
* @property {GUID} invoiceSource - invoice_source_id
* @property {string} msid - msid
* @property {string} origin - my invoices,preview,create invoice
* @property {string} origin_device - web,native
* @property {string} platform - platform
* @property {string} status - Creation form/Draft/Sent/Paid
**/
/**
 * Name: Wix Invoices - Charge with credit card click. src: 5 Evid: 8954.
 * Event description: Charge with credit card on invoice click (MOTO).

 * fully_paid - Type: bool. Desc: true for fully paid selected, false for partial payment selected
 *
 * invoice_id - Type: guid. Desc: invoice guid
 *
 * invoiceSource - Type: guid. Desc: invoice_source_id
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: my invoices,preview,create invoice
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string. Desc: platform
 *
 * status - Type: string. Desc: Creation form/Draft/Sent/Paid
 * @param {wixInvoicesChargeWithCreditCardClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var wixInvoicesChargeWithCreditCardClick = function (params) {
    return { evid: 8954, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesDismissManagePaymentsBannerParams
* @property {GUID} msid - msid
* @property {string} name - banner name {manage payments}
* @property {string} platform - null
**/
/**
 * Name: Quotes - dismiss manage payments banner. src: 5 Evid: 456.
 * Event description: dismiss manage payments banner.

 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: banner name {manage payments}
 *
 * platform - Type: string.
 * @param {quotesDismissManagePaymentsBannerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesDismissManagePaymentsBanner = function (params) {
    return { evid: 456, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} teamManagementDeleteTeamMemberDeleteClickSuccessParams
* @property {string} invite_status - pending/expired/leave team
* @property {GUID} member_id - the uuid of the deleted member (if status is pending then invite_id)
* @property {string} origin - where the dialog was opened from
* @property {string} platform - null
* @property {string} role - the deleted user’s role
**/
/**
 * Name: Team Management - delete team member - delete click success. src: 5 Evid: 180.
 * Event description: When a user clicks on 'delete' in the delete team member window - success response.

 * invite_status - Type: string. Desc: pending/expired/leave team
 *
 * member_id - Type: guid. Desc: the uuid of the deleted member (if status is pending then invite_id)
 *
 * origin - Type: string. Desc: where the dialog was opened from
 *
 * platform - Type: string.
 *
 * role - Type: string. Desc: the deleted user’s role
 * @param {teamManagementDeleteTeamMemberDeleteClickSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teamManagementDeleteTeamMemberDeleteClickSuccess = function (params) {
    return { evid: 180, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} notificationNotificationAutomationCreatedParams
* @property {string} channel - deprecated
* @property {string} channels - Web / browser / mobile / SMS / email- multiple channels
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} recipients_type - all contributors / owner
**/
/**
 * Name: Notification -  Notification Automation Created. src: 5 Evid: 269.
 * Event description: Notification that was created by Automations.

 * channel - Type: string. Desc: deprecated
 *
 * channels - Type: string. Desc: Web / browser / mobile / SMS / email- multiple channels
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * recipients_type - Type: string. Desc: all contributors / owner
 * @param {notificationNotificationAutomationCreatedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var notificationNotificationAutomationCreated = function (params) {
    return { evid: 269, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardClickOnMySitesParams
* @property {GUID} msid - null
* @property {string} origin - null
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: dashboard > click on my sites. src: 5 Evid: 40.


 * msid - Type: guid.
 *
 * origin - Type: string.
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {dashboardClickOnMySitesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardClickOnMySites = function (params) {
    return { evid: 40, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} sideBarItemClick550Params
* @property {string} app_id - app_id of the item
* @property {number} counter - The value inside the counter clicked (if counter exists)
* @property {string} hosting - MA/editor
* @property {string} hosting_platform - accountmanagr/bizmanagr/devcenter/etc.
* @property {boolean} is_from_main_sidebar - true if the click is from main sidebar and false if it's from sidebar dropdown tooltip
* @property {string} items_list - JSON of all the items the user saw in the sidebar when clicked on item- key:unique item name, value: number of notifications the user sees in this item. In case the type is navigated - please send the sidebar items list
* @property {string} legacy_name - deprecated
* @property {GUID} msid - metasite id
* @property {string} name - unique item name that doesn't change when changing the name on the side bar
* @property {string} origin - tooltip / sidebar / add new
* @property {string} platform - null
* @property {GUID} prev_app_id - The app_id of the previous page/previous item (before clicking on item)
* @property {string} previous_item_name - the previous unique item name that doesn't change when changing the name, this is the item which was highlighted before the click
* @property {string} previous_sidebar_name - deprecated
* @property {string} referral_info - referral parameter
* @property {string} section_name - the name of the source section (where the click occurred)
* @property {string} sidebar_name - deprecated
* @property {string} type - click / expand / collapse
**/
/**
 * Name: Giza - click on sidebar item. src: 5 Evid: 550.
 * Event description: user clicks on an item from the sidebar in one of Giza's hosting platforms. currently in business manager it's not reported from Giza..

 * app_id - Type: string. Desc: app_id of the item
 *
 * counter - Type: numeric. Desc: The value inside the counter clicked (if counter exists)
 *
 * hosting - Type: string. Desc: MA/editor
 *
 * hosting_platform - Type: string. Desc: accountmanagr/bizmanagr/devcenter/etc.
 *
 * is_from_main_sidebar - Type: bool. Desc: true if the click is from main sidebar and false if it's from sidebar dropdown tooltip
 *
 * items_list - Type: string. Desc: JSON of all the items the user saw in the sidebar when clicked on item- key:unique item name, value: number of notifications the user sees in this item. In case the type is navigated - please send the sidebar items list
 *
 * legacy_name - Type: string. Desc: deprecated
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: unique item name that doesn't change when changing the name on the side bar
 *
 * origin - Type: string. Desc: tooltip / sidebar / add new
 *
 * platform - Type: string.
 *
 * prev_app_id - Type: guid. Desc: The app_id of the previous page/previous item (before clicking on item)
 *
 * previous_item_name - Type: string. Desc: the previous unique item name that doesn't change when changing the name, this is the item which was highlighted before the click
 *
 * previous_sidebar_name - Type: string. Desc: deprecated
 *
 * referral_info - Type: string. Desc: referral parameter
 *
 * section_name - Type: string. Desc: the name of the source section (where the click occurred)
 *
 * sidebar_name - Type: string. Desc: deprecated
 *
 * type - Type: string. Desc: click / expand / collapse
 * @param {sideBarItemClick550Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sideBarItemClick550 = function (params) {
    return { evid: 550, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} accountManagerClickOnSidebarItemParams
* @property {string} name - unique name that doesn't change when changing the name on the side bar
* @property {string} platform - null
* @property {string} referral_info - referral_info
* @property {string} sidebar_name - the name that appears in the sidebar - can be changed
**/
/**
 * Name: Account Manager - click on sidebar item. src: 5 Evid: 114.
 * Event description: user clicks on an item from the sidebar in the account manager.

 * name - Type: string. Desc: unique name that doesn't change when changing the name on the side bar
 *
 * platform - Type: string.
 *
 * referral_info - Type: string. Desc: referral_info
 *
 * sidebar_name - Type: string. Desc: the name that appears in the sidebar - can be changed
 * @param {accountManagerClickOnSidebarItemParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accountManagerClickOnSidebarItem = function (params) {
    return { evid: 114, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesChangeValueParams
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} name - field name key (customer, email, subject, message, ..)
* @property {string} origin - name of page: create invoice, email invoice, settings
* @property {string} platform - null
* @property {string} value - value of field
**/
/**
 * Name: Quotes - Change value. src: 5 Evid: 407.
 * Event description: change value.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * name - Type: string. Desc: field name key (customer, email, subject, message, ..)
 *
 * origin - Type: string. Desc: name of page: create invoice, email invoice, settings
 *
 * platform - Type: string.
 *
 * value - Type: string. Desc: value of field
 * @param {quotesChangeValueParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesChangeValue = function (params) {
    return { evid: 407, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardTourNextStepParams
* @property {string} experiment_name - null
* @property {GUID} msid - null
* @property {string} stage_process - null
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: dashboard tour > next step. src: 5 Evid: 32.


 * experiment_name - Type: string.
 *
 * msid - Type: guid.
 *
 * stage_process - Type: string.
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {dashboardTourNextStepParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardTourNextStep = function (params) {
    return { evid: 32, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsGoogleSheetsConnectToGoogleAccountEndParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations - google sheets - connect to google account - end. src: 5 Evid: 1484.
 * Event description: Automations - google sheets - connect to google account - end.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsGoogleSheetsConnectToGoogleAccountEndParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsGoogleSheetsConnectToGoogleAccountEnd = function (params) {
    return { evid: 1484, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} customerNotificationsSettingsPreviewEditClickOnToggleParams
* @property {string} channel - email/mobile/sms
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {GUID} rule_id - automations rule_id
* @property {boolean} status - on=true, off=false
* @property {string} template_id - ping template_id
**/
/**
 * Name: customer notifications settings > preview&edit > click on toggle. src: 5 Evid: 1252.
 * Event description: When the user clicks on the toggle to mute/unmute each channel.

 * channel - Type: string. Desc: email/mobile/sms
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * rule_id - Type: guid. Desc: automations rule_id
 *
 * status - Type: bool. Desc: on=true, off=false
 *
 * template_id - Type: string. Desc: ping template_id
 * @param {customerNotificationsSettingsPreviewEditClickOnToggleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var customerNotificationsSettingsPreviewEditClickOnToggle = function (params) {
    return { evid: 1252, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} customerNotificationsSettingsPreviewEditShowTooltipParams
* @property {string} error_name - turn_off_all_channels
* @property {GUID} msid - msid
* @property {string} platform - deprecated
* @property {string} rule_id - automations rule id
* @property {string} template_id - ping template_id
**/
/**
 * Name: customer notifications settings > preview&edit > show tooltip. src: 5 Evid: 1259.
 * Event description: when the user tries to mute all channels the last button is disabled and if he hovers over it a tooltip is shown.

 * error_name - Type: string. Desc: turn_off_all_channels
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string. Desc: deprecated
 *
 * rule_id - Type: string. Desc: automations rule id
 *
 * template_id - Type: string. Desc: ping template_id
 * @param {customerNotificationsSettingsPreviewEditShowTooltipParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var customerNotificationsSettingsPreviewEditShowTooltip = function (params) {
    return { evid: 1259, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} verticalsEmailNotificationSent1271Params
* @property {string} channel - email
* @property {string} contact_id - If the email has been sent to member/contact
* @property {GUID} msid - msid
* @property {string} notificationid - Notification ID
* @property {string} platform - null
* @property {string} template_id - Descriptive name for the type of email. e.g. Identity.Member_Approved
**/
/**
 * Name: Verticals -> email notification -> Sent. src: 5 Evid: 1271.
 * Event description: When a user opens vertical's email  notification which doesn't go via Ping!.

 * channel - Type: string. Desc: email
 *
 * contact_id - Type: string. Desc: If the email has been sent to member/contact
 *
 * msid - Type: guid. Desc: msid
 *
 * notificationid - Type: string. Desc: Notification ID
 *
 * platform - Type: string.
 *
 * template_id - Type: string. Desc: Descriptive name for the type of email. e.g. Identity.Member_Approved
 * @param {verticalsEmailNotificationSent1271Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var verticalsEmailNotificationSent1271 = function (params) {
    return { evid: 1271, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationHomePageAutomationTableMoreActionsParams
* @property {GUID} msid - msid
* @property {string} origin - where from the user clicked
* @property {string} platform - null
* @property {GUID} ruleId - ruleId
* @property {string} status - automation status
**/
/**
 * Name: Automation > automation more actions per specific automation. src: 5 Evid: 1352.
 * Event description: Automation > automation more actions per specific automation, more actions = 3 dots.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: where from the user clicked
 *
 * platform - Type: string.
 *
 * ruleId - Type: guid. Desc: ruleId
 *
 * status - Type: string. Desc: automation status
 * @param {automationHomePageAutomationTableMoreActionsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationHomePageAutomationTableMoreActions = function (params) {
    return { evid: 1352, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesAddAProductVariantAddToInvoiceParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Invoices - Add a product Variant - add to invoice. src: 5 Evid: 1210.
 * Event description: Invoices - Add a product Variant - add to invoice.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {invoicesAddAProductVariantAddToInvoiceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesAddAProductVariantAddToInvoice = function (params) {
    return { evid: 1210, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesDeleteProductClickParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Quotes - Delete product click. src: 5 Evid: 418.
 * Event description: Delete product click.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {quotesDeleteProductClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesDeleteProductClick = function (params) {
    return { evid: 418, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesClickSaveOnAddBusinessDetailsPageParams
* @property {string} msid - msid
* @property {string} platform - null
* @property {GUID} uuid - uuid
**/
/**
 * Name: Quotes - Click Save On Add Business Details Page. src: 5 Evid: 472.
 * Event description: Click Save On Add Business Details Page (mobile).

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 * @param {quotesClickSaveOnAddBusinessDetailsPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesClickSaveOnAddBusinessDetailsPage = function (params) {
    return { evid: 472, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} apesSaveEditedNotification1235Params
* @property {string} componentChanged - which component was changed
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {GUID} rule_id - rule id
**/
/**
 * Name: APeS - Save edited notification. src: 5 Evid: 1235.
 * Event description: APeS - Save edited notification.

 * componentChanged - Type: string. Desc: which component was changed
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * rule_id - Type: guid. Desc: rule id
 * @param {apesSaveEditedNotification1235Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var apesSaveEditedNotification1235 = function (params) {
    return { evid: 1235, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSettingsDeleteValueFailureParams
* @property {string} experience - user's experience
* @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
* @property {GUID} msid - msid
* @property {string} name - name of the field that was changed
* @property {string} origin - name of current tab
* @property {string} platform - null
* @property {number} src - null
* @property {string} value - delete/clear value
**/
/**
 * Name: dashboard > site settings > delete value failure. src: 5 Evid: 318.
 * Event description: user deleted/cleared a value from field - failure.

 * experience - Type: string. Desc: user's experience
 *
 * hosting - Type: string. Desc: from where user arrived to sitesettings (Editor/MA/...)
 *
 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: name of the field that was changed
 *
 * origin - Type: string. Desc: name of current tab
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 *
 * value - Type: string. Desc: delete/clear value
 * @param {dashboardSiteSettingsDeleteValueFailureParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSettingsDeleteValueFailure = function (params) {
    return { evid: 318, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesCreateQuoteSaveDraftFailedParams
* @property {string} msid - msid
* @property {string} origin - create quote, edit quote
* @property {string} platform - null
* @property {GUID} quoteId - quote guid
* @property {string} reason - failure reason
**/
/**
 * Name: Quotes - Create quote - Save draft failed. src: 5 Evid: 79.
 * Event description: Create quote - Save draft failed.

 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: create quote, edit quote
 *
 * platform - Type: string.
 *
 * quoteId - Type: guid. Desc: quote guid
 *
 * reason - Type: string. Desc: failure reason
 * @param {quotesCreateQuoteSaveDraftFailedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesCreateQuoteSaveDraftFailed = function (params) {
    return { evid: 79, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} transferSiteOpenTransferDialogClickParams
* @property {string} hosting - MA /Editor
* @property {string} block_from_transfer_reason - Block from transferring a site
* @property {GUID} msid - msid
* @property {string} origin - quick-actions/roles-contributor/roles-owner
* @property {string} platform - null
**/
/**
 * Name: Transfer site - open transfer dialog - click. src: 5 Evid: 63.
 * Event description: user clicks on transfer site and dialog is opened.

 * hosting - Type: string. Desc: MA /Editor
 *
 * block_from_transfer_reason - Type: string. Desc: Block from transferring a site
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: quick-actions/roles-contributor/roles-owner
 *
 * platform - Type: string.
 * @param {transferSiteOpenTransferDialogClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var transferSiteOpenTransferDialogClick = function (params) {
    return { evid: 63, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} transferSiteCancelTransferClickParams
* @property {string} hosting - MA /Editor
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Transfer site - cancel transfer - click. src: 5 Evid: 60.
 * Event description: user clicked on cancel transfer and cancel dialog is opened.

 * hosting - Type: string. Desc: MA /Editor
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {transferSiteCancelTransferClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var transferSiteCancelTransferClick = function (params) {
    return { evid: 60, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteActivityCenterClickUndoDeletedItemParams
* @property {string} action_desc - null
* @property {string} action_url - null
* @property {number} expire - null
* @property {GUID} feed_id - null
* @property {boolean} is_archived - null
* @property {boolean} is_deleted - null
* @property {GUID} item_id - null
* @property {number} items_count - null
* @property {GUID} msid - null
* @property {string} origin - null
* @property {string} platform - null
* @property {string} referral - null
* @property {string} source - null
* @property {number} src - null
* @property {string} type - null
**/
/**
 * Name: dashboard > site -> activity center -> click undo deleted item. src: 5 Evid: 103.


 * action_desc - Type: string.
 *
 * action_url - Type: string.
 *
 * expire - Type: numeric.
 *
 * feed_id - Type: guid.
 *
 * is_archived - Type: bool.
 *
 * is_deleted - Type: bool.
 *
 * item_id - Type: guid.
 *
 * items_count - Type: numeric.
 *
 * msid - Type: guid.
 *
 * origin - Type: string.
 *
 * platform - Type: string.
 *
 * referral - Type: string.
 *
 * source - Type: string.
 *
 * src - Type: numeric.
 *
 * type - Type: string.
 * @param {dashboardSiteActivityCenterClickUndoDeletedItemParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteActivityCenterClickUndoDeletedItem = function (params) {
    return { evid: 103, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsDaComponentCreateYourOwn292Params
* @property {string} asset_campaign_guid - asset_campaign_guid
* @property {number} countAutomations - count how many automations was presented in the widget
* @property {GUID} msid - msid
* @property {string} origin - button, link, header, success creation dialog
* @property {string} platform - null
* @property {string} referral_info - indicate which vertical is the dacomponent triggered from
**/
/**
 * Name: Automations > Recommendation Widget > Create Your Own. src: 5 Evid: 292.
 * Event description: Automations > DaComponent > Create Your Own.

 * asset_campaign_guid - Type: string. Desc: asset_campaign_guid
 *
 * countAutomations - Type: numeric. Desc: count how many automations was presented in the widget
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: button, link, header, success creation dialog
 *
 * platform - Type: string.
 *
 * referral_info - Type: string. Desc: indicate which vertical is the dacomponent triggered from
 * @param {automationsDaComponentCreateYourOwn292Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsDaComponentCreateYourOwn292 = function (params) {
    return { evid: 292, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsWidgetDisplayLoadingParams
* @property {GUID} appId - app_id
* @property {boolean} isCardOpen - if the collapse of the widget is opened by default or not
* @property {GUID} msid - msid
* @property {string} origin - origin which this action was made
* @property {string} platform - null
* @property {string} ruleIdsArray - rule_ids_array
* @property {string} type - widget type -row, dashboard , v2 etc
**/
/**
 * Name: Automations - Automation widget display (start loading). src: 5 Evid: 8952.
 * Event description: Automations - Automation widget display.

 * appId - Type: guid. Desc: app_id
 *
 * isCardOpen - Type: bool. Desc: if the collapse of the widget is opened by default or not
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin which this action was made
 *
 * platform - Type: string.
 *
 * ruleIdsArray - Type: string. Desc: rule_ids_array
 *
 * type - Type: string. Desc: widget type -row, dashboard , v2 etc
 * @param {automationsWidgetDisplayLoadingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsWidgetDisplayLoading = function (params) {
    return { evid: 8952, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} sidebarState107Params
* @property {string} active_item - the active sidebar item the user is navigated to
* @property {string} active_item_cta - deprecated
* @property {string} category_items_list - list of category items in the main sidebar menu (might be under the fold)
* @property {string} hosting - MA/editor
* @property {string} hosting_platform - accountmanagr/bizmanagr/devcenter/etc.
* @property {string} hosting_platform_context_id - context id: when the context is site - msid, when the context is app_id (like in devCenter f.e) - appDefId. In account manager is null
* @property {GUID} msid - --
* @property {string} page_id - the active page id
* @property {string} platform - deprecated
* @property {string} prev_page_id - the previous page id
* @property {string} referral_info - referral of previous page
* @property {string} section_name - the name of the section (main sidebar shown) -in case of expand it will be the expanded menu name
* @property {string} sub_category_items_list - list of sub_category items in the expanded sidebar menu (might be under the fold)
* @property {string} view - the page loaded with the sidebar (not internal page - module)
**/
/**
 * Name: Giza - Sidebar State. src: 5 Evid: 107.
 * Event description: on each Bizmgr page, the event sends the current state of the sidebar.
this event will be sent also when the user arrives to Bizgmr from an external link.
e.g. main menu/setting menu/marketing tools menu etc..

 * active_item - Type: string. Desc: the active sidebar item the user is navigated to
 *
 * active_item_cta - Type: string. Desc: deprecated
 *
 * category_items_list - Type: string. Desc: list of category items in the main sidebar menu (might be under the fold)
 *
 * hosting - Type: string. Desc: MA/editor
 *
 * hosting_platform - Type: string. Desc: accountmanagr/bizmanagr/devcenter/etc.
 *
 * hosting_platform_context_id - Type: string. Desc: context id: when the context is site - msid, when the context is app_id (like in devCenter f.e) - appDefId. In account manager is null
 *
 * msid - Type: guid. Desc: --
 *
 * page_id - Type: string. Desc: the active page id
 *
 * platform - Type: string. Desc: deprecated
 *
 * prev_page_id - Type: string. Desc: the previous page id
 *
 * referral_info - Type: string. Desc: referral of previous page
 *
 * section_name - Type: string. Desc: the name of the section (main sidebar shown) -in case of expand it will be the expanded menu name
 *
 * sub_category_items_list - Type: string. Desc: list of sub_category items in the expanded sidebar menu (might be under the fold)
 *
 * view - Type: string. Desc: the page loaded with the sidebar (not internal page - module)
 * @param {sidebarState107Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sidebarState107 = function (params) {
    return { evid: 107, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsStoresChooseSpecificProductClickParams
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} productName - which product was chosen
**/
/**
 * Name: Automations - choose specific product click. src: 5 Evid: 1319.
 * Event description: Automations -  choose specific product click.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * productName - Type: string. Desc: which product was chosen
 * @param {automationsStoresChooseSpecificProductClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsStoresChooseSpecificProductClick = function (params) {
    return { evid: 1319, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesCreateQuoteSaveDraftCompleteParams
* @property {string} msid - msid
* @property {string} origin - create quote, edit quote
* @property {string} platform - null
* @property {GUID} quoteId - quote guid
**/
/**
 * Name: Quotes - Create quote - Save draft complete. src: 5 Evid: 78.
 * Event description: Create quote - Save draft completed.

 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: create quote, edit quote
 *
 * platform - Type: string.
 *
 * quoteId - Type: guid. Desc: quote guid
 * @param {quotesCreateQuoteSaveDraftCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesCreateQuoteSaveDraftComplete = function (params) {
    return { evid: 78, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesRecurringClientSelectedParams
* @property {string} contact_id - contact_id selected
* @property {string} msid - msid
* @property {string} platform - platform
* @property {GUID} uuid - uuid
**/
/**
 * Name: Invoices - Client selected. src: 5 Evid: 1651.
 * Event description: Quotes - recurring -  Client selected.

 * contact_id - Type: string. Desc: contact_id selected
 *
 * msid - Type: string. Desc: msid
 *
 * platform - Type: string. Desc: platform
 *
 * uuid - Type: guid. Desc: uuid
 * @param {invoicesRecurringClientSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesRecurringClientSelected = function (params) {
    return { evid: 1651, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} email2faSetupSendCodeParams
* @property {string} action - send/resend
* @property {string} platform - null
**/
/**
 * Name: Email 2FA Setup - Send Code. src: 5 Evid: 1673.
 * Event description: The user clicks on 'send code' or 'resend code' in the email 2fa setup modal.

 * action - Type: string. Desc: send/resend
 *
 * platform - Type: string.
 * @param {email2faSetupSendCodeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var email2faSetupSendCode = function (params) {
    return { evid: 1673, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesFilterInvoicesParams
* @property {string} filter_type - period, currency, display
* @property {string} msid - msid
* @property {string} name - name of filter
* @property {number} num_of_invoices - number of invoices the user has
* @property {string} origin_device - web,native
* @property {string} platform - null
**/
/**
 * Name: Quotes - Filter invoices. src: 5 Evid: 447.
 * Event description: user filters the invoices view.

 * filter_type - Type: string. Desc: period, currency, display
 *
 * msid - Type: string. Desc: msid
 *
 * name - Type: string. Desc: name of filter
 *
 * num_of_invoices - Type: numeric. Desc: number of invoices the user has
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string.
 * @param {quotesFilterInvoicesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesFilterInvoices = function (params) {
    return { evid: 447, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} app2faSetupSubmitCodeParams
* @property {string} mode - change app/enable
* @property {string} platform - null
**/
/**
 * Name: App 2FA Setup - Submit Code. src: 5 Evid: 1741.
 * Event description: The user clicks on 'submit' in the app 2fa setup modal after entering the 6-digit code from the authenticator app.

 * mode - Type: string. Desc: change app/enable
 *
 * platform - Type: string.
 * @param {app2faSetupSubmitCodeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var app2faSetupSubmitCode = function (params) {
    return { evid: 1741, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsWebhookV2CustomizeStructureParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations - webhook v2 - customize structure. src: 5 Evid: 1395.
 * Event description: Automations - webhook v2 - customize structure.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsWebhookV2CustomizeStructureParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsWebhookV2CustomizeStructure = function (params) {
    return { evid: 1395, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} notificationsPushNotificationToggleIsDisplayedParams
* @property {string} feed_name - All Sites/This Site/ Settings
* @property {string} msid - deprecated
* @property {string} origin - (Msid/my-site) MSID of the site the user is on, my-sites if on Site List. Later on, also account-settings, and other account-level pages.
* @property {string} permission_type - permission
* @property {string} platform - null
**/
/**
 * Name: Notifications > Push notification toggle is displayed. src: 5 Evid: 274.
 * Event description: user clicks the "Allow/ Block " and toggle is displayed.

 * feed_name - Type: string. Desc: All Sites/This Site/ Settings
 *
 * msid - Type: string. Desc: deprecated
 *
 * origin - Type: string. Desc: (Msid/my-site) MSID of the site the user is on, my-sites if on Site List. Later on, also account-settings, and other account-level pages.
 *
 * permission_type - Type: string. Desc: permission
 *
 * platform - Type: string.
 * @param {notificationsPushNotificationToggleIsDisplayedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var notificationsPushNotificationToggleIsDisplayed = function (params) {
    return { evid: 274, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsPriceQuotesInvoicesSendFeedbackFormParams
* @property {GUID} msid - msid
* @property {string} origin - {automations, price quotes, invoices}
* @property {string} platform - null
**/
/**
 * Name: Automations/ Price Quotes/ Invoices > Send Feedback Form. src: 5 Evid: 232.
 * Event description: user click on Send Feedback.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: {automations, price quotes, invoices}
 *
 * platform - Type: string.
 * @param {automationsPriceQuotesInvoicesSendFeedbackFormParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsPriceQuotesInvoicesSendFeedbackForm = function (params) {
    return { evid: 232, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardShowMorePopularShortcutsClickParams
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: dashboard > 'show more' popular shortcuts click. src: 5 Evid: 28.
 * Event description: each time user clicks the 'show more' link.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {dashboardShowMorePopularShortcutsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardShowMorePopularShortcutsClick = function (params) {
    return { evid: 28, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsMissingEmailPhoneLearnMoreFromAutomationsPageParams
* @property {string} actionName - actionName
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} recipeName - recipeName
* @property {GUID} ruleId - ruleId
* @property {string} triggerActivityType - triggerActivityType
**/
/**
 * Name: Automations > missing email/phone - learn more. src: 5 Evid: 1647.
 * Event description: Automations > missing email/phone - learn more.

 * actionName - Type: string. Desc: actionName
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * recipeName - Type: string. Desc: recipeName
 *
 * ruleId - Type: guid. Desc: ruleId
 *
 * triggerActivityType - Type: string. Desc: triggerActivityType
 * @param {automationsMissingEmailPhoneLearnMoreFromAutomationsPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsMissingEmailPhoneLearnMoreFromAutomationsPage = function (params) {
    return { evid: 1647, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesItemsListLinkInTooltipProductsParams
* @property {GUID} appDefId - appDefId
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Invoices - Items List - link in tooltip products. src: 5 Evid: 1317.
 * Event description: Invoices - Items List - link in tooltip products.

 * appDefId - Type: guid. Desc: appDefId
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {invoicesItemsListLinkInTooltipProductsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesItemsListLinkInTooltipProducts = function (params) {
    return { evid: 1317, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteClickNextOnTransferSiteActionFirstWindowParams
* @property {boolean} addAdmin - true if marked
* @property {string} hosting - ma/editor
* @property {boolean} isContributor - true if email is contact
* @property {boolean} keepCopy - true if marked
* @property {GUID} msid - --
* @property {string} name - name of quick action (transfer,etc.)
* @property {string} origin - --
* @property {string} stage_process - deprecated
* @property {string} platform - null
* @property {boolean} transferDomain - true if marked
* @property {boolean} transferPremium - true if marked
**/
/**
 * Name: dashboard > site -> click next on transfer site action first window. src: 5 Evid: 48.
 * Event description: when user click on quick action, and then click next after chooses relevant transfer options.

 * addAdmin - Type: bool. Desc: true if marked
 *
 * hosting - Type: string. Desc: ma/editor
 *
 * isContributor - Type: bool. Desc: true if email is contact
 *
 * keepCopy - Type: bool. Desc: true if marked
 *
 * msid - Type: guid. Desc: --
 *
 * name - Type: string. Desc: name of quick action (transfer,etc.)
 *
 * origin - Type: string. Desc: --
 *
 * stage_process - Type: string. Desc: deprecated
 *
 * platform - Type: string.
 *
 * transferDomain - Type: bool. Desc: true if marked
 *
 * transferPremium - Type: bool. Desc: true if marked
 * @param {dashboardSiteClickNextOnTransferSiteActionFirstWindowParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteClickNextOnTransferSiteActionFirstWindow = function (params) {
    return { evid: 48, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} rolesDeleteRoleClickParams
* @property {string} accept_email - accepted email
* @property {string} hosting - MA / Editor
* @property {GUID} msid - msid
* @property {string} origin - name of tab
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: Roles - delete role - click. src: 5 Evid: 360.
 * Event description: user clicked on delete role.

 * accept_email - Type: string. Desc: accepted email
 *
 * hosting - Type: string. Desc: MA / Editor
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: name of tab
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {rolesDeleteRoleClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rolesDeleteRoleClick = function (params) {
    return { evid: 360, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} ascendPpClickOnShowMoreLessParams
* @property {string} action - more/less
* @property {string} ascend_product - CRM / Promote product  - click show more
* @property {string} origin - product name open PP
* @property {string} platform - null
* @property {string} productName - product name of show more/less
* @property {string} referralInfo - button name open PP
**/
/**
 * Name: Ascend PP - Click on show more/less. src: 5 Evid: 132.
 * Event description: User click on show more/less in Ascend PP.

 * action - Type: string. Desc: more/less
 *
 * ascend_product - Type: string. Desc: CRM / Promote product  - click show more
 *
 * origin - Type: string. Desc: product name open PP
 *
 * platform - Type: string.
 *
 * productName - Type: string. Desc: product name of show more/less
 *
 * referralInfo - Type: string. Desc: button name open PP
 * @param {ascendPpClickOnShowMoreLessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ascendPpClickOnShowMoreLess = function (params) {
    return { evid: 132, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteNewsFilterParams
* @property {string} filter_type - null
* @property {string} location - null
* @property {GUID} msid - null
* @property {string} name - null
* @property {string} origin - null
* @property {string} platform - null
* @property {number} src - null
* @property {string} type - null
**/
/**
 * Name: dashboard > site -> news -> filter. src: 5 Evid: 21.


 * filter_type - Type: string.
 *
 * location - Type: string.
 *
 * msid - Type: guid.
 *
 * name - Type: string.
 *
 * origin - Type: string.
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 *
 * type - Type: string.
 * @param {dashboardSiteNewsFilterParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteNewsFilter = function (params) {
    return { evid: 21, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesTabPageViewParams
* @property {string} experience - deprecated
* @property {string} msid - msid
* @property {string} name - tab name
* @property {string} origin - web,native
* @property {string} place - how the user arrived to the tab
* @property {string} platform - null
**/
/**
 * Name: Quotes/Invoices - tab page view. src: 5 Evid: 400.
 * Event description: wix invoices/ quotes tab page view.

 * experience - Type: string. Desc: deprecated
 *
 * msid - Type: string. Desc: msid
 *
 * name - Type: string. Desc: tab name
 *
 * origin - Type: string. Desc: web,native
 *
 * place - Type: string. Desc: how the user arrived to the tab
 *
 * platform - Type: string.
 * @param {quotesTabPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesTabPageView = function (params) {
    return { evid: 400, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsSendCouponErrorMissingFieldsParams
* @property {string} errorReason - errorReason
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations - send coupon - error missing fields. src: 5 Evid: 1617.
 * Event description: Automations - send coupon - error missing fields.

 * errorReason - Type: string. Desc: errorReason
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsSendCouponErrorMissingFieldsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsSendCouponErrorMissingFields = function (params) {
    return { evid: 1617, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesSettingsNewTaxPageCancelParams
* @property {GUID} invoice_id - invoice guid
* @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
* @property {string} msid - msid
* @property {string} origin - create,edit
* @property {string} platform - null
* @property {string} source - source
**/
/**
 * Name: Quotes - Settings - New tax page - Cancel. src: 5 Evid: 435.
 * Event description: Settings - New tax page - Cancel (for every close (cancel, x, background click)).

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * invoiceType - Type: string. Desc: ’recurringAutoCharge’/ 'recurring'/ 'one time'
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: create,edit
 *
 * platform - Type: string.
 *
 * source - Type: string. Desc: source
 * @param {quotesSettingsNewTaxPageCancelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesSettingsNewTaxPageCancel = function (params) {
    return { evid: 435, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} tooltipForOwnerAppClickParams
* @property {string} hosting - Dashboard/editor/ADI
* @property {GUID} msid - msid
* @property {string} name - cta/close
* @property {string} platform - null
**/
/**
 * Name: Tooltip for owner app click. src: 5 Evid: 2003.
 * Event description: when click onTooltip for owner app.

 * hosting - Type: string. Desc: Dashboard/editor/ADI
 *
 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: cta/close
 *
 * platform - Type: string.
 * @param {tooltipForOwnerAppClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tooltipForOwnerAppClick = function (params) {
    return { evid: 2003, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationHomePageClickOnTableActionsParams
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} type - filter / search
**/
/**
 * Name: Automation > home page - click on filter or search. src: 5 Evid: 1350.
 * Event description: Automation > home page - click on table actions. Click on filter button or search line.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * type - Type: string. Desc: filter / search
 * @param {automationHomePageClickOnTableActionsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationHomePageClickOnTableActions = function (params) {
    return { evid: 1350, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeButtonClickedParams
* @property {string} button_name - button name
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} section - i.e create automation , manage finance , all crm tabs
* @property {GUID} uuid - uuid
**/
/**
 * Name: CRM Home - Button Clicked. src: 5 Evid: 354.
 * Event description: CRM Home - Button Clicked.

 * button_name - Type: string. Desc: button name
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * section - Type: string. Desc: i.e create automation , manage finance , all crm tabs
 *
 * uuid - Type: guid. Desc: uuid
 * @param {crmHomeButtonClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeButtonClicked = function (params) {
    return { evid: 354, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerNavigateToViewStartParams
* @property {GUID} app_id - last  application loaded
* @property {string} hosting - MA/editor
* @property {string} module_id - *not in use*
* @property {GUID} msid - metasite id
* @property {string} platform - null
* @property {string} prev_module_id - *not in use*
* @property {string} prev_sub_view - prev page in app
* @property {string} prev_view - last view loaded
* @property {string} referral_info - specific button that triggers the navigation
* @property {string} sub_view - page in app
* @property {string} view - requested view
* @property {string} wixsession - authentication token. if the session exists, then the user is logged in.
**/
/**
 * Name: Biz Manager - Navigate To View - start. src: 5 Evid: 566.
 * Event description: user's click triggers the Router to start a navigation.

 * app_id - Type: guid. Desc: last  application loaded
 *
 * hosting - Type: string. Desc: MA/editor
 *
 * module_id - Type: string. Desc: *not in use*
 *
 * msid - Type: guid. Desc: metasite id
 *
 * platform - Type: string.
 *
 * prev_module_id - Type: string. Desc: *not in use*
 *
 * prev_sub_view - Type: string. Desc: prev page in app
 *
 * prev_view - Type: string. Desc: last view loaded
 *
 * referral_info - Type: string. Desc: specific button that triggers the navigation
 *
 * sub_view - Type: string. Desc: page in app
 *
 * view - Type: string. Desc: requested view
 *
 * wixsession - Type: string. Desc: authentication token. if the session exists, then the user is logged in.
 * @param {bizManagerNavigateToViewStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerNavigateToViewStart = function (params) {
    return { evid: 566, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsNewHomeBannerLoadingStartParams
* @property {string} jsonData - json
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations > New Home - Banner Loading Start -NOT FOR USE. src: 5 Evid: 241.
 * Event description: All data when opening automation before banner NOT FOR USE, need to delete after 1/7/2022.

 * jsonData - Type: string. Desc: json
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsNewHomeBannerLoadingStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsNewHomeBannerLoadingStart = function (params) {
    return { evid: 241, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} transferSiteGetTransferLinkClickParams
* @property {string} hosting - MA /Editor
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Transfer site - get transfer link - click. src: 5 Evid: 59.
 * Event description: user clicked on get transfer link.

 * hosting - Type: string. Desc: MA /Editor
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {transferSiteGetTransferLinkClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var transferSiteGetTransferLinkClick = function (params) {
    return { evid: 59, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesDeleteInvoicePageOkParams
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} origin_device - web,native
* @property {string} platform - null
**/
/**
 * Name: Quotes - Delete invoice page - Ok. src: 5 Evid: 431.
 * Event description: OK clicked in delete page.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string.
 * @param {quotesDeleteInvoicePageOkParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesDeleteInvoicePageOk = function (params) {
    return { evid: 431, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} accountSettingsSetPasswordModalLoadParams
* @property {string} platform - null
**/
/**
 * Name: Account Settings - Set Password Modal Load. src: 5 Evid: 688.
 * Event description: When a user tries to access account settings after social signup (which means he didn't choose a wix password when signing up), the set password modal pops up and asks him to choose an account password..

 * platform - Type: string.
 * @param {accountSettingsSetPasswordModalLoadParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accountSettingsSetPasswordModalLoad = function (params) {
    return { evid: 688, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} rolesAddNewRoleClickParams
* @property {string} hosting - MA/Editor
* @property {boolean} is_blog_shown - true if shown (blog manager appears only for sites with blog)
* @property {boolean} is_events_shown - true if shown (event manager appears only for sites with events )
* @property {GUID} msid - msid
* @property {string} origin - name of tab dashboard/authorization/my sites
* @property {string} platform - null
* @property {string} roles_displayed - list of roles displayed to the user
* @property {number} src - null
**/
/**
 * Name: Roles - add new role - open dialog. src: 5 Evid: 350.
 * Event description: click on add new from authorization tab in site settings.

 * hosting - Type: string. Desc: MA/Editor
 *
 * is_blog_shown - Type: bool. Desc: true if shown (blog manager appears only for sites with blog)
 *
 * is_events_shown - Type: bool. Desc: true if shown (event manager appears only for sites with events )
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: name of tab dashboard/authorization/my sites
 *
 * platform - Type: string.
 *
 * roles_displayed - Type: string. Desc: list of roles displayed to the user
 *
 * src - Type: numeric.
 * @param {rolesAddNewRoleClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rolesAddNewRoleClick = function (params) {
    return { evid: 350, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardTriggersCancelDeleteParams
* @property {GUID} msid - msid
* @property {string} origin - origin page
* @property {string} platform - null
* @property {string} recipe_name - recipie
* @property {GUID} rule_id - id of rule
* @property {number} src - null
**/
/**
 * Name: Automations > Cancel delete. src: 5 Evid: 210.
 * Event description: Save or update trigger.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin page
 *
 * platform - Type: string.
 *
 * recipe_name - Type: string. Desc: recipie
 *
 * rule_id - Type: guid. Desc: id of rule
 *
 * src - Type: numeric.
 * @param {dashboardTriggersCancelDeleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardTriggersCancelDelete = function (params) {
    return { evid: 210, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} deleteLocationModalIsOpenedParams
* @property {string} hosting - dashboard/editor/ADI
* @property {boolean} is_default - true if trying to delete default location
* @property {boolean} is_draft - true if the location is a draft or not
* @property {boolean} is_multiple_choice - true/ false if the modal present a few options to choose from
* @property {GUID} msid - msid
* @property {string} page_view - business info
* @property {string} platform - null
**/
/**
 * Name: Delete Location Modal is opened. src: 5 Evid: 1217.
 * Event description: When the delete modal is opened (after clicking delete location).

 * hosting - Type: string. Desc: dashboard/editor/ADI
 *
 * is_default - Type: bool. Desc: true if trying to delete default location
 *
 * is_draft - Type: bool. Desc: true if the location is a draft or not
 *
 * is_multiple_choice - Type: bool. Desc: true/ false if the modal present a few options to choose from
 *
 * msid - Type: guid. Desc: msid
 *
 * page_view - Type: string. Desc: business info
 *
 * platform - Type: string.
 * @param {deleteLocationModalIsOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var deleteLocationModalIsOpened = function (params) {
    return { evid: 1217, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} mySitesUnableToMoveSitesToTrashModalIsShownOnBulkMoveToTrashOrSingleSiteMoveToTrashParams
* @property {string} hosting - MA/editor
* @property {number} num_untrashed_sites - number of sites can't be moved to trash
* @property {string} origin - my sites / dashboard / sites-list-enterprise
* @property {string} platform - deprecated
* @property {string} reasons - a JSON of the reasons the sites can't be moved to trash when the key is the reason and the value is a list of the sites msid's which can't be moved to trash, the keys: pending subscription/active subscription/unpermitted/tech error
**/
/**
 * Name: My Sites - Unable to Move Sites to Trash modal is shown (on bulk/single site move to trash). src: 5 Evid: 1771.
 * Event description: when Unable to Move Sites to Trash modal is shown after user tried to move to trash (the modal will appear in single site moving to trash or in bulk moving to trash).

 * hosting - Type: string. Desc: MA/editor
 *
 * num_untrashed_sites - Type: numeric. Desc: number of sites can't be moved to trash
 *
 * origin - Type: string. Desc: my sites / dashboard / sites-list-enterprise
 *
 * platform - Type: string. Desc: deprecated
 *
 * reasons - Type: string. Desc: a JSON of the reasons the sites can't be moved to trash when the key is the reason and the value is a list of the sites msid's which can't be moved to trash, the keys: pending subscription/active subscription/unpermitted/tech error
 * @param {mySitesUnableToMoveSitesToTrashModalIsShownOnBulkMoveToTrashOrSingleSiteMoveToTrashParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mySitesUnableToMoveSitesToTrashModalIsShownOnBulkMoveToTrashOrSingleSiteMoveToTrash = function (params) {
    return { evid: 1771, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesSettingsSaveButtonParams
* @property {string} card_name - Header details, Business Info, Tax settings, Footer Notes)
* @property {string} customFields - what custom fields is added (header fields, business custom fields, footer notes)
* @property {string} documentName - documentName
* @property {boolean} hasLogo - weather logo is uploaded
* @property {string} invoiceNumber - invoiceNumber
* @property {string} invoiceEmail - what is written in email that is sending to cutomer
* @property {GUID} msid - msid
* @property {string} origin - From which place it was saved: ‘Discard Modal’ , ‘Save button’
* @property {string} platform - mobile/web
* @property {boolean} showTaxAmount - weather net taxes is shown in invoice
* @property {boolean} showTaxColumn - is tax is shown per line item (first checkbox in settings)
**/
/**
 * Name: Invoices Settings Save Button. src: 5 Evid: 8930.
 * Event description: When Invoices settings is Saved by clicking on button.

 * card_name - Type: string. Desc: Header details, Business Info, Tax settings, Footer Notes)
 *
 * customFields - Type: string. Desc: what custom fields is added (header fields, business custom fields, footer notes)
 *
 * documentName - Type: string. Desc: documentName
 *
 * hasLogo - Type: bool. Desc: weather logo is uploaded
 *
 * invoiceNumber - Type: string. Desc: invoiceNumber
 *
 * invoiceEmail - Type: string. Desc: what is written in email that is sending to cutomer
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: From which place it was saved: ‘Discard Modal’ , ‘Save button’
 *
 * platform - Type: string. Desc: mobile/web
 *
 * showTaxAmount - Type: bool. Desc: weather net taxes is shown in invoice
 *
 * showTaxColumn - Type: bool. Desc: is tax is shown per line item (first checkbox in settings)
 * @param {invoicesSettingsSaveButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesSettingsSaveButton = function (params) {
    return { evid: 8930, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSelectorSearchResultsParams
* @property {string} device - mobile / desktop
* @property {string} filtered_by - premium/published/adi / none
* @property {string} platform - null
* @property {string} selectionType - single / multi
* @property {number} site_type_enriched - site_type
* @property {undefined} site_type - HtmlWeb / modal
* @property {string} status - success / no match
* @property {string} type - HtmlWeb /modal
**/
/**
 * Name: dashboard > site selector search results. src: 5 Evid: 1598.


 * device - Type: string. Desc: mobile / desktop
 *
 * filtered_by - Type: string. Desc: premium/published/adi / none
 *
 * platform - Type: string.
 *
 * selectionType - Type: string. Desc: single / multi
 *
 * site_type_enriched - Type: numeric. Desc: site_type
 *
 * site_type - Type: map. Desc: HtmlWeb / modal
 *
 * status - Type: string. Desc: success / no match
 *
 * type - Type: string. Desc: HtmlWeb /modal
 * @param {dashboardSiteSelectorSearchResultsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSelectorSearchResults = function (params) {
    return { evid: 1598, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} twoFactorAuthenticationSetupDisableClickParams
* @property {string} platform - null
**/
/**
 * Name: Phone 2FA Setup - Disable Confirm. src: 5 Evid: 687.
 * Event description: The user clicks on "disable" in the disable modal for 2-factor authentication (confirms disable).

 * platform - Type: string.
 * @param {twoFactorAuthenticationSetupDisableClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var twoFactorAuthenticationSetupDisableClick = function (params) {
    return { evid: 687, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteQuickActionDialogApproveParams
* @property {GUID} msid - -
* @property {string} name - quick action name
* @property {string} origin - site-settings, my-sites
* @property {string} platform - null
**/
/**
 * Name: dashboard > site -> quick action dialog  - approve. src: 5 Evid: 42.
 * Event description: user clicks approve in dialog of a quick action (e.g approve rename).

 * msid - Type: guid. Desc: -
 *
 * name - Type: string. Desc: quick action name
 *
 * origin - Type: string. Desc: site-settings, my-sites
 *
 * platform - Type: string.
 * @param {dashboardSiteQuickActionDialogApproveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteQuickActionDialogApprove = function (params) {
    return { evid: 42, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsClickOnBannerCarrouselArrowParams
* @property {boolean} isEnd - he last click in the carrousel
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations > click on banner carrousel arrow. src: 5 Evid: 1244.
 * Event description: User clicks on banner carrousel arrow to see more tips & recipes.

 * isEnd - Type: bool. Desc: he last click in the carrousel
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsClickOnBannerCarrouselArrowParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsClickOnBannerCarrouselArrow = function (params) {
    return { evid: 1244, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} siteActionsDropDownListShownParams
* @property {string} cta - ‘sidepanel’ \ ‘menu’
* @property {string} itemsList - list of all the shown items when drop down menu is shown
* @property {GUID} msid - site guid
* @property {string} origin - my-sites/dashboard/sites-list-enterprise
* @property {string} permitted_items - list of all the items the user can click on (unblocked items)
* @property {string} platform - deprecated
* @property {string} site_class - client/organization, not mendatory
* @property {string} view_mode - list/grid
**/
/**
 * Name: Site actions > drop down list shown. src: 5 Evid: 1662.


 * cta - Type: string. Desc: ‘sidepanel’ \ ‘menu’
 *
 * itemsList - Type: string. Desc: list of all the shown items when drop down menu is shown
 *
 * msid - Type: guid. Desc: site guid
 *
 * origin - Type: string. Desc: my-sites/dashboard/sites-list-enterprise
 *
 * permitted_items - Type: string. Desc: list of all the items the user can click on (unblocked items)
 *
 * platform - Type: string. Desc: deprecated
 *
 * site_class - Type: string. Desc: client/organization, not mendatory
 *
 * view_mode - Type: string. Desc: list/grid
 * @param {siteActionsDropDownListShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteActionsDropDownListShown = function (params) {
    return { evid: 1662, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationAscendBannerDisplayParams
* @property {GUID} msid - msid
* @property {string} origin - button location
* @property {string} platform - null
**/
/**
 * Name: Automation - ascend banner display. src: 5 Evid: 1288.
 * Event description: Automation - ascend banner display.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: button location
 *
 * platform - Type: string.
 * @param {automationAscendBannerDisplayParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationAscendBannerDisplay = function (params) {
    return { evid: 1288, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerBizInfoNavigateAwayDialogIsShownParams
* @property {string} hosting - MA/editor
* @property {GUID} msid - metasite id
* @property {string} platform - null
**/
/**
 * Name: Biz Manager - Biz Info - navigate away dialog is shown. src: 5 Evid: 557.
 * Event description: user navigates away and gets the navigate away modal.

 * hosting - Type: string. Desc: MA/editor
 *
 * msid - Type: guid. Desc: metasite id
 *
 * platform - Type: string.
 * @param {bizManagerBizInfoNavigateAwayDialogIsShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerBizInfoNavigateAwayDialogIsShown = function (params) {
    return { evid: 557, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} toolcastUserExposureParams
* @property {string} campaignId - from dealer
* @property {boolean} firstStep - if the toolcast in the next step
* @property {string} offeringGuid - offer guid
* @property {string} origin - from Panel or Dashboard steps or bubble
* @property {string} platform - null
* @property {string} stepName - The name of the toolcast step
**/
/**
 * Name: Toolcast- First step viewed. src: 5 Evid: 1372.
 * Event description: when user expose to the toolcast
and if the toolcast in the first step or in the panel bubble or dashboard.

 * campaignId - Type: string. Desc: from dealer
 *
 * firstStep - Type: bool. Desc: if the toolcast in the next step
 *
 * offeringGuid - Type: string. Desc: offer guid
 *
 * origin - Type: string. Desc: from Panel or Dashboard steps or bubble
 *
 * platform - Type: string.
 *
 * stepName - Type: string. Desc: The name of the toolcast step
 * @param {toolcastUserExposureParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var toolcastUserExposure = function (params) {
    return { evid: 1372, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} mySitesShowTooltipParams
* @property {string} name - tooltip name
* @property {string} num_of_sites - num of sites on screen
* @property {string} platform - null
**/
/**
 * Name: My Sites - show tooltip. src: 5 Evid: 159.
 * Event description: select a site tooltip.

 * name - Type: string. Desc: tooltip name
 *
 * num_of_sites - Type: string. Desc: num of sites on screen
 *
 * platform - Type: string.
 * @param {mySitesShowTooltipParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mySitesShowTooltip = function (params) {
    return { evid: 159, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardFinishLoadingLoadingTimeFromStartModuleParams
* @property {string} hosting - dashboard/editor/onboarding
* @property {number} loading_time - loading from start loading the page
* @property {GUID} msid - --
* @property {string} platform - --
* @property {string} refferal_info - refferal
* @property {string} sub_view - sub_view
* @property {string} view - requested view
**/
/**
 * Name: dashboard > finish loading > loading time from start module. src: 5 Evid: 1215.
 * Event description: event to check the loading time from start loading.

 * hosting - Type: string. Desc: dashboard/editor/onboarding
 *
 * loading_time - Type: numeric. Desc: loading from start loading the page
 *
 * msid - Type: guid. Desc: --
 *
 * platform - Type: string. Desc: --
 *
 * refferal_info - Type: string. Desc: refferal
 *
 * sub_view - Type: string. Desc: sub_view
 *
 * view - Type: string. Desc: requested view
 * @param {dashboardFinishLoadingLoadingTimeFromStartModuleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardFinishLoadingLoadingTimeFromStartModule = function (params) {
    return { evid: 1215, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerBizInfoFieldValueChangedNotSavedParams
* @property {string} category - category of of the selected sub-category
* @property {string} field_type - text, drop down, image, ..
* @property {string} fold_name - name of fold: basic info, contact info, location language and region,
* @property {string} hosting - MA/editor
* @property {string} industry_id - industry_id of of the selected sub-category
* @property {string} location_details - 0- first location (create), 1-second location (add), 2- third location (add),...
* @property {GUID} msid - metasite id
* @property {string} name - name of field (key): business name, description, main category, sub category, etc
* @property {string} origin - app name
* @property {string} page_view - The page where the changes were made. before the new settings the page was only general info
* @property {string} platform - null
* @property {string} structure_id - structure_id of the selected sub-category
* @property {string} sub_category - ADI business type of the selection in business info category
* @property {string} value - value of field: only for drop down fields
**/
/**
 * Name: Biz Manager - Biz Info - field value changed (not saved). src: 5 Evid: 551.
 * Event description: user updates a field in the business info. reported only when field is out of focus.

 * category - Type: string. Desc: category of of the selected sub-category
 *
 * field_type - Type: string. Desc: text, drop down, image, ..
 *
 * fold_name - Type: string. Desc: name of fold: basic info, contact info, location language and region,
 *
 * hosting - Type: string. Desc: MA/editor
 *
 * industry_id - Type: string. Desc: industry_id of of the selected sub-category
 *
 * location_details - Type: string. Desc: 0- first location (create), 1-second location (add), 2- third location (add),...
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: name of field (key): business name, description, main category, sub category, etc
 *
 * origin - Type: string. Desc: app name
 *
 * page_view - Type: string. Desc: The page where the changes were made. before the new settings the page was only general info
 *
 * platform - Type: string.
 *
 * structure_id - Type: string. Desc: structure_id of the selected sub-category
 *
 * sub_category - Type: string. Desc: ADI business type of the selection in business info category
 *
 * value - Type: string. Desc: value of field: only for drop down fields
 * @param {bizManagerBizInfoFieldValueChangedNotSavedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerBizInfoFieldValueChangedNotSaved = function (params) {
    return { evid: 551, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerClickOnWidgetCtaParams
* @property {string} app_id - app def id
* @property {number} done_steps - number of done steps in setup
* @property {string} hosting - MA/editor
* @property {string} module_id - module name
* @property {GUID} msid - metasite id
* @property {string} platform - null
* @property {number} skipped_steps - skipped_steps
* @property {string} step - step id
* @property {GUID} step_guid - deprecated
* @property {number} step_id - deprecated
* @property {number} steps - number of steps in setup
**/
/**
 * Name: Biz Manager - click on setup widget CTA. src: 5 Evid: 579.
 * Event description: user clicked on a CTA in TPA setup widget in biz mgr.

 * app_id - Type: string. Desc: app def id
 *
 * done_steps - Type: numeric. Desc: number of done steps in setup
 *
 * hosting - Type: string. Desc: MA/editor
 *
 * module_id - Type: string. Desc: module name
 *
 * msid - Type: guid. Desc: metasite id
 *
 * platform - Type: string.
 *
 * skipped_steps - Type: numeric. Desc: skipped_steps
 *
 * step - Type: string. Desc: step id
 *
 * step_guid - Type: guid. Desc: deprecated
 *
 * step_id - Type: numeric. Desc: deprecated
 *
 * steps - Type: numeric. Desc: number of steps in setup
 * @param {bizManagerClickOnWidgetCtaParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerClickOnWidgetCta = function (params) {
    return { evid: 579, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesInvoicesOnboardingPageViewParams
* @property {string} msid - msid
* @property {string} name - phase name
* @property {string} platform - null
**/
/**
 * Name: Quotes - Invoices onboarding page view. src: 5 Evid: 401.
 * Event description: wix invoices onboarding flow - page view.

 * msid - Type: string. Desc: msid
 *
 * name - Type: string. Desc: phase name
 *
 * platform - Type: string.
 * @param {quotesInvoicesOnboardingPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesInvoicesOnboardingPageView = function (params) {
    return { evid: 401, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerSetupWidgetOmniPhaseCompletedInDashboardParams
* @property {string} asset_campaign_guid - omni setup phase id, sent the event for each "done" phase
* @property {string} hosting - ADI/Editor/MA
* @property {GUID} msid - msid
* @property {number} number_of_resolved_items - deprecate
* @property {number} number_of_skipped_items - deprecate
* @property {string} platform - null
* @property {string} resolved_items - a list of asset campaign IDs that were resolved in the phase
* @property {string} skipped_items - a list of asset campaign IDs that were skipped in the phase
**/
/**
 * Name: Biz Manager - setup widget - OMNI Phase Completed in Dashboard. src: 5 Evid: 284.
 * Event description: When a user doesn't see an open phase in the dashboard (since they completed all tasks in the OMNI widget or the phase is collapsed - since they skipped all items in the phase), sent each time the user enters the dashboard - home.

 * asset_campaign_guid - Type: string. Desc: omni setup phase id, sent the event for each "done" phase
 *
 * hosting - Type: string. Desc: ADI/Editor/MA
 *
 * msid - Type: guid. Desc: msid
 *
 * number_of_resolved_items - Type: numeric. Desc: deprecate
 *
 * number_of_skipped_items - Type: numeric. Desc: deprecate
 *
 * platform - Type: string.
 *
 * resolved_items - Type: string. Desc: a list of asset campaign IDs that were resolved in the phase
 *
 * skipped_items - Type: string. Desc: a list of asset campaign IDs that were skipped in the phase
 * @param {bizManagerSetupWidgetOmniPhaseCompletedInDashboardParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerSetupWidgetOmniPhaseCompletedInDashboard = function (params) {
    return { evid: 284, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSelectorClickForDebuggingPurposesParams
* @property {Url} action_url - null
* @property {string} cta - x / cancel / continue
* @property {string} device - mobile / desktop
* @property {GUID} esi -
* @property {string} filtered - premium/published/adi / none
* @property {boolean} is_partner_dashboard - true - if partner dashboard chosen
* @property {GUID} msid - the site guid
* @property {string} platform - deprecated
* @property {number} position - The position of the selected site in the page. 1 is the highest site.
* @property {number} positionIndex - the index of the selected site position in the site selector
* @property {Url} referer - Referral url
* @property {string} result - json of all chosen msid separated with comma
* @property {string} selectionType - single / multi
* @property {GUID} site_id -
* @property {number} site_type_enriched -
* @property {string} siteTypeName - ADI/Editor
* @property {number} sites_count - how many sites were chosen
* @property {number} sites_number - the number of sites available in site selector (not necessarily equal to number of sites owned)
* @property {string} siteType - HtmlWeb / modal
**/
/**
 * Name: dashboard > site selector click for debugging purposes. src: 5 Evid: 1715.
 * Event description: when user clicks on the select in site selector, this event is for debugging purposes and will be sent via native reporting approach.

 * action_url - Type: url.
 *
 * cta - Type: string. Desc: x / cancel / continue
 *
 * device - Type: string. Desc: mobile / desktop
 *
 * esi - Type: guid.
 *
 * filtered - Type: string. Desc: premium/published/adi / none
 *
 * is_partner_dashboard - Type: bool. Desc: true - if partner dashboard chosen
 *
 * msid - Type: guid. Desc: the site guid
 *
 * platform - Type: string. Desc: deprecated
 *
 * position - Type: numeric. Desc: The position of the selected site in the page. 1 is the highest site.
 *
 * positionIndex - Type: numeric. Desc: the index of the selected site position in the site selector
 *
 * referer - Type: url. Desc: Referral url
 *
 * result - Type: string. Desc: json of all chosen msid separated with comma
 *
 * selectionType - Type: string. Desc: single / multi
 *
 * site_id - Type: guid.
 *
 * site_type_enriched - Type: numeric.
 *
 * siteTypeName - Type: string. Desc: ADI/Editor
 *
 * sites_count - Type: numeric. Desc: how many sites were chosen
 *
 * sites_number - Type: numeric. Desc: the number of sites available in site selector (not necessarily equal to number of sites owned)
 *
 * siteType - Type: string. Desc: HtmlWeb / modal
 * @param {dashboardSiteSelectorClickForDebuggingPurposesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSelectorClickForDebuggingPurposes = function (params) {
    return { evid: 1715, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} searchScrollingInResultViewParams
* @property {GUID} msid - msid
* @property {string} origin - settings lobby / bizmgr
* @property {string} platform - null
* @property {string} sub_view - page in app
* @property {string} view - requested view
**/
/**
 * Name: Search > scrolling in result view. src: 5 Evid: 163.
 * Event description: send an event when a user's scroll in search's results.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: settings lobby / bizmgr
 *
 * platform - Type: string.
 *
 * sub_view - Type: string. Desc: page in app
 *
 * view - Type: string. Desc: requested view
 * @param {searchScrollingInResultViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var searchScrollingInResultView = function (params) {
    return { evid: 163, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} ascendPpClickOnCycleInPpParams
* @property {number} cycleId - cycle id
* @property {string} cycle_name - cycle name
* @property {string} origin - product name open PP
* @property {GUID} packageId - packageid
* @property {string} package_name - packagename
* @property {string} platform - null
* @property {string} referralInfo - button name open PP
**/
/**
 * Name: Ascend PP - Click on Cycle in PP. src: 5 Evid: 136.
 * Event description: User click on a cycle.

 * cycleId - Type: numeric. Desc: cycle id
 *
 * cycle_name - Type: string. Desc: cycle name
 *
 * origin - Type: string. Desc: product name open PP
 *
 * packageId - Type: guid. Desc: packageid
 *
 * package_name - Type: string. Desc: packagename
 *
 * platform - Type: string.
 *
 * referralInfo - Type: string. Desc: button name open PP
 * @param {ascendPpClickOnCycleInPpParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ascendPpClickOnCycleInPp = function (params) {
    return { evid: 136, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} wixInvoicesMotoCashierWidgetIsShownParams
* @property {string} currency - currency of the amount paid
* @property {boolean} fully_paid - Is the full invoice amount is going to be paid or part of the total amount
* @property {GUID} invoice_id - invoice_id
* @property {boolean} is_deposit - invoice has deposit
* @property {boolean} is_new - New or Edited Invoice
* @property {GUID} msid - metasite id
* @property {string} name - Opened/Clicked Charge/Processed ( Three stages defines the flow, when modal is opened and a user put details in cashiers modal, then user is clicking charge and final stage if the data is good it is processing). Exact values: 'opened' | 'clicked charge' | 'paid'
* @property {string} origin - origin
* @property {number} paidAmountLong - Total amount that is paid, comes only when name=paid or name-clickedcharge
* @property {string} platform - platform
* @property {number} totalAmountLong - Invoice total amount
**/
/**
 * Name: Wix Invoices - MOTO cashier widget is shown. src: 5 Evid: 8960.
 * Event description: When a user is choosing MOTO, cashier widget is shown.

 * currency - Type: string. Desc: currency of the amount paid
 *
 * fully_paid - Type: bool. Desc: Is the full invoice amount is going to be paid or part of the total amount
 *
 * invoice_id - Type: guid. Desc: invoice_id
 *
 * is_deposit - Type: bool. Desc: invoice has deposit
 *
 * is_new - Type: bool. Desc: New or Edited Invoice
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: Opened/Clicked Charge/Processed ( Three stages defines the flow, when modal is opened and a user put details in cashiers modal, then user is clicking charge and final stage if the data is good it is processing). Exact values: 'opened' | 'clicked charge' | 'paid'
 *
 * origin - Type: string. Desc: origin
 *
 * paidAmountLong - Type: numeric. Desc: Total amount that is paid, comes only when name=paid or name-clickedcharge
 *
 * platform - Type: string. Desc: platform
 *
 * totalAmountLong - Type: numeric. Desc: Invoice total amount
 * @param {wixInvoicesMotoCashierWidgetIsShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var wixInvoicesMotoCashierWidgetIsShown = function (params) {
    return { evid: 8960, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} toastClicked86Params
* @property {string} click_type - CTA/dismiss
* @property {string} hosting - MA/editor/dashboard
* @property {GUID} msid - metasite id
* @property {string} name - toast name, supplied by toast initiator
* @property {string} platform - null
* @property {string} scope - toast scope {app/ dashboard}
* @property {string} severity - high, normal, low
* @property {number} timeout - seconds to auto hide toast, 0 is sticky toast
* @property {string} type - info, error, warning, success, premium
**/
/**
 * Name: Giza - click on toast. src: 5 Evid: 86.
 * Event description: user clicks on toast CTA or dismisses toast in one of Giza's hosting platform. currently, in case of business manager - the reporting is from business manager itself and not from Giza. in the meantime to get business manager toasts filter hosting is not null.

 * click_type - Type: string. Desc: CTA/dismiss
 *
 * hosting - Type: string. Desc: MA/editor/dashboard
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: toast name, supplied by toast initiator
 *
 * platform - Type: string.
 *
 * scope - Type: string. Desc: toast scope {app/ dashboard}
 *
 * severity - Type: string. Desc: high, normal, low
 *
 * timeout - Type: numeric. Desc: seconds to auto hide toast, 0 is sticky toast
 *
 * type - Type: string. Desc: info, error, warning, success, premium
 * @param {toastClicked86Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var toastClicked86 = function (params) {
    return { evid: 86, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardTriggersReachStepCustomizeTheActionParams
* @property {string} action - open/close - which action the user did
* @property {string} flowType - flow in which the save happens: {create, edit}
* @property {number} index - the action number when multi action
* @property {boolean} is_auto - window opens automatically/manually
* @property {GUID} msid - msid
* @property {string} origin - deprecated
* @property {string} platform - null
* @property {string} recipe_name - recipe name
* @property {GUID} rule_id - if this trigger already customized, null if it first time customization
* @property {number} src - deprecated
**/
/**
 * Name: Automations > Reach step customize the action. src: 5 Evid: 207.
 * Event description: open/close choose an action.

 * action - Type: string. Desc: open/close - which action the user did
 *
 * flowType - Type: string. Desc: flow in which the save happens: {create, edit}
 *
 * index - Type: numeric. Desc: the action number when multi action
 *
 * is_auto - Type: bool. Desc: window opens automatically/manually
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: deprecated
 *
 * platform - Type: string.
 *
 * recipe_name - Type: string. Desc: recipe name
 *
 * rule_id - Type: guid. Desc: if this trigger already customized, null if it first time customization
 *
 * src - Type: numeric. Desc: deprecated
 * @param {dashboardTriggersReachStepCustomizeTheActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardTriggersReachStepCustomizeTheAction = function (params) {
    return { evid: 207, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} rolesGetInviteLinkParams
* @property {string} action - not in use
* @property {string} hosting - MA /Editor
* @property {string} invite_role - invited role
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Roles - get invite link. src: 5 Evid: 368.
 * Event description: user clicked on get invite link.

 * action - Type: string. Desc: not in use
 *
 * hosting - Type: string. Desc: MA /Editor
 *
 * invite_role - Type: string. Desc: invited role
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {rolesGetInviteLinkParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rolesGetInviteLink = function (params) {
    return { evid: 368, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} ascendPpScrollToEndParams
* @property {string} origin - product name open PP
* @property {string} platform - null
* @property {string} referralInfo - button name open PP
* @property {number} timeInPage - in milisec
**/
/**
 * Name: Ascend PP - Scroll to end. src: 5 Evid: 133.
 * Event description: User scroll to end of table.

 * origin - Type: string. Desc: product name open PP
 *
 * platform - Type: string.
 *
 * referralInfo - Type: string. Desc: button name open PP
 *
 * timeInPage - Type: numeric. Desc: in milisec
 * @param {ascendPpScrollToEndParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ascendPpScrollToEnd = function (params) {
    return { evid: 133, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesClickOnCopyLinkFromMoreActionsParams
* @property {GUID} invoiceId - invoiceId
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Quotes - click on copy-link from more actions. src: 5 Evid: 727.
 * Event description: Quotes - click on copy-link from more actions.

 * invoiceId - Type: guid. Desc: invoiceId
 *
 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {quotesClickOnCopyLinkFromMoreActionsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesClickOnCopyLinkFromMoreActions = function (params) {
    return { evid: 727, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsAskMoreLinkParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations > ask more link. src: 5 Evid: 744.
 * Event description: Automations > ask more link.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsAskMoreLinkParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsAskMoreLink = function (params) {
    return { evid: 744, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesChooseADueDateRecurringInvoicesParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Invoices - choose a due date-  recurring invoices. src: 5 Evid: 1565.
 * Event description: Quotes - choose a due date - recurring invoices.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {invoicesChooseADueDateRecurringInvoicesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesChooseADueDateRecurringInvoices = function (params) {
    return { evid: 1565, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeTopCarouselLoadEndParams
* @property {number} loadingTime - loading time in ms
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: CRM Home - Top carousel load end. src: 5 Evid: 1387.
 * Event description: CRM Home - Top carousel main CTA click.

 * loadingTime - Type: numeric. Desc: loading time in ms
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {crmHomeTopCarouselLoadEndParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeTopCarouselLoadEnd = function (params) {
    return { evid: 1387, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} myAccountClickOnHelpParams
* @property {string} app_id - null
* @property {string} origin - null
* @property {string} origin_app - if dashboard then 'MAD'
* @property {string} page_view - my-sites /dashboard / account settings
* @property {string} platform - null
**/
/**
 * Name: My Account --> Click on Help. src: 5 Evid: 44.
 * Event description: User click on help center (Can be either from '?' button or account -->help center).

 * app_id - Type: string.
 *
 * origin - Type: string.
 *
 * origin_app - Type: string. Desc: if dashboard then 'MAD'
 *
 * page_view - Type: string. Desc: my-sites /dashboard / account settings
 *
 * platform - Type: string.
 * @param {myAccountClickOnHelpParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var myAccountClickOnHelp = function (params) {
    return { evid: 44, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} ascendHoverOnUpgradeAscendParams
* @property {string} appName - BM App
* @property {string} button_name - upgrade button / ascend title
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {GUID} uuid - uuid
**/
/**
 * Name: Ascend - Hover on Upgrade Ascend. src: 5 Evid: 188.
 * Event description: Hover on Upgrade Ascend.

 * appName - Type: string. Desc: BM App
 *
 * button_name - Type: string. Desc: upgrade button / ascend title
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 * @param {ascendHoverOnUpgradeAscendParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ascendHoverOnUpgradeAscend = function (params) {
    return { evid: 188, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} accountSettingsDeactivateAccountClickOnLearnMoreParams
* @property {string} platform - null
* @property {string} section - deactivate account/recovery phone/two factor authentication/2FA disable/username/email address
**/
/**
 * Name: Account Settings - Learn More. src: 5 Evid: 680.
 * Event description: The user clicks on 'Learn more' after clicking the "i" icon, in account settings (redesign), in a few possible locations on the page.

 * platform - Type: string.
 *
 * section - Type: string. Desc: deactivate account/recovery phone/two factor authentication/2FA disable/username/email address
 * @param {accountSettingsDeactivateAccountClickOnLearnMoreParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accountSettingsDeactivateAccountClickOnLearnMore = function (params) {
    return { evid: 680, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} successfullyDeletedLocationParams
* @property {string} hosting - dashboard/editor/ADI
* @property {boolean} is_default - true if trying to delete default location
* @property {boolean} is_multiple_choice - true/ false if the modal present a few options to choose from
* @property {GUID} msid - msid
* @property {string} page_view - business info
* @property {string} platform - null
**/
/**
 * Name: Successfully deleted location. src: 5 Evid: 1218.
 * Event description: When the user clicks on delete location and the location successfully deleted and removed from the db.

 * hosting - Type: string. Desc: dashboard/editor/ADI
 *
 * is_default - Type: bool. Desc: true if trying to delete default location
 *
 * is_multiple_choice - Type: bool. Desc: true/ false if the modal present a few options to choose from
 *
 * msid - Type: guid. Desc: msid
 *
 * page_view - Type: string. Desc: business info
 *
 * platform - Type: string.
 * @param {successfullyDeletedLocationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var successfullyDeletedLocation = function (params) {
    return { evid: 1218, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesCreateInvoiceAdditionalInfoHoverOnTooltipShownParams
* @property {string} fieldName - notes  /legal terms
* @property {GUID} invoice_id - invoice guid
* @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
* @property {string} msid - msid
* @property {string} origin - create invoice, edit invoice
* @property {string} platform - platform
* @property {string} source - source
**/
/**
 * Name: Quotes - Create invoice - Additional Info - Hover on tooltip shown. src: 5 Evid: 1555.
 * Event description: Create invoice - user hover over notes or legal terms fields in the Additional Info section, leading to tooltip appear.

 * fieldName - Type: string. Desc: notes  /legal terms
 *
 * invoice_id - Type: guid. Desc: invoice guid
 *
 * invoiceType - Type: string. Desc: ’recurringAutoCharge’/ 'recurring'/ 'one time'
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: create invoice, edit invoice
 *
 * platform - Type: string. Desc: platform
 *
 * source - Type: string. Desc: source
 * @param {quotesCreateInvoiceAdditionalInfoHoverOnTooltipShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesCreateInvoiceAdditionalInfoHoverOnTooltipShown = function (params) {
    return { evid: 1555, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardAccountSettingsHoverOverSendConfirmationIParams
* @property {string} platform - null
**/
/**
 * Name: dashboard > account settings -> hover over 'send confirmation' i. src: 5 Evid: 66.
 * Event description: user hovers the i of 'send confirmation email'.

 * platform - Type: string.
 * @param {dashboardAccountSettingsHoverOverSendConfirmationIParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardAccountSettingsHoverOverSendConfirmationI = function (params) {
    return { evid: 66, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsEditAutomationOpenParams
* @property {boolean} isPreinsalled - if the automation was pre installed
* @property {GUID} msid - msid
* @property {string} origin - where did the automation were edited from
* @property {string} platform - null
* @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
**/
/**
 * Name: Automations > Widget Edit automation open. src: 5 Evid: 390.
 * Event description: Automations > Edit automation open.

 * isPreinsalled - Type: bool. Desc: if the automation was pre installed
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: where did the automation were edited from
 *
 * platform - Type: string.
 *
 * rule_id - Type: guid. Desc: if this trigger all ready customized, null if it first time customization
 * @param {automationsEditAutomationOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsEditAutomationOpen = function (params) {
    return { evid: 390, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsRenameAutomationClickParams
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} recipe_name - recipe name
* @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
**/
/**
 * Name: Automations > Rename Automation Click. src: 5 Evid: 248.
 * Event description: Automations > Rename Automation Click.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * recipe_name - Type: string. Desc: recipe name
 *
 * rule_id - Type: guid. Desc: if this trigger all ready customized, null if it first time customization
 * @param {automationsRenameAutomationClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsRenameAutomationClick = function (params) {
    return { evid: 248, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesDeleteQuotePageCancelParams
* @property {string} msid - msid
* @property {string} origin_device - web,native
* @property {string} platform - null
* @property {GUID} quoteId - quote guid
**/
/**
 * Name: Quotes - Delete quote page - Cancel. src: 5 Evid: 92.
 * Event description: cancel in delete page (for every close (cancel, x, background click)).

 * msid - Type: string. Desc: msid
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string.
 *
 * quoteId - Type: guid. Desc: quote guid
 * @param {quotesDeleteQuotePageCancelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesDeleteQuotePageCancel = function (params) {
    return { evid: 92, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSettingsClosingComponentParams
* @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
* @property {GUID} msid - msid
* @property {string} name - name of the field that was selected
* @property {string} origin - name of current tab
* @property {string} place - close type (x/cancel...)
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: dashboard > site settings > closing component. src: 5 Evid: 320.
 * Event description: user closed site settings' component.

 * hosting - Type: string. Desc: from where user arrived to sitesettings (Editor/MA/...)
 *
 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: name of the field that was selected
 *
 * origin - Type: string. Desc: name of current tab
 *
 * place - Type: string. Desc: close type (x/cancel...)
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {dashboardSiteSettingsClosingComponentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSettingsClosingComponent = function (params) {
    return { evid: 320, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} siteSelectorSiteChosenParams
* @property {Url} action_url - action_url
* @property {string} device - mobile / desktop
* @property {GUID} esi - esi
* @property {string} filtered - premium/published/adi / none
* @property {boolean} is_default_selection - Is current selection selected by default or actively
* @property {boolean} is_partner_dashboard - true - if partner dashboard chosen
* @property {string} platform - deprecated
* @property {number} positionIndex - the index of the selected site position in the site selector
* @property {number} previous_position_index - index of previous (before change) selected site
* @property {Url} referer - Referral url
* @property {string} result - json of all chosen msid separated with comma
* @property {string} selectionType - single / multi
* @property {number} sites_available - the number of sites available in site selector (not necessarily equal to number of sites owned)
* @property {number} sites_count - how many sites were chosen
* @property {string} siteType - HtmlWeb / modal
**/
/**
 * Name: site selector -> site chosen. src: 5 Evid: 1709.
 * Event description: Site is chosen within the site selector (button is highlighted, but the selection isn't applied yet).

 * action_url - Type: url. Desc: action_url
 *
 * device - Type: string. Desc: mobile / desktop
 *
 * esi - Type: guid. Desc: esi
 *
 * filtered - Type: string. Desc: premium/published/adi / none
 *
 * is_default_selection - Type: bool. Desc: Is current selection selected by default or actively
 *
 * is_partner_dashboard - Type: bool. Desc: true - if partner dashboard chosen
 *
 * platform - Type: string. Desc: deprecated
 *
 * positionIndex - Type: numeric. Desc: the index of the selected site position in the site selector
 *
 * previous_position_index - Type: numeric. Desc: index of previous (before change) selected site
 *
 * referer - Type: url. Desc: Referral url
 *
 * result - Type: string. Desc: json of all chosen msid separated with comma
 *
 * selectionType - Type: string. Desc: single / multi
 *
 * sites_available - Type: numeric. Desc: the number of sites available in site selector (not necessarily equal to number of sites owned)
 *
 * sites_count - Type: numeric. Desc: how many sites were chosen
 *
 * siteType - Type: string. Desc: HtmlWeb / modal
 * @param {siteSelectorSiteChosenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteSelectorSiteChosen = function (params) {
    return { evid: 1709, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} app2faSetupConfirmChangeAppParams
* @property {string} platform - null
**/
/**
 * Name: App 2FA Setup - Confirm Change App. src: 5 Evid: 1745.
 * Event description: The user clicks on 'Change' in the change app modal, to confirm the action.

 * platform - Type: string.
 * @param {app2faSetupConfirmChangeAppParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var app2faSetupConfirmChangeApp = function (params) {
    return { evid: 1745, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} websiteCardPageUsabilityParams
* @property {boolean} domainPremision - true
* @property {boolean} editPremision - true
* @property {boolean} isConnectedDomainModal - true
* @property {boolean} isPremium - true
* @property {boolean} isPublished - true
* @property {DateTime} lastPublishDate - date stamp
* @property {boolean} liveSitePremision - true
* @property {GUID} msid - msid
* @property {boolean} onlyDomain - false
* @property {string} platform - null
* @property {boolean} settingPremision - true
**/
/**
 * Name: Website card page Snapshot. src: 5 Evid: 8931.
 * Event description: when a user see the main card in the website page.

 * domainPremision - Type: bool. Desc: true
 *
 * editPremision - Type: bool. Desc: true
 *
 * isConnectedDomainModal - Type: bool. Desc: true
 *
 * isPremium - Type: bool. Desc: true
 *
 * isPublished - Type: bool. Desc: true
 *
 * lastPublishDate - Type: datetime. Desc: date stamp
 *
 * liveSitePremision - Type: bool. Desc: true
 *
 * msid - Type: guid. Desc: msid
 *
 * onlyDomain - Type: bool. Desc: false
 *
 * platform - Type: string.
 *
 * settingPremision - Type: bool. Desc: true
 * @param {websiteCardPageUsabilityParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var websiteCardPageUsability = function (params) {
    return { evid: 8931, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizmgrComponentLoadingFinishParams
* @property {string} app_id - The app_id of the page which hosts the component
* @property {string} component_app_id - The app_id of the component
* @property {string} component_id - the Id of the component
* @property {string} component_name - The component name
* @property {string} component_type - page/widget/modal/sidebar/header
* @property {string} host_id - the host id (meaningful string - f.e. ‘sidebar’,’settings-lobby’)
* @property {string} hosting - MA/Editor/onboarding
* @property {string} hosting_platform - accountmanagr/bizmanagr/devcenter/etc.
* @property {string} hosting_platform_context_id - context id: when the context is site - msid, when the context is app_id (like in devCenter f.e) - appDefId. In account manager is null
* @property {boolean} is_first - True if the component loaded as part of the first page in session (before navigation). otherwise false
* @property {number} loading_time - loading time from the start loading of the componen
* @property {number} loading_time_from_host_load - loading time from the start loading of the page
* @property {number} loading_time_from_host_platform_load - loading time from the start loading of the hosting platform
* @property {number} loading_time_from_start_loading_page - deprecated
* @property {GUID} msid - msid
* @property {string} page_id - the page id
* @property {string} platform - platform
* @property {string} prev_page_id - the previous page id
* @property {string} state - The expected state of the component -  regular/empty_state/no_permission
* @property {string} sub_view - The sub_view of the hosted page in Bizmgr
* @property {string} view - The view of the hosted page in Bizmgr
**/
/**
 * Name: Bizmgr -> Component -> Loading finish. src: 5 Evid: 1460.
 * Event description: Generic loading component event in the Bizmgr- When the component finishes loading.

 * app_id - Type: string. Desc: The app_id of the page which hosts the component
 *
 * component_app_id - Type: string. Desc: The app_id of the component
 *
 * component_id - Type: string. Desc: the Id of the component
 *
 * component_name - Type: string. Desc: The component name
 *
 * component_type - Type: string. Desc: page/widget/modal/sidebar/header
 *
 * host_id - Type: string. Desc: the host id (meaningful string - f.e. ‘sidebar’,’settings-lobby’)
 *
 * hosting - Type: string. Desc: MA/Editor/onboarding
 *
 * hosting_platform - Type: string. Desc: accountmanagr/bizmanagr/devcenter/etc.
 *
 * hosting_platform_context_id - Type: string. Desc: context id: when the context is site - msid, when the context is app_id (like in devCenter f.e) - appDefId. In account manager is null
 *
 * is_first - Type: bool. Desc: True if the component loaded as part of the first page in session (before navigation). otherwise false
 *
 * loading_time - Type: numeric. Desc: loading time from the start loading of the componen
 *
 * loading_time_from_host_load - Type: numeric. Desc: loading time from the start loading of the page
 *
 * loading_time_from_host_platform_load - Type: numeric. Desc: loading time from the start loading of the hosting platform
 *
 * loading_time_from_start_loading_page - Type: numeric. Desc: deprecated
 *
 * msid - Type: guid. Desc: msid
 *
 * page_id - Type: string. Desc: the page id
 *
 * platform - Type: string. Desc: platform
 *
 * prev_page_id - Type: string. Desc: the previous page id
 *
 * state - Type: string. Desc: The expected state of the component -  regular/empty_state/no_permission
 *
 * sub_view - Type: string. Desc: The sub_view of the hosted page in Bizmgr
 *
 * view - Type: string. Desc: The view of the hosted page in Bizmgr
 * @param {bizmgrComponentLoadingFinishParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizmgrComponentLoadingFinish = function (params) {
    return { evid: 1460, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} twoFactorAuthenticationSetupDisableActionParams
* @property {string} platform - null
**/
/**
 * Name: Phone 2FA Setup - Disable Click. src: 5 Evid: 686.
 * Event description: The user clicks on 'disable' to disable phone 2FA.

 * platform - Type: string.
 * @param {twoFactorAuthenticationSetupDisableActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var twoFactorAuthenticationSetupDisableAction = function (params) {
    return { evid: 686, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesDeleteProductPageCancelParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Quotes - Delete product page - Cancel. src: 5 Evid: 420.
 * Event description: cancel in delete product page (for every close (cancel, x, background click)).

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {quotesDeleteProductPageCancelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesDeleteProductPageCancel = function (params) {
    return { evid: 420, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} mySitesEditSiteParams
* @property {string} ds_origin - destination
* @property {string} hosting - hosting
* @property {GUID} msid - msid
* @property {string} origin - {site_list_top, site_list_bottom, top_bar, account_templates,...}
* @property {string} place - origin inside page
* @property {string} platform - platform
**/
/**
 * Name: My Sites - edit site. src: 5 Evid: 486.
 * Event description: clicking on edit site in My Sites.

 * ds_origin - Type: string. Desc: destination
 *
 * hosting - Type: string. Desc: hosting
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: {site_list_top, site_list_bottom, top_bar, account_templates,...}
 *
 * place - Type: string. Desc: origin inside page
 *
 * platform - Type: string. Desc: platform
 * @param {mySitesEditSiteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mySitesEditSite = function (params) {
    return { evid: 486, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesDismissGetWixAppBannerParams
* @property {GUID} msid - msid
* @property {string} name - banner name {get wix app}
* @property {string} platform - null
**/
/**
 * Name: Quotes - dismiss get wix app banner. src: 5 Evid: 475.
 * Event description: dismiss get wix app banner.

 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: banner name {get wix app}
 *
 * platform - Type: string.
 * @param {quotesDismissGetWixAppBannerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesDismissGetWixAppBanner = function (params) {
    return { evid: 475, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesPrintInvoice423Params
* @property {GUID} appDefId - appDefId (application ID)
* @property {GUID} externalId - An external id of an entity, relevant to the oridapplication
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} origin - my invoices, preview
* @property {string} originPage - origin page - from which place this action was made (invoices, contacts full page, crm home...)
* @property {string} paymentType - 'recurring','one time'
* @property {string} platform - null
**/
/**
 * Name: Quotes - Print invoice. src: 5 Evid: 423.
 * Event description: print invoice.

 * appDefId - Type: guid. Desc: appDefId (application ID)
 *
 * externalId - Type: guid. Desc: An external id of an entity, relevant to the oridapplication
 *
 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: my invoices, preview
 *
 * originPage - Type: string. Desc: origin page - from which place this action was made (invoices, contacts full page, crm home...)
 *
 * paymentType - Type: string. Desc: 'recurring','one time'
 *
 * platform - Type: string.
 * @param {quotesPrintInvoice423Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesPrintInvoice423 = function (params) {
    return { evid: 423, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesOwnerappClickOnInvoiceParams
* @property {GUID} invoice_id - invoice guid
* @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
* @property {string} msid - msid
* @property {string} origin - my invoices, edit invoice, widget
* @property {string} origin_device - web,native
* @property {string} paymentType - one time, recurring
* @property {string} platform - null
* @property {string} tabName - most recent / overdue
**/
/**
 * Name: Invoices - Ownerapp-  click on invoice. src: 5 Evid: 1593.
 * Event description: Click on invoice in owner app widget.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * invoiceType - Type: string. Desc: ’recurringAutoCharge’/ 'recurring'/ 'one time'
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: my invoices, edit invoice, widget
 *
 * origin_device - Type: string. Desc: web,native
 *
 * paymentType - Type: string. Desc: one time, recurring
 *
 * platform - Type: string.
 *
 * tabName - Type: string. Desc: most recent / overdue
 * @param {invoicesOwnerappClickOnInvoiceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesOwnerappClickOnInvoice = function (params) {
    return { evid: 1593, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} teamManagementGetInviteLinkParams
* @property {string} invite_status - pending/expired/leave team
* @property {string} origin - where the dialog was opened from
* @property {string} platform - null
* @property {string} role - the deleted user’s role
**/
/**
 * Name: Team Management – get invite link. src: 5 Evid: 182.
 * Event description: When a user clicks on get invitation link.

 * invite_status - Type: string. Desc: pending/expired/leave team
 *
 * origin - Type: string. Desc: where the dialog was opened from
 *
 * platform - Type: string.
 *
 * role - Type: string. Desc: the deleted user’s role
 * @param {teamManagementGetInviteLinkParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teamManagementGetInviteLink = function (params) {
    return { evid: 182, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardClickOnConnectDomainParams
* @property {GUID} msid - null
* @property {string} origin - null
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: dashboard > click on connect domain. src: 5 Evid: 50.


 * msid - Type: guid.
 *
 * origin - Type: string.
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {dashboardClickOnConnectDomainParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardClickOnConnectDomain = function (params) {
    return { evid: 50, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} ascendPpPageViewParams
* @property {GUID} app_id - app_id
* @property {number} num_of_packages - num_of_packages presented in the PP
* @property {string} origin - product name open PP
* @property {string} platform - native or web
* @property {string} referralInfo - button name open PP
**/
/**
 * Name: Ascend PP - Page view. src: 5 Evid: 131.
 * Event description: User view Ascend PP.

 * app_id - Type: guid. Desc: app_id
 *
 * num_of_packages - Type: numeric. Desc: num_of_packages presented in the PP
 *
 * origin - Type: string. Desc: product name open PP
 *
 * platform - Type: string. Desc: native or web
 *
 * referralInfo - Type: string. Desc: button name open PP
 * @param {ascendPpPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ascendPpPageView = function (params) {
    return { evid: 131, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSettingsDomainSslPopupCancelParams
* @property {string} experience - user's experience
* @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
* @property {string} mode - {Turn on SSL,Remove SSL}
* @property {GUID} msid - msid
* @property {string} name - name of the field that was changed
* @property {string} origin - name of current tab
* @property {string} platform - null
**/
/**
 * Name: dashboard > site settings > Domain > SSL popup cancel. src: 5 Evid: 322.
 * Event description: close Pop-up window either with 'cancel' option or 'X' ..

 * experience - Type: string. Desc: user's experience
 *
 * hosting - Type: string. Desc: from where user arrived to sitesettings (Editor/MA/...)
 *
 * mode - Type: string. Desc: {Turn on SSL,Remove SSL}
 *
 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: name of the field that was changed
 *
 * origin - Type: string. Desc: name of current tab
 *
 * platform - Type: string.
 * @param {dashboardSiteSettingsDomainSslPopupCancelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSettingsDomainSslPopupCancel = function (params) {
    return { evid: 322, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationAutomationTableFilterMenuCheckboxesParams
* @property {boolean} checkbox - checked or enchecked
* @property {string} filter - null
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} value - ‘running’ / ‘inactive’ etc
**/
/**
 * Name: Automation > automation table > filter menu - checkboxes. src: 5 Evid: 1362.
 * Event description: Automation > automation table > filter menu - checkboxes.

 * checkbox - Type: bool. Desc: checked or enchecked
 *
 * filter - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * value - Type: string. Desc: ‘running’ / ‘inactive’ etc
 * @param {automationAutomationTableFilterMenuCheckboxesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationAutomationTableFilterMenuCheckboxes = function (params) {
    return { evid: 1362, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardMySitesWelcomeMessageForProsClickParams
* @property {string} action - check it out, close, disable
* @property {string} platform - null
**/
/**
 * Name: dashboard > My Sites - welcome message for pros click. src: 5 Evid: 155.
 * Event description: user clicked in welcome message of pro account, clicks":  close, disable, "check it out".

 * action - Type: string. Desc: check it out, close, disable
 *
 * platform - Type: string.
 * @param {dashboardMySitesWelcomeMessageForProsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardMySitesWelcomeMessageForProsClick = function (params) {
    return { evid: 155, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} viewedAllUpdatesParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: New Releases - View all updates. src: 5 Evid: 343.
 * Event description: Users gets to the bottom of the feed.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {viewedAllUpdatesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var viewedAllUpdates = function (params) {
    return { evid: 343, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesAddingBusinessLogoParams
* @property {string} msid - msid
* @property {string} platform - null
* @property {GUID} uuid - uuid
**/
/**
 * Name: Quotes - Adding Business Logo. src: 5 Evid: 470.
 * Event description: User added business logo (mobile).

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 * @param {quotesAddingBusinessLogoParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesAddingBusinessLogo = function (params) {
    return { evid: 470, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} app2faSetupClickOnCopyCodeParams
* @property {string} mode - change app/enable
* @property {string} platform - null
**/
/**
 * Name: App 2FA Setup - Click on Copy Code. src: 5 Evid: 1740.
 * Event description: The user clicked on 'copy code' in the QR scan step of the app 2FA enable modal..

 * mode - Type: string. Desc: change app/enable
 *
 * platform - Type: string.
 * @param {app2faSetupClickOnCopyCodeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var app2faSetupClickOnCopyCode = function (params) {
    return { evid: 1740, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesClickCtaInGetWixAppBannerParams
* @property {GUID} msid - msid
* @property {string} name - banner name {get wix app}
* @property {string} platform - null
**/
/**
 * Name: Quotes - click CTA in get wix app banner. src: 5 Evid: 476.
 * Event description: User clicks on CTA (get the wix app) in get wix app banner.

 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: banner name {get wix app}
 *
 * platform - Type: string.
 * @param {quotesClickCtaInGetWixAppBannerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesClickCtaInGetWixAppBanner = function (params) {
    return { evid: 476, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} accountManagerClickOnBackInSidebarItemParams
* @property {string} name - unique name that doesn't change when changing the name on the side bar
* @property {string} platform - null
* @property {string} referral_info - referral_info
* @property {string} sidebar_name - the name that appears in the sidebar - can be changed
**/
/**
 * Name: Account Manager - click on back in sidebar item. src: 5 Evid: 115.
 * Event description: user clicks on back from the sidebar in the account manager.

 * name - Type: string. Desc: unique name that doesn't change when changing the name on the side bar
 *
 * platform - Type: string.
 *
 * referral_info - Type: string. Desc: referral_info
 *
 * sidebar_name - Type: string. Desc: the name that appears in the sidebar - can be changed
 * @param {accountManagerClickOnBackInSidebarItemParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accountManagerClickOnBackInSidebarItem = function (params) {
    return { evid: 115, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsDaComponentExploreMoreClick294Params
* @property {string} asset_campaign_guid - asset_campaign_guid
* @property {number} countAutomations - count how many automations was presented in the widget
* @property {GUID} msid - msid
* @property {number} offer_location - offer_location
* @property {string} origin - button, link, header, success creation dialog
* @property {string} platform - null
* @property {string} referral_info - indicate which vertical is the dacomponent triggered from
**/
/**
 * Name: Automations >  Recommendation Widget > Explore More Click. src: 5 Evid: 294.
 * Event description: Automations > DaComponent > Explore More Click.

 * asset_campaign_guid - Type: string. Desc: asset_campaign_guid
 *
 * countAutomations - Type: numeric. Desc: count how many automations was presented in the widget
 *
 * msid - Type: guid. Desc: msid
 *
 * offer_location - Type: numeric. Desc: offer_location
 *
 * origin - Type: string. Desc: button, link, header, success creation dialog
 *
 * platform - Type: string.
 *
 * referral_info - Type: string. Desc: indicate which vertical is the dacomponent triggered from
 * @param {automationsDaComponentExploreMoreClick294Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsDaComponentExploreMoreClick294 = function (params) {
    return { evid: 294, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesBoardingPageClickCloseParams
* @property {string} msid - msid
* @property {string} platform - null
* @property {GUID} uuid - uuid
**/
/**
 * Name: Quotes - Boarding Page - click close. src: 5 Evid: 473.
 * Event description: Quotes - Boarding Page - click close  (mobile).

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 * @param {quotesBoardingPageClickCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesBoardingPageClickClose = function (params) {
    return { evid: 473, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsQuickGoogleSpreadsheetsRecipeActivationViewAutomationToastClickParams
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} rule_id - automation ID
**/
/**
 * Name: Automations > Quick Google Spreadsheets Recipe Activation -  view automation toast click. src: 5 Evid: 1731.
 * Event description: Triggered when user wants to view the automation thru the toast button.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * rule_id - Type: string. Desc: automation ID
 * @param {automationsQuickGoogleSpreadsheetsRecipeActivationViewAutomationToastClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsQuickGoogleSpreadsheetsRecipeActivationViewAutomationToastClick = function (params) {
    return { evid: 1731, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeSuggestionsCarouselCloseBannerParams
* @property {string} bannerName - which banner was clicked
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: CRM Home - Suggestions carousel close banner. src: 5 Evid: 1512.
 * Event description: CRM Home - Suggestions carousel close banner.

 * bannerName - Type: string. Desc: which banner was clicked
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {crmHomeSuggestionsCarouselCloseBannerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeSuggestionsCarouselCloseBanner = function (params) {
    return { evid: 1512, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSelectorPopupSelectActionParams
* @property {string} action - go to editor/ stay in ADI
* @property {GUID} msid - site guid
* @property {string} name - popup name
* @property {string} platform - null
* @property {string} siteTypeName - ADI/Editor
**/
/**
 * Name: dashboard > site selector popup> select action. src: 5 Evid: 83.
 * Event description: users selection in the popup- go to editor/ stay in ADI.

 * action - Type: string. Desc: go to editor/ stay in ADI
 *
 * msid - Type: guid. Desc: site guid
 *
 * name - Type: string. Desc: popup name
 *
 * platform - Type: string.
 *
 * siteTypeName - Type: string. Desc: ADI/Editor
 * @param {dashboardSiteSelectorPopupSelectActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSelectorPopupSelectAction = function (params) {
    return { evid: 83, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsNewHomeBannerLoadingEndParams
* @property {string} jsonData - json
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations > New Home - Banner Loading End. src: 5 Evid: 242.
 * Event description: All data when opening automation after banner.

 * jsonData - Type: string. Desc: json
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsNewHomeBannerLoadingEndParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsNewHomeBannerLoadingEnd = function (params) {
    return { evid: 242, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesVoidPageOkParams
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} origin_device - web,native
* @property {string} platform - null
**/
/**
 * Name: Quotes - Void page - Ok. src: 5 Evid: 428.
 * Event description: OK clicked in Void page.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string.
 * @param {quotesVoidPageOkParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesVoidPageOk = function (params) {
    return { evid: 428, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerBizInfoClickOnDiscardButtonParams
* @property {string} hosting - MA/editor
* @property {string} location_details - 0- first location (create), 1-second location (add), 2- third location (add),...
* @property {GUID} msid - metasite id
* @property {string} origin - app
* @property {string} page_view - The page where the changes were made (website settings/business info/language and region)
* @property {string} place - place of discard button: header, footer
* @property {string} platform - null
**/
/**
 * Name: Biz Manager - Biz Info - click on discard button. src: 5 Evid: 554.
 * Event description: user click on discard button.

 * hosting - Type: string. Desc: MA/editor
 *
 * location_details - Type: string. Desc: 0- first location (create), 1-second location (add), 2- third location (add),...
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: app
 *
 * page_view - Type: string. Desc: The page where the changes were made (website settings/business info/language and region)
 *
 * place - Type: string. Desc: place of discard button: header, footer
 *
 * platform - Type: string.
 * @param {bizManagerBizInfoClickOnDiscardButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerBizInfoClickOnDiscardButton = function (params) {
    return { evid: 554, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} settingsLobbyClickOnItemParams
* @property {string} status - If the red badge is shown when the user clicks then "true", if not "false"
* @property {string} click_type - if the helper is dismiss then the value is 'dismissed'
* @property {string} cta_name - the cta value (if exists) - f.e. “Get a business number”
* @property {string} hosting - MA/editor/onboarding
* @property {string} item_location - item_location in this format {section,column,row}
* @property {number} item_location_on_page - the location of item in page (order from 0,1,..
* @property {string} item_name - upgrade/connect_domain/.../website settings/business info/ roles and permissions/.../accept payments…
* @property {GUID} msid - --
* @property {string} page_id - page component id of lined page
* @property {string} platform - null
* @property {string} section_name - site-details/general/ecommerce/..
**/
/**
 * Name: Settings Lobby > Click on Item. src: 5 Evid: 1158.
 * Event description: when a user clicks on an item in one of the settings' sections,.

 * status - Type: string. Desc: If the red badge is shown when the user clicks then "true", if not "false"
 *
 * click_type - Type: string. Desc: if the helper is dismiss then the value is 'dismissed'
 *
 * cta_name - Type: string. Desc: the cta value (if exists) - f.e. “Get a business number”
 *
 * hosting - Type: string. Desc: MA/editor/onboarding
 *
 * item_location - Type: string. Desc: item_location in this format {section,column,row}
 *
 * item_location_on_page - Type: numeric. Desc: the location of item in page (order from 0,1,..
 *
 * item_name - Type: string. Desc: upgrade/connect_domain/.../website settings/business info/ roles and permissions/.../accept payments…
 *
 * msid - Type: guid. Desc: --
 *
 * page_id - Type: string. Desc: page component id of lined page
 *
 * platform - Type: string.
 *
 * section_name - Type: string. Desc: site-details/general/ecommerce/..
 * @param {settingsLobbyClickOnItemParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var settingsLobbyClickOnItem = function (params) {
    return { evid: 1158, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} priorityASuggestionCarouselInteractionParams
* @property {GUID} msid - msid
* @property {string} platform - deprecated
* @property {number} totalPriortySeen - if click next if it was 1,2,3 and 4 for previous
* @property {string} type - type of navigation (next, previous)
**/
/**
 * Name: Priority A - suggestion carousel interaction. src: 5 Evid: 8974.
 * Event description: when the user click on carousel.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string. Desc: deprecated
 *
 * totalPriortySeen - Type: numeric. Desc: if click next if it was 1,2,3 and 4 for previous
 *
 * type - Type: string. Desc: type of navigation (next, previous)
 * @param {priorityASuggestionCarouselInteractionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var priorityASuggestionCarouselInteraction = function (params) {
    return { evid: 8974, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSelectorLoadedSuccessfullyForDebuggingPurposesParams
* @property {number} account_sites_number - absolute account sites number
* @property {string} device - mobile / desktop
* @property {string} filtered - premium/published/adi / none
* @property {boolean} is_partner_dashboard - true - if partner dashboard displayed
* @property {number} loadingTime - in ms
* @property {string} platform - -
* @property {string} sitePublished - -
* @property {string} referral - -
* @property {string} selectionType - single / multi
* @property {number} site_type_enriched - -
* @property {number} sites_count - # sites returned to site selector
* @property {string} status - no thumbnails / empty state / success
* @property {string} siteType - HtmlWeb / modal
**/
/**
 * Name: dashboard > site selector loaded successfully for debugging purposes. src: 5 Evid: 1716.
 * Event description: when Site Selector loaded successfully, this event is for debugging purposes and will be sent via native reporting approach.

 * account_sites_number - Type: numeric. Desc: absolute account sites number
 *
 * device - Type: string. Desc: mobile / desktop
 *
 * filtered - Type: string. Desc: premium/published/adi / none
 *
 * is_partner_dashboard - Type: bool. Desc: true - if partner dashboard displayed
 *
 * loadingTime - Type: numeric. Desc: in ms
 *
 * platform - Type: string. Desc: -
 *
 * sitePublished - Type: string. Desc: -
 *
 * referral - Type: string. Desc: -
 *
 * selectionType - Type: string. Desc: single / multi
 *
 * site_type_enriched - Type: numeric. Desc: -
 *
 * sites_count - Type: numeric. Desc: # sites returned to site selector
 *
 * status - Type: string. Desc: no thumbnails / empty state / success
 *
 * siteType - Type: string. Desc: HtmlWeb / modal
 * @param {dashboardSiteSelectorLoadedSuccessfullyForDebuggingPurposesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSelectorLoadedSuccessfullyForDebuggingPurposes = function (params) {
    return { evid: 1716, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} accountManagerFinishLoadingAccountManagerParams
* @property {boolean} initial_load - initial_load
* @property {number} loading_time - loading_time from 110
* @property {string} platform - null
* @property {string} referral_info - referral_info
**/
/**
 * Name: account manager - Finish loading account manager. src: 5 Evid: 111.
 * Event description: start loading account manager.

 * initial_load - Type: bool. Desc: initial_load
 *
 * loading_time - Type: numeric. Desc: loading_time from 110
 *
 * platform - Type: string.
 *
 * referral_info - Type: string. Desc: referral_info
 * @param {accountManagerFinishLoadingAccountManagerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accountManagerFinishLoadingAccountManager = function (params) {
    return { evid: 111, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsClickOnViewMyAutomationsParams
* @property {GUID} msid - msid
* @property {string} origin - statistics banner / view my automations button
* @property {string} platform - null
**/
/**
 * Name: Automations > click on view my automations. src: 5 Evid: 143.
 * Event description: click on view my automations:
statistics banner / view my automations button / more actions.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: statistics banner / view my automations button
 *
 * platform - Type: string.
 * @param {automationsClickOnViewMyAutomationsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsClickOnViewMyAutomations = function (params) {
    return { evid: 143, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} accountSettingsUpdatesConfirmEnterPasswordParams
* @property {string} action - 2FA enable/2FA disable/2FA edit/add recovery phone/remove recovery phone/edit recovery phone/username/email address
* @property {boolean} is_valid - true/false
* @property {string} platform - null
**/
/**
 * Name: Account Settings Updates - Confirm Password Click. src: 5 Evid: 682.
 * Event description: The user clicks on 'ok' after entering the password, in the 'enter password' modal that pops up when updating account settings..

 * action - Type: string. Desc: 2FA enable/2FA disable/2FA edit/add recovery phone/remove recovery phone/edit recovery phone/username/email address
 *
 * is_valid - Type: bool. Desc: true/false
 *
 * platform - Type: string.
 * @param {accountSettingsUpdatesConfirmEnterPasswordParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accountSettingsUpdatesConfirmEnterPassword = function (params) {
    return { evid: 682, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} hooverNewReleasesIconParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: New Releases - Hover new releases icon. src: 5 Evid: 336.
 * Event description: The user hoovers the new releases icon in the top bar of the BM.
The event tracks the first time per load page..

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {hooverNewReleasesIconParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var hooverNewReleasesIcon = function (params) {
    return { evid: 336, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerDismissTooltipParams
* @property {string} hosting - MA/editor
* @property {GUID} msid - metasite id
* @property {string} name - tooltip name
* @property {string} place - where tooltip was shown (sidebar, rename dialog)
* @property {string} platform - null
**/
/**
 * Name: Biz Manager - dismiss tooltip. src: 5 Evid: 589.
 * Event description: tooltip is dismissed manually.

 * hosting - Type: string. Desc: MA/editor
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: tooltip name
 *
 * place - Type: string. Desc: where tooltip was shown (sidebar, rename dialog)
 *
 * platform - Type: string.
 * @param {bizManagerDismissTooltipParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerDismissTooltip = function (params) {
    return { evid: 589, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesFilterQuotesParams
* @property {string} filter_type - period, currency, display
* @property {string} msid - msid
* @property {string} name - name of filter
* @property {number} num_of_quotes - number of quotes the user has
* @property {string} origin_device - web,native
* @property {string} platform - null
**/
/**
 * Name: Quotes - Filter Quotes. src: 5 Evid: 69.
 * Event description: user filters the Quotes view.

 * filter_type - Type: string. Desc: period, currency, display
 *
 * msid - Type: string. Desc: msid
 *
 * name - Type: string. Desc: name of filter
 *
 * num_of_quotes - Type: numeric. Desc: number of quotes the user has
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string.
 * @param {quotesFilterQuotesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesFilterQuotes = function (params) {
    return { evid: 69, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerDashboardAssetClickOnArrowParams
* @property {string} asset_campaign_guid - ids to be consistent with premium events
* @property {string} click_type - left / right/ link
* @property {string} hosting - ADI/MA/editor
* @property {GUID} msid - site guid
* @property {string} platform - null
**/
/**
 * Name: Biz Manager - dashboard asset click on arrow. src: 5 Evid: 597.
 * Event description: asset click on arrow.

 * asset_campaign_guid - Type: string. Desc: ids to be consistent with premium events
 *
 * click_type - Type: string. Desc: left / right/ link
 *
 * hosting - Type: string. Desc: ADI/MA/editor
 *
 * msid - Type: guid. Desc: site guid
 *
 * platform - Type: string.
 * @param {bizManagerDashboardAssetClickOnArrowParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerDashboardAssetClickOnArrow = function (params) {
    return { evid: 597, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} wixInvoicesClickOnDynamicValueInAutomationParams
* @property {string} msid - msid
* @property {string} origin - Chosen app in which this automation was clicked (Now only Bookings)
* @property {string} origin_device - web,native
* @property {string} platform - platform
**/
/**
 * Name: Wix Invoices click on Dynamic Value in Automation. src: 5 Evid: 8973.
 * Event description: Clicking on Dynamic Value.

 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: Chosen app in which this automation was clicked (Now only Bookings)
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string. Desc: platform
 * @param {wixInvoicesClickOnDynamicValueInAutomationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var wixInvoicesClickOnDynamicValueInAutomation = function (params) {
    return { evid: 8973, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesClickViewOrderBookingParams
* @property {string} app_name - app name (stores/booking)
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Quotes - click view order/booking. src: 5 Evid: 458.
 * Event description: click on view order/booking, when invoice was created from a stores order/booking.

 * app_name - Type: string. Desc: app name (stores/booking)
 *
 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {quotesClickViewOrderBookingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesClickViewOrderBooking = function (params) {
    return { evid: 458, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesAddPaymentClickParams
* @property {GUID} appDefId - appDefId of the source
* @property {GUID} externalId - An external id of an entity, relevant to the invoiceSource application
* @property {boolean} fully_paid - true for fully paid selected, false for partial payment selected
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} origin - my invoices,preview
* @property {string} origin_device - web,native
* @property {string} platform - null
* @property {string} status - Creation form/Draft/Sent/Paid
**/
/**
 * Name: Quotes - Add payment click. src: 5 Evid: 424.
 * Event description: add payment for an invoice click.

 * appDefId - Type: guid. Desc: appDefId of the source
 *
 * externalId - Type: guid. Desc: An external id of an entity, relevant to the invoiceSource application
 *
 * fully_paid - Type: bool. Desc: true for fully paid selected, false for partial payment selected
 *
 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: my invoices,preview
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string.
 *
 * status - Type: string. Desc: Creation form/Draft/Sent/Paid
 * @param {quotesAddPaymentClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesAddPaymentClick = function (params) {
    return { evid: 424, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsBannerPresentedStatisticsParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations -> Banner presented - Statistics. src: 5 Evid: 236.
 * Event description: Automations -> Banner presented - Statistics.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsBannerPresentedStatisticsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsBannerPresentedStatistics = function (params) {
    return { evid: 236, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesRecurringTableActionsParams
* @property {string} action - edit/duplicate/view invoices/cancel
* @property {GUID} invoiceId - instanceId
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Invoices - recurring-  table actions. src: 5 Evid: 1578.
 * Event description: user selecting an action in recurring invoices table for a specific invoice.

 * action - Type: string. Desc: edit/duplicate/view invoices/cancel
 *
 * invoiceId - Type: guid. Desc: instanceId
 *
 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {invoicesRecurringTableActionsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesRecurringTableActions = function (params) {
    return { evid: 1578, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} headerClickOnItemInOneOfTheHeaderDialogsDropDownMenusParams
* @property {string} itemName - the item name, f.e: courses and lessons, updates and releases, etc.
* @property {GUID} msid - site guid (when the click is in site level)
* @property {string} pageView - my-sites /dashboard / account settings
* @property {string} platform - deprecated
* @property {string} view - the dropdown menu name, f.e: explore, priority support, site-dropdown, notifications, etc.
**/
/**
 * Name: Header > click on item in one of the header dialogs (drop down menus). src: 5 Evid: 1768.
 * Event description: click on item in one of the header dialogs which are drop down menus, it can be click on item in explore menu, help menu, etc..

 * itemName - Type: string. Desc: the item name, f.e: courses and lessons, updates and releases, etc.
 *
 * msid - Type: guid. Desc: site guid (when the click is in site level)
 *
 * pageView - Type: string. Desc: my-sites /dashboard / account settings
 *
 * platform - Type: string. Desc: deprecated
 *
 * view - Type: string. Desc: the dropdown menu name, f.e: explore, priority support, site-dropdown, notifications, etc.
 * @param {headerClickOnItemInOneOfTheHeaderDialogsDropDownMenusParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var headerClickOnItemInOneOfTheHeaderDialogsDropDownMenus = function (params) {
    return { evid: 1768, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardTriggersAlertDeleteOpenParams
* @property {GUID} msid - msid
* @property {string} origin - (e.g: 'Forms') from where this action was called
* @property {string} platform - null
* @property {string} recipe_name - recipe name
* @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
* @property {number} src - null
**/
/**
 * Name: Automations > Alert delete open. src: 5 Evid: 214.
 * Event description:  Alert delete open.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: (e.g: 'Forms') from where this action was called
 *
 * platform - Type: string.
 *
 * recipe_name - Type: string. Desc: recipe name
 *
 * rule_id - Type: guid. Desc: if this trigger all ready customized, null if it first time customization
 *
 * src - Type: numeric.
 * @param {dashboardTriggersAlertDeleteOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardTriggersAlertDeleteOpen = function (params) {
    return { evid: 214, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesPrintQuoteParams
* @property {string} msid - msid
* @property {string} origin - my invoices, preview
* @property {string} platform - null
* @property {GUID} quoteId - quote guid
**/
/**
 * Name: Quotes - Print quote. src: 5 Evid: 88.
 * Event description: print quote.

 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: my invoices, preview
 *
 * platform - Type: string.
 *
 * quoteId - Type: guid. Desc: quote guid
 * @param {quotesPrintQuoteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesPrintQuote = function (params) {
    return { evid: 88, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSelectorButtonParams
* @property {Url} action_url - action_url
* @property {string} cta - x / cancel / continue
* @property {string} device - mobile / desktop
* @property {GUID} esi - null
* @property {string} filtered - premium/published/adi / none
* @property {boolean} is_partner_dashboard - true - if partner dashboard chosen
* @property {GUID} msid - null
* @property {string} platform - deprecated
* @property {number} position - The position of the selected site in the page. 1 is the highest site.
* @property {number} positionIndex - the index of the selected site position in the site selector
* @property {string} referral - referral URL
* @property {string} result - json of all chosen msid separated with comma
* @property {string} selectionType - single / multi
* @property {GUID} site_id - null
* @property {number} site_type_enriched - null
* @property {string} siteTypeName - ADI/Editor
* @property {number} sites_count - how many sites were chosen
* @property {number} sites_number - the number of sites available in site selector (not necessarily equal to number of sites owned)
* @property {number} src - null
* @property {string} siteType - HtmlWeb / modal
**/
/**
 * Name: dashboard > site selector click. src: 5 Evid: 25.


 * action_url - Type: url. Desc: action_url
 *
 * cta - Type: string. Desc: x / cancel / continue
 *
 * device - Type: string. Desc: mobile / desktop
 *
 * esi - Type: guid.
 *
 * filtered - Type: string. Desc: premium/published/adi / none
 *
 * is_partner_dashboard - Type: bool. Desc: true - if partner dashboard chosen
 *
 * msid - Type: guid.
 *
 * platform - Type: string. Desc: deprecated
 *
 * position - Type: numeric. Desc: The position of the selected site in the page. 1 is the highest site.
 *
 * positionIndex - Type: numeric. Desc: the index of the selected site position in the site selector
 *
 * referral - Type: string. Desc: referral URL
 *
 * result - Type: string. Desc: json of all chosen msid separated with comma
 *
 * selectionType - Type: string. Desc: single / multi
 *
 * site_id - Type: guid.
 *
 * site_type_enriched - Type: numeric.
 *
 * siteTypeName - Type: string. Desc: ADI/Editor
 *
 * sites_count - Type: numeric. Desc: how many sites were chosen
 *
 * sites_number - Type: numeric. Desc: the number of sites available in site selector (not necessarily equal to number of sites owned)
 *
 * src - Type: numeric.
 *
 * siteType - Type: string. Desc: HtmlWeb / modal
 * @param {dashboardSiteSelectorButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSelectorButton = function (params) {
    return { evid: 25, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesDeleteTaxPageOkParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Quotes - Delete tax page - Ok. src: 5 Evid: 438.
 * Event description: OK click in delete tax page.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {quotesDeleteTaxPageOkParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesDeleteTaxPageOk = function (params) {
    return { evid: 438, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} twoFactorAuthenticationSetupEditNumberParams
* @property {string} click_from - security box/main page
* @property {string} platform - null
**/
/**
 * Name: Phone 2FA Setup - Edit Number. src: 5 Evid: 685.
 * Event description: The user clicks on 'edit number' to update the phone number chosen for 2-factor authentication.

 * click_from - Type: string. Desc: security box/main page
 *
 * platform - Type: string.
 * @param {twoFactorAuthenticationSetupEditNumberParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var twoFactorAuthenticationSetupEditNumber = function (params) {
    return { evid: 685, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} clickOnSidebarSHeaderParams
* @property {string} app_id - app_id of the item
* @property {string} hosting - MA/editor
* @property {GUID} msid - metasite id
* @property {string} name - unique name that doesn't change when changing the name on the side bar
* @property {string} platform - null
**/
/**
 * Name: Click on Sidebar's Header. src: 5 Evid: 106.
 * Event description: user clicks on sidebar's header and returns to the dashboard.

 * app_id - Type: string. Desc: app_id of the item
 *
 * hosting - Type: string. Desc: MA/editor
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: unique name that doesn't change when changing the name on the side bar
 *
 * platform - Type: string.
 * @param {clickOnSidebarSHeaderParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickOnSidebarSHeader = function (params) {
    return { evid: 106, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsDaComponentManageAutomations291Params
* @property {string} asset_campaign_guid - asset_campaign_guid
* @property {GUID} msid - msid
* @property {number} offer_location - offer_location
* @property {string} origin - button, link, header, success creation dialog
* @property {string} platform - null
* @property {string} referral_info - indicate which vertical is the dacomponent triggered from
**/
/**
 * Name: Automations > DaComponent > Manage Automations. src: 5 Evid: 291.
 * Event description: Automations > DaComponent > Manage Automations.

 * asset_campaign_guid - Type: string. Desc: asset_campaign_guid
 *
 * msid - Type: guid. Desc: msid
 *
 * offer_location - Type: numeric. Desc: offer_location
 *
 * origin - Type: string. Desc: button, link, header, success creation dialog
 *
 * platform - Type: string.
 *
 * referral_info - Type: string. Desc: indicate which vertical is the dacomponent triggered from
 * @param {automationsDaComponentManageAutomations291Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsDaComponentManageAutomations291 = function (params) {
    return { evid: 291, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} financialServicesSettingsChangeTabParams
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} tabFrom - tabFrom
* @property {string} tabTo - tabTo
**/
/**
 * Name: Financial Services Settings - Change Tab. src: 5 Evid: 1301.
 * Event description: Financial Services Settings - Change Tab.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * tabFrom - Type: string. Desc: tabFrom
 *
 * tabTo - Type: string. Desc: tabTo
 * @param {financialServicesSettingsChangeTabParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var financialServicesSettingsChangeTab = function (params) {
    return { evid: 1301, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesDepositLearnMoreParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Invoices - Deposit - learn more. src: 5 Evid: 1694.
 * Event description: Invoices - Deposit - learn more.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {invoicesDepositLearnMoreParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesDepositLearnMore = function (params) {
    return { evid: 1694, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSettingsLocationsModalPageViewParams
* @property {string} fields - not sent
* @property {string} hosting - from where user arrived to locations modal (Editor/MA/bookings...)
* @property {string} location_details - 0- first location (create), 1-second location, 2- third location,...
* @property {GUID} msid - msid
* @property {string} origin - name of previous tab
* @property {string} platform - null
**/
/**
 * Name: dashboard > site settings > Locations Modal page view. src: 5 Evid: 1189.
 * Event description: Locations Modal page view.

 * fields - Type: string. Desc: not sent
 *
 * hosting - Type: string. Desc: from where user arrived to locations modal (Editor/MA/bookings...)
 *
 * location_details - Type: string. Desc: 0- first location (create), 1-second location, 2- third location,...
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: name of previous tab
 *
 * platform - Type: string.
 * @param {dashboardSiteSettingsLocationsModalPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSettingsLocationsModalPageView = function (params) {
    return { evid: 1189, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsClickOnAutomationsTabsParams
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} previous_tab - {my_automations,recommended}
* @property {string} tab_name - {my_automations,recommended}
**/
/**
 * Name: Automations > click on Automations tabs. src: 5 Evid: 230.
 * Event description: User click on Automations tabs.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * previous_tab - Type: string. Desc: {my_automations,recommended}
 *
 * tab_name - Type: string. Desc: {my_automations,recommended}
 * @param {automationsClickOnAutomationsTabsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsClickOnAutomationsTabs = function (params) {
    return { evid: 230, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} foldersClickOnFolderParams
* @property {string} folder_name - the name of the folder
* @property {string} hosting - MA
* @property {GUID} msid - --
* @property {string} platform - null
* @property {string} sub_view - list-view/grid
* @property {string} view - my-sites
**/
/**
 * Name: Folders > click on folder. src: 5 Evid: 130.
 * Event description: click on the folder from my-sites and see it's content.

 * folder_name - Type: string. Desc: the name of the folder
 *
 * hosting - Type: string. Desc: MA
 *
 * msid - Type: guid. Desc: --
 *
 * platform - Type: string.
 *
 * sub_view - Type: string. Desc: list-view/grid
 *
 * view - Type: string. Desc: my-sites
 * @param {foldersClickOnFolderParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var foldersClickOnFolder = function (params) {
    return { evid: 130, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesEmailInvoicePageParams
* @property {GUID} invoice_id - invoice guid
* @property {string} invoiceSource - by app_def_id
* @property {string} msid - msid
* @property {string} origin - origin page
* @property {string} origin_device - web,native
* @property {string} paymentType - 'one time', 'recurring'
* @property {string} platform - null
* @property {boolean} resend - resend mode?
* @property {string} status - Creation form/Draft/Sent/Paid
**/
/**
 * Name: Quotes - Email invoice page. src: 5 Evid: 404.
 * Event description: email invoice pop up.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * invoiceSource - Type: string. Desc: by app_def_id
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: origin page
 *
 * origin_device - Type: string. Desc: web,native
 *
 * paymentType - Type: string. Desc: 'one time', 'recurring'
 *
 * platform - Type: string.
 *
 * resend - Type: bool. Desc: resend mode?
 *
 * status - Type: string. Desc: Creation form/Draft/Sent/Paid
 * @param {quotesEmailInvoicePageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesEmailInvoicePage = function (params) {
    return { evid: 404, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsViewAllMainAutomationsPageParams
* @property {boolean} flag - if view all then false, otherwise true
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} recipeCategory - recipeCategory
**/
/**
 * Name: Automations > view all main automations page. src: 5 Evid: 1648.
 * Event description: Automations > view all main automations page.

 * flag - Type: bool. Desc: if view all then false, otherwise true
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * recipeCategory - Type: string. Desc: recipeCategory
 * @param {automationsViewAllMainAutomationsPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsViewAllMainAutomationsPage = function (params) {
    return { evid: 1648, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardTriggersReachStepCustomizeTheTriggerParams
* @property {string} action - open/close - which action the user did
* @property {string} flowType - edit or create
* @property {number} index - index for drip campaign
* @property {boolean} is_auto - window opens automatically/manually
* @property {GUID} msid - msid
* @property {string} origin - deprecated
* @property {string} platform - null
* @property {string} recipe_name - recipe name
* @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
* @property {number} src - deprecated
**/
/**
 * Name: Automations > Reach step customize the trigger. src: 5 Evid: 206.
 * Event description: open/close choose a trigger.

 * action - Type: string. Desc: open/close - which action the user did
 *
 * flowType - Type: string. Desc: edit or create
 *
 * index - Type: numeric. Desc: index for drip campaign
 *
 * is_auto - Type: bool. Desc: window opens automatically/manually
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: deprecated
 *
 * platform - Type: string.
 *
 * recipe_name - Type: string. Desc: recipe name
 *
 * rule_id - Type: guid. Desc: if this trigger all ready customized, null if it first time customization
 *
 * src - Type: numeric. Desc: deprecated
 * @param {dashboardTriggersReachStepCustomizeTheTriggerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardTriggersReachStepCustomizeTheTrigger = function (params) {
    return { evid: 206, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSettingsUpdateParams
* @property {string} click_from - security box/main page
* @property {GUID} msid - null
* @property {string} name - settings section name
* @property {string} origin - button/description (only for 'edit password' - where did the user click)
* @property {string} platform - null
* @property {string} providerId - social provider for enable/disable social actions (facebook/google)
* @property {number} src - null
* @property {string} value - deprecated
**/
/**
 * Name: dashboard > settings -> update. src: 5 Evid: 22.


 * click_from - Type: string. Desc: security box/main page
 *
 * msid - Type: guid.
 *
 * name - Type: string. Desc: settings section name
 *
 * origin - Type: string. Desc: button/description (only for 'edit password' - where did the user click)
 *
 * platform - Type: string.
 *
 * providerId - Type: string. Desc: social provider for enable/disable social actions (facebook/google)
 *
 * src - Type: numeric.
 *
 * value - Type: string. Desc: deprecated
 * @param {dashboardSettingsUpdateParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSettingsUpdate = function (params) {
    return { evid: 22, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesBulkActionsExportCsvParams
* @property {string} filter - type of filter
* @property {string} msid - msid
* @property {string} number - number of invoices choose or all
* @property {string} platform - null
**/
/**
 * Name: Quotes - bulk actions - Export CSV. src: 5 Evid: 398.
 * Event description: Quotes - Create invoice - Toggle Recurring.

 * filter - Type: string. Desc: type of filter
 *
 * msid - Type: string. Desc: msid
 *
 * number - Type: string. Desc: number of invoices choose or all
 *
 * platform - Type: string.
 * @param {quotesBulkActionsExportCsvParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesBulkActionsExportCsv = function (params) {
    return { evid: 398, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardProsSiteActionsOpenedParams
* @property {GUID} msid - -
* @property {string} platform - null
**/
/**
 * Name: dashboard > pros -> site actions opened. src: 5 Evid: 39.
 * Event description: user opens site actions  dialog in pro-my-sites.

 * msid - Type: guid. Desc: -
 *
 * platform - Type: string.
 * @param {dashboardProsSiteActionsOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardProsSiteActionsOpened = function (params) {
    return { evid: 39, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsEndOfStepsQuotaUpgradeAscendParams
* @property {string} ascend_package - ascend_package
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {number} steps - number of steps when event shot
**/
/**
 * Name: Automations > end of steps quota upgrade ascend. src: 5 Evid: 742.
 * Event description: Automations > end of steps quota upgrade ascend.

 * ascend_package - Type: string. Desc: ascend_package
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * steps - Type: numeric. Desc: number of steps when event shot
 * @param {automationsEndOfStepsQuotaUpgradeAscendParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsEndOfStepsQuotaUpgradeAscend = function (params) {
    return { evid: 742, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsSendCouponCreateNewCouponParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations - send coupon - create new coupon. src: 5 Evid: 1615.
 * Event description: Automations - send coupon - create new coupon.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsSendCouponCreateNewCouponParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsSendCouponCreateNewCoupon = function (params) {
    return { evid: 1615, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeScrollDownParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: CRM Home - scroll down. src: 5 Evid: 1300.
 * Event description: CRM Home - scroll down.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {crmHomeScrollDownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeScrollDown = function (params) {
    return { evid: 1300, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} headerLoadedParams
* @property {GUID} msid - in account level/my-sites send null
* @property {string} page_view - name of the page - my-sites/bizmgr/account manager/partner dashboard
* @property {string} platform - null
**/
/**
 * Name: Header Shown. src: 5 Evid: 1452.
 * Event description: when the header is shown to the user in my-sites/bizmgr/account manager/partner dashboard the event is sent.

 * msid - Type: guid. Desc: in account level/my-sites send null
 *
 * page_view - Type: string. Desc: name of the page - my-sites/bizmgr/account manager/partner dashboard
 *
 * platform - Type: string.
 * @param {headerLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var headerLoaded = function (params) {
    return { evid: 1452, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesCreateInvoiceSaveDraftClickParams
* @property {GUID} invoice_id - invoice guid
* @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
* @property {string} msid - msid
* @property {string} origin - create invoice, edit invoice,premium banner
* @property {string} paymentType - 'one time','recurring'
* @property {string} platform - null
* @property {string} status - Creation form/Draft/Sent/Paid
**/
/**
 * Name: Quotes - Create invoice - Save draft click. src: 5 Evid: 408.
 * Event description: Create invoice - Save draft button click.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * invoiceType - Type: string. Desc: ’recurringAutoCharge’/ 'recurring'/ 'one time'
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: create invoice, edit invoice,premium banner
 *
 * paymentType - Type: string. Desc: 'one time','recurring'
 *
 * platform - Type: string.
 *
 * status - Type: string. Desc: Creation form/Draft/Sent/Paid
 * @param {quotesCreateInvoiceSaveDraftClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesCreateInvoiceSaveDraftClick = function (params) {
    return { evid: 408, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} email2faSetupDisableClickParams
* @property {string} platform - null
**/
/**
 * Name: Email 2FA Setup - Disable Click. src: 5 Evid: 1680.
 * Event description: The user clicked on 'disable' to disable Email 2FA.

 * platform - Type: string.
 * @param {email2faSetupDisableClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var email2faSetupDisableClick = function (params) {
    return { evid: 1680, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoiceSettingsSelectTaxDetailsCustomFieldCheckboxParams
* @property {boolean} checkbox - checked or enchecked
* @property {GUID} msid - msid
* @property {string} platform - Web/ Mobile
* @property {string} value - ‘tax per line item’/ ‘net tax amount’
* @property {string} value2 - ‘other setting same modal value (enambled/disabled)
**/
/**
 * Name: Invoice Settings - Select Tax Details Custom Field (Checkbox). src: 5 Evid: 8917.
 * Event description: How user select to show taxes in Invoice.

 * checkbox - Type: bool. Desc: checked or enchecked
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string. Desc: Web/ Mobile
 *
 * value - Type: string. Desc: ‘tax per line item’/ ‘net tax amount’
 *
 * value2 - Type: string. Desc: ‘other setting same modal value (enambled/disabled)
 * @param {invoiceSettingsSelectTaxDetailsCustomFieldCheckboxParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoiceSettingsSelectTaxDetailsCustomFieldCheckbox = function (params) {
    return { evid: 8917, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} discardModalClickParams
* @property {string} modal_name - weather its ‘Discard modal’, clicking on discard or clicking anywhere else, getting ‘Save changes’ modal
* @property {GUID} msid - msid
* @property {string} platform - mobile/web
* @property {string} value - ‘Discard’, ‘x’, ‘Close’
**/
/**
 * Name: Discard Modal Click. src: 5 Evid: 8935.
 * Event description: In Invoices settings Discard modal chosen action.

 * modal_name - Type: string. Desc: weather its ‘Discard modal’, clicking on discard or clicking anywhere else, getting ‘Save changes’ modal
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string. Desc: mobile/web
 *
 * value - Type: string. Desc: ‘Discard’, ‘x’, ‘Close’
 * @param {discardModalClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var discardModalClick = function (params) {
    return { evid: 8935, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesShowPaymentPopupPageParams
* @property {string} msid - msid
* @property {string} name - name of payment
* @property {string} origin - how user arrived to the flow onboarding/payments
* @property {string} platform - null
**/
/**
 * Name: Quotes - Show Payment popup page. src: 5 Evid: 440.
 * Event description: Stripe popup is shown.

 * msid - Type: string. Desc: msid
 *
 * name - Type: string. Desc: name of payment
 *
 * origin - Type: string. Desc: how user arrived to the flow onboarding/payments
 *
 * platform - Type: string.
 * @param {quotesShowPaymentPopupPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesShowPaymentPopupPage = function (params) {
    return { evid: 440, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} teamManagementDeleteTeamMemberDeleteClickFailParams
* @property {string} invite_status - pending/expired/leave team
* @property {GUID} member_id - the uuid of the deleted member (if status is pending then invite_id)
* @property {string} origin - where the dialog was opened from
* @property {string} platform - null
* @property {string} role - the deleted user’s role
**/
/**
 * Name: Team Management - delete team member - delete click fail. src: 5 Evid: 181.
 * Event description: When a user clicks on 'delete' in the delete team member window - fail response.

 * invite_status - Type: string. Desc: pending/expired/leave team
 *
 * member_id - Type: guid. Desc: the uuid of the deleted member (if status is pending then invite_id)
 *
 * origin - Type: string. Desc: where the dialog was opened from
 *
 * platform - Type: string.
 *
 * role - Type: string. Desc: the deleted user’s role
 * @param {teamManagementDeleteTeamMemberDeleteClickFailParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teamManagementDeleteTeamMemberDeleteClickFail = function (params) {
    return { evid: 181, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} homeOpenDialogClickParams
* @property {GUID} app_id - -
* @property {GUID} msid - -
* @property {string} origin - place of clicking my sites ( Header, top left bar). Relevant only for site list
* @property {string} page_view - my-sites /dashboard / account settings
* @property {string} platform - null
* @property {string} prev_view - -
* @property {string} referral_info - -
* @property {string} view - my-apps, site-list, account,notifications,priority support
* @property {string} wixsession - authentication token. if the session exists, then the user is logged in.
**/
/**
 * Name: Home > open dialog click. src: 5 Evid: 303.
 * Event description: opening a dialog from home: my apps, my sites, account menu,notifications,priority support.

 * app_id - Type: guid. Desc: -
 *
 * msid - Type: guid. Desc: -
 *
 * origin - Type: string. Desc: place of clicking my sites ( Header, top left bar). Relevant only for site list
 *
 * page_view - Type: string. Desc: my-sites /dashboard / account settings
 *
 * platform - Type: string.
 *
 * prev_view - Type: string. Desc: -
 *
 * referral_info - Type: string. Desc: -
 *
 * view - Type: string. Desc: my-apps, site-list, account,notifications,priority support
 *
 * wixsession - Type: string. Desc: authentication token. if the session exists, then the user is logged in.
 * @param {homeOpenDialogClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var homeOpenDialogClick = function (params) {
    return { evid: 303, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} foldersClickOnShowMoreShoeLessParams
* @property {string} hosting - MA
* @property {string} name - the name of the button
* @property {string} platform - null
* @property {string} view - my-sites
* @property {string} view_mode - grid
**/
/**
 * Name: Folders > Click on 'Show More'/'Show Less'. src: 5 Evid: 119.
 * Event description: Click on 'show more' or 'show less' button from my-sites to see more/less folders.

 * hosting - Type: string. Desc: MA
 *
 * name - Type: string. Desc: the name of the button
 *
 * platform - Type: string.
 *
 * view - Type: string. Desc: my-sites
 *
 * view_mode - Type: string. Desc: grid
 * @param {foldersClickOnShowMoreShoeLessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var foldersClickOnShowMoreShoeLess = function (params) {
    return { evid: 119, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsSendCouponEditCouponDetailsParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations - send coupon - edit coupon details. src: 5 Evid: 1616.
 * Event description: Automations - send coupon - edit coupon details.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsSendCouponEditCouponDetailsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsSendCouponEditCouponDetails = function (params) {
    return { evid: 1616, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteNewsViewAllParams
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: dashboard > site -> news -> view all. src: 5 Evid: 18.


 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {dashboardSiteNewsViewAllParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteNewsViewAll = function (params) {
    return { evid: 18, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesSetBusinessInfoModalClickOnAddContinueParams
* @property {GUID} appDefId - application id
* @property {string} msid - msid
* @property {string} origin - origin page - from which place this action was made (invoices, contacts full page, crm home...)
* @property {string} platform - null
**/
/**
 * Name: Invoices - Set Business Info Modal - click on Add & Continue. src: 5 Evid: 1464.
 * Event description: Set Business Info Modal - click on Add & Continue.

 * appDefId - Type: guid. Desc: application id
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: origin page - from which place this action was made (invoices, contacts full page, crm home...)
 *
 * platform - Type: string.
 * @param {invoicesSetBusinessInfoModalClickOnAddContinueParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesSetBusinessInfoModalClickOnAddContinue = function (params) {
    return { evid: 1464, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsCreationModalUserSearchFocusOutParams
* @property {GUID} msid - msid
* @property {number} numOfResults - null
* @property {string} platform - null
* @property {string} searchText - what the user search for
**/
/**
 * Name: Automations > creation modal - user search focus out. src: 5 Evid: 1269.
 * Event description: Automations > creation modal - user search focus out.

 * msid - Type: guid. Desc: msid
 *
 * numOfResults - Type: numeric.
 *
 * platform - Type: string.
 *
 * searchText - Type: string. Desc: what the user search for
 * @param {automationsCreationModalUserSearchFocusOutParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsCreationModalUserSearchFocusOut = function (params) {
    return { evid: 1269, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesSearchInvoicesParams
* @property {string} msid - msid
* @property {number} num_of_invoices - number of invoices the user has
* @property {number} num_of_results - number of returned results
* @property {string} origin_device - web,native
* @property {string} platform - null
* @property {string} text - text searched
**/
/**
 * Name: Quotes - search invoices. src: 5 Evid: 448.
 * Event description: user searches  in the invoices view.

 * msid - Type: string. Desc: msid
 *
 * num_of_invoices - Type: numeric. Desc: number of invoices the user has
 *
 * num_of_results - Type: numeric. Desc: number of returned results
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string.
 *
 * text - Type: string. Desc: text searched
 * @param {quotesSearchInvoicesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesSearchInvoices = function (params) {
    return { evid: 448, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardBannerLoadingInitParams
* @property {GUID} msid - msid
* @property {string} name - banner name for identification
* @property {string} origin - origin
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: dashboard > banner loading init. src: 5 Evid: 54.
 * Event description: Please add event for banners loading initiation (as we have for seeing, clicking and closing banners events src= 5 evid=14,34,36).

 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: banner name for identification
 *
 * origin - Type: string. Desc: origin
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {dashboardBannerLoadingInitParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardBannerLoadingInit = function (params) {
    return { evid: 54, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardClickOnCreatePriorityTicketExpertsParams
* @property {string} origin - location of the click
* @property {string} origin_app - if dashboard then 'MAD'
* @property {string} platform - null
**/
/**
 * Name: dashboard > Click on Create Priority Ticket (Experts). src: 5 Evid: 57.
 * Event description: User click on 'Create Priority Ticket' - available for Experts.

 * origin - Type: string. Desc: location of the click
 *
 * origin_app - Type: string. Desc: if dashboard then 'MAD'
 *
 * platform - Type: string.
 * @param {dashboardClickOnCreatePriorityTicketExpertsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardClickOnCreatePriorityTicketExperts = function (params) {
    return { evid: 57, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesRecurringAddPremiumPlanClickParams
* @property {string} msid - msid
* @property {string} platform - BM/ client billing
* @property {GUID} uuid - uuid
**/
/**
 * Name: Invoices - recurring - Add Premium Plan click. src: 5 Evid: 1633.
 * Event description: Quotes - recurring - Add Premium Plan click.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string. Desc: BM/ client billing
 *
 * uuid - Type: guid. Desc: uuid
 * @param {invoicesRecurringAddPremiumPlanClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesRecurringAddPremiumPlanClick = function (params) {
    return { evid: 1633, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} homeNotificationBadgeShownParams
* @property {string} msid - deprecated
* @property {number} num_of_new - number of new notifications - number in badge
* @property {boolean} on_page_load - true if sent on page load
* @property {string} origin - MSID of the site the user is on, my-sites if on Site List. Later on, also account-settings, and other account-level pages.
* @property {string} platform - null
**/
/**
 * Name: Home > notification badge shown. src: 5 Evid: 254.
 * Event description: a badge with new notifications/ urgent notifications is shown to the user.

 * msid - Type: string. Desc: deprecated
 *
 * num_of_new - Type: numeric. Desc: number of new notifications - number in badge
 *
 * on_page_load - Type: bool. Desc: true if sent on page load
 *
 * origin - Type: string. Desc: MSID of the site the user is on, my-sites if on Site List. Later on, also account-settings, and other account-level pages.
 *
 * platform - Type: string.
 * @param {homeNotificationBadgeShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var homeNotificationBadgeShown = function (params) {
    return { evid: 254, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsBackToAutomationFromShoutOutUpdatingParams
* @property {string} event_name - 'triggered-emails'
* @property {GUID} msid - msid
* @property {string} origin - shoutout
* @property {string} platform - null
* @property {GUID} rule_id - rule_id
**/
/**
 * Name: Automations - Back to Automation from ShoutOut Updating. src: 5 Evid: 234.
 * Event description: user click on 'Back to Automations' from ShoutOut Updating page
(when using action 'Send email to visitors' in Automations).

 * event_name - Type: string. Desc: 'triggered-emails'
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: shoutout
 *
 * platform - Type: string.
 *
 * rule_id - Type: guid. Desc: rule_id
 * @param {automationsBackToAutomationFromShoutOutUpdatingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsBackToAutomationFromShoutOutUpdating = function (params) {
    return { evid: 234, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} toolcastClickOnLetsGoThePopUpParams
* @property {string} campaignId - from dealer
* @property {string} clickType - From where the user click panel or dashboard
* @property {boolean} firstStep - if the toolcast in the first step he can see text, bool.
* @property {string} offeringGuid - offer guid
* @property {string} origin - From where the user click panel or dashboard or bubble
* @property {string} platform - null
* @property {string} stepName - The name of the toolcast step
**/
/**
 * Name: Toolcast- Click on 'Lets Go' from the pop up. src: 5 Evid: 1366.
 * Event description: when user click on Lets go in the pop up toolcast in the first step and if the click is from the focus widget or panel.

 * campaignId - Type: string. Desc: from dealer
 *
 * clickType - Type: string. Desc: From where the user click panel or dashboard
 *
 * firstStep - Type: bool. Desc: if the toolcast in the first step he can see text, bool.
 *
 * offeringGuid - Type: string. Desc: offer guid
 *
 * origin - Type: string. Desc: From where the user click panel or dashboard or bubble
 *
 * platform - Type: string.
 *
 * stepName - Type: string. Desc: The name of the toolcast step
 * @param {toolcastClickOnLetsGoThePopUpParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var toolcastClickOnLetsGoThePopUp = function (params) {
    return { evid: 1366, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} widgetLoadedParams
* @property {string} hosting - --
* @property {boolean} is_shown - 1- shown 0 hidden
* @property {number} loading_time - loading time from start loading the widget
* @property {number} loading_time_from_start_loading_home - loading time from start loading the home
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} widget_name - widget name
**/
/**
 * Name: dashboard > Widget loaded. src: 5 Evid: 299.
 * Event description: widget is shown in dashboard.

 * hosting - Type: string. Desc: --
 *
 * is_shown - Type: bool. Desc: 1- shown 0 hidden
 *
 * loading_time - Type: numeric. Desc: loading time from start loading the widget
 *
 * loading_time_from_start_loading_home - Type: numeric. Desc: loading time from start loading the home
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * widget_name - Type: string. Desc: widget name
 * @param {widgetLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetLoaded = function (params) {
    return { evid: 299, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeIntegrationsCommunicationsViewAllParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: CRM Home - integrations - communications view all. src: 5 Evid: 854.
 * Event description: CRM Home - integrations - communications view all.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {crmHomeIntegrationsCommunicationsViewAllParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeIntegrationsCommunicationsViewAll = function (params) {
    return { evid: 854, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} accountSettingsChangeEmailAddressModalSubmitParams
* @property {string} platform - null
**/
/**
 * Name: Account Settings - Change Email Address Modal - Submit. src: 5 Evid: 1785.
 * Event description: The user clicks on submit after entering the code in the change email address modal.

 * platform - Type: string.
 * @param {accountSettingsChangeEmailAddressModalSubmitParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accountSettingsChangeEmailAddressModalSubmit = function (params) {
    return { evid: 1785, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} app2faSetupClickOnNextAfterScanningQrCodeParams
* @property {string} mode - change app/enable
* @property {string} origin - account settings page/phone modal/email modal
* @property {string} platform - null
**/
/**
 * Name: App 2FA Setup - Click on Next After Scanning QR Code. src: 5 Evid: 1739.
 * Event description: The user scanned the QR code, or entered the code manually in the authentication app, and clicked on next..

 * mode - Type: string. Desc: change app/enable
 *
 * origin - Type: string. Desc: account settings page/phone modal/email modal
 *
 * platform - Type: string.
 * @param {app2faSetupClickOnNextAfterScanningQrCodeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var app2faSetupClickOnNextAfterScanningQrCode = function (params) {
    return { evid: 1739, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesWidgetMoreActionParams
* @property {GUID} contactId - contact id
* @property {GUID} invoiceId - invoice id
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Invoices - widget - more action. src: 5 Evid: 1320.
 * Event description: Invoices - widget - more action.

 * contactId - Type: guid. Desc: contact id
 *
 * invoiceId - Type: guid. Desc: invoice id
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {invoicesWidgetMoreActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesWidgetMoreAction = function (params) {
    return { evid: 1320, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsExportAutomationExpertModeParams
* @property {GUID} msid - msid
* @property {string} origin - from where this action was called
* @property {string} platform - null
* @property {GUID} rule_id - rule_id
* @property {string} rule_name - rule_name
**/
/**
 * Name: Automations > Export automation (expert mode). src: 5 Evid: 8916.
 * Event description: Click on 'Export' automation.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: from where this action was called
 *
 * platform - Type: string.
 *
 * rule_id - Type: guid. Desc: rule_id
 *
 * rule_name - Type: string. Desc: rule_name
 * @param {automationsExportAutomationExpertModeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsExportAutomationExpertMode = function (params) {
    return { evid: 8916, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesPrintReportClickParams
* @property {string} basis - accural, cash
* @property {string} msid - msid
* @property {string} name - tax, revenue
* @property {string} platform - null
**/
/**
 * Name: Quotes - print report click. src: 5 Evid: 452.
 * Event description: user clicks on print report in tax/revenue summary. use 'name'  to choose tax or revenue..

 * basis - Type: string. Desc: accural, cash
 *
 * msid - Type: string. Desc: msid
 *
 * name - Type: string. Desc: tax, revenue
 *
 * platform - Type: string.
 * @param {quotesPrintReportClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesPrintReportClick = function (params) {
    return { evid: 452, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeWorkflowsWidgetStartFromScratchParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: CRM Home - workflows widget - start from scratch. src: 5 Evid: 853.
 * Event description: CRM Home - workflows widget - start from scratch.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {crmHomeWorkflowsWidgetStartFromScratchParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeWorkflowsWidgetStartFromScratch = function (params) {
    return { evid: 853, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} teamManagementEditTeamProfileOpenDialogParams
* @property {boolean} onboarding - the dialog was opened from the onboarding page - true, from team management - false
* @property {string} platform - null
**/
/**
 * Name: Team management - Edit team profile – open dialog. src: 5 Evid: 171.
 * Event description: When a user clicks to edit team profile please send this event with the next fields:.

 * onboarding - Type: bool. Desc: the dialog was opened from the onboarding page - true, from team management - false
 *
 * platform - Type: string.
 * @param {teamManagementEditTeamProfileOpenDialogParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teamManagementEditTeamProfileOpenDialog = function (params) {
    return { evid: 171, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardTpaUpgradeClickParams
* @property {GUID} app_id - null
* @property {GUID} msid - null
* @property {string} origin - null
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: dashboard > tpa upgrade click. src: 5 Evid: 23.


 * app_id - Type: guid.
 *
 * msid - Type: guid.
 *
 * origin - Type: string.
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {dashboardTpaUpgradeClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardTpaUpgradeClick = function (params) {
    return { evid: 23, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSelectorPopupShownParams
* @property {GUID} msid - site guid
* @property {string} name - popup name
* @property {string} platform - null
* @property {string} siteTypeName - ADI/Editor
**/
/**
 * Name: dashboard > site selector popup shown. src: 5 Evid: 81.
 * Event description: when a user selected an ADI site when his previous action is not suitable for ADI (add app etc... ).

 * msid - Type: guid. Desc: site guid
 *
 * name - Type: string. Desc: popup name
 *
 * platform - Type: string.
 *
 * siteTypeName - Type: string. Desc: ADI/Editor
 * @param {dashboardSiteSelectorPopupShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSelectorPopupShown = function (params) {
    return { evid: 81, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardMySitesSiteHomeAlertMessageFromPremiumClickParams
* @property {string} action - close (window), cancel , OK
* @property {string} alert_type - alert_message
* @property {string} hosting - hosting
* @property {string} platform - null
* @property {string} premium_alert_id - alert received from premium
**/
/**
 * Name: dashboard > My Sites/site-home - alert message from premium click. src: 5 Evid: 158.
 * Event description: when a user opens my-sites/site-home he receives a message based on notifications that transferred from premiums. This event collects data about what user choose.

 * action - Type: string. Desc: close (window), cancel , OK
 *
 * alert_type - Type: string. Desc: alert_message
 *
 * hosting - Type: string. Desc: hosting
 *
 * platform - Type: string.
 *
 * premium_alert_id - Type: string. Desc: alert received from premium
 * @param {dashboardMySitesSiteHomeAlertMessageFromPremiumClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardMySitesSiteHomeAlertMessageFromPremiumClick = function (params) {
    return { evid: 158, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesRecurringFilterInvoicesParams
* @property {string} filter_type - period, currency, display
* @property {string} msid - msid
* @property {string} name - name of filter
* @property {number} num_of_invoices - number of invoices the user has
* @property {string} origin_device - web,native
* @property {string} platform - null
**/
/**
 * Name: Invoices - recurring-  - Filter invoices. src: 5 Evid: 1577.
 * Event description: user filters the recurring invoices view.

 * filter_type - Type: string. Desc: period, currency, display
 *
 * msid - Type: string. Desc: msid
 *
 * name - Type: string. Desc: name of filter
 *
 * num_of_invoices - Type: numeric. Desc: number of invoices the user has
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string.
 * @param {invoicesRecurringFilterInvoicesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesRecurringFilterInvoices = function (params) {
    return { evid: 1577, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsDripCampaignsBannerCloseParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations > drip campaigns banner close. src: 5 Evid: 1121.
 * Event description: Automations > drip campaigns banner close.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsDripCampaignsBannerCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsDripCampaignsBannerClose = function (params) {
    return { evid: 1121, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} websiteCardPageFailedCommitParams
* @property {string} failReason - server,network,validation
* @property {GUID} msid - site
* @property {string} platform - null
**/
/**
 * Name: Website card page - Failed commit. src: 5 Evid: 8932.
 * Event description: when a user failed to complete load the card.

 * failReason - Type: string. Desc: server,network,validation
 *
 * msid - Type: guid. Desc: site
 *
 * platform - Type: string.
 * @param {websiteCardPageFailedCommitParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var websiteCardPageFailedCommit = function (params) {
    return { evid: 8932, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesWidgetSeeAllInvoicesParams
* @property {GUID} appDefId - appDefId of the source
* @property {GUID} externalId - An external id of an entity, relevant to the invoiceSource application
* @property {GUID} msid - msid
* @property {string} origin - ‘invoice preview’, ‘crm home widget/ ‘os-dashboard)
* @property {string} platform - null
**/
/**
 * Name: Invoices -  see all invoices. src: 5 Evid: 1326.
 * Event description: Invoices - widget - see all invoices.

 * appDefId - Type: guid. Desc: appDefId of the source
 *
 * externalId - Type: guid. Desc: An external id of an entity, relevant to the invoiceSource application
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: ‘invoice preview’, ‘crm home widget/ ‘os-dashboard)
 *
 * platform - Type: string.
 * @param {invoicesWidgetSeeAllInvoicesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesWidgetSeeAllInvoices = function (params) {
    return { evid: 1326, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsGoogleSheetsActivatingErrorParams
* @property {string} errorReason - errorReason
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations - google sheets - activating error. src: 5 Evid: 1603.
 * Event description: Automations - google sheets - match data to sheet - refresh data.

 * errorReason - Type: string. Desc: errorReason
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsGoogleSheetsActivatingErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsGoogleSheetsActivatingError = function (params) {
    return { evid: 1603, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoiceSettingsSaveButtonClickParams
* @property {GUID} msid - msid
* @property {string} origin - From which place it was saved: ‘Discard Modal’ , ‘Save button’
* @property {string} platform - mobile/web
**/
/**
 * Name: Invoice Settings- Save Button Click. src: 5 Evid: 8937.
 * Event description: In Invoices settings Save button click.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: From which place it was saved: ‘Discard Modal’ , ‘Save button’
 *
 * platform - Type: string. Desc: mobile/web
 * @param {invoiceSettingsSaveButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoiceSettingsSaveButtonClick = function (params) {
    return { evid: 8937, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsGoogleSheetsMatchDataToSheetRefreshDataParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations - google sheets - match data to sheet - refresh data. src: 5 Evid: 1529.
 * Event description: Automations - google sheets - match data to sheet - refresh data.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsGoogleSheetsMatchDataToSheetRefreshDataParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsGoogleSheetsMatchDataToSheetRefreshData = function (params) {
    return { evid: 1529, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsSendCouponLearnMoreParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations - send coupon - learn more. src: 5 Evid: 1612.
 * Event description: Automations - send coupon - learn more.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsSendCouponLearnMoreParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsSendCouponLearnMore = function (params) {
    return { evid: 1612, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerBusinessInfoMergeDialogCloseParams
* @property {string} hosting - MA/editor/ADI
* @property {string} merged_apps - merged app def id, use delimiter "," between each app_id
* @property {GUID} msid - metasite id
* @property {string} platform - null
**/
/**
 * Name: Biz Manager - Business Info Merge Dialog - Close. src: 5 Evid: 587.
 * Event description: This dialog will alert the user about the change to his settings.
It will be displayed only in case of a conflict (my account and other verticals) in the merge process. This event represents closing the dialog.

 * hosting - Type: string. Desc: MA/editor/ADI
 *
 * merged_apps - Type: string. Desc: merged app def id, use delimiter "," between each app_id
 *
 * msid - Type: guid. Desc: metasite id
 *
 * platform - Type: string.
 * @param {bizManagerBusinessInfoMergeDialogCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerBusinessInfoMergeDialogClose = function (params) {
    return { evid: 587, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} analyticsHoverAKpiParams
* @property {string} hosting - MA/editor/ADI
* @property {number} kpi_location - 0-left 1-middle 2-right
* @property {string} kpi_name - kpi's name
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Analytics > hover a KPI. src: 5 Evid: 377.
 * Event description: Hover a KPI from Analytics Widget.

 * hosting - Type: string. Desc: MA/editor/ADI
 *
 * kpi_location - Type: numeric. Desc: 0-left 1-middle 2-right
 *
 * kpi_name - Type: string. Desc: kpi's name
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {analyticsHoverAKpiParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var analyticsHoverAKpi = function (params) {
    return { evid: 377, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} accountDialogClickItemParams
* @property {string} item_id - the page name the item leads to (e.g. account-settings)
* @property {number} item_index - item's index in the entire dialog (only for main display, index starts from 1, logout (or any side location)=0)
* @property {number} item_index_ex_separators - item's index in the entire dialog excluding separators (only for main display, index starts from 1, logout (or any side location)=0)
* @property {string} item_name - the display name in the dialog
* @property {string} items_displayed - items list including section separators as 'delimiter'
* @property {GUID} msid - only for dashboard dialog
* @property {string} origin - main-menu/sub-menu (e.g. languages)
* @property {string} page_view - my-sites /dashboard / account settings
* @property {string} platform - null
**/
/**
 * Name: Account Dialog > Click Item. src: 5 Evid: 296.
 * Event description: When a user/anonymous clicks on a dialog item in the account dialog.

 * item_id - Type: string. Desc: the page name the item leads to (e.g. account-settings)
 *
 * item_index - Type: numeric. Desc: item's index in the entire dialog (only for main display, index starts from 1, logout (or any side location)=0)
 *
 * item_index_ex_separators - Type: numeric. Desc: item's index in the entire dialog excluding separators (only for main display, index starts from 1, logout (or any side location)=0)
 *
 * item_name - Type: string. Desc: the display name in the dialog
 *
 * items_displayed - Type: string. Desc: items list including section separators as 'delimiter'
 *
 * msid - Type: guid. Desc: only for dashboard dialog
 *
 * origin - Type: string. Desc: main-menu/sub-menu (e.g. languages)
 *
 * page_view - Type: string. Desc: my-sites /dashboard / account settings
 *
 * platform - Type: string.
 * @param {accountDialogClickItemParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accountDialogClickItem = function (params) {
    return { evid: 296, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardClickOnSelectPremiumPlanParams
* @property {GUID} msid - null
* @property {string} platform - null
* @property {string} referral_info - null
* @property {number} src - null
**/
/**
 * Name: dashboard > click on select premium plan. src: 5 Evid: 51.


 * msid - Type: guid.
 *
 * platform - Type: string.
 *
 * referral_info - Type: string.
 *
 * src - Type: numeric.
 * @param {dashboardClickOnSelectPremiumPlanParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardClickOnSelectPremiumPlan = function (params) {
    return { evid: 51, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardMySitesWelcomeMessageForProsDisplayedParams
* @property {string} platform - null
**/
/**
 * Name: dashboard > My Sites - welcome message for pros displayed. src: 5 Evid: 154.
 * Event description: welcome message of pro account is displayed.

 * platform - Type: string.
 * @param {dashboardMySitesWelcomeMessageForProsDisplayedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardMySitesWelcomeMessageForProsDisplayed = function (params) {
    return { evid: 154, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesVoidPageCancelParams
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} origin_device - web,native
* @property {string} platform - null
**/
/**
 * Name: Quotes - Void page - Cancel. src: 5 Evid: 429.
 * Event description: cancel in Void page (for every close (cancel, x, background click)).

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string.
 * @param {quotesVoidPageCancelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesVoidPageCancel = function (params) {
    return { evid: 429, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesRecurringErrorMessageForInvoiceAmountLowerThenPremiumParams
* @property {string} errorReason - reason of error
* @property {string} msid - msid
* @property {string} platform - null
* @property {GUID} uuid - uuid
**/
/**
 * Name: Invoices - recurring - Error message for invoice. src: 5 Evid: 1635.
 * Event description: When a partner try to send an recurring invoice contains premium plan, and the amount of the invoice is lower the premium plan price.

 * errorReason - Type: string. Desc: reason of error
 *
 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 * @param {invoicesRecurringErrorMessageForInvoiceAmountLowerThenPremiumParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesRecurringErrorMessageForInvoiceAmountLowerThenPremium = function (params) {
    return { evid: 1635, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} analyticsClickOnButtonFromCustomizationListParams
* @property {string} hosting - MA/editor/ADI
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} selected_kpis - the chosen kpis in the following way -> kpi: location: (json)
**/
/**
 * Name: Analytics > Click on button from customization list. src: 5 Evid: 375.
 * Event description: Click on apply button from customization list.

 * hosting - Type: string. Desc: MA/editor/ADI
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * selected_kpis - Type: string. Desc: the chosen kpis in the following way -> kpi: location: (json)
 * @param {analyticsClickOnButtonFromCustomizationListParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var analyticsClickOnButtonFromCustomizationList = function (params) {
    return { evid: 375, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} homeClickOnCreateAnythingItemParams
* @property {string} add_app_id - add_app_id
* @property {GUID} app_id - deprecated
* @property {GUID} msid - -
* @property {string} name - item name
* @property {string} page_view - from where the users opened the dialog
* @property {string} platform - null
* @property {string} view - dialog name
**/
/**
 * Name: Home > click on create anything item. src: 5 Evid: 307.
 * Event description: click on create anything item.

 * add_app_id - Type: string. Desc: add_app_id
 *
 * app_id - Type: guid. Desc: deprecated
 *
 * msid - Type: guid. Desc: -
 *
 * name - Type: string. Desc: item name
 *
 * page_view - Type: string. Desc: from where the users opened the dialog
 *
 * platform - Type: string.
 *
 * view - Type: string. Desc: dialog name
 * @param {homeClickOnCreateAnythingItemParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var homeClickOnCreateAnythingItem = function (params) {
    return { evid: 307, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSettingsDeleteValueParams
* @property {string} experience - user's experience
* @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
* @property {GUID} msid - msid
* @property {string} name - name of the field that was changed
* @property {string} origin - name of current tab
* @property {string} platform - null
* @property {number} src - null
* @property {string} value - delete/clear value
**/
/**
 * Name: dashboard > site settings > delete value. src: 5 Evid: 316.
 * Event description: user deleted/cleared a value from field.

 * experience - Type: string. Desc: user's experience
 *
 * hosting - Type: string. Desc: from where user arrived to sitesettings (Editor/MA/...)
 *
 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: name of the field that was changed
 *
 * origin - Type: string. Desc: name of current tab
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 *
 * value - Type: string. Desc: delete/clear value
 * @param {dashboardSiteSettingsDeleteValueParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSettingsDeleteValue = function (params) {
    return { evid: 316, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSettingsChangeValueParams
* @property {string} create_method - save(pop-up),create new
* @property {string} experience - user's experience
* @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
* @property {GUID} msid - msid
* @property {string} name - name of the field that was changed
* @property {string} origin - name of current tab
* @property {string} platform - null
* @property {number} src - null
* @property {string} value - field's value
**/
/**
 * Name: dashboard > site settings > change value. src: 5 Evid: 312.
 * Event description: user changed a value in the site settings.

 * create_method - Type: string. Desc: save(pop-up),create new
 *
 * experience - Type: string. Desc: user's experience
 *
 * hosting - Type: string. Desc: from where user arrived to sitesettings (Editor/MA/...)
 *
 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: name of the field that was changed
 *
 * origin - Type: string. Desc: name of current tab
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 *
 * value - Type: string. Desc: field's value
 * @param {dashboardSiteSettingsChangeValueParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSettingsChangeValue = function (params) {
    return { evid: 312, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} clickOnSeeMoreButtonParams
* @property {GUID} msid - msid
* @property {string} origin - settings lobby / bizmgr
* @property {string} platform - null
* @property {string} query - query
* @property {string} result - send all results who return on time in the following way -> section: number of results: time to load
* @property {string} section - result's section
* @property {number} section_index - the index of the section in results
* @property {string} sub_view - page in app
* @property {string} title - result's title
* @property {string} title_id - result's title id
* @property {string} view - requested view
**/
/**
 * Name: Click on expand results button. src: 5 Evid: 167.
 * Event description: When a user clicks on expand results button.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: settings lobby / bizmgr
 *
 * platform - Type: string.
 *
 * query - Type: string. Desc: query
 *
 * result - Type: string. Desc: send all results who return on time in the following way -> section: number of results: time to load
 *
 * section - Type: string. Desc: result's section
 *
 * section_index - Type: numeric. Desc: the index of the section in results
 *
 * sub_view - Type: string. Desc: page in app
 *
 * title - Type: string. Desc: result's title
 *
 * title_id - Type: string. Desc: result's title id
 *
 * view - Type: string. Desc: requested view
 * @param {clickOnSeeMoreButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickOnSeeMoreButton = function (params) {
    return { evid: 167, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmDiscoverCrmToolsParams
* @property {GUID} msid - msid
* @property {string} pageView - which page clicked this link
* @property {string} platform - null
**/
/**
 * Name: CRM - Discover CRM Tools. src: 5 Evid: 1333.
 * Event description: CRM - Discover CRM Tools.

 * msid - Type: guid. Desc: msid
 *
 * pageView - Type: string. Desc: which page clicked this link
 *
 * platform - Type: string.
 * @param {crmDiscoverCrmToolsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmDiscoverCrmTools = function (params) {
    return { evid: 1333, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesRecurringSelectABillingCycleParams
* @property {string} msid - msid
* @property {string} platform - null
* @property {string} value - selected value of billing cycle
**/
/**
 * Name: Invoices - recurring - select a billing cycle. src: 5 Evid: 1566.
 * Event description: Quotes - recurring - select a billing cycle.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 *
 * value - Type: string. Desc: selected value of billing cycle
 * @param {invoicesRecurringSelectABillingCycleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesRecurringSelectABillingCycle = function (params) {
    return { evid: 1566, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} ssoSettingsIsMandatoryToggleStatusParams
* @property {string} platform - null
* @property {GUID} sso_id - null
* @property {string} status - null
**/
/**
 * Name: SSO Settings - Is Mandatory Toggle Status. src: 5 Evid: 1685.


 * platform - Type: string.
 *
 * sso_id - Type: guid.
 *
 * status - Type: string.
 * @param {ssoSettingsIsMandatoryToggleStatusParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ssoSettingsIsMandatoryToggleStatus = function (params) {
    return { evid: 1685, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} foldersMarkUnmarkSelectAllButtonParams
* @property {string} hosting - MA
* @property {string} name - mark/unmark
* @property {string} platform - null
* @property {string} sub_view - grid/ list-view
* @property {string} view - my-sites
**/
/**
 * Name: Folders > Mark/Unmark 'Select All' button. src: 5 Evid: 116.
 * Event description: mark/unmark 'select all' button.

 * hosting - Type: string. Desc: MA
 *
 * name - Type: string. Desc: mark/unmark
 *
 * platform - Type: string.
 *
 * sub_view - Type: string. Desc: grid/ list-view
 *
 * view - Type: string. Desc: my-sites
 * @param {foldersMarkUnmarkSelectAllButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var foldersMarkUnmarkSelectAllButton = function (params) {
    return { evid: 116, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} customerNotificationsSettingsClickOnHideUnhideParams
* @property {GUID} msid - msid
* @property {string} origin - from where the hide/unhide happened
* @property {string} platform - null
* @property {string} section_name - component name: notifications_channel/more_notifications/automated_emails you created/system_notifications
* @property {boolean} status - true - click on unhide , false - click on hide
* @property {string} template_id - null
**/
/**
 * Name: customer notifications settings > click on hide/unhide. src: 5 Evid: 1251.
 * Event description: When the user clicks on "hide/unhide" in each section in the page.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: from where the hide/unhide happened
 *
 * platform - Type: string.
 *
 * section_name - Type: string. Desc: component name: notifications_channel/more_notifications/automated_emails you created/system_notifications
 *
 * status - Type: bool. Desc: true - click on unhide , false - click on hide
 *
 * template_id - Type: string.
 * @param {customerNotificationsSettingsClickOnHideUnhideParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var customerNotificationsSettingsClickOnHideUnhide = function (params) {
    return { evid: 1251, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSelectorStartLoadingParams
* @property {Url} action_url - action_url
* @property {string} device - mobile / desktop
* @property {string} filtered - premium/published/adi / none
* @property {Url} page_url - page url
* @property {string} platform - null
* @property {Url} referral - from where the screen was open
* @property {string} selectionType - single / multi
* @property {number} site_type_enriched - site_type
* @property {string} status - no thumbnails / empty state / success
* @property {string} siteType - htmlWeb / modal
* @property {string} version_experienced - which experience the user is getting in Site Selector (old/new)
**/
/**
 * Name: dashboard > site selector start loading. src: 5 Evid: 1596.
 * Event description: send when site selector start loading.

 * action_url - Type: url. Desc: action_url
 *
 * device - Type: string. Desc: mobile / desktop
 *
 * filtered - Type: string. Desc: premium/published/adi / none
 *
 * page_url - Type: url. Desc: page url
 *
 * platform - Type: string.
 *
 * referral - Type: url. Desc: from where the screen was open
 *
 * selectionType - Type: string. Desc: single / multi
 *
 * site_type_enriched - Type: numeric. Desc: site_type
 *
 * status - Type: string. Desc: no thumbnails / empty state / success
 *
 * siteType - Type: string. Desc: htmlWeb / modal
 *
 * version_experienced - Type: string. Desc: which experience the user is getting in Site Selector (old/new)
 * @param {dashboardSiteSelectorStartLoadingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSelectorStartLoading = function (params) {
    return { evid: 1596, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} app2faSetupDisableConfirmParams
* @property {string} platform - null
**/
/**
 * Name: App 2FA Setup - Disable Confirm. src: 5 Evid: 1743.
 * Event description: The user clicks on disable in the disable modal, to confirm the action.

 * platform - Type: string.
 * @param {app2faSetupDisableConfirmParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var app2faSetupDisableConfirm = function (params) {
    return { evid: 1743, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeTasksWidgetAddNewTaskParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: CRM Home - Tasks widget - add new task. src: 5 Evid: 822.
 * Event description: CRM Home - Tasks widget - add new task.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {crmHomeTasksWidgetAddNewTaskParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeTasksWidgetAddNewTask = function (params) {
    return { evid: 822, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsChooseSpecificServiceFromTriggerClickParams
* @property {string} conditionKeys - conditionKey
* @property {number} inputLevel - how many dropdowns parents
* @property {string} inputName - the key name of the dropdown
* @property {string} inputType - multiselect / single select / number
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} selectedOption - selectedOption
* @property {string} triggerApp - trigger vertical / app / TPA
* @property {string} triggerName - triggerName
* @property {string} value - null
**/
/**
 * Name: Automations  - Trigger -  user click on option in the condition dropdown. src: 5 Evid: 1515.
 * Event description: Automations - choose specific condition options.

 * conditionKeys - Type: string. Desc: conditionKey
 *
 * inputLevel - Type: numeric. Desc: how many dropdowns parents
 *
 * inputName - Type: string. Desc: the key name of the dropdown
 *
 * inputType - Type: string. Desc: multiselect / single select / number
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * selectedOption - Type: string. Desc: selectedOption
 *
 * triggerApp - Type: string. Desc: trigger vertical / app / TPA
 *
 * triggerName - Type: string. Desc: triggerName
 *
 * value - Type: string.
 * @param {automationsChooseSpecificServiceFromTriggerClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsChooseSpecificServiceFromTriggerClick = function (params) {
    return { evid: 1515, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSettingsOverviewUnpublishSiteParams
* @property {string} experience - user's experience
* @property {string} hosting - from where user arrived to sitesettings (Editor/MA/...)
* @property {GUID} msid - msid
* @property {string} name - name of the field that was changed
* @property {string} origin - name of current tab
* @property {string} platform - null
**/
/**
 * Name: dashboard > site settings > overview > unpublish site. src: 5 Evid: 326.
 * Event description: User choose to unpublish site in pop up window.

 * experience - Type: string. Desc: user's experience
 *
 * hosting - Type: string. Desc: from where user arrived to sitesettings (Editor/MA/...)
 *
 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: name of the field that was changed
 *
 * origin - Type: string. Desc: name of current tab
 *
 * platform - Type: string.
 * @param {dashboardSiteSettingsOverviewUnpublishSiteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSettingsOverviewUnpublishSite = function (params) {
    return { evid: 326, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesDuplicateInvoiceParams
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Quotes - Duplicate Invoice. src: 5 Evid: 399.
 * Event description: Quotes - Duplicate Invoice.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {quotesDuplicateInvoiceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesDuplicateInvoice = function (params) {
    return { evid: 399, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeSeeAllContactsViaContactsWidgetParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: CRM Home - see all contacts via contacts widget. src: 5 Evid: 820.
 * Event description: CRM Home - see all contacts via contacts widget.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {crmHomeSeeAllContactsViaContactsWidgetParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeSeeAllContactsViaContactsWidget = function (params) {
    return { evid: 820, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardClickInSiteSelectorParams
* @property {string} item_name - item clicked: all-sites/create-new-site
* @property {GUID} msid - metasite id
* @property {string} page_view - my-sites /dashboard / account settings
* @property {string} platform - null
**/
/**
 * Name: Dashboard > Click in Site  dropdown. src: 5 Evid: 1381.
 * Event description: When the user clicks on “create new site” OR “all sites” in the site  dropdown in the header.

 * item_name - Type: string. Desc: item clicked: all-sites/create-new-site
 *
 * msid - Type: guid. Desc: metasite id
 *
 * page_view - Type: string. Desc: my-sites /dashboard / account settings
 *
 * platform - Type: string.
 * @param {dashboardClickInSiteSelectorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardClickInSiteSelector = function (params) {
    return { evid: 1381, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesRecurringClickOnLearnMoreAboutAutomaticChargingParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Invoices - recurring - click on Learn More about automatic charging. src: 5 Evid: 1576.
 * Event description: Invoices - recurring - click on Learn More about automatic charging.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {invoicesRecurringClickOnLearnMoreAboutAutomaticChargingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesRecurringClickOnLearnMoreAboutAutomaticCharging = function (params) {
    return { evid: 1576, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} teamManagementEditRoleUpdateClickParams
* @property {boolean} is_accepted - true if invite was accepted
* @property {string} new_role - new role
* @property {string} origin - where the dialog is opened from
* @property {string} platform - null
* @property {string} prev_role - previous role
* @property {string} roles_displayed - list of roles displayed to the user
**/
/**
 * Name: Team Management - edit role - update click. src: 5 Evid: 184.
 * Event description: When the user clicks on 'update' in the edit role window - success response.

 * is_accepted - Type: bool. Desc: true if invite was accepted
 *
 * new_role - Type: string. Desc: new role
 *
 * origin - Type: string. Desc: where the dialog is opened from
 *
 * platform - Type: string.
 *
 * prev_role - Type: string. Desc: previous role
 *
 * roles_displayed - Type: string. Desc: list of roles displayed to the user
 * @param {teamManagementEditRoleUpdateClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teamManagementEditRoleUpdateClick = function (params) {
    return { evid: 184, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationAnAutomationErrorMessageIsDisplayedParams
* @property {string} status - 'active’ / ‘suspended’
* @property {string} errorType - which error the user see
* @property {GUID} msid - msid
* @property {string} origin - origin which this action was made
* @property {string} platform - null
* @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
**/
/**
 * Name: Automation > an automation error message is displayed. src: 5 Evid: 2012.
 * Event description: an automation error message is displayed (example: automation disconnect, on hold etc.).

 * status - Type: string. Desc: 'active’ / ‘suspended’
 *
 * errorType - Type: string. Desc: which error the user see
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin which this action was made
 *
 * platform - Type: string.
 *
 * rule_id - Type: guid. Desc: if this trigger all ready customized, null if it first time customization
 * @param {automationAnAutomationErrorMessageIsDisplayedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationAnAutomationErrorMessageIsDisplayed = function (params) {
    return { evid: 2012, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} downloadModalClickParams
* @property {string} action - send_link/learn_how/close
* @property {string} hosting - Dashboard/editor/ADI
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: download modal click. src: 5 Evid: 2005.
 * Event description: download modal click.

 * action - Type: string. Desc: send_link/learn_how/close
 *
 * hosting - Type: string. Desc: Dashboard/editor/ADI
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {downloadModalClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var downloadModalClick = function (params) {
    return { evid: 2005, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeCarouselClickParams
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {GUID} uuid - uuid
**/
/**
 * Name: CRM Home - carousel click. src: 5 Evid: 492.
 * Event description: CRM Home - carousel click.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 * @param {crmHomeCarouselClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeCarouselClick = function (params) {
    return { evid: 492, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoiceSettingsClickOnLinkParams
* @property {string} modal_name - modal name ( example: ‘Tax setting’s)
* @property {string} msid - msid
* @property {string} origin - tab name (example: ‘Invoice’)
* @property {string} platform - platform
* @property {string} value - value clicked ( example: ’General’)
**/
/**
 * Name: Invoice settings - click on link. src: 5 Evid: 8918.
 * Event description: When a user click on some strings/values which takes to another page.

 * modal_name - Type: string. Desc: modal name ( example: ‘Tax setting’s)
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: tab name (example: ‘Invoice’)
 *
 * platform - Type: string. Desc: platform
 *
 * value - Type: string. Desc: value clicked ( example: ’General’)
 * @param {invoiceSettingsClickOnLinkParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoiceSettingsClickOnLink = function (params) {
    return { evid: 8918, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} ascendPpClickOnNextInCyclePageParams
* @property {number} cycle_id - cycle id
* @property {string} cycle_name - cycle name
* @property {boolean} isChecked - is most popular
* @property {string} origin - product name open PP
* @property {GUID} packageId - packageid
* @property {string} package_name - package name
* @property {string} platform - null
* @property {string} referralInfo - button name open PP
* @property {number} timeInPage - in milisec
**/
/**
 * Name: Ascend PP - Click on next in cycle page. src: 5 Evid: 137.
 * Event description: User click on select in cycle page.

 * cycle_id - Type: numeric. Desc: cycle id
 *
 * cycle_name - Type: string. Desc: cycle name
 *
 * isChecked - Type: bool. Desc: is most popular
 *
 * origin - Type: string. Desc: product name open PP
 *
 * packageId - Type: guid. Desc: packageid
 *
 * package_name - Type: string. Desc: package name
 *
 * platform - Type: string.
 *
 * referralInfo - Type: string. Desc: button name open PP
 *
 * timeInPage - Type: numeric. Desc: in milisec
 * @param {ascendPpClickOnNextInCyclePageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ascendPpClickOnNextInCyclePage = function (params) {
    return { evid: 137, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} teamManagementDeleteTeamMemberOpenDialogParams
* @property {string} invite_status - pending/expired/leave team
* @property {GUID} member_id - the uuid of the deleted member (if status is pending then invite_id)
* @property {string} origin - where the user opened the dialog from
* @property {string} platform - null
* @property {string} role - the deleted user’s role
**/
/**
 * Name: Team Management - delete team member - open dialog. src: 5 Evid: 178.
 * Event description: When a user clicks on delete member.

 * invite_status - Type: string. Desc: pending/expired/leave team
 *
 * member_id - Type: guid. Desc: the uuid of the deleted member (if status is pending then invite_id)
 *
 * origin - Type: string. Desc: where the user opened the dialog from
 *
 * platform - Type: string.
 *
 * role - Type: string. Desc: the deleted user’s role
 * @param {teamManagementDeleteTeamMemberOpenDialogParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teamManagementDeleteTeamMemberOpenDialog = function (params) {
    return { evid: 178, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesExportReportClickParams
* @property {string} basis - accural, cash
* @property {string} file_type - csv,pdf,excel
* @property {string} msid - msid
* @property {string} name - tax, revenue
* @property {string} platform - null
**/
/**
 * Name: Quotes - export report click. src: 5 Evid: 453.
 * Event description: user clicks on export report in tax/revenue summary. use 'name'  to choose tax or revenue..

 * basis - Type: string. Desc: accural, cash
 *
 * file_type - Type: string. Desc: csv,pdf,excel
 *
 * msid - Type: string. Desc: msid
 *
 * name - Type: string. Desc: tax, revenue
 *
 * platform - Type: string.
 * @param {quotesExportReportClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesExportReportClick = function (params) {
    return { evid: 453, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} transferSiteCancelTransferAbortParams
* @property {string} hosting - MA /Editor
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Transfer site - cancel transfer - abort. src: 5 Evid: 62.
 * Event description: user clicks on "don't cancel transfer" or closes dialog with x.

 * hosting - Type: string. Desc: MA /Editor
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {transferSiteCancelTransferAbortParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var transferSiteCancelTransferAbort = function (params) {
    return { evid: 62, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsChooseTimePhaseToggleParams
* @property {boolean} boolValue - {true,false}
* @property {string} flowType - flow {create, edit}
* @property {GUID} msid - msid
* @property {string} name - {sendOncePerContact}
* @property {string} platform - null
* @property {string} recipe_name - recipe name
* @property {GUID} rule_id - the rule_id that the user started/edited
**/
/**
 * Name: Automations > Choose Time Phase > toggle. src: 5 Evid: 229.
 * Event description: change the "send one per contact" toggle.

 * boolValue - Type: bool. Desc: {true,false}
 *
 * flowType - Type: string. Desc: flow {create, edit}
 *
 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: {sendOncePerContact}
 *
 * platform - Type: string.
 *
 * recipe_name - Type: string. Desc: recipe name
 *
 * rule_id - Type: guid. Desc: the rule_id that the user started/edited
 * @param {automationsChooseTimePhaseToggleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsChooseTimePhaseToggle = function (params) {
    return { evid: 229, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} financialServicesSettingsInvoicesBusinessInfoEditThemParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Financial Services Settings - invoices - business info - edit them. src: 5 Evid: 1305.
 * Event description: Financial Services Settings - invoices - business info - edit them.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {financialServicesSettingsInvoicesBusinessInfoEditThemParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var financialServicesSettingsInvoicesBusinessInfoEditThem = function (params) {
    return { evid: 1305, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesOwnerappClickOnCreateNewInvoiceParams
* @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
* @property {string} msid - msid
* @property {string} origin - my invoices, edit invoice, widget
* @property {string} origin_device - web,native
* @property {string} paymentType - one time, recurring
* @property {string} platform - null
* @property {string} tabName - most recent / overdue
**/
/**
 * Name: Invoices - Ownerapp-  click on create new invoice. src: 5 Evid: 1592.
 * Event description: In invoices widget click on new invoice empty state.

 * invoiceType - Type: string. Desc: ’recurringAutoCharge’/ 'recurring'/ 'one time'
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: my invoices, edit invoice, widget
 *
 * origin_device - Type: string. Desc: web,native
 *
 * paymentType - Type: string. Desc: one time, recurring
 *
 * platform - Type: string.
 *
 * tabName - Type: string. Desc: most recent / overdue
 * @param {invoicesOwnerappClickOnCreateNewInvoiceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesOwnerappClickOnCreateNewInvoice = function (params) {
    return { evid: 1592, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardTriggersServerSaveOrUpdateTriggerSuccessParams
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} recipe_name - recipe_name
* @property {GUID} rule_id - rule
* @property {number} src - null
**/
/**
 * Name: Automations Server > save or update trigger success. src: 5 Evid: 220.
 * Event description: save or update trigger success from server.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * recipe_name - Type: string. Desc: recipe_name
 *
 * rule_id - Type: guid. Desc: rule
 *
 * src - Type: numeric.
 * @param {dashboardTriggersServerSaveOrUpdateTriggerSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardTriggersServerSaveOrUpdateTriggerSuccess = function (params) {
    return { evid: 220, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} removePhoneNumberRemoveClickedParams
* @property {string} platform - null
**/
/**
 * Name: Remove Phone Number - Remove Clicked. src: 5 Evid: 97.
 * Event description: verification pop up before deleting the phone.

 * platform - Type: string.
 * @param {removePhoneNumberRemoveClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var removePhoneNumberRemoveClicked = function (params) {
    return { evid: 97, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesRecurringClickOnConnectNowForAutoChargingParams
* @property {string} msid - msid
* @property {string} platform - null
* @property {string} source - hover / page
**/
/**
 * Name: Invoices - recurring - click on connect now for auto charging. src: 5 Evid: 1575.
 * Event description: Invoices - recurring - click on connect now for auto charging.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 *
 * source - Type: string. Desc: hover / page
 * @param {invoicesRecurringClickOnConnectNowForAutoChargingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesRecurringClickOnConnectNowForAutoCharging = function (params) {
    return { evid: 1575, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteCategoryShownParams
* @property {boolean} has_category - true/false
* @property {string} hosting - null
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} site_category - site category/null
**/
/**
 * Name: dashboard > Site Category Shown. src: 5 Evid: 1714.
 * Event description: When site category is shown..

 * has_category - Type: bool. Desc: true/false
 *
 * hosting - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * site_category - Type: string. Desc: site category/null
 * @param {dashboardSiteCategoryShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteCategoryShown = function (params) {
    return { evid: 1714, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesPreviewFromTableParams
* @property {GUID} appdefid - appDefId (application ID)
* @property {GUID} externalId - An external id of an entity, relevant to the invoiceSource application
* @property {GUID} invoice_id - invoice_guid
* @property {string} msid - msid
* @property {string} origin - origin page - from which place this action was made (invoices, contacts full page, crm home...)
* @property {string} platform - null
**/
/**
 * Name: Quotes - Preview from table. src: 5 Evid: 484.
 * Event description: Quotes - Preview from table.

 * appdefid - Type: guid. Desc: appDefId (application ID)
 *
 * externalId - Type: guid. Desc: An external id of an entity, relevant to the invoiceSource application
 *
 * invoice_id - Type: guid. Desc: invoice_guid
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: origin page - from which place this action was made (invoices, contacts full page, crm home...)
 *
 * platform - Type: string.
 * @param {quotesPreviewFromTableParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesPreviewFromTable = function (params) {
    return { evid: 484, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerUrgentMessagesClickedParams
* @property {string} asset_campaign_guid - ids to be consistent with premium events
* @property {string} asset_campaign_id - ids to be consistent with premium events
* @property {string} click_type - click/ close
* @property {string} hosting - ADI/MA/editor
* @property {GUID} msid - site guid
* @property {string} offering_guid - ids to be consistent with premium events
* @property {string} platform - null
**/
/**
 * Name: Biz Manager - urgent messages clicked. src: 5 Evid: 594.
 * Event description: urgent messages clicked.

 * asset_campaign_guid - Type: string. Desc: ids to be consistent with premium events
 *
 * asset_campaign_id - Type: string. Desc: ids to be consistent with premium events
 *
 * click_type - Type: string. Desc: click/ close
 *
 * hosting - Type: string. Desc: ADI/MA/editor
 *
 * msid - Type: guid. Desc: site guid
 *
 * offering_guid - Type: string. Desc: ids to be consistent with premium events
 *
 * platform - Type: string.
 * @param {bizManagerUrgentMessagesClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerUrgentMessagesClicked = function (params) {
    return { evid: 594, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} financialSettingsGoToInvoicesPriceQuotesParams
* @property {string} msid - null
* @property {string} platform - null
* @property {string} type - if it's price quotes or invoices
**/
/**
 * Name: financial settings - go to invoices/price quotes. src: 5 Evid: 1688.
 * Event description: financial settings - go to invoices/price quotes.

 * msid - Type: string.
 *
 * platform - Type: string.
 *
 * type - Type: string. Desc: if it's price quotes or invoices
 * @param {financialSettingsGoToInvoicesPriceQuotesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var financialSettingsGoToInvoicesPriceQuotes = function (params) {
    return { evid: 1688, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesCreateInvoiceAdditionalInfoFieldChangeParams
* @property {string} fieldName - notes  /legal terms
* @property {GUID} invoice_id - invoice guid
* @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
* @property {string} msid - msid
* @property {string} origin - create invoice, edit invoice
* @property {string} platform - platform
* @property {string} source - source
**/
/**
 * Name: Quotes - Create invoice - Additional Info - field change. src: 5 Evid: 1553.
 * Event description: Create invoice - user change notes or legal terms fields in the Additional Info section.

 * fieldName - Type: string. Desc: notes  /legal terms
 *
 * invoice_id - Type: guid. Desc: invoice guid
 *
 * invoiceType - Type: string. Desc: ’recurringAutoCharge’/ 'recurring'/ 'one time'
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: create invoice, edit invoice
 *
 * platform - Type: string. Desc: platform
 *
 * source - Type: string. Desc: source
 * @param {quotesCreateInvoiceAdditionalInfoFieldChangeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesCreateInvoiceAdditionalInfoFieldChange = function (params) {
    return { evid: 1553, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} app2faSetupClickOnBackParams
* @property {string} mode - change app/enable
* @property {string} platform - null
**/
/**
 * Name: App 2FA Setup - Click on Back. src: 5 Evid: 1747.
 * Event description: The user clicked on 'back' in the enter code step, when enabling app 2fa.

 * mode - Type: string. Desc: change app/enable
 *
 * platform - Type: string.
 * @param {app2faSetupClickOnBackParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var app2faSetupClickOnBack = function (params) {
    return { evid: 1747, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationHomePageClickOnTabInAutomationTableParams
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} previousTab - ‘all’ / ‘pre_installed’ / ‘created_by_you’
* @property {string} tabName - null
**/
/**
 * Name: Automation > home page - click on tab in automation table. src: 5 Evid: 1336.
 * Event description: Automation > home page - click on tab in automation table (all automations / pre installed / created by you).

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * previousTab - Type: string. Desc: ‘all’ / ‘pre_installed’ / ‘created_by_you’
 *
 * tabName - Type: string.
 * @param {automationHomePageClickOnTabInAutomationTableParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationHomePageClickOnTabInAutomationTable = function (params) {
    return { evid: 1336, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} searchFocusedOnASearchResultParams
* @property {boolean} is_first_hover - 1- first item that was hovered (without the default) , 0 - not the first
* @property {number} item_index - item's index in all results
* @property {number} item_index_in_section - the item's index in it's section
* @property {GUID} msid - msid
* @property {string} origin - settings lobby / bizmgr
* @property {string} platform - null
* @property {string} query - query
* @property {string} result - send all results who return on time in the following way -> section: number of results: time to load
* @property {string} section - result's section
* @property {number} section_index - the index of the section in results
* @property {string} sub_view - page in app
* @property {string} title - result's title
* @property {string} title_id - result's title id
* @property {string} view - requested view
**/
/**
 * Name: Search > Hover over result item. src: 5 Evid: 164.
 * Event description: when a user is focused on a result.

 * is_first_hover - Type: bool. Desc: 1- first item that was hovered (without the default) , 0 - not the first
 *
 * item_index - Type: numeric. Desc: item's index in all results
 *
 * item_index_in_section - Type: numeric. Desc: the item's index in it's section
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: settings lobby / bizmgr
 *
 * platform - Type: string.
 *
 * query - Type: string. Desc: query
 *
 * result - Type: string. Desc: send all results who return on time in the following way -> section: number of results: time to load
 *
 * section - Type: string. Desc: result's section
 *
 * section_index - Type: numeric. Desc: the index of the section in results
 *
 * sub_view - Type: string. Desc: page in app
 *
 * title - Type: string. Desc: result's title
 *
 * title_id - Type: string. Desc: result's title id
 *
 * view - Type: string. Desc: requested view
 * @param {searchFocusedOnASearchResultParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var searchFocusedOnASearchResult = function (params) {
    return { evid: 164, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeGoToMarketingToolsParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: CRM Home - go to marketing tools. src: 5 Evid: 1122.
 * Event description: CRM Home - go to marketing tools.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {crmHomeGoToMarketingToolsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeGoToMarketingTools = function (params) {
    return { evid: 1122, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardMySitesClickPromoteParams
* @property {GUID} msid - msid
* @property {string} origin - original page
* @property {string} place - place inside origin page
* @property {string} platform - null
**/
/**
 * Name: dashboard > My Sites - Click Promote. src: 5 Evid: 153.
 * Event description: my sites selection page.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: original page
 *
 * place - Type: string. Desc: place inside origin page
 *
 * platform - Type: string.
 * @param {dashboardMySitesClickPromoteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardMySitesClickPromote = function (params) {
    return { evid: 153, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsGiveFeedbackParams
* @property {GUID} msid - msid
* @property {string} origin - null
* @property {string} platform - null
**/
/**
 * Name: Automations > give feedback. src: 5 Evid: 1274.
 * Event description: the user click on 'clear search' button.

 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string.
 *
 * platform - Type: string.
 * @param {automationsGiveFeedbackParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsGiveFeedback = function (params) {
    return { evid: 1274, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} newReleasesApiRequestParams
* @property {GUID} announcement_id - announcement_id
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: New Releases - API request. src: 5 Evid: 338.
 * Event description: This event fires every time there is a new request from the API. It means that the dealer sent a new release update to a site.
The event is unique by announcement_id and metasite_id..

 * announcement_id - Type: guid. Desc: announcement_id
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {newReleasesApiRequestParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var newReleasesApiRequest = function (params) {
    return { evid: 338, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} exposureEventForPaginationTestParams
* @property {number} folders_number - the number of folders in the root (1st level)
* @property {boolean} is_pagination_user - True if the user has more than 50 folders in the root, false if less
* @property {string} platform - deprecated
**/
/**
 * Name: exposure event for pagination test. src: 5 Evid: 8906.
 * Event description: will be sent when users enter to my sites page, providing data about folders number.

 * folders_number - Type: numeric. Desc: the number of folders in the root (1st level)
 *
 * is_pagination_user - Type: bool. Desc: True if the user has more than 50 folders in the root, false if less
 *
 * platform - Type: string. Desc: deprecated
 * @param {exposureEventForPaginationTestParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var exposureEventForPaginationTest = function (params) {
    return { evid: 8906, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} financialServicesSettingsPriceQuotesBusinessDetailsGoToSiteSettingsParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Financial Services Settings - Price Quotes - business details - go to site settings. src: 5 Evid: 1311.
 * Event description: Financial Services Settings - Price Quotes - business details - go to site settings.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {financialServicesSettingsPriceQuotesBusinessDetailsGoToSiteSettingsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var financialServicesSettingsPriceQuotesBusinessDetailsGoToSiteSettings = function (params) {
    return { evid: 1311, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} notificationsDisplayPopupForUserBlockedDesktopNotificationsParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Notifications > display popup for user blocked desktop notifications. src: 5 Evid: 278.
 * Event description: When the user clicks the link, show a popup window telling the user they need to unblock notifications at their browser level..

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {notificationsDisplayPopupForUserBlockedDesktopNotificationsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var notificationsDisplayPopupForUserBlockedDesktopNotifications = function (params) {
    return { evid: 278, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardBannerClickParams
* @property {string} abTest - ab test group
* @property {string} bannerid - Banner id from dealer
* @property {string} bannerLocationOnPage - 'LIST_TOP' 'LIST_RIGHT' 'LIST_LEFT' ,the location of the banner
* @property {string} click_type - click/close
* @property {boolean} isPremium - is_premium
* @property {GUID} msid - null
* @property {string} name - null
* @property {string} origin - null
* @property {string} platform - null
* @property {number} src - null
* @property {string} targetUrl - the banner link url
**/
/**
 * Name: dashboard > banner click. src: 5 Evid: 14.


 * abTest - Type: string. Desc: ab test group
 *
 * bannerid - Type: string. Desc: Banner id from dealer
 *
 * bannerLocationOnPage - Type: string. Desc: 'LIST_TOP' 'LIST_RIGHT' 'LIST_LEFT' ,the location of the banner
 *
 * click_type - Type: string. Desc: click/close
 *
 * isPremium - Type: bool. Desc: is_premium
 *
 * msid - Type: guid.
 *
 * name - Type: string.
 *
 * origin - Type: string.
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 *
 * targetUrl - Type: string. Desc: the banner link url
 * @param {dashboardBannerClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardBannerClick = function (params) {
    return { evid: 14, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSeeBannerParams
* @property {string} abTest - ab test group
* @property {boolean} aboveTheFold - was the item full viewed above the fold
* @property {string} bannerid - Banner id from dealer
* @property {string} bannerLocationOnPage - 'LIST_TOP' 'LIST_RIGHT' 'LIST_LEFT' ,the location of the banner
* @property {boolean} isPremium - is_premium
* @property {GUID} msid - msid
* @property {string} name - name of the banner
* @property {string} origin - the page it displays in
* @property {string} platform - null
* @property {number} src - null
* @property {string} targetUrl - the banner link url
**/
/**
 * Name: dashboard > see banner. src: 5 Evid: 34.
 * Event description: send each time user see banner.

 * abTest - Type: string. Desc: ab test group
 *
 * aboveTheFold - Type: bool. Desc: was the item full viewed above the fold
 *
 * bannerid - Type: string. Desc: Banner id from dealer
 *
 * bannerLocationOnPage - Type: string. Desc: 'LIST_TOP' 'LIST_RIGHT' 'LIST_LEFT' ,the location of the banner
 *
 * isPremium - Type: bool. Desc: is_premium
 *
 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: name of the banner
 *
 * origin - Type: string. Desc: the page it displays in
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 *
 * targetUrl - Type: string. Desc: the banner link url
 * @param {dashboardSeeBannerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSeeBanner = function (params) {
    return { evid: 34, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerShowWarningMessageParams
* @property {string} fold_name - null
* @property {string} hosting - MA/editor
* @property {GUID} msid - msid
* @property {string} name - the name of the message (for example unsupported language message)
* @property {string} page_view - The page where the warning message is shown
* @property {string} platform - deprecated
* @property {string} unsupport_apps - null
* @property {string} unsupported_language - the chosen language
**/
/**
 * Name: Biz Manager - show warning message. src: 5 Evid: 1254.
 * Event description: warning message is shown.

 * fold_name - Type: string.
 *
 * hosting - Type: string. Desc: MA/editor
 *
 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: the name of the message (for example unsupported language message)
 *
 * page_view - Type: string. Desc: The page where the warning message is shown
 *
 * platform - Type: string. Desc: deprecated
 *
 * unsupport_apps - Type: string.
 *
 * unsupported_language - Type: string. Desc: the chosen language
 * @param {bizManagerShowWarningMessageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerShowWarningMessage = function (params) {
    return { evid: 1254, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeManageYourFinancesChooseParams
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} tabName - which tab the user choose
* @property {GUID} uuid - uuid
**/
/**
 * Name: CRM Home - manage your finances - choose. src: 5 Evid: 493.


 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * tabName - Type: string. Desc: which tab the user choose
 *
 * uuid - Type: guid. Desc: uuid
 * @param {crmHomeManageYourFinancesChooseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeManageYourFinancesChoose = function (params) {
    return { evid: 493, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} downloadModalParams
* @property {string} hosting - Dashboard/editor/ADI
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: download modal. src: 5 Evid: 2004.
 * Event description: whendownload modal shown.

 * hosting - Type: string. Desc: Dashboard/editor/ADI
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {downloadModalParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var downloadModal = function (params) {
    return { evid: 2004, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesNonValidPaypalAccountPopupParams
* @property {string} msid - msid
* @property {string} name - name of payment
* @property {string} origin - how user arrived to the flow
* @property {string} platform - null
**/
/**
 * Name: Quotes - Non valid Paypal account popup. src: 5 Evid: 443.
 * Event description: when a user has an old / non business paypal account and connection to paypal is not possible.

 * msid - Type: string. Desc: msid
 *
 * name - Type: string. Desc: name of payment
 *
 * origin - Type: string. Desc: how user arrived to the flow
 *
 * platform - Type: string.
 * @param {quotesNonValidPaypalAccountPopupParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesNonValidPaypalAccountPopup = function (params) {
    return { evid: 443, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} rolesLoginPageLoadStartParams
* @property {string} invite_email - invited email
* @property {string} invite_id - invite_id
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: Roles - login page load start. src: 5 Evid: 356.
 * Event description: before login component is loaded - page load start.

 * invite_email - Type: string. Desc: invited email
 *
 * invite_id - Type: string. Desc: invite_id
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {rolesLoginPageLoadStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var rolesLoginPageLoadStart = function (params) {
    return { evid: 356, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesBulkActionsPrintParams
* @property {string} filter - type of filter
* @property {string} msid - msid
* @property {string} number - number of invoices choose or all
* @property {string} platform - null
**/
/**
 * Name: Quotes - bulk actions - Print. src: 5 Evid: 348.
 * Event description: Quotes - Create invoice - Toggle Recurring.

 * filter - Type: string. Desc: type of filter
 *
 * msid - Type: string. Desc: msid
 *
 * number - Type: string. Desc: number of invoices choose or all
 *
 * platform - Type: string.
 * @param {quotesBulkActionsPrintParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesBulkActionsPrint = function (params) {
    return { evid: 348, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesSettingsNewTaxClickParams
* @property {GUID} invoice_id - invoice guid
* @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
* @property {string} msid - msid
* @property {string} origin - settings , create invoice, empty experience
* @property {string} platform - null
* @property {string} source - source
**/
/**
 * Name: Quotes - Settings - New tax click. src: 5 Evid: 433.
 * Event description: Settings - New tax click.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * invoiceType - Type: string. Desc: ’recurringAutoCharge’/ 'recurring'/ 'one time'
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: settings , create invoice, empty experience
 *
 * platform - Type: string.
 *
 * source - Type: string. Desc: source
 * @param {quotesSettingsNewTaxClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesSettingsNewTaxClick = function (params) {
    return { evid: 433, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardTriggersLearnMoreClickParams
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: Automations > Learn More Click. src: 5 Evid: 218.
 * Event description: Learn More Click.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {dashboardTriggersLearnMoreClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardTriggersLearnMoreClick = function (params) {
    return { evid: 218, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} apesVersioningPreviewNewEmailParams
* @property {boolean} isPreinstalled - if the automation is pre installed
* @property {GUID} msid - msid
* @property {string} origin - app id
* @property {string} pingTemplateId - pingTemplateId
* @property {string} platform - null
* @property {GUID} ruleId - ruleId
**/
/**
 * Name: APeS - versioning - preview new email. src: 5 Evid: 1702.
 * Event description: APeS - versioning - preview new email.

 * isPreinstalled - Type: bool. Desc: if the automation is pre installed
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: app id
 *
 * pingTemplateId - Type: string. Desc: pingTemplateId
 *
 * platform - Type: string.
 *
 * ruleId - Type: guid. Desc: ruleId
 * @param {apesVersioningPreviewNewEmailParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var apesVersioningPreviewNewEmail = function (params) {
    return { evid: 1702, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} accountSettingsCloseYourWixAccountCloseAccountRequestSubmitedParams
* @property {string} free_text - users feedback
* @property {string} platform - null
* @property {string} reason - why are you closing the account
* @property {GUID} uuid - user id
**/
/**
 * Name: Account Settings > Close your WIX account - close account request summited. src: 5 Evid: 1279.
 * Event description: the user clicks on the "close my account" button

https://docs.google.com/presentation/d/1toummTuN1-7cxFR3TgbGMi5F5UR-vYntZHpCRfYhkOo/edit#slide=id.gaa2182f012_3_18.

 * free_text - Type: string. Desc: users feedback
 *
 * platform - Type: string.
 *
 * reason - Type: string. Desc: why are you closing the account
 *
 * uuid - Type: guid. Desc: user id
 * @param {accountSettingsCloseYourWixAccountCloseAccountRequestSubmitedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accountSettingsCloseYourWixAccountCloseAccountRequestSubmited = function (params) {
    return { evid: 1279, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} headerFullyLoadedParams
* @property {boolean} is_partner - null
* @property {GUID} msid - in account level/my-sites send null
* @property {string} page_view - name of the page - my-sites/bizmgr/account manager/partner dashboard
* @property {string} platform - platform
**/
/**
 * Name: Header Fully Loaded. src: 5 Evid: 1467.
 * Event description: when the header is fully loaded in my-sites/bizmgr/account manager/partner dashboard the event is sent.

 * is_partner - Type: bool.
 *
 * msid - Type: guid. Desc: in account level/my-sites send null
 *
 * page_view - Type: string. Desc: name of the page - my-sites/bizmgr/account manager/partner dashboard
 *
 * platform - Type: string. Desc: platform
 * @param {headerFullyLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var headerFullyLoaded = function (params) {
    return { evid: 1467, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesChooseIssueDateParams
* @property {string} invoiceType - null
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Quotes - choose issue date. src: 5 Evid: 386.
 * Event description: Quotes - choose issue date.

 * invoiceType - Type: string.
 *
 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {quotesChooseIssueDateParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesChooseIssueDate = function (params) {
    return { evid: 386, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} apesSaveEditedNotification1234Params
* @property {string} componentChanged - which component was changed
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {GUID} rule_id - rule id
**/
/**
 * Name: APeS - Save edited notification. src: 5 Evid: 1234.
 * Event description: APeS - Save edited notification.

 * componentChanged - Type: string. Desc: which component was changed
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * rule_id - Type: guid. Desc: rule id
 * @param {apesSaveEditedNotification1234Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var apesSaveEditedNotification1234 = function (params) {
    return { evid: 1234, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesWidgetResendViaEmailParams
* @property {GUID} contactId - contact id
* @property {GUID} invoiceId - invoice id
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Invoices - widget - resend via email. src: 5 Evid: 1322.
 * Event description: Invoices - widget - resend via email.

 * contactId - Type: guid. Desc: contact id
 *
 * invoiceId - Type: guid. Desc: invoice id
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {invoicesWidgetResendViaEmailParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesWidgetResendViaEmail = function (params) {
    return { evid: 1322, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} teamManagementAddMembersInviteClickFailParams
* @property {string} error_desc - error description
* @property {string} invite_role - (please note that using the toggle changes role desc) the role the user sends to the invitees
* @property {string} origin - where the dialog was opened
* @property {string} platform - null
**/
/**
 * Name: Team Management - add members - invite click fail. src: 5 Evid: 177.
 * Event description: When a user clicks on 'send invites' in the add member window - fail response.

 * error_desc - Type: string. Desc: error description
 *
 * invite_role - Type: string. Desc: (please note that using the toggle changes role desc) the role the user sends to the invitees
 *
 * origin - Type: string. Desc: where the dialog was opened
 *
 * platform - Type: string.
 * @param {teamManagementAddMembersInviteClickFailParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teamManagementAddMembersInviteClickFail = function (params) {
    return { evid: 177, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeImportContactsViaContactsBannerParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: CRM Home - import contacts via contacts banner. src: 5 Evid: 821.
 * Event description: CRM Home - import contacts via contacts banner.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {crmHomeImportContactsViaContactsBannerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeImportContactsViaContactsBanner = function (params) {
    return { evid: 821, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} analyticsChangeKpisTimePeriodParams
* @property {string} app_id - app id of the vertical that displays the widget.
* @property {string} hosting - MA/Editor
* @property {string} kpi_period - the kpis period chosen for all seen kpis when the kpi is shown
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: analytics > change kpis time period. src: 5 Evid: 376.
 * Event description: When a user chooses to change the time period of the kpis shown to him in analytics widget (the click that actually changes the period - not the period selection menu).

 * app_id - Type: string. Desc: app id of the vertical that displays the widget.
 *
 * hosting - Type: string. Desc: MA/Editor
 *
 * kpi_period - Type: string. Desc: the kpis period chosen for all seen kpis when the kpi is shown
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {analyticsChangeKpisTimePeriodParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var analyticsChangeKpisTimePeriod = function (params) {
    return { evid: 376, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesCreateInvoiceSendInvoiceModalFieldChangeParams
* @property {string} fieldName - subject line /message
* @property {GUID} invoice_id - invoice guid
* @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
* @property {string} msid - msid
* @property {string} origin - create invoice, edit invoice
* @property {string} platform - platform
* @property {string} source - source
**/
/**
 * Name: Quotes - Create invoice - Send invoice modal- field change. src: 5 Evid: 1552.
 * Event description: Create invoice - user change message or subject line in the send invoice final modal.

 * fieldName - Type: string. Desc: subject line /message
 *
 * invoice_id - Type: guid. Desc: invoice guid
 *
 * invoiceType - Type: string. Desc: ’recurringAutoCharge’/ 'recurring'/ 'one time'
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: create invoice, edit invoice
 *
 * platform - Type: string. Desc: platform
 *
 * source - Type: string. Desc: source
 * @param {quotesCreateInvoiceSendInvoiceModalFieldChangeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesCreateInvoiceSendInvoiceModalFieldChange = function (params) {
    return { evid: 1552, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} clickingOnQuickActionButtonThreeDotsParams
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} origin - origin page ( Invoices Dashboard, Recurring Invoices,Pricing Quotes, Invoice Interface
* @property {string} platform - OneApp/ Web
**/
/**
 * Name: Clicking on quick action button (three dots). src: 5 Evid: 2001.
 * Event description: Clicking on three dots for more actions.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: origin page ( Invoices Dashboard, Recurring Invoices,Pricing Quotes, Invoice Interface
 *
 * platform - Type: string. Desc: OneApp/ Web
 * @param {clickingOnQuickActionButtonThreeDotsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickingOnQuickActionButtonThreeDots = function (params) {
    return { evid: 2001, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} wixInvoicesBannerToUpgradeToPremiumClickParams
* @property {GUID} msid - msid
* @property {string} name - upgrade to business premium
* @property {string} origin - banner, modal which shows when clicking on ( Send via email, Send in Invoice Form, Share link, Charge with Credit card)
* @property {string} origin_device - web,native
* @property {string} platform - platform
**/
/**
 * Name: Wix Invoices- Banner to upgrade to Premium click. src: 5 Evid: 8967.
 * Event description: Banner to upgrade to Premium click.

 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: upgrade to business premium
 *
 * origin - Type: string. Desc: banner, modal which shows when clicking on ( Send via email, Send in Invoice Form, Share link, Charge with Credit card)
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string. Desc: platform
 * @param {wixInvoicesBannerToUpgradeToPremiumClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var wixInvoicesBannerToUpgradeToPremiumClick = function (params) {
    return { evid: 8967, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesCreateOrderNewInvoiceClickParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Invoices - create order - new invoice click. src: 5 Evid: 1213.
 * Event description: Invoices - Add a product Variant - add to invoice.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {invoicesCreateOrderNewInvoiceClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesCreateOrderNewInvoiceClick = function (params) {
    return { evid: 1213, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsBannerActivateParams
* @property {string} banner_name - banner_name
* @property {GUID} msid - msid
* @property {string} offerId - Dealer Offer id
* @property {string} platform - null
* @property {string} recipe_id - recipe_id
**/
/**
 * Name: Automations > User click on banner. src: 5 Evid: 145.
 * Event description: Automations > User click on banner CTA (only recipes).

 * banner_name - Type: string. Desc: banner_name
 *
 * msid - Type: guid. Desc: msid
 *
 * offerId - Type: string. Desc: Dealer Offer id
 *
 * platform - Type: string.
 *
 * recipe_id - Type: string. Desc: recipe_id
 * @param {automationsBannerActivateParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsBannerActivate = function (params) {
    return { evid: 145, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardTriggersGetTheAppClickParams
* @property {GUID} app_id - app_id
* @property {GUID} msid - msid
* @property {string} origin - origin page
* @property {string} platform - null
* @property {string} recipe_name - recipe name
* @property {number} src - null
**/
/**
 * Name: Automations > get the app click. src: 5 Evid: 202.
 * Event description: get the app click.

 * app_id - Type: guid. Desc: app_id
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin page
 *
 * platform - Type: string.
 *
 * recipe_name - Type: string. Desc: recipe name
 *
 * src - Type: numeric.
 * @param {dashboardTriggersGetTheAppClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardTriggersGetTheAppClick = function (params) {
    return { evid: 202, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerOpenPanelInteractiveParams
* @property {string} hosting - MA/editor
* @property {number} loading_time - time from start opening the panel till interactive
* @property {GUID} msid - msid
* @property {string} panel_name - the panel that was opened
* @property {string} platform - null
* @property {string} sub_view - page in app
* @property {string} view - requested view
**/
/**
 * Name: Biz Manager > Open panel - interactive. src: 5 Evid: 657.
 * Event description: panel is interactive.

 * hosting - Type: string. Desc: MA/editor
 *
 * loading_time - Type: numeric. Desc: time from start opening the panel till interactive
 *
 * msid - Type: guid. Desc: msid
 *
 * panel_name - Type: string. Desc: the panel that was opened
 *
 * platform - Type: string.
 *
 * sub_view - Type: string. Desc: page in app
 *
 * view - Type: string. Desc: requested view
 * @param {bizManagerOpenPanelInteractiveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerOpenPanelInteractive = function (params) {
    return { evid: 657, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} verticalsEmailNotificationSent1270Params
* @property {string} channel - email
* @property {string} contact_id - If the email has been sent to member/contact
* @property {GUID} msid - msid
* @property {GUID} notificationId - Notification ID
* @property {string} platform - null
* @property {string} template_id - Descriptive name for the type of email. e.g. Identity.Member_Approved
**/
/**
 * Name: Verticals -> email notification -> Sent. src: 5 Evid: 1270.
 * Event description: When A vertical send an email notification which doesn't go via Ping!.

 * channel - Type: string. Desc: email
 *
 * contact_id - Type: string. Desc: If the email has been sent to member/contact
 *
 * msid - Type: guid. Desc: msid
 *
 * notificationId - Type: guid. Desc: Notification ID
 *
 * platform - Type: string.
 *
 * template_id - Type: string. Desc: Descriptive name for the type of email. e.g. Identity.Member_Approved
 * @param {verticalsEmailNotificationSent1270Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var verticalsEmailNotificationSent1270 = function (params) {
    return { evid: 1270, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardWidgetSeenParams
* @property {string} hosting - hosting
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} widget_name - widget name
**/
/**
 * Name: dashboard > widget seen (not relevenat). src: 5 Evid: 298.
 * Event description: widget is shown in the dashboard - the event is being sent only when the user sees the widget.

 * hosting - Type: string. Desc: hosting
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * widget_name - Type: string. Desc: widget name
 * @param {dashboardWidgetSeenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardWidgetSeen = function (params) {
    return { evid: 298, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} foldersSortListViewParams
* @property {string} name - name/date_created/last_edited(name of field sorted by)
* @property {string} order - desc/asc
* @property {string} platform - null
* @property {string} sub_view - list-view
* @property {string} view - my-sites
**/
/**
 * Name: Folders > sort list view. src: 5 Evid: 127.
 * Event description: sort list view.

 * name - Type: string. Desc: name/date_created/last_edited(name of field sorted by)
 *
 * order - Type: string. Desc: desc/asc
 *
 * platform - Type: string.
 *
 * sub_view - Type: string. Desc: list-view
 *
 * view - Type: string. Desc: my-sites
 * @param {foldersSortListViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var foldersSortListView = function (params) {
    return { evid: 127, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerModuleLoadingStartParams
* @property {GUID} app_id - application id
* @property {string} hosting - MA/editor
* @property {boolean} initial_load - first load
* @property {string} module_id - requested module
* @property {GUID} msid - metasite id
* @property {string} origin - specific button triggered the the view loading (== referral info from editor)
* @property {string} origin_app_id - origin_app_id (what app opened the bizmgr)
* @property {string} platform - null
* @property {string} prev_module_id - last module loaded
* @property {string} referral_info - specific button triggered the the view loading
* @property {string} wixsession - authentication token. if the session exists, then the user is logged in.
**/
/**
 * Name: Biz Manager - module loading - start. src: 5 Evid: 564.
 * Event description: module that is loaded in the biz manager (like Stores, Shoutout, etc.).

 * app_id - Type: guid. Desc: application id
 *
 * hosting - Type: string. Desc: MA/editor
 *
 * initial_load - Type: bool. Desc: first load
 *
 * module_id - Type: string. Desc: requested module
 *
 * msid - Type: guid. Desc: metasite id
 *
 * origin - Type: string. Desc: specific button triggered the the view loading (== referral info from editor)
 *
 * origin_app_id - Type: string. Desc: origin_app_id (what app opened the bizmgr)
 *
 * platform - Type: string.
 *
 * prev_module_id - Type: string. Desc: last module loaded
 *
 * referral_info - Type: string. Desc: specific button triggered the the view loading
 *
 * wixsession - Type: string. Desc: authentication token. if the session exists, then the user is logged in.
 * @param {bizManagerModuleLoadingStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerModuleLoadingStart = function (params) {
    return { evid: 564, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} ascendPpPurchasePageEnterPromoParams
* @property {GUID} app_id - app_id
* @property {number} cycleId - cycle id
* @property {string} cycle_name - cycle name
* @property {string} origin - product name open PP
* @property {GUID} packageId - package id
* @property {string} package_name - package name
* @property {string} platform - null
* @property {string} referralInfo - button name open PP
* @property {string} selection - enter click / apply
**/
/**
 * Name: Ascend PP - Purchase Page Enter promo. src: 5 Evid: 140.
 * Event description: User click on enter promo code or apply.

 * app_id - Type: guid. Desc: app_id
 *
 * cycleId - Type: numeric. Desc: cycle id
 *
 * cycle_name - Type: string. Desc: cycle name
 *
 * origin - Type: string. Desc: product name open PP
 *
 * packageId - Type: guid. Desc: package id
 *
 * package_name - Type: string. Desc: package name
 *
 * platform - Type: string.
 *
 * referralInfo - Type: string. Desc: button name open PP
 *
 * selection - Type: string. Desc: enter click / apply
 * @param {ascendPpPurchasePageEnterPromoParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ascendPpPurchasePageEnterPromo = function (params) {
    return { evid: 140, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} engageEmailSettingsPageViewParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Quotes - Settings - error toast. src: 5 Evid: 540.
 * Event description: Quotes - Settings - error toast.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {engageEmailSettingsPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var engageEmailSettingsPageView = function (params) {
    return { evid: 540, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardClickOnSideBarParams
* @property {GUID} msid - null
* @property {string} name - null
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: dashboard > click on side bar. src: 5 Evid: 27.


 * msid - Type: guid.
 *
 * name - Type: string.
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {dashboardClickOnSideBarParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardClickOnSideBar = function (params) {
    return { evid: 27, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} settingsLobbyHoverOverAnItemParams
* @property {string} cta_name - the cta value (if exists) - f.e. “Get a business number”
* @property {string} item_location - will be in this format {section,column,row}.  F.e. website settings will be {1,1,1}.  If there are no sections send 0.
* @property {number} item_location_on_page - Item order (f.e. 0,1 etc.)
* @property {string} item_name - upgrade/connect_domain/.../website settings/business info/ roles and permissions/.../accept payments…
* @property {GUID} msid - msid
* @property {string} page_id - the pageComppnentId of the item that was hovered on
* @property {string} platform - null
* @property {string} section_name - general/ecommerce/..
**/
/**
 * Name: Settings Lobby -> hover over an item. src: 5 Evid: 1457.
 * Event description: When the user hovers over an item in the lobby.

 * cta_name - Type: string. Desc: the cta value (if exists) - f.e. “Get a business number”
 *
 * item_location - Type: string. Desc: will be in this format {section,column,row}.  F.e. website settings will be {1,1,1}.  If there are no sections send 0.
 *
 * item_location_on_page - Type: numeric. Desc: Item order (f.e. 0,1 etc.)
 *
 * item_name - Type: string. Desc: upgrade/connect_domain/.../website settings/business info/ roles and permissions/.../accept payments…
 *
 * msid - Type: guid. Desc: msid
 *
 * page_id - Type: string. Desc: the pageComppnentId of the item that was hovered on
 *
 * platform - Type: string.
 *
 * section_name - Type: string. Desc: general/ecommerce/..
 * @param {settingsLobbyHoverOverAnItemParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var settingsLobbyHoverOverAnItem = function (params) {
    return { evid: 1457, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} mobilePhoneNumberConfirmationPopUpClickConfirmForSmsCodeParams
* @property {string} code - confirmation code
* @property {string} hashed_phone - hashed_phone
* @property {string} mode - add/edit
* @property {string} platform - null
* @property {GUID} uuid - uuid
**/
/**
 * Name: Mobile Phone Number Confirmation - Verify Clicked. src: 5 Evid: 662.
 * Event description: the final user confirmation before the server validates the number.

 * code - Type: string. Desc: confirmation code
 *
 * hashed_phone - Type: string. Desc: hashed_phone
 *
 * mode - Type: string. Desc: add/edit
 *
 * platform - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 * @param {mobilePhoneNumberConfirmationPopUpClickConfirmForSmsCodeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mobilePhoneNumberConfirmationPopUpClickConfirmForSmsCode = function (params) {
    return { evid: 662, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardTriggersMyTriggersClickParams
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {number} src - null
**/
/**
 * Name: Automations > My Triggers Click. src: 5 Evid: 217.
 * Event description: My Triggers Click.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 * @param {dashboardTriggersMyTriggersClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardTriggersMyTriggersClick = function (params) {
    return { evid: 217, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationUserClickOnAutomationErrorMessageParams
* @property {string} status - 'active’ / ‘suspended’
* @property {string} buttonType - null
* @property {string} errorType - which error the user see
* @property {GUID} msid - msid
* @property {string} origin - origin which this action was made
* @property {string} platform - null
* @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
**/
/**
 * Name: Automation > user click on automation error message. src: 5 Evid: 2013.
 * Event description: User click on the automation error  (example: 'fix automation', 'learn more' etc.).

 * status - Type: string. Desc: 'active’ / ‘suspended’
 *
 * buttonType - Type: string.
 *
 * errorType - Type: string. Desc: which error the user see
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin which this action was made
 *
 * platform - Type: string.
 *
 * rule_id - Type: guid. Desc: if this trigger all ready customized, null if it first time customization
 * @param {automationUserClickOnAutomationErrorMessageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationUserClickOnAutomationErrorMessage = function (params) {
    return { evid: 2013, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} bizManagerSetupWidgetIsDisplayedParams
* @property {string} asset_campaign_guid - asset_campaign_guid
* @property {number} done_steps - number of done steps in setup
* @property {string} hosting - MA/editor
* @property {string} module_id - module  name
* @property {GUID} msid - metasite id
* @property {string} platform - null
* @property {number} skipped_steps - skipped_steps
* @property {number} steps - number of steps in setup
* @property {string} widget_state - minimized/expanded
**/
/**
 * Name: Biz Manager - setup widget is displayed. src: 5 Evid: 573.
 * Event description: TPA setup widget is displayed in biz mgr.

 * asset_campaign_guid - Type: string. Desc: asset_campaign_guid
 *
 * done_steps - Type: numeric. Desc: number of done steps in setup
 *
 * hosting - Type: string. Desc: MA/editor
 *
 * module_id - Type: string. Desc: module  name
 *
 * msid - Type: guid. Desc: metasite id
 *
 * platform - Type: string.
 *
 * skipped_steps - Type: numeric. Desc: skipped_steps
 *
 * steps - Type: numeric. Desc: number of steps in setup
 *
 * widget_state - Type: string. Desc: minimized/expanded
 * @param {bizManagerSetupWidgetIsDisplayedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bizManagerSetupWidgetIsDisplayed = function (params) {
    return { evid: 573, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} accountManagerStartLoadingAccountManagerParams
* @property {boolean} initial_load - initial_load
* @property {string} platform - null
* @property {string} referral_info - referral_info
**/
/**
 * Name: account manager - start loading account manager. src: 5 Evid: 110.
 * Event description: start loading account manager.

 * initial_load - Type: bool. Desc: initial_load
 *
 * platform - Type: string.
 *
 * referral_info - Type: string. Desc: referral_info
 * @param {accountManagerStartLoadingAccountManagerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accountManagerStartLoadingAccountManager = function (params) {
    return { evid: 110, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} homeCloseDialogParams
* @property {GUID} app_id - -
* @property {GUID} msid - -
* @property {string} origin - place of clicking my sites ( Header, top left bar). Relevant only for site list
* @property {string} page_view - Dashboard / my sites
* @property {string} platform - null
* @property {string} prev_view - -
* @property {string} referral_info - -
* @property {string} view - name of dialog: my-apps, site-list, account
* @property {string} wixsession - deprecated
**/
/**
 * Name: Home > close dialog. src: 5 Evid: 301.
 * Event description: closing a dialog from home my apps, my sites, account menu.

 * app_id - Type: guid. Desc: -
 *
 * msid - Type: guid. Desc: -
 *
 * origin - Type: string. Desc: place of clicking my sites ( Header, top left bar). Relevant only for site list
 *
 * page_view - Type: string. Desc: Dashboard / my sites
 *
 * platform - Type: string.
 *
 * prev_view - Type: string. Desc: -
 *
 * referral_info - Type: string. Desc: -
 *
 * view - Type: string. Desc: name of dialog: my-apps, site-list, account
 *
 * wixsession - Type: string. Desc: deprecated
 * @param {homeCloseDialogParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var homeCloseDialog = function (params) {
    return { evid: 301, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesEditModesNegativePriceToastParams
* @property {string} invoiceStatus - if no status then create
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Invoices - edit modes - negative price toast. src: 5 Evid: 1331.
 * Event description: Invoices - edit modes - negative price toast.

 * invoiceStatus - Type: string. Desc: if no status then create
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {invoicesEditModesNegativePriceToastParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesEditModesNegativePriceToast = function (params) {
    return { evid: 1331, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesDeleteInvoicePageCancelParams
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} origin_device - web,native
* @property {string} platform - null
**/
/**
 * Name: Quotes - Delete invoice page - Cancel. src: 5 Evid: 432.
 * Event description: cancel in delete page (for every close (cancel, x, background click)).

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string.
 * @param {quotesDeleteInvoicePageCancelParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesDeleteInvoicePageCancel = function (params) {
    return { evid: 432, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} phoneVerificationHoverOnMotivationParams
* @property {string} platform - null
* @property {GUID} uuid - uuid
**/
/**
 * Name: Phone Verification - Hover on motivation. src: 5 Evid: 660.
 * Event description: hover on "why add a mobile number?".

 * platform - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 * @param {phoneVerificationHoverOnMotivationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var phoneVerificationHoverOnMotivation = function (params) {
    return { evid: 660, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteQuickActionDialogCloseParams
* @property {GUID} msid - -
* @property {string} name - quick action name
* @property {string} origin - site-settings, my-sites
* @property {string} platform - null
**/
/**
 * Name: dashboard > site -> quick action dialog  - close. src: 5 Evid: 43.
 * Event description: user clicks cancel or X in dialog of a quick action (e.g cancel rename).

 * msid - Type: guid. Desc: -
 *
 * name - Type: string. Desc: quick action name
 *
 * origin - Type: string. Desc: site-settings, my-sites
 *
 * platform - Type: string.
 * @param {dashboardSiteQuickActionDialogCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteQuickActionDialogClose = function (params) {
    return { evid: 43, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesCreateInvoiceAddLineParams
* @property {GUID} appDefId - appDefId
* @property {GUID} invoice_id - invoice guid
* @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
* @property {string} msid - msid
* @property {string} origin - create invoice, edit invoice
* @property {string} platform - null
* @property {string} source - productSource
**/
/**
 * Name: Quotes - Create invoice - Add line. src: 5 Evid: 412.
 * Event description: Create invoice - add line.

 * appDefId - Type: guid. Desc: appDefId
 *
 * invoice_id - Type: guid. Desc: invoice guid
 *
 * invoiceType - Type: string. Desc: ’recurringAutoCharge’/ 'recurring'/ 'one time'
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: create invoice, edit invoice
 *
 * platform - Type: string.
 *
 * source - Type: string. Desc: productSource
 * @param {quotesCreateInvoiceAddLineParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesCreateInvoiceAddLine = function (params) {
    return { evid: 412, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationFilterMenuAutomationTableClickOnDoneButtonParams
* @property {string} actionsArray - null
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} statusesArray - null
* @property {string} triggersArray - the selected triggers
**/
/**
 * Name: Form Builder - Autocomplete Address Field - address design changed. src: 5 Evid: 1361.
 * Event description: Automation > filter menu automation table - click on the done button.

 * actionsArray - Type: string.
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * statusesArray - Type: string.
 *
 * triggersArray - Type: string. Desc: the selected triggers
 * @param {automationFilterMenuAutomationTableClickOnDoneButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationFilterMenuAutomationTableClickOnDoneButton = function (params) {
    return { evid: 1361, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} ascendSelectCancelReasonParams
* @property {string} cancel_reason_name - cancel reason selection
* @property {string} cancel_reason_text - cancel reason free text
* @property {GUID} msid - msid
* @property {string} platform - native or web
* @property {string} premium - premium_id
* @property {string} referralInfo - from where the screen was opened
**/
/**
 * Name: Ascend - Select cancel reason. src: 5 Evid: 1390.
 * Event description: User click on cancel reason in cancelation screen.

 * cancel_reason_name - Type: string. Desc: cancel reason selection
 *
 * cancel_reason_text - Type: string. Desc: cancel reason free text
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string. Desc: native or web
 *
 * premium - Type: string. Desc: premium_id
 *
 * referralInfo - Type: string. Desc: from where the screen was opened
 * @param {ascendSelectCancelReasonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ascendSelectCancelReason = function (params) {
    return { evid: 1390, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} apesMoreActionsChooseAnOptionParams
* @property {boolean} isPreinstalled - if the automation was preinstalled
* @property {GUID} msid - msid
* @property {string} option - which option was choose
* @property {string} origin - which origin this action was made from
* @property {string} platform - null
* @property {GUID} rule_id - rule id
**/
/**
 * Name: automations - widget - more actions - choose an option. src: 5 Evid: 1237.
 * Event description: APeS - Save edited notification.

 * isPreinstalled - Type: bool. Desc: if the automation was preinstalled
 *
 * msid - Type: guid. Desc: msid
 *
 * option - Type: string. Desc: which option was choose
 *
 * origin - Type: string. Desc: which origin this action was made from
 *
 * platform - Type: string.
 *
 * rule_id - Type: guid. Desc: rule id
 * @param {apesMoreActionsChooseAnOptionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var apesMoreActionsChooseAnOption = function (params) {
    return { evid: 1237, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesAddCustomerClickParams
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} platform - null
* @property {GUID} uuid - uuid
**/
/**
 * Name: Quotes - Add Customer - Click. src: 5 Evid: 460.
 * Event description: Add Customer - Click.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 * @param {quotesAddCustomerClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesAddCustomerClick = function (params) {
    return { evid: 460, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} toolcastClickOnXOnThePopUpParams
* @property {string} campaignId - from dealer
* @property {string} clickType - click X from Panel or Dashboard steps
* @property {boolean} firstStep - If the toolcast is first step and the user see the text
* @property {string} offeringGuid - offer guid
* @property {string} origin - click X from Panel or Dashboard steps or bubble
* @property {string} platform - null
* @property {string} stepName - The name of the toolcast step
**/
/**
 * Name: Toolcast- Click on X the pop up. src: 5 Evid: 1367.
 * Event description: when user click exist X on the pop up of the toolcast.

 * campaignId - Type: string. Desc: from dealer
 *
 * clickType - Type: string. Desc: click X from Panel or Dashboard steps
 *
 * firstStep - Type: bool. Desc: If the toolcast is first step and the user see the text
 *
 * offeringGuid - Type: string. Desc: offer guid
 *
 * origin - Type: string. Desc: click X from Panel or Dashboard steps or bubble
 *
 * platform - Type: string.
 *
 * stepName - Type: string. Desc: The name of the toolcast step
 * @param {toolcastClickOnXOnThePopUpParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var toolcastClickOnXOnThePopUp = function (params) {
    return { evid: 1367, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardTriggersCustomizeTheTriggerValueChangeValueChangeParams
* @property {number} delay - timing
* @property {string} flowType - flow in which the save happens: {create, edit}
* @property {number} index - index for drip campaign
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} recipe_name - recipe name
* @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
* @property {string} section - which section the user changed
* @property {number} src - deprecated
* @property {string} units - units
* @property {string} value - value of rule
**/
/**
 * Name: Automations > Customize the timing - Value change. src: 5 Evid: 205.
 * Event description: customize the timing value (scheduled field and frequency field).

 * delay - Type: numeric. Desc: timing
 *
 * flowType - Type: string. Desc: flow in which the save happens: {create, edit}
 *
 * index - Type: numeric. Desc: index for drip campaign
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * recipe_name - Type: string. Desc: recipe name
 *
 * rule_id - Type: guid. Desc: if this trigger all ready customized, null if it first time customization
 *
 * section - Type: string. Desc: which section the user changed
 *
 * src - Type: numeric. Desc: deprecated
 *
 * units - Type: string. Desc: units
 *
 * value - Type: string. Desc: value of rule
 * @param {dashboardTriggersCustomizeTheTriggerValueChangeValueChangeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardTriggersCustomizeTheTriggerValueChangeValueChange = function (params) {
    return { evid: 205, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} addNoteTermClickParams
* @property {GUID} appDefId - appDefId
* @property {GUID} invoice_id - invoice guid
* @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
* @property {string} msid - msid
* @property {string} origin - create invoice, edit invoice
* @property {string} platform - platform
* @property {string} source - productSource
**/
/**
 * Name: Add Note/Term click. src: 5 Evid: 8923.
 * Event description: Clicking on ‘Add’ note or term in PayME request.

 * appDefId - Type: guid. Desc: appDefId
 *
 * invoice_id - Type: guid. Desc: invoice guid
 *
 * invoiceType - Type: string. Desc: ’recurringAutoCharge’/ 'recurring'/ 'one time'
 *
 * msid - Type: string. Desc: msid
 *
 * origin - Type: string. Desc: create invoice, edit invoice
 *
 * platform - Type: string. Desc: platform
 *
 * source - Type: string. Desc: productSource
 * @param {addNoteTermClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addNoteTermClick = function (params) {
    return { evid: 8923, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesItemsListChooseAProductParams
* @property {GUID} appDefId - appDefId
* @property {boolean} ifVariantModal - For subscriptions, the item selection is not from dropdown, it’s from the modal
* @property {string} invoiceType - ’recurringAutoCharge’/ 'recurring'/ 'one time'
* @property {GUID} msid - msid
* @property {string} origin - invoice/ invoice and order
* @property {string} platform - null
**/
/**
 * Name: Invoices - Items List - choose a product. src: 5 Evid: 1315.
 * Event description: Invoices - Items List - choose a product.

 * appDefId - Type: guid. Desc: appDefId
 *
 * ifVariantModal - Type: bool. Desc: For subscriptions, the item selection is not from dropdown, it’s from the modal
 *
 * invoiceType - Type: string. Desc: ’recurringAutoCharge’/ 'recurring'/ 'one time'
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: invoice/ invoice and order
 *
 * platform - Type: string.
 * @param {invoicesItemsListChooseAProductParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesItemsListChooseAProduct = function (params) {
    return { evid: 1315, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} notificationClickOnNotificationParams
* @property {string} channel - Web / browser / mobile / SMS / email
* @property {string} clickOrigin - deprecated
* @property {string} click_type - mark read/mark unread/click/delete
* @property {string} contact_id - contact_id
* @property {string} correlationId - correlation_id
* @property {string} deep_link - deep_link
* @property {string} feed_name - Sub category of the channel (All Sites/This Site /Float/Oneapp notification center/ mobile os)
* @property {string} grouped_notifications - list of notification ids contain in this notification. if the notification is not grouped this field will be null
* @property {boolean} is_high_priority - true / false
* @property {GUID} msid - msid of the notification
* @property {string} notification_id - deprecated
* @property {string} notificationid - notificationid
* @property {string} origin - (Msid/my-site) MSID of the site the user is on, my-sites if on Site List. Later on, also account-settings, and other account-level pages.
* @property {string} platform - null
**/
/**
 * Name: Notification - Click on notification. src: 5 Evid: 272.
 * Event description: user clicks on a notification and opens app (test).

 * channel - Type: string. Desc: Web / browser / mobile / SMS / email
 *
 * clickOrigin - Type: string. Desc: deprecated
 *
 * click_type - Type: string. Desc: mark read/mark unread/click/delete
 *
 * contact_id - Type: string. Desc: contact_id
 *
 * correlationId - Type: string. Desc: correlation_id
 *
 * deep_link - Type: string. Desc: deep_link
 *
 * feed_name - Type: string. Desc: Sub category of the channel (All Sites/This Site /Float/Oneapp notification center/ mobile os)
 *
 * grouped_notifications - Type: string. Desc: list of notification ids contain in this notification. if the notification is not grouped this field will be null
 *
 * is_high_priority - Type: bool. Desc: true / false
 *
 * msid - Type: guid. Desc: msid of the notification
 *
 * notification_id - Type: string. Desc: deprecated
 *
 * notificationid - Type: string. Desc: notificationid
 *
 * origin - Type: string. Desc: (Msid/my-site) MSID of the site the user is on, my-sites if on Site List. Later on, also account-settings, and other account-level pages.
 *
 * platform - Type: string.
 * @param {notificationClickOnNotificationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var notificationClickOnNotification = function (params) {
    return { evid: 272, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsActionUserEnterInputOnActionItemParams
* @property {GUID} actionAppId - action provider app id
* @property {string} actionKey - action English key
* @property {number} inputLevel - how many dropdowns parents
* @property {string} inputName - display name / button name
* @property {string} inputType - input_type
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} value - input value
**/
/**
 * Name: Automations - Action - user enter input on action item. src: 5 Evid: 8951.
 * Event description: User enter input to a follow up item (component) in the action options.
In automation wizard.

 * actionAppId - Type: guid. Desc: action provider app id
 *
 * actionKey - Type: string. Desc: action English key
 *
 * inputLevel - Type: numeric. Desc: how many dropdowns parents
 *
 * inputName - Type: string. Desc: display name / button name
 *
 * inputType - Type: string. Desc: input_type
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * value - Type: string. Desc: input value
 * @param {automationsActionUserEnterInputOnActionItemParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsActionUserEnterInputOnActionItem = function (params) {
    return { evid: 8951, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsXOnAutomationsBannerParams
* @property {string} bannerName - which banner this event was activated on
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations - X on automations banner. src: 5 Evid: 1392.
 * Event description: CRM Home - Top carousel main CTA click.

 * bannerName - Type: string. Desc: which banner this event was activated on
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsXOnAutomationsBannerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsXOnAutomationsBanner = function (params) {
    return { evid: 1392, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSelectorLoadedParams
* @property {number} account_sites_number - absolute account sites number
* @property {string} device - mobile / desktop
* @property {string} filtered - premium/published/adi / none
* @property {boolean} is_partner_dashboard - true - if partner dashboard displayed
* @property {number} loadingTime - in ms
* @property {string} platform - null
* @property {string} sitePublished - null
* @property {string} referral - null
* @property {string} selectionType - single / multi
* @property {number} site_type_enriched - null
* @property {number} sites_count - # sites returned to site selector
* @property {number} src - null
* @property {string} status - no thumbnails / empty state / success
* @property {string} siteType - HtmlWeb / modal
**/
/**
 * Name: dashboard > site selector loaded successfully. src: 5 Evid: 24.


 * account_sites_number - Type: numeric. Desc: absolute account sites number
 *
 * device - Type: string. Desc: mobile / desktop
 *
 * filtered - Type: string. Desc: premium/published/adi / none
 *
 * is_partner_dashboard - Type: bool. Desc: true - if partner dashboard displayed
 *
 * loadingTime - Type: numeric. Desc: in ms
 *
 * platform - Type: string.
 *
 * sitePublished - Type: string.
 *
 * referral - Type: string.
 *
 * selectionType - Type: string. Desc: single / multi
 *
 * site_type_enriched - Type: numeric.
 *
 * sites_count - Type: numeric. Desc: # sites returned to site selector
 *
 * src - Type: numeric.
 *
 * status - Type: string. Desc: no thumbnails / empty state / success
 *
 * siteType - Type: string. Desc: HtmlWeb / modal
 * @param {dashboardSiteSelectorLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSelectorLoaded = function (params) {
    return { evid: 24, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} teamManagementAddMembersSendInviteParams
* @property {string} invite_role - (please note that using the toggle changes role desc) the role the user sends to the invitees
* @property {number} number_of_existing_emails - emails that already exist in the team
* @property {number} number_of_invalid_emails - number of invalid numbers (error for not typing correctly - exclude errors for existing emails)
* @property {number} number_of_valid_emails - number of valid emails
* @property {string} origin - where the user opened the dialog from
* @property {string} platform - null
* @property {string} roles_displayed - list of roles displayed to the user
**/
/**
 * Name: Team Management – add members – send invite. src: 5 Evid: 175.
 * Event description: When a user clicks on 'send invites' in the add member window.

 * invite_role - Type: string. Desc: (please note that using the toggle changes role desc) the role the user sends to the invitees
 *
 * number_of_existing_emails - Type: numeric. Desc: emails that already exist in the team
 *
 * number_of_invalid_emails - Type: numeric. Desc: number of invalid numbers (error for not typing correctly - exclude errors for existing emails)
 *
 * number_of_valid_emails - Type: numeric. Desc: number of valid emails
 *
 * origin - Type: string. Desc: where the user opened the dialog from
 *
 * platform - Type: string.
 *
 * roles_displayed - Type: string. Desc: list of roles displayed to the user
 * @param {teamManagementAddMembersSendInviteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var teamManagementAddMembersSendInvite = function (params) {
    return { evid: 175, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} accountManagerPageComponentFinishLoadingAccountManagerParams
* @property {number} loading_time - loading_time
* @property {string} platform - null
* @property {string} prev_sub_view - prev_sub_view
* @property {string} prev_view - prev_view
* @property {string} referral_info - referral_info
* @property {string} sub_view - sub_view
* @property {string} view - view
**/
/**
 * Name: account manager - page component finish loading account manager. src: 5 Evid: 113.
 * Event description: start loading account manager module.

 * loading_time - Type: numeric. Desc: loading_time
 *
 * platform - Type: string.
 *
 * prev_sub_view - Type: string. Desc: prev_sub_view
 *
 * prev_view - Type: string. Desc: prev_view
 *
 * referral_info - Type: string. Desc: referral_info
 *
 * sub_view - Type: string. Desc: sub_view
 *
 * view - Type: string. Desc: view
 * @param {accountManagerPageComponentFinishLoadingAccountManagerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accountManagerPageComponentFinishLoadingAccountManager = function (params) {
    return { evid: 113, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardQuickActionsDragNDropParams
* @property {string} direction - null
* @property {number} from - null
* @property {boolean} isFromTopSix - null
* @property {boolean} isToTopSix - null
* @property {GUID} msid - null
* @property {string} name - null
* @property {string} platform - null
* @property {number} src - null
* @property {number} to - null
* @property {number} duration - null
**/
/**
 * Name: dashboard > quick actions drag'N'drop. src: 5 Evid: 26.


 * direction - Type: string.
 *
 * from - Type: numeric.
 *
 * isFromTopSix - Type: bool.
 *
 * isToTopSix - Type: bool.
 *
 * msid - Type: guid.
 *
 * name - Type: string.
 *
 * platform - Type: string.
 *
 * src - Type: numeric.
 *
 * to - Type: numeric.
 *
 * duration - Type: numeric.
 * @param {dashboardQuickActionsDragNDropParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardQuickActionsDragNDrop = function (params) {
    return { evid: 26, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} toastShown85Params
* @property {string} hosting - MA/editor/dashboard
* @property {GUID} msid - metasite id
* @property {string} name - toast name, supplied by toast initiator
* @property {string} platform - null
* @property {string} scope - toast scope {app/ dashboard/my-sites}
* @property {string} severity - high, normal, low
* @property {number} timeout - miliseconds to auto hide toast, 0 is sticky toast
* @property {string} type - standard, error, warning, success, premium
**/
/**
 * Name: Giza - toast is shown. src: 5 Evid: 85.
 * Event description: a toast is shown in one of Giza's hosting platform. currently, in case of business manager - the reporting is from business manager itself and not from Giza. in the meantime to get business manager toasts filter hosting is not null.

 * hosting - Type: string. Desc: MA/editor/dashboard
 *
 * msid - Type: guid. Desc: metasite id
 *
 * name - Type: string. Desc: toast name, supplied by toast initiator
 *
 * platform - Type: string.
 *
 * scope - Type: string. Desc: toast scope {app/ dashboard/my-sites}
 *
 * severity - Type: string. Desc: high, normal, low
 *
 * timeout - Type: numeric. Desc: miliseconds to auto hide toast, 0 is sticky toast
 *
 * type - Type: string. Desc: standard, error, warning, success, premium
 * @param {toastShown85Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var toastShown85 = function (params) {
    return { evid: 85, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesConnectPaymentClickParams
* @property {string} msid - msid
* @property {string} name - name of payment
* @property {string} origin - how user arrived to the flow onboarding/payments
* @property {string} platform - null
**/
/**
 * Name: Quotes - Connect payment click. src: 5 Evid: 441.
 * Event description: user clicks on 'connect' from the payment popup page.

 * msid - Type: string. Desc: msid
 *
 * name - Type: string. Desc: name of payment
 *
 * origin - Type: string. Desc: how user arrived to the flow onboarding/payments
 *
 * platform - Type: string.
 * @param {quotesConnectPaymentClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesConnectPaymentClick = function (params) {
    return { evid: 441, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dialogFirstLoadParams
* @property {GUID} app_id - -
* @property {number} loading_time - loading time of page
* @property {GUID} msid - -
* @property {string} origin - place of clicking my sites ( Header, top left bar). Relevant only for site list
* @property {string} platform - null
* @property {string} prev_view - -
* @property {string} referral_info - -
* @property {string} view - my-apps, site-list
* @property {string} wixsession - authentication token. if the session exists, then the user is logged in.
**/
/**
 * Name: dialog first load. src: 5 Evid: 304.
 * Event description: opening a dialog from home (sent only in the first click within the same session) {my apps, my sites}.

 * app_id - Type: guid. Desc: -
 *
 * loading_time - Type: numeric. Desc: loading time of page
 *
 * msid - Type: guid. Desc: -
 *
 * origin - Type: string. Desc: place of clicking my sites ( Header, top left bar). Relevant only for site list
 *
 * platform - Type: string.
 *
 * prev_view - Type: string. Desc: -
 *
 * referral_info - Type: string. Desc: -
 *
 * view - Type: string. Desc: my-apps, site-list
 *
 * wixsession - Type: string. Desc: authentication token. if the session exists, then the user is logged in.
 * @param {dialogFirstLoadParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dialogFirstLoad = function (params) {
    return { evid: 304, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} crmHomeTasksWidgetSeeAllTasksParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: CRM Home - Tasks widget - see all tasks. src: 5 Evid: 823.
 * Event description: CRM Home - Tasks widget - see all tasks.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {crmHomeTasksWidgetSeeAllTasksParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var crmHomeTasksWidgetSeeAllTasks = function (params) {
    return { evid: 823, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesClickDueDateParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Quotes - click due date. src: 5 Evid: 383.
 * Event description: Quotes - click due date.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {quotesClickDueDateParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesClickDueDate = function (params) {
    return { evid: 383, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} analyticsKpiIsShownInAnalyticsWidgetParams
* @property {string} app_id - app id of the vertical that displays the widget.
* @property {string} hosting - MA/editor/ADI
* @property {number} kpi_location - 0-left 1-middle 2-right
* @property {string} kpi_name - kpi's name
* @property {string} kpi_period - the kpis period chosen for all seen kpis when the kpi is shown
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} value - the value that WAS returns as the kpi value
**/
/**
 * Name: Analytics > KPI is shown in analytics widget. src: 5 Evid: 369.
 * Event description: For each kpi shown in the analytics widget.

 * app_id - Type: string. Desc: app id of the vertical that displays the widget.
 *
 * hosting - Type: string. Desc: MA/editor/ADI
 *
 * kpi_location - Type: numeric. Desc: 0-left 1-middle 2-right
 *
 * kpi_name - Type: string. Desc: kpi's name
 *
 * kpi_period - Type: string. Desc: the kpis period chosen for all seen kpis when the kpi is shown
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * value - Type: string. Desc: the value that WAS returns as the kpi value
 * @param {analyticsKpiIsShownInAnalyticsWidgetParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var analyticsKpiIsShownInAnalyticsWidget = function (params) {
    return { evid: 369, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} wixInvoicesBannerToUpgradeToPremiumShownParams
* @property {GUID} msid - msid
* @property {string} name - banner name (upgrade to business premium)
* @property {string} origin - origin page, my invoices ( on mobile, when creating from list), create invoice - on web, when creating for the first time
* @property {string} origin_device - web,native
* @property {string} platform - platform
**/
/**
 * Name: Wix Invoices- Banner to upgrade to Premium shown. src: 5 Evid: 8966.
 * Event description: Banner to upgrade to Premium shown.

 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: banner name (upgrade to business premium)
 *
 * origin - Type: string. Desc: origin page, my invoices ( on mobile, when creating from list), create invoice - on web, when creating for the first time
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string. Desc: platform
 * @param {wixInvoicesBannerToUpgradeToPremiumShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var wixInvoicesBannerToUpgradeToPremiumShown = function (params) {
    return { evid: 8966, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardTriggersStep2EditingActionParams
* @property {string} button_name - button name
* @property {string} event_name - name of event (action)
* @property {GUID} msid - msid
* @property {string} platform - null
* @property {string} recipe_name - recipe name
* @property {GUID} rule_id - if this trigger all ready customized, null if it first time customization
**/
/**
 * Name: Automations > step 2 > editing action. src: 5 Evid: 225.
 * Event description: editing an action.

 * button_name - Type: string. Desc: button name
 *
 * event_name - Type: string. Desc: name of event (action)
 *
 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 *
 * recipe_name - Type: string. Desc: recipe name
 *
 * rule_id - Type: guid. Desc: if this trigger all ready customized, null if it first time customization
 * @param {dashboardTriggersStep2EditingActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardTriggersStep2EditingAction = function (params) {
    return { evid: 225, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} accountSettingsCloseYourWixAccountEnterPageParams
* @property {string} platform - null
* @property {GUID} uuid - user id
**/
/**
 * Name: Account Settings > Close your WIX account - enter page. src: 5 Evid: 1278.
 * Event description: new UX for the close your account

https://docs.google.com/presentation/d/1toummTuN1-7cxFR3TgbGMi5F5UR-vYntZHpCRfYhkOo/edit#slide=id.gaa2182f012_3_18.

 * platform - Type: string.
 *
 * uuid - Type: guid. Desc: user id
 * @param {accountSettingsCloseYourWixAccountEnterPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var accountSettingsCloseYourWixAccountEnterPage = function (params) {
    return { evid: 1278, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} invoicesRecurringClickOnHowDoRecurringInvoicesWorkParams
* @property {string} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Invoices - recurring - click on 'How do recurring invoices work’. src: 5 Evid: 1571.
 * Event description: user clicks on 'How do recurring invoices work’.

 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 * @param {invoicesRecurringClickOnHowDoRecurringInvoicesWorkParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var invoicesRecurringClickOnHowDoRecurringInvoicesWork = function (params) {
    return { evid: 1571, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} mobilePhoneNumberConfirmationPopUpClickOkForSendingSmsParams
* @property {string} hashed_phone - hashed_phone
* @property {string} mode - add/edit
* @property {string} origin - send / resend
* @property {string} platform - null
* @property {GUID} uuid - uuid
**/
/**
 * Name: Mobile Phone Number Confirmation - send SMS. src: 5 Evid: 661.
 * Event description: request for sms has sent.

 * hashed_phone - Type: string. Desc: hashed_phone
 *
 * mode - Type: string. Desc: add/edit
 *
 * origin - Type: string. Desc: send / resend
 *
 * platform - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 * @param {mobilePhoneNumberConfirmationPopUpClickOkForSendingSmsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mobilePhoneNumberConfirmationPopUpClickOkForSendingSms = function (params) {
    return { evid: 661, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardSiteSelectorMoreSitesLoadedSuccessfullyParams
* @property {string} device - mobile / desktop
* @property {string} filtered - premium/published/adi / none
* @property {number} loadingTime - in ms
* @property {string} platform - relevant for mobile only
* @property {Url} referral - referral
* @property {string} selectionType - single / multi
* @property {number} site_type_enriched - id
* @property {undefined} site_type - HtmlWeb / modal
* @property {number} sites_count - # sites loaded
* @property {string} status - no thumbnails / empty state / success
* @property {string} siteType - HtmlWeb / modal
**/
/**
 * Name: dashboard > site selector more sites loaded successfully. src: 5 Evid: 1608.
 * Event description: when user scrolls and loads more sites.

 * device - Type: string. Desc: mobile / desktop
 *
 * filtered - Type: string. Desc: premium/published/adi / none
 *
 * loadingTime - Type: numeric. Desc: in ms
 *
 * platform - Type: string. Desc: relevant for mobile only
 *
 * referral - Type: url. Desc: referral
 *
 * selectionType - Type: string. Desc: single / multi
 *
 * site_type_enriched - Type: numeric. Desc: id
 *
 * site_type - Type: map. Desc: HtmlWeb / modal
 *
 * sites_count - Type: numeric. Desc: # sites loaded
 *
 * status - Type: string. Desc: no thumbnails / empty state / success
 *
 * siteType - Type: string. Desc: HtmlWeb / modal
 * @param {dashboardSiteSelectorMoreSitesLoadedSuccessfullyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardSiteSelectorMoreSitesLoadedSuccessfully = function (params) {
    return { evid: 1608, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsDaComponentManageAutomations286Params
* @property {GUID} invoice_id - invoice guid
* @property {string} msid - msid
* @property {string} platform - null
* @property {boolean} status - success,failure
**/
/**
 * Name: Quotes - partial payment success/failure page. src: 5 Evid: 286.
 * Event description: Quotes - partial payment success/failure page.

 * invoice_id - Type: guid. Desc: invoice guid
 *
 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 *
 * status - Type: bool. Desc: success,failure
 * @param {automationsDaComponentManageAutomations286Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsDaComponentManageAutomations286 = function (params) {
    return { evid: 286, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} dashboardEnterEditorxParams
* @property {string} origin - the location of the button e.g. my-sites top button
* @property {string} platform - null
**/
/**
 * Name: dashboard > enter editorx. src: 5 Evid: 257.
 * Event description: user enters EditorX from different origins (site_list_top, site_list_bottom, top_bar, account_templates).

 * origin - Type: string. Desc: the location of the button e.g. my-sites top button
 *
 * platform - Type: string.
 * @param {dashboardEnterEditorxParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var dashboardEnterEditorx = function (params) {
    return { evid: 257, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} foldersClickOnCreateNewFolderInDialogParams
* @property {string} folder_name - the name of the folder
* @property {string} hosting - MA
* @property {number} nesting_level - 0 (my-sites)/1 (folder) /2/3..
* @property {string} platform - null
* @property {string} sub_view - grid/list-view
* @property {string} view - my-sites/folder-view
**/
/**
 * Name: Folders > Click on 'Create' button in folder's dialog. src: 5 Evid: 123.
 * Event description: when a user clicks on 'Create' from new folder dialog.

 * folder_name - Type: string. Desc: the name of the folder
 *
 * hosting - Type: string. Desc: MA
 *
 * nesting_level - Type: numeric. Desc: 0 (my-sites)/1 (folder) /2/3..
 *
 * platform - Type: string.
 *
 * sub_view - Type: string. Desc: grid/list-view
 *
 * view - Type: string. Desc: my-sites/folder-view
 * @param {foldersClickOnCreateNewFolderInDialogParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var foldersClickOnCreateNewFolderInDialog = function (params) {
    return { evid: 123, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} automationsClosePreInstallAutomationBannerParams
* @property {GUID} msid - msid
* @property {string} platform - null
**/
/**
 * Name: Automations - close pre install automation banner. src: 5 Evid: 1185.
 * Event description: Automations - close pre install automation banner.

 * msid - Type: guid. Desc: msid
 *
 * platform - Type: string.
 * @param {automationsClosePreInstallAutomationBannerParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var automationsClosePreInstallAutomationBanner = function (params) {
    return { evid: 1185, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} wixInvoicesBannerToConnectPaymentMethodsParams
* @property {GUID} msid - null
* @property {string} name - banner name
* @property {string} origin - origin page, my invoices ( on mobile, when creating from list), create invoice - on web, when creating for the first time
* @property {string} origin_device - web,native
* @property {string} platform - platform
**/
/**
 * Name: Wix Invoices- Banner to connect Payment Methods. src: 5 Evid: 8969.
 * Event description: Wix Invoices- Banner to connect Payment Methods.

 * msid - Type: guid.
 *
 * name - Type: string. Desc: banner name
 *
 * origin - Type: string. Desc: origin page, my invoices ( on mobile, when creating from list), create invoice - on web, when creating for the first time
 *
 * origin_device - Type: string. Desc: web,native
 *
 * platform - Type: string. Desc: platform
 * @param {wixInvoicesBannerToConnectPaymentMethodsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var wixInvoicesBannerToConnectPaymentMethods = function (params) {
    return { evid: 8969, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} notificationShowNotificationParams
* @property {string} channel - Web / browser / mobile / SMS / email
* @property {string} contact_id - contact_id guid
* @property {string} correlationId - correlation_id
* @property {string} feed_name - All sites/This site /float
* @property {boolean} is_high_priority - true / false
* @property {string} mode - online / cashed (in case of no internet)
* @property {string} notification_ids - all notifications that were shown in the page ( separated with a comma)
* @property {string} notificationid - deprecated
* @property {string} origin - MSID of the site the user is on, my-sites if on Site List. Later on, also account-settings, and other account-level pages.
* @property {number} page_number - page number - each page is limited to 30 notifications
* @property {string} platform - null
* @property {string} source - where the display was triggered from: site_level / account_level / home_site_level
**/
/**
 * Name: Notification - Notifications are displayed. src: 5 Evid: 271.
 * Event description: user opens the dialog and X notifications are being displayed , after scrolling another event will be sent with a new page number.

 * channel - Type: string. Desc: Web / browser / mobile / SMS / email
 *
 * contact_id - Type: string. Desc: contact_id guid
 *
 * correlationId - Type: string. Desc: correlation_id
 *
 * feed_name - Type: string. Desc: All sites/This site /float
 *
 * is_high_priority - Type: bool. Desc: true / false
 *
 * mode - Type: string. Desc: online / cashed (in case of no internet)
 *
 * notification_ids - Type: string. Desc: all notifications that were shown in the page ( separated with a comma)
 *
 * notificationid - Type: string. Desc: deprecated
 *
 * origin - Type: string. Desc: MSID of the site the user is on, my-sites if on Site List. Later on, also account-settings, and other account-level pages.
 *
 * page_number - Type: numeric. Desc: page number - each page is limited to 30 notifications
 *
 * platform - Type: string.
 *
 * source - Type: string. Desc: where the display was triggered from: site_level / account_level / home_site_level
 * @param {notificationShowNotificationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var notificationShowNotification = function (params) {
    return { evid: 271, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} quotesInvoicesAutomaticallyCreateAndSendInvoicesParams
* @property {boolean} is_auto - {true/false}
* @property {string} msid - msid
* @property {string} platform - null
* @property {GUID} uuid - uuid
**/
/**
 * Name: Quotes/Invoices - Automatically create and send invoices. src: 5 Evid: 459.
 * Event description: User Clicked on 'Automatically create and send invoices for accepted price quotes' checkbox in Price Quotes/Invoices settings.

 * is_auto - Type: bool. Desc: {true/false}
 *
 * msid - Type: string. Desc: msid
 *
 * platform - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 * @param {quotesInvoicesAutomaticallyCreateAndSendInvoicesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var quotesInvoicesAutomaticallyCreateAndSendInvoices = function (params) {
    return { evid: 459, src: 5, endpoint: 'dash', params: params };
};
/**
* @typedef {Object} homeMarkNotificationReadParams
* @property {string} activity_type - activity type - not sent
* @property {string} app_id - app that sent the notification
* @property {string} msid - msid
* @property {string} notification_id - notification id
* @property {string} platform - null
**/
/**
 * Name: Home > mark notification read old event . now deprecated. src: 5 Evid: 252.
 * Event description: user clicks on mark as read.

 * activity_type - Type: string. Desc: activity type - not sent
 *
 * app_id - Type: string. Desc: app that sent the notification
 *
 * msid - Type: string. Desc: msid
 *
 * notification_id - Type: string. Desc: notification id
 *
 * platform - Type: string.
 * @param {homeMarkNotificationReadParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var homeMarkNotificationRead = function (params) {
    return { evid: 252, src: 5, endpoint: 'dash', params: params };
};
//# sourceMappingURL=index.js.map